import { jsxs as Ie, jsx as A } from "@emotion/react/jsx-runtime";
import { Modal as le } from "@inflearn/ds-modal";
import { Divider as Xr, Group as Ed, Checkbox as Cd, Button as nl, VisuallyHidden as Ba, TextInput as bd, PasswordInput as Td, Text as qi, OptimizeImage as wd, COLOR_PALETTE as il, openAlertModal as ja, Tooltip as Nd, ActionIcon as Od, Icon as Jn, Box as Md, Flex as wr, Anchor as Zn } from "@inflearn/ds-react";
import Ha, { useMemo as ol, createElement as _d, useRef as Sd, useEffect as De, createContext as Rd, useState as al, useCallback as Yn } from "react";
import { I as xd, u as An, C as Go, a as sl, b as Pd, e as er, A as Ud, h as nt, S as tr, c as Dd, d as Ld, f as ul, g as eo, i as $d, M as kd, H as Fd, O as Gd, j as Nr, k as Vd, l as Bd, m as jd, q as Kn, n as Hd } from "./StickyHeaderSkeleton-dac046bb.mjs";
import { ApiError as Xd } from "@inflearn/datasource-rest";
import { useForm as Wd, useWatch as zd } from "react-hook-form";
import { css as Jd } from "@emotion/react";
import Zd from "dayjs/plugin/duration";
import Yd from "dayjs/plugin/relativeTime";
import En from "dayjs";
function Kd({
  i18n: t,
  defaultNS: e,
  children: r
}) {
  const n = ol(() => ({
    i18n: t,
    defaultNS: e
  }), [t, e]);
  return _d(xd.Provider, {
    value: n
  }, r);
}
function Qd(t) {
  if (typeof window > "u")
    return t;
  const e = document.createElement("div");
  return e.innerHTML = t, e.querySelectorAll("script").forEach((i) => i.remove()), e.querySelectorAll("*").forEach((i) => {
    Array.from(i.attributes).forEach((o) => {
      (o.name.startsWith("on") || o.value.toLowerCase().includes("javascript:")) && i.removeAttribute(o.name);
    });
  }), e.innerHTML;
}
const qd = new Date((/* @__PURE__ */ new Date()).setHours(23, 59, 59));
function MD({
  id: t,
  isOpened: e,
  title: r,
  body: n,
  onClose: i
}) {
  const {
    t: o
  } = An(), a = Sd(null), s = () => {
    var u;
    Go.set("checked_gr_noti_id", String(t), (u = a == null ? void 0 : a.current) != null && u.checked ? 365 : qd), i();
  };
  return /* @__PURE__ */ Ie(le.Root, { opened: e, onClose: i, closeOnClickOutside: !1, children: [
    /* @__PURE__ */ A(le.Overlay, {}),
    /* @__PURE__ */ Ie(le.Content, { children: [
      /* @__PURE__ */ A(le.Header, { children: /* @__PURE__ */ A(le.Title, { children: r }) }),
      /* @__PURE__ */ Ie(le.Body, { children: [
        /* @__PURE__ */ A("div", { dangerouslySetInnerHTML: {
          __html: Qd(n)
        } }),
        /* @__PURE__ */ A(Xr, { mt: 16 })
      ] }),
      /* @__PURE__ */ A(le.Footer, { children: /* @__PURE__ */ Ie(Ed, { position: "apart", w: "100%", children: [
        /* @__PURE__ */ A(Cd, { ref: a, label: o("이 공지를 그만 볼래요"), styles: (u) => ({
          label: {
            color: u.colors.gray[6]
          }
        }) }),
        /* @__PURE__ */ A(nl, { variant: "default", onClick: s, children: o("닫기") })
      ] }) })
    ] })
  ] });
}
function ev() {
  var S, T;
  const {
    t
  } = An(), {
    trackEvent: e
  } = sl(), {
    register: r,
    setFocus: n,
    handleSubmit: i,
    control: o,
    formState: {
      errors: a,
      isValid: s
    }
  } = Wd({
    mode: "onChange",
    defaultValues: {
      email: "",
      password: ""
    }
  }), {
    isLoading: u,
    isError: c,
    error: l,
    mutate: f,
    reset: p
  } = Pd({
    url: Ud.CLIENT_V2_AUTH_SIGNIN,
    options: {
      useErrorBoundary: !1,
      onSuccess: () => {
        nt() && (window.location.href = encodeURI(`${tr.SIGN_IN}?referUrl=${window.location.href}`));
      }
    }
  }), [d, C] = zd({
    name: ["email", "password"],
    control: o
  });
  return De(() => {
    e(er.VIEW_SIGNIN_MODAL);
  }, []), De(() => {
    n("email");
  }, [n]), De(() => {
    p();
  }, [d, C]), // eslint-disable-next-line @typescript-eslint/no-misused-promises
  /* @__PURE__ */ Ie("form", { onSubmit: i((N, U) => {
    U == null || U.preventDefault(), s && nt() && f({
      email: N.email,
      password: N.password
    });
  }), noValidate: !0, children: [
    /* @__PURE__ */ A(Ba, { children: /* @__PURE__ */ A("label", { htmlFor: "email", children: t("이메일") }) }),
    /* @__PURE__ */ A(bd, { mb: 12, size: "md", id: "email", type: "email", placeholder: t("이메일"), disabled: u, error: (S = a.email) == null ? void 0 : S.message, ...r("email", {
      required: t("이메일을 입력해주세요.")
    }) }),
    /* @__PURE__ */ A(Ba, { children: /* @__PURE__ */ A("label", { htmlFor: "password", children: t("비밀번호") }) }),
    /* @__PURE__ */ A(Td, { mb: 12, size: "md", id: "password", placeholder: t("비밀번호"), disabled: u, error: (T = a.password) == null ? void 0 : T.message, ...r("password", {
      required: t("비밀번호를 입력해주세요.")
    }) }),
    c && /* @__PURE__ */ A(qi, { size: "sm", color: "red.6", children: l instanceof Xd ? t(rv(l)) : t("문제가 발생했습니다.") }),
    /* @__PURE__ */ A(nl, { mt: 18, fullWidth: !0, variant: "filled", size: "md", type: "submit", loading: u, onClick: () => e(er.CLICK_SIGNIN_AT_SIGNIN, {
      spot: "modal"
    }), children: t("로그인") })
  ] });
}
const tv = {
  EMAIL_NOT_FOUND: "SIGNIN_001",
  BLOCKED_ACCOUNT: "SIGNIN_002",
  INVALID_PASSWORD: "SIGNIN_003",
  EMAIL_VERIFICATION_REQUIRED: "SIGNIN_004"
}, rv = (t) => t.errorCode === tv.EMAIL_VERIFICATION_REQUIRED ? "가입 이메일 인증이 필요합니다." : "이메일 또는 비밀번호를 확인해주세요.";
function nv({
  type: t = "inflearn",
  fill: e,
  size: r = 100,
  className: n
}) {
  return t === "inflearn" ? /* @__PURE__ */ A(wd, { w: r * 2 + 1, css: /* @__PURE__ */ Jd({
    width: r
  }, process.env.NODE_ENV === "production" ? "" : ";label:BrandLogo;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), className: n, src: `${Dd}/assets/brand/brand_logo.png`, alt: "Inflearn brand logo image" }) : t === "inflearn-circle" ? /* @__PURE__ */ A(ov, { size: r, className: n, fill: e }) : /* @__PURE__ */ A(iv, { size: r, className: n, fill: e });
}
function iv({
  size: t,
  className: e,
  fill: r
}) {
  return /* @__PURE__ */ Ie("svg", { fill: "none", width: t, height: t, className: e, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !0, children: [
    /* @__PURE__ */ A("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 10.7626C3 7.3177 5.76662 4.52502 9.17943 4.52502H12.7955V7.11248H9.17943C7.1823 7.11248 5.56332 8.74672 5.56332 10.7626C5.56332 12.7786 7.1823 14.4128 9.17943 14.4128C11.1765 14.4128 12.7955 12.7786 12.7955 10.7626V7.11248H15.3589V10.7626C15.3589 14.2076 12.5922 17.0003 9.17943 17.0003C5.76662 17.0003 3 14.2076 3 10.7626Z", fill: r || "#21252A" }),
    /* @__PURE__ */ A("path", { d: "M15.4272 5.91089C16.2235 5.91089 16.8691 5.25927 16.8691 4.45545C16.8691 3.65163 16.2235 3 15.4272 3C14.6309 3 13.9854 3.65163 13.9854 4.45545V5.91089H15.4272Z", fill: r || il.infgreen[6] })
  ] });
}
function ov({
  size: t,
  className: e,
  fill: r
}) {
  return /* @__PURE__ */ A("svg", { fill: "none", width: t, height: t, className: e, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !0, children: /* @__PURE__ */ A("path", { d: "M16.4702 7.30208C16.1056 6.46354 15.6135 5.71615 14.9937 5.07813C14.3558 4.4401 13.6267 3.92969 12.7882 3.5651C11.9497 3.20052 11.0383 3 10.0723 3C9.12446 3 8.21308 3.16406 7.35638 3.52865C6.49969 3.89323 5.75236 4.38542 5.09617 5.00521C4.43998 5.64323 3.92961 6.3724 3.56505 7.21094C3.2005 8.04948 3 8.96094 3 9.92708C3 10.875 3.16405 11.7865 3.5286 12.6432C3.89315 13.5 4.38529 14.2474 5.02326 14.9036C5.66122 15.5599 6.40855 16.0703 7.24702 16.4349C8.10371 16.7995 8.99686 17 9.96292 17H16.9988V10.0365C17.017 9.07031 16.8347 8.15885 16.4702 7.30208ZM7.79384 15.1406C7.11943 14.849 6.51792 14.4297 6.00755 13.9193C5.49717 13.3906 5.09617 12.7891 4.80453 12.1146C4.51289 11.4219 4.38529 10.7109 4.38529 9.94531C4.38529 9.16146 4.54934 8.43229 4.84098 7.75781C5.13262 7.08333 5.55186 6.5 6.06223 5.98958C6.59083 5.47917 7.19234 5.09635 7.86676 4.80469C8.5594 4.51302 9.27028 4.38542 10.0358 4.38542C10.8196 4.38542 11.5487 4.54948 12.2231 4.84115C12.8976 5.13281 13.4808 5.53385 13.9912 6.0625C14.5016 6.57292 14.8844 7.17448 15.176 7.84896C15.4676 8.52344 15.5952 9.25261 15.5952 10.0365V14.7396L10.5644 9.65365L11.6763 6.59115C11.8039 6.26302 11.6216 5.89844 11.2935 5.77083C10.9654 5.64323 10.6009 5.82552 10.4733 6.15365L9.58015 8.63281L8.01258 7.04688C7.75739 6.79167 7.35638 6.79167 7.11943 7.04688C6.86424 7.30208 6.86424 7.70313 7.11943 7.9401L10.9472 11.8594H8.17662C7.8303 11.8594 7.53866 12.151 7.53866 12.4974C7.53866 12.8438 7.8303 13.1354 8.17662 13.1354H12.1502C12.1685 13.1354 12.1867 13.1354 12.1867 13.1354L14.6656 15.6146H9.96292C9.17914 15.5964 8.48649 15.4505 7.79384 15.1406Z", fill: r || il.infgreen[6] }) });
}
const av = (t) => Ld.find((r) => t.startsWith(`/${r}`)) || ul;
En.extend(Yd);
En.extend(Zd);
En.locale(eo.language ?? ul);
function sv({
  children: t
}) {
  return De(function() {
    if (!nt())
      return;
    const r = av(window.location.pathname);
    En.locale(r), eo.changeLanguage(r);
  }, []), /* @__PURE__ */ A(Kd, { i18n: eo, children: t });
}
var cl = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", r = "comment", n = 512, i = 512, o = [128489, 61669], a = "f075", s = "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z";
  t.definition = {
    prefix: e,
    iconName: r,
    icon: [
      n,
      i,
      o,
      a,
      s
    ]
  }, t.faComment = t.definition, t.prefix = e, t.iconName = r, t.width = n, t.height = i, t.ligatures = o, t.unicode = a, t.svgPathData = s, t.aliases = o;
})(cl);
var uv = {
  prefix: "fab",
  iconName: "apple",
  icon: [384, 512, [], "f179", "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"]
}, cv = {
  prefix: "fab",
  iconName: "github",
  icon: [496, 512, [], "f09b", "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"]
}, Or, lv = new Uint8Array(16);
function fv() {
  if (!Or && (Or = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Or))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Or(lv);
}
const pv = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function dv(t) {
  return typeof t == "string" && pv.test(t);
}
var te = [];
for (var Qn = 0; Qn < 256; ++Qn)
  te.push((Qn + 256).toString(16).substr(1));
function vv(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (te[t[e + 0]] + te[t[e + 1]] + te[t[e + 2]] + te[t[e + 3]] + "-" + te[t[e + 4]] + te[t[e + 5]] + "-" + te[t[e + 6]] + te[t[e + 7]] + "-" + te[t[e + 8]] + te[t[e + 9]] + "-" + te[t[e + 10]] + te[t[e + 11]] + te[t[e + 12]] + te[t[e + 13]] + te[t[e + 14]] + te[t[e + 15]]).toLowerCase();
  if (!dv(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function Pt(t, e, r) {
  t = t || {};
  var n = t.random || (t.rng || fv)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (var i = 0; i < 16; ++i)
      e[r + i] = n[i];
    return e;
  }
  return vv(n);
}
const ll = "3.7.7", hv = ll, Ut = typeof Buffer == "function", Xa = typeof TextDecoder == "function" ? new TextDecoder() : void 0, Wa = typeof TextEncoder == "function" ? new TextEncoder() : void 0, gv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Qt = Array.prototype.slice.call(gv), Mr = ((t) => {
  let e = {};
  return t.forEach((r, n) => e[r] = n), e;
})(Qt), yv = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, re = String.fromCharCode.bind(String), za = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (t) => new Uint8Array(Array.prototype.slice.call(t, 0)), fl = (t) => t.replace(/=/g, "").replace(/[+\/]/g, (e) => e == "+" ? "-" : "_"), pl = (t) => t.replace(/[^A-Za-z0-9\+\/]/g, ""), dl = (t) => {
  let e, r, n, i, o = "";
  const a = t.length % 3;
  for (let s = 0; s < t.length; ) {
    if ((r = t.charCodeAt(s++)) > 255 || (n = t.charCodeAt(s++)) > 255 || (i = t.charCodeAt(s++)) > 255)
      throw new TypeError("invalid character found");
    e = r << 16 | n << 8 | i, o += Qt[e >> 18 & 63] + Qt[e >> 12 & 63] + Qt[e >> 6 & 63] + Qt[e & 63];
  }
  return a ? o.slice(0, a - 3) + "===".substring(a) : o;
}, Vo = typeof btoa == "function" ? (t) => btoa(t) : Ut ? (t) => Buffer.from(t, "binary").toString("base64") : dl, to = Ut ? (t) => Buffer.from(t).toString("base64") : (t) => {
  let r = [];
  for (let n = 0, i = t.length; n < i; n += 4096)
    r.push(re.apply(null, t.subarray(n, n + 4096)));
  return Vo(r.join(""));
}, Wr = (t, e = !1) => e ? fl(to(t)) : to(t), Iv = (t) => {
  if (t.length < 2) {
    var e = t.charCodeAt(0);
    return e < 128 ? t : e < 2048 ? re(192 | e >>> 6) + re(128 | e & 63) : re(224 | e >>> 12 & 15) + re(128 | e >>> 6 & 63) + re(128 | e & 63);
  } else {
    var e = 65536 + (t.charCodeAt(0) - 55296) * 1024 + (t.charCodeAt(1) - 56320);
    return re(240 | e >>> 18 & 7) + re(128 | e >>> 12 & 63) + re(128 | e >>> 6 & 63) + re(128 | e & 63);
  }
}, mv = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, vl = (t) => t.replace(mv, Iv), Ja = Ut ? (t) => Buffer.from(t, "utf8").toString("base64") : Wa ? (t) => to(Wa.encode(t)) : (t) => Vo(vl(t)), Nt = (t, e = !1) => e ? fl(Ja(t)) : Ja(t), Za = (t) => Nt(t, !0), Av = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, Ev = (t) => {
  switch (t.length) {
    case 4:
      var e = (7 & t.charCodeAt(0)) << 18 | (63 & t.charCodeAt(1)) << 12 | (63 & t.charCodeAt(2)) << 6 | 63 & t.charCodeAt(3), r = e - 65536;
      return re((r >>> 10) + 55296) + re((r & 1023) + 56320);
    case 3:
      return re((15 & t.charCodeAt(0)) << 12 | (63 & t.charCodeAt(1)) << 6 | 63 & t.charCodeAt(2));
    default:
      return re((31 & t.charCodeAt(0)) << 6 | 63 & t.charCodeAt(1));
  }
}, hl = (t) => t.replace(Av, Ev), gl = (t) => {
  if (t = t.replace(/\s+/g, ""), !yv.test(t))
    throw new TypeError("malformed base64.");
  t += "==".slice(2 - (t.length & 3));
  let e, r = "", n, i;
  for (let o = 0; o < t.length; )
    e = Mr[t.charAt(o++)] << 18 | Mr[t.charAt(o++)] << 12 | (n = Mr[t.charAt(o++)]) << 6 | (i = Mr[t.charAt(o++)]), r += n === 64 ? re(e >> 16 & 255) : i === 64 ? re(e >> 16 & 255, e >> 8 & 255) : re(e >> 16 & 255, e >> 8 & 255, e & 255);
  return r;
}, Bo = typeof atob == "function" ? (t) => atob(pl(t)) : Ut ? (t) => Buffer.from(t, "base64").toString("binary") : gl, yl = Ut ? (t) => za(Buffer.from(t, "base64")) : (t) => za(Bo(t).split("").map((e) => e.charCodeAt(0))), Il = (t) => yl(ml(t)), Cv = Ut ? (t) => Buffer.from(t, "base64").toString("utf8") : Xa ? (t) => Xa.decode(yl(t)) : (t) => hl(Bo(t)), ml = (t) => pl(t.replace(/[-_]/g, (e) => e == "-" ? "+" : "/")), ro = (t) => Cv(ml(t)), bv = (t) => {
  if (typeof t != "string")
    return !1;
  const e = t.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(e) || !/[^\s0-9a-zA-Z\-_]/.test(e);
}, Al = (t) => ({
  value: t,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), El = function() {
  const t = (e, r) => Object.defineProperty(String.prototype, e, Al(r));
  t("fromBase64", function() {
    return ro(this);
  }), t("toBase64", function(e) {
    return Nt(this, e);
  }), t("toBase64URI", function() {
    return Nt(this, !0);
  }), t("toBase64URL", function() {
    return Nt(this, !0);
  }), t("toUint8Array", function() {
    return Il(this);
  });
}, Cl = function() {
  const t = (e, r) => Object.defineProperty(Uint8Array.prototype, e, Al(r));
  t("toBase64", function(e) {
    return Wr(this, e);
  }), t("toBase64URI", function() {
    return Wr(this, !0);
  }), t("toBase64URL", function() {
    return Wr(this, !0);
  });
}, Tv = () => {
  El(), Cl();
}, wv = {
  version: ll,
  VERSION: hv,
  atob: Bo,
  atobPolyfill: gl,
  btoa: Vo,
  btoaPolyfill: dl,
  fromBase64: ro,
  toBase64: Nt,
  encode: Nt,
  encodeURI: Za,
  encodeURL: Za,
  utob: vl,
  btou: hl,
  decode: ro,
  isValid: bv,
  fromUint8Array: Wr,
  toUint8Array: Il,
  extendString: El,
  extendUint8Array: Cl,
  extendBuiltins: Tv
};
var v = (
  /** @class */
  function() {
    function t() {
    }
    return t.isNotNullOrUndefined = function(e) {
      return e != null;
    }, t.isNullOrUndefined = function(e) {
      return e == null;
    }, t.requiredNotNullOrUndefined = function(e, r) {
      if (r === void 0 && (r = function() {
        return "Required value is null or undefined";
      }), this.isNullOrUndefined(e))
        throw new Error(r());
      return e;
    }, t.fromMap = function(e) {
      var r = {};
      return e.forEach(function(n, i) {
        r[i] = n;
      }), r;
    }, t;
  }()
), x = (
  /** @class */
  function() {
    function t() {
    }
    return t.mapNotNullOrUndefined = function(e, r) {
      for (var n = Array(), i = 0, o = e; i < o.length; i++) {
        var a = o[i], s = r(a);
        v.isNotNullOrUndefined(s) && n.push(s);
      }
      return n;
    }, t.mapOrUndefined = function(e, r) {
      for (var n = Array(), i = 0, o = e; i < o.length; i++) {
        var a = o[i], s = r(a);
        if (v.isNullOrUndefined(s))
          return;
        n.push(s);
      }
      return n;
    }, t.associateTo = function(e, r, n) {
      for (var i = 0, o = e; i < o.length; i++) {
        var a = o[i], s = n(a);
        r.set(s[0], s[1]);
      }
      return r;
    }, t.associate = function(e, r) {
      return this.associateTo(e, /* @__PURE__ */ new Map(), r);
    }, t.associateBy = function(e, r) {
      return this.associate(e, function(n) {
        return [r(n), n];
      });
    }, t.chunked = function(e, r) {
      for (var n = [], i = e.slice(); i.length; )
        n.push(i.splice(0, r));
      return n;
    }, t;
  }()
), Me = {
  DISABLE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4
}, O = (
  /** @class */
  function() {
    function t() {
    }
    return t.setLogLevel = function(e) {
      e === void 0 && (e = Me.INFO), this.logLevel = e;
    }, t.initCounter = function(e) {
      this.counters = x.associate(Object.keys(Me), function(r) {
        return [r, e(r)];
      });
    }, t._log = function(e, r) {
      var n;
      switch (e) {
        case "WARN":
          n = "orange";
          break;
        case "ERROR":
          n = "red";
          break;
        default:
          n = "#AAAAAA";
      }
      if (r instanceof Error) {
        Ya.log(e, n, r.message, r);
        return;
      }
      try {
        Ya.log(e, n, r);
      } catch {
      }
    }, t.increment = function(e) {
      var r, n;
      (n = (r = t.counters) === null || r === void 0 ? void 0 : r.get(e)) === null || n === void 0 || n.increment();
    }, t.logLevel = Me.INFO, t.log = {
      error: function(e) {
        t.logLevel >= Me.ERROR && (t._log("ERROR", e), t.increment("ERROR"));
      },
      warn: function(e) {
        t.logLevel >= Me.WARN && (t._log("WARN", e), t.increment("WARN"));
      },
      info: function(e) {
        t.logLevel >= Me.INFO && (t._log("INFO", e), t.increment("INFO"));
      },
      debug: function(e) {
        t.logLevel >= Me.DEBUG && (t._log("DEBUG", e), t.increment("DEBUG"));
      }
    }, t;
  }()
), Ya = (
  /** @class */
  function() {
    function t() {
    }
    return t.log = function(e, r, n, i) {
      try {
        console.log("%c[".concat(e, "] Hackle: ").concat(n), "color: ".concat(r));
      } catch {
      }
    }, t;
  }()
), no = function(t, e) {
  return no = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, no(t, e);
};
function Y(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  no(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var b = function() {
  return b = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, b.apply(this, arguments);
};
function Nv(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(t); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
  return r;
}
function M(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(t, e || [])).next());
  });
}
function _(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = c;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(c);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = e.call(t, r);
      } catch (l) {
        c = [6, l], i = 0;
      } finally {
        n = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function qn(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var Ka = O.log, fe = (
  /** @class */
  function() {
    function t() {
    }
    return t.isEqual = function(e, r) {
      return e.type === r.type && e.value === r.value;
    }, t.isEquals = function(e, r) {
      if (r == null)
        return !1;
      var n = Object.keys(e);
      return n.length !== Object.keys(r).length ? !1 : n.every(function(i) {
        return e[i] === r[i];
      });
    }, t.sanitize = function(e) {
      var r = {};
      if (v.isNullOrUndefined(e))
        return r;
      for (var n = 0, i = Object.entries(e); n < i.length; n++) {
        var o = i[n], a = o[0], s = o[1];
        if (!this.isValidType(a)) {
          Ka.debug("Invalid identifier type. The identifier type must be a string of 128 characters or less. [".concat(a, "]"));
          continue;
        }
        var u = this.sanitizeValue(s);
        if (v.isNullOrUndefined(u)) {
          Ka.debug("Invalid identifier value. The identifier type value be a string of 512 characters or less. [".concat(a, "]"));
          continue;
        }
        r[a] = u;
      }
      return r;
    }, t.isValidType = function(e) {
      return v.isNullOrUndefined(e) ? !1 : typeof e == "string" && e.length > 0 && e.length <= this.MAX_IDENTIFIER_TYPE_LENGTH;
    }, t.sanitizeValue = function(e) {
      return typeof e == "string" && e.length > 0 && e.length <= this.MAX_IDENTIFIER_VALUE_LENGTH ? e : typeof e == "number" ? e.toString() : null;
    }, t.MAX_IDENTIFIER_TYPE_LENGTH = 128, t.MAX_IDENTIFIER_VALUE_LENGTH = 512, t;
  }()
), ei = O.log, de = (
  /** @class */
  function() {
    function t() {
    }
    return t.sanitize = function(e) {
      var r = {};
      if (v.isNullOrUndefined(e))
        return r;
      for (var n = 0, i = Object.entries(e); n < i.length; n++) {
        var o = i[n], a = o[0], s = o[1];
        if (Object.keys(r).length >= this.MAX_PROPERTIES_COUNT) {
          ei.debug("The number of properties cannot exceed 128. Drops excess properties. [".concat(a, ", ").concat(s, "]"));
          break;
        }
        if (!this.isValidKey(a)) {
          ei.debug("Invalid property key. The property key must be a string of 128 characters or less. [".concat(a, "]"));
          continue;
        }
        var u = this.sanitizeValue(a, s);
        if (v.isNullOrUndefined(u)) {
          ei.debug("Invalid property value. The property value mus be 'string(..1024)', 'number', 'boolean', or 'array' type. [".concat(s, "]"));
          continue;
        }
        r[a] = u;
      }
      return r;
    }, t.isValidProperty = function(e, r) {
      return this.isValidKey(e) && this.isValidValue(r);
    }, t.isValidKey = function(e) {
      return v.isNotNullOrUndefined(e) && typeof e == "string" && e.length > 0 && e.length <= this.MAX_PROPERTY_KEY_LENGTH;
    }, t.sanitizeValue = function(e, r) {
      var n = this;
      return typeof e == "string" && e.startsWith(this.SYSTEM_PROPERTY_KEY_PREFIX) ? r : this.isValidValue(r) ? Array.isArray(r) ? r.filter(function(i) {
        return n.isValidElement(i);
      }) : r : null;
    }, t.isValidValue = function(e) {
      return v.isNullOrUndefined(e) ? !1 : typeof e == "string" ? e.length <= this.MAX_PROPERTY_VALUE_LENGTH : typeof e == "number" ? !isNaN(e) && isFinite(e) : typeof e == "boolean" || Array.isArray(e);
    }, t.isValidElement = function(e) {
      return v.isNullOrUndefined(e) ? !1 : typeof e == "string" ? e.length > 0 && e.length <= this.MAX_PROPERTY_VALUE_LENGTH : typeof e == "number";
    }, t.truncateStringValue = function(e) {
      return typeof e == "string" && e.length > this.MAX_PROPERTY_VALUE_LENGTH ? e.slice(0, this.MAX_PROPERTY_VALUE_LENGTH) : e;
    }, t.SYSTEM_PROPERTY_KEY_PREFIX = "$", t.MAX_PROPERTIES_COUNT = 128, t.MAX_PROPERTY_KEY_LENGTH = 128, t.MAX_PROPERTY_VALUE_LENGTH = 1024, t;
  }()
), Ov = ["nanoseconds", "microseconds", "milliseconds", "seconds", "minutes", "hours", "days"], zr = (
  /** @class */
  function() {
    function t() {
    }
    return t.nanosToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e;
        case "microseconds":
          return e / (t.C1 / t.C0);
        case "milliseconds":
          return e / (t.C2 / t.C0);
        case "seconds":
          return e / (t.C3 / t.C0);
        case "minutes":
          return e / (t.C4 / t.C0);
        case "hours":
          return e / (t.C5 / t.C0);
        case "days":
          return e / (t.C6 / t.C0);
      }
    }, t.microsToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C1 / t.C0);
        case "milliseconds":
          return e / (t.C2 / t.C1);
        case "microseconds":
          return e;
        case "seconds":
          return e / (t.C3 / t.C1);
        case "minutes":
          return e / (t.C4 / t.C1);
        case "hours":
          return e / (t.C5 / t.C1);
        case "days":
          return e / (t.C6 / t.C1);
      }
    }, t.millisToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C2 / t.C0);
        case "microseconds":
          return e * (t.C2 / t.C1);
        case "milliseconds":
          return e;
        case "seconds":
          return e / (t.C3 / t.C2);
        case "minutes":
          return e / (t.C4 / t.C2);
        case "hours":
          return e / (t.C5 / t.C2);
        case "days":
          return e / (t.C6 / t.C2);
      }
    }, t.secondsToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C3 / t.C0);
        case "microseconds":
          return e * (t.C3 / t.C1);
        case "milliseconds":
          return e * (t.C3 / t.C2);
        case "seconds":
          return e;
        case "minutes":
          return e / (t.C4 / t.C3);
        case "hours":
          return e / (t.C5 / t.C3);
        case "days":
          return e / (t.C6 / t.C3);
      }
    }, t.minutesToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C4 / t.C0);
        case "microseconds":
          return e * (t.C4 / t.C1);
        case "milliseconds":
          return e * (t.C4 / t.C2);
        case "seconds":
          return e * (t.C4 / t.C3);
        case "minutes":
          return e;
        case "hours":
          return e / (t.C5 / t.C4);
        case "days":
          return e / (t.C6 / t.C4);
      }
    }, t.hoursToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C5 / t.C0);
        case "microseconds":
          return e * (t.C5 / t.C1);
        case "milliseconds":
          return e * (t.C5 / t.C2);
        case "seconds":
          return e * (t.C5 / t.C3);
        case "minutes":
          return e * (t.C5 / t.C4);
        case "hours":
          return e;
        case "days":
          return e / (t.C6 / t.C5);
      }
    }, t.daysToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C6 / t.C0);
        case "microseconds":
          return e * (t.C6 / t.C1);
        case "milliseconds":
          return e * (t.C6 / t.C2);
        case "seconds":
          return e * (t.C6 / t.C3);
        case "minutes":
          return e * (t.C6 / t.C4);
        case "hours":
          return e * (t.C6 / t.C5);
        case "days":
          return e;
      }
    }, t.C0 = 1, t.C1 = t.C0 * 1e3, t.C2 = t.C1 * 1e3, t.C3 = t.C2 * 1e3, t.C4 = t.C3 * 60, t.C5 = t.C4 * 60, t.C6 = t.C5 * 24, t.converter = {
      nanoseconds: t.nanosToUnit,
      microseconds: t.microsToUnit,
      milliseconds: t.millisToUnit,
      seconds: t.secondsToUnit,
      minutes: t.minutesToUnit,
      hours: t.hoursToUnit,
      days: t.daysToUnit
    }, t;
  }()
), be = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.tick = function() {
      return Date.now() * 1e3;
    }, t.prototype.currentMillis = function() {
      return Date.now();
    }, t.instance = new t(), t;
  }()
), ur = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.get = function(e, r) {
      return r;
    }, t;
  }()
), io = (
  /** @class */
  function() {
    function t(e) {
      this.parameters = e;
    }
    return t.prototype.get = function(e, r) {
      var n = this.parameters.get(e);
      return v.isNullOrUndefined(n) ? r : v.isNullOrUndefined(r) || typeof n == typeof r ? n : r;
    }, t;
  }()
), Mv = "https://client-sdk.hackle.io", _v = "https://event.hackle.io", Sv = "https://monitoring.hackle.io", Rv = "https://static.hackle.io", bl = "X-HACKLE-SDK-KEY", Tl = "X-HACKLE-SDK-NAME", wl = "X-HACKLE-SDK-VERSION", Nl = "X-HACKLE-SDK-TIME", xv = "11.37.1", Pv = 3e4, oo = 100, Uv = 1e3 * 60, Dv = 500, Qa = 3e3, Ol = 365 * 10, jo = "_hackle_hid", Ml = "_hackle_id", Lv = "hackle-repository-storage", $v = 1e3 * 60 * 30, qa = "_hackle_session_id", es = "_hackle_last_event_ts", Ot = -1, Jr = 1e3 * 60, kv = -1, ts = "_hackle_uid", rs = "_hackle_did", ns = "_hackle_mkt", Fv = "hackle-manual-override_ab", Gv = "hackle-manual-override_ff", Vv = "hackle-iam-hide", Bv = "hackle-iam-impression", jv = "0.0.8", Hv = "hackle-split-url-redirected", Xv = 3 * (1 / (60 * 60 * 24)), ti = "hackle-workspace-config", Wv = 1e3 * 60, zv = 1e3, _l = 24 * 60 * 60 * 1e3, Ho = O.log;
function Q(t, e) {
  var r = t.find(function(n) {
    return n === e || n.toLowerCase() === e.toLowerCase();
  });
  return r || Ho.debug("Unsupported type [".concat(e, "]. Please use the latest version of sdk.")), r;
}
function is(t, e) {
  if (!v.isNullOrUndefined(e)) {
    for (var r = new Array(), n = 0, i = e; n < i.length; n++) {
      var o = i[n], a = Q(t, o);
      if (v.isNullOrUndefined(a))
        return;
      r.push(a);
    }
    return r;
  }
}
var rr = (
  /** @class */
  function() {
    function t(e, r) {
      this.value = e, this.reason = r;
    }
    return t.of = function(e, r) {
      return new t(e, r);
    }, t;
  }()
), _r = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.inAppMessage = e, this.message = r, this.reason = n, this.properties = i;
    }
    return t.prototype.isShow = function() {
      return v.isNotNullOrUndefined(this.inAppMessage) && v.isNotNullOrUndefined(this.message);
    }, t.of = function(e, r, n, i) {
      return i === void 0 && (i = {}), new t(r, n, e, i);
    }, t;
  }()
), et = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.variation = e, this.reason = r, this.config = n, this.experiment = i;
    }
    return t.of = function(e, r, n, i) {
      return n === void 0 && (n = new ur()), i === void 0 && (i = void 0), new t(e, r, n, i);
    }, t.prototype.get = function(e, r) {
      switch (typeof r) {
        case "string":
          return this.config.get(e, r);
        case "number":
          return this.config.get(e, r);
        case "boolean":
          return this.config.get(e, r);
        default:
          return this.config.get(e, r);
      }
    }, t;
  }()
), je = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.isOn = e, this.reason = r, this.config = n, this.experiment = i;
    }
    return t.on = function(e, r, n) {
      return r === void 0 && (r = new ur()), n === void 0 && (n = void 0), new t(!0, e, r, n);
    }, t.off = function(e, r, n) {
      return r === void 0 && (r = new ur()), n === void 0 && (n = void 0), new t(!1, e, r, n);
    }, t.prototype.get = function(e, r) {
      switch (typeof r) {
        case "string":
          return this.config.get(e, r);
        case "number":
          return this.config.get(e, r);
        case "boolean":
          return this.config.get(e, r);
        default:
          return this.config.get(e, r);
      }
    }, t;
  }()
), Jv = (
  /** @class */
  function() {
    function t(e, r) {
      this.id = e, this.config = r;
    }
    return t.fromJson = function(e) {
      return new t(e.id, new io(x.associate(e.parameters, function(r) {
        return [r.key, r.value];
      })));
    }, t.prototype.get = function(e, r) {
      switch (typeof r) {
        case "string":
          return this.config.get(e, r);
        case "number":
          return this.config.get(e, r);
        case "boolean":
          return this.config.get(e, r);
        default:
          return r;
      }
    }, t;
  }()
), w = (
  /** @class */
  function() {
    function t() {
    }
    return t.SDK_NOT_READY = "SDK_NOT_READY", t.EXCEPTION = "EXCEPTION", t.INVALID_INPUT = "INVALID_INPUT", t.UNSUPPORTED_PLATFORM = "UNSUPPORTED_PLATFORM", t.TYPE_MISMATCH = "TYPE_MISMATCH", t.EXPERIMENT_NOT_FOUND = "EXPERIMENT_NOT_FOUND", t.EXPERIMENT_DRAFT = "EXPERIMENT_DRAFT", t.EXPERIMENT_PAUSED = "EXPERIMENT_PAUSED", t.EXPERIMENT_COMPLETED = "EXPERIMENT_COMPLETED", t.OVERRIDDEN = "OVERRIDDEN", t.TRAFFIC_NOT_ALLOCATED = "TRAFFIC_NOT_ALLOCATED", t.NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT = "NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT", t.IDENTIFIER_NOT_FOUND = "IDENTIFIER_NOT_FOUND", t.VARIATION_DROPPED = "VARIATION_DROPPED", t.TRAFFIC_ALLOCATED = "TRAFFIC_ALLOCATED", t.TRAFFIC_ALLOCATED_BY_TARGETING = "TRAFFIC_ALLOCATED_BY_TARGETING", t.NOT_IN_EXPERIMENT_TARGET = "NOT_IN_EXPERIMENT_TARGET", t.FEATURE_FLAG_NOT_FOUND = "FEATURE_FLAG_NOT_FOUND", t.FEATURE_FLAG_INACTIVE = "FEATURE_FLAG_INACTIVE", t.INDIVIDUAL_TARGET_MATCH = "INDIVIDUAL_TARGET_MATCH", t.TARGET_RULE_MATCH = "TARGET_RULE_MATCH", t.DEFAULT_RULE = "DEFAULT_RULE", t.REMOTE_CONFIG_PARAMETER_NOT_FOUND = "REMOTE_CONFIG_PARAMETER_NOT_FOUND", t.IN_APP_MESSAGE_NOT_FOUND = "IN_APP_MESSAGE_NOT_FOUND", t.IN_APP_MESSAGE_DRAFT = "IN_APP_MESSAGE_DRAFT", t.IN_APP_MESSAGE_PAUSED = "IN_APP_MESSAGE_PAUSED", t.IN_APP_MESSAGE_HIDDEN = "IN_APP_MESSAGE_HIDDEN", t.IN_APP_MESSAGE_TARGET = "IN_APP_MESSAGE_TARGET", t.NOT_IN_IN_APP_MESSAGE_PERIOD = "NOT_IN_IN_APP_MESSAGE_PERIOD", t.NOT_IN_IN_APP_MESSAGE_TARGET = "NOT_IN_IN_APP_MESSAGE_TARGET", t;
  }()
), Zv = ["DEFAULT", "SPLIT_URL", "IN_APP_MESSAGE"], ri = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u, c, l, f, p, d, C, R, S, T) {
      this.id = e, this.key = r, this.type = n, this.identifierType = i, this.status = o, this.version = a, this.executionVersion = s, this.variations = u, this.userOverrides = c, this.segmentOverrides = l, this.targetAudiences = f, this.splitUrlTargets = p, this.targetRules = d, this.defaultRule = C, this.containerId = R, this.implementationType = S, this.winnerVariationId = T;
    }
    return t.fromJson = function(e, r) {
      var n = t.experimentStatusOrNull(r.execution.status), i = r.variations.map(function(p) {
        return new Yv(p.id, p.key, p.status === "DROPPED", p.parameterConfigurationId);
      }), o = x.associate(r.execution.userOverrides, function(p) {
        return [p.userId, p.variationId];
      }), a = x.mapNotNullOrUndefined(r.execution.segmentOverrides, function(p) {
        return os.fromJson(p, Le.IDENTIFIER);
      }), s = x.mapNotNullOrUndefined(r.execution.targetAudiences, function(p) {
        return We.fromJson(p, Le.PROPERTY);
      }), u = Xh.fromJson(r.execution.targetUrls), c = Q(Zv, r.implementationType), l = x.mapNotNullOrUndefined(r.execution.targetRules, function(p) {
        return os.fromJson(p, Le.PROPERTY);
      }), f = Rl.fromJson(r.execution.defaultRule);
      return n && c && f && new t(r.id, r.key, e, r.identifierType, n, r.version, r.execution.version, i, o, a, s, u, l, f, r.containerId, c, r.winnerVariationId);
    }, t.experimentStatusOrNull = function(e) {
      switch (e) {
        case "READY":
          return "DRAFT";
        case "RUNNING":
          return "RUNNING";
        case "PAUSED":
          return "PAUSED";
        case "STOPPED":
          return "COMPLETED";
        default:
          Ho.debug("Unsupported status [".concat(e, "]"));
          return;
      }
    }, t.prototype._winnerVariationOrNull = function() {
      if (this.winnerVariationId)
        return this._getVariationByIdOrNull(this.winnerVariationId);
    }, t.prototype._getVariationByIdOrNull = function(e) {
      return this.variations.find(function(r) {
        return r.id === e;
      });
    }, t.prototype._getVariationByKeyOrNull = function(e) {
      return this.variations.find(function(r) {
        return r.key === e;
      });
    }, t;
  }()
), Yv = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.id = e, this.key = r, this.isDropped = n, this.parameterConfigurationId = i;
    }
    return t;
  }()
), Kv = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.id = e, this.seed = r, this.slotSize = n, this.slots = i;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.seed, e.slotSize, e.slots.map(function(r) {
        var n = r.startInclusive, i = r.endExclusive, o = r.variationId;
        return new Qv(n, i, o);
      }));
    }, t;
  }()
), Qv = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.startInclusive = e, this.endExclusive = r, this.variationId = n;
    }
    return t.prototype.contains = function(e) {
      return this.startInclusive <= e && e < this.endExclusive;
    }, t;
  }()
), Sl = (
  /** @class */
  function() {
    function t(e, r) {
      this.id = e, this.key = r;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.key);
    }, t;
  }()
), Ee = (
  /** @class */
  function() {
    function t() {
    }
    return t.ID = "$id", t.USER = "$userId", t.DEVICE = "$deviceId", t.SESSION = "$sessionId", t.HACKLE_DEVICE = "$hackleDeviceId", t;
  }()
), on = function(t) {
  var e = new Xo();
  return e.addIdentifiers(t.identifiers || {}), e.add(Ee.ID, t.id), e.add(Ee.DEVICE, t.deviceId), v.isNotNullOrUndefined(t.userId) && e.add(Ee.USER, t.userId), e.build();
}, Xo = (
  /** @class */
  function() {
    function t() {
      this.identifiers = {};
    }
    return t.prototype.addIdentifiers = function(e) {
      for (var r in e)
        this.add(r, e[r]);
      return this;
    }, t.prototype.add = function(e, r) {
      var n = fe.sanitizeValue(r);
      return fe.isValidType(e) && n ? this.identifiers[e] = r : Ho.warn("Invalid user identifier [type=".concat(e, ", value=").concat(r, "]")), this;
    }, t.prototype.build = function() {
      return this.identifiers;
    }, t;
  }()
), qv = function(t) {
  return !!(t.id || t.userId || t.deviceId || t.identifiers && Object.keys(t.identifiers).length > 0);
}, Zr = function(t) {
  var e, r, n, i = {};
  return i.id = (e = fe.sanitizeValue(t.id)) !== null && e !== void 0 ? e : void 0, i.userId = (r = fe.sanitizeValue(t.userId)) !== null && r !== void 0 ? r : void 0, i.deviceId = (n = fe.sanitizeValue(t.deviceId)) !== null && n !== void 0 ? n : void 0, typeof t.properties == "object" && (i.properties = de.sanitize(t.properties)), typeof t.identifiers == "object" && (i.identifiers = fe.sanitize(t.identifiers)), qv(i) ? i : null;
}, We = (
  /** @class */
  function() {
    function t(e) {
      this.conditions = e;
    }
    return t.fromJson = function(e, r) {
      var n = x.mapNotNullOrUndefined(e.conditions, function(i) {
        return eh.fromJson(i, r);
      });
      return new t(n);
    }, t.prototype.toJson = function() {
      return {
        conditions: this.conditions.map(function(e) {
          return e.toJson();
        })
      };
    }, t;
  }()
), eh = (
  /** @class */
  function() {
    function t(e, r) {
      this.key = e, this.match = r;
    }
    return t.fromJson = function(e, r) {
      var n = th.fromJson(e.key);
      if (n && r.supports(n.type)) {
        var i = rh.fromJson(e.match);
        return i && new t(n, i);
      }
    }, t.prototype.toJson = function() {
      return {
        key: this.key.toJson(),
        match: this.match.toJson()
      };
    }, t;
  }()
), th = (
  /** @class */
  function() {
    function t(e, r) {
      this.type = e, this.name = r;
    }
    return t.fromJson = function(e) {
      var r = Q(ph, e.type);
      return r && new t(r, e.name);
    }, t.prototype.toJson = function() {
      return {
        type: this.type,
        name: this.name
      };
    }, t;
  }()
), rh = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.type = e, this.operator = r, this.valueType = n, this.values = i;
    }
    return t.fromJson = function(e) {
      var r = Q(ch, e.type), n = Q(lh, e.operator), i = Q(Pl, e.valueType);
      return r && n && i && new t(r, n, i, e.values);
    }, t.prototype.toJson = function() {
      return {
        operator: this.operator,
        type: this.type,
        valueType: this.valueType,
        values: this.values
      };
    }, t;
  }()
), Rl = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.type = e, this.variationId = r, this.bucketId = n;
    }
    return t.fromJson = function(e) {
      var r = Q(fh, e.type);
      return r && new t(r, e.variationId, e.bucketId);
    }, t;
  }()
), os = (
  /** @class */
  function() {
    function t(e, r) {
      this.target = e, this.action = r;
    }
    return t.fromJson = function(e, r) {
      var n = We.fromJson(e.target, r), i = Rl.fromJson(e.action);
      return n && i && new t(n, i);
    }, t;
  }()
), nh = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.id = e, this.key = r, this.type = n, this.targets = i;
    }
    return t.fromJson = function(e) {
      var r = Q(dh, e.type);
      return r && new t(e.id, e.key, r, x.mapNotNullOrUndefined(e.targets, function(n) {
        return We.fromJson(n, Le.SEGMENT);
      }));
    }, t;
  }()
), ih = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.id = e, this.bucketId = r, this.groups = n;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.bucketId, e.groups.map(function(r) {
        return oh.fromJson(r);
      }));
    }, t.prototype.getGroupOrNull = function(e) {
      return this.groups.find(function(r) {
        return r.id === e;
      });
    }, t;
  }()
), oh = (
  /** @class */
  function() {
    function t(e, r) {
      this.id = e, this.experiments = r;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.experiments);
    }, t;
  }()
), ah = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      this.id = e, this.key = r, this.type = n, this.identifierType = i, this.targetRules = o, this.defaultValue = a;
    }
    return t.fromJson = function(e) {
      var r = Q(Pl, e.type), n = x.mapNotNullOrUndefined(e.targetRules, function(o) {
        return sh.fromJson(o, Le.PROPERTY);
      }), i = xl.fromJson(e.defaultValue);
      return r && new t(e.id, e.key, r, e.identifierType, n, i);
    }, t;
  }()
), sh = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.key = e, this.name = r, this.target = n, this.bucketId = i, this.value = o;
    }
    return t.fromJson = function(e, r) {
      var n = We.fromJson(e.target, r);
      return n && new t(e.key, e.name, n, e.bucketId, xl.fromJson(e.value));
    }, t;
  }()
), xl = (
  /** @class */
  function() {
    function t(e, r) {
      this.id = e, this.rawValue = r;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.value);
    }, t;
  }()
);
function nr(t, e) {
  return t - e;
}
var as = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.coreVersion = e, this.prerelease = r, this.build = n;
    }
    return t.tryParse = function(e) {
      var r = t.regExp.exec(e);
      if (r) {
        r[0];
        var n = r[1], i = r[2], o = i === void 0 ? "0" : i, a = r[3], s = a === void 0 ? "0" : a, u = r[4], c = r[5], l = new uh(parseInt(n, 10), parseInt(o, 10), parseInt(s, 10));
        return new t(l, ss.parse(u), ss.parse(c));
      }
    }, t.prototype.compareTo = function(e) {
      return this.coreVersion.compareTo(e.coreVersion) || this.prerelease.compareTo(e.prerelease);
    }, t.prototype.isEqualTo = function(e) {
      return this.compareTo(e) === 0;
    }, t.prototype.isGreaterThan = function(e) {
      return this.compareTo(e) > 0;
    }, t.prototype.isGreaterThanOrEqualTo = function(e) {
      return this.compareTo(e) >= 0;
    }, t.prototype.isLessThan = function(e) {
      return this.compareTo(e) < 0;
    }, t.prototype.isLessThanOrEqualTo = function(e) {
      return this.compareTo(e) <= 0;
    }, t.regExp = /^(0|[1-9]\d*)(?:\.(0|[1-9]\d*))?(?:\.(0|[1-9]\d*))?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/, t;
  }()
), uh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.major = e, this.minor = r, this.patch = n;
    }
    return t.prototype.compareTo = function(e) {
      return nr(this.major, e.major) || nr(this.minor, e.minor) || nr(this.patch, e.patch);
    }, t;
  }()
), ss = (
  /** @class */
  function() {
    function t(e) {
      this.identifiers = e;
    }
    return t.parse = function(e) {
      return e ? new t(e.split(".")) : t.EMPTY;
    }, t.prototype.isEmpty = function() {
      return this.identifiers.length === 0;
    }, t.prototype.isNotEmpty = function() {
      return !this.isEmpty();
    }, t.prototype.compareTo = function(e) {
      return this.isEmpty() && e.isEmpty() ? 0 : this.isEmpty() && e.isNotEmpty() ? 1 : this.isNotEmpty() && e.isEmpty() ? -1 : this.compareIdentifiers(e);
    }, t.prototype.compareIdentifiers = function(e) {
      for (var r = Math.min(this.identifiers.length, e.identifiers.length), n = 0; n < r; n++) {
        var i = t.compareIdentifiers(this.identifiers[n], e.identifiers[n]);
        if (i !== 0)
          return i;
      }
      return nr(this.identifiers.length, e.identifiers.length);
    }, t.compareIdentifiers = function(e, r) {
      return t.numericIdentifierRegExp.test(e) && t.numericIdentifierRegExp.test(r) ? nr(+e, +r) : e === r ? 0 : e < r ? -1 : 1;
    }, t.EMPTY = new t([]), t.numericIdentifierRegExp = /^(0|[1-9]\d*)$/, t;
  }()
), ch = ["MATCH", "NOT_MATCH"], Pl = ["STRING", "NUMBER", "BOOLEAN", "VERSION", "JSON", "URL", "NULL", "UNKNOWN"], lh = ["IN", "CONTAINS", "STARTS_WITH", "ENDS_WITH", "GT", "GTE", "LT", "LTE"], fh = ["VARIATION", "BUCKET"], ph = [
  "USER_ID",
  "USER_PROPERTY",
  "HACKLE_PROPERTY",
  "SEGMENT",
  "AB_TEST",
  "FEATURE_FLAG",
  "EVENT_PROPERTY",
  "COHORT"
], dh = ["USER_ID", "USER_PROPERTY"], Le = (
  /** @class */
  function() {
    function t() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      this.supportedKeyTypes = e;
    }
    return t.prototype.supports = function(e) {
      return this.supportedKeyTypes.includes(e);
    }, t.IDENTIFIER = new t("SEGMENT"), t.PROPERTY = new t("SEGMENT", "USER_PROPERTY", "HACKLE_PROPERTY", "AB_TEST", "FEATURE_FLAG", "EVENT_PROPERTY", "COHORT"), t.SEGMENT = new t("USER_ID", "USER_PROPERTY", "HACKLE_PROPERTY", "COHORT"), t;
  }()
), vh = ["ACTIVE", "DRAFT", "PAUSE"], hh = ["WEB", "ANDROID", "IOS"], gh = ["IMMEDIATE", "CUSTOM"], yh = ["MODAL", "BANNER", "BOTTOM_SHEET", "NONE"], Ih = ["IMAGE_TEXT", "IMAGE_ONLY", "TEXT_ONLY", "IMAGE", "NONE"], Ul = ["VERTICAL", "HORIZONTAL"], mh = ["CLICK"], Ah = [
  "CLOSE",
  "WEB_LINK",
  "HIDDEN",
  "LINK_AND_CLOSE",
  "LINK_NEW_TAB",
  "LINK_NEW_TAB_AND_CLOSE",
  "LINK_NEW_WINDOW",
  "LINK_NEW_WINDOW_AND_CLOSE"
], Eh = ["TOP", "MIDDLE", "BOTTOM"], Ch = ["LEFT", "CENTER", "RIGHT"], bh = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s) {
      this.id = e, this.key = r, this.status = n, this.period = i, this.eventTrigger = o, this.targetContext = a, this.messageContext = s;
    }
    return t.fromJson = function(e) {
      var r = Q(vh, e.status);
      if (!v.isNullOrUndefined(r)) {
        var n;
        switch (Q(gh, e.timeUnit)) {
          case "IMMEDIATE":
            n = new Th();
            break;
          case "CUSTOM":
            if (v.isNullOrUndefined(e.startEpochTimeMillis) || v.isNullOrUndefined(e.endEpochTimeMillis))
              return;
            n = new wh(e.startEpochTimeMillis, e.endEpochTimeMillis);
            break;
          default:
            return;
        }
        var i = Ph.fromJson(e.messageContext);
        if (!v.isNullOrUndefined(i)) {
          var o = e.eventTriggerRules.map(Oh.fromJson), a = Mh.fromJson(e.eventFrequencyCap);
          return new t(e.id, e.key, r, n, new Nh(o, a), Rh.fromJson(e.targetContext), i);
        }
      }
    }, t.prototype.supports = function(e) {
      return this.messageContext.platformTypes.includes(e);
    }, t;
  }()
), Th = (
  /** @class */
  function() {
    function t() {
      this.type = "IMMEDIATE";
    }
    return t.prototype.within = function(e) {
      return !0;
    }, t;
  }()
), wh = (
  /** @class */
  function() {
    function t(e, r) {
      this.startMillisInclusive = e, this.endMillisExclusive = r, this.type = "CUSTOM";
    }
    return t.prototype.within = function(e) {
      return this.startMillisInclusive <= e && e < this.endMillisExclusive;
    }, t;
  }()
), Nh = (
  /** @class */
  function() {
    function t(e, r) {
      this.rules = e, this.frequencyCap = r;
    }
    return t;
  }()
), Oh = (
  /** @class */
  function() {
    function t(e, r) {
      this.eventKey = e, this.targets = r;
    }
    return t.fromJson = function(e) {
      return new t(e.eventKey, x.mapNotNullOrUndefined(e.targets, function(r) {
        return We.fromJson(r, Le.PROPERTY);
      }));
    }, t;
  }()
), Mh = (
  /** @class */
  function() {
    function t(e, r) {
      this.identifierCaps = e, this.durationCap = r;
    }
    return t.fromJson = function(e) {
      if (!e)
        return null;
      var r = e.identifiers.map(_h.fromJson), n = Sh.fromJson(e.duration);
      return new t(r, n);
    }, t;
  }()
), _h = (
  /** @class */
  function() {
    function t(e, r) {
      this.identifierType = e, this.count = r;
    }
    return t.fromJson = function(e) {
      return new t(e.identifierType, e.countPerIdentifier);
    }, t;
  }()
), Sh = (
  /** @class */
  function() {
    function t(e, r) {
      this.durationMillis = e, this.count = r;
    }
    return t.fromJson = function(e) {
      if (!e)
        return null;
      var r = Q(Ov, e.durationUnit.timeUnit);
      return r ? new t(zr.converter[r](e.durationUnit.amount, "milliseconds"), e.countPerDuration) : null;
    }, t;
  }()
), Rh = (
  /** @class */
  function() {
    function t(e, r) {
      this.overrides = e, this.targets = r;
    }
    return t.fromJson = function(e) {
      return new t(e.overrides.map(xh.fromJson), x.mapNotNullOrUndefined(e.targets, function(r) {
        return We.fromJson(r, Le.PROPERTY);
      }));
    }, t;
  }()
), xh = (
  /** @class */
  function() {
    function t(e, r) {
      this.identifierType = e, this.identifiers = r;
    }
    return t.fromJson = function(e) {
      return new t(e.identifierType, e.identifiers);
    }, t;
  }()
), Ph = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.defaultLang = e, this.experimentContext = r, this.platformTypes = n, this.orientations = i, this.messages = o;
    }
    return t.fromJson = function(e) {
      var r = null;
      e.exposure.type === "AB_TEST" && e.exposure.key !== null && (r = new Uh(e.exposure.key));
      var n = is(hh, e.platformTypes);
      if (!v.isNullOrUndefined(n)) {
        var i = is(Ul, e.orientations);
        if (!v.isNullOrUndefined(i)) {
          var o = x.mapOrUndefined(e.messages, Dh.fromJson);
          if (!v.isNullOrUndefined(o))
            return new t(e.defaultLang, r, n, i, o);
        }
      }
    }, t;
  }()
), Uh = (
  /** @class */
  function() {
    function t(e) {
      this.key = e;
    }
    return t;
  }()
), Dh = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u, c, l, f) {
      this.variationKey = e, this.lang = r, this.layout = n, this.images = i, this.text = o, this.buttons = a, this.closeButton = s, this.background = u, this.action = c, this.outerButtons = l, this.innerButtons = f;
    }
    return t.fromJson = function(e) {
      var r = Lh.fromJson(e.layout);
      if (!v.isNullOrUndefined(r)) {
        var n = x.mapOrUndefined(e.images, $h.fromJson);
        if (!v.isNullOrUndefined(n)) {
          var i = x.mapOrUndefined(e.buttons, ao.fromJson);
          if (!v.isNullOrUndefined(i)) {
            var o = void 0;
            if (!(v.isNotNullOrUndefined(e.closeButton) && (o = ao.fromJson2(e.closeButton), v.isNullOrUndefined(o)))) {
              var a = x.mapOrUndefined(e.outerButtons, cs.fromJson), s = x.mapOrUndefined(e.innerButtons, cs.fromJson);
              if (!(v.isNullOrUndefined(a) || v.isNullOrUndefined(s)))
                return new t(e.variationKey, e.lang, r, n, e.text ? kh.fromJson(e.text) : void 0, i, o, new Gh(e.background.color), e.action ? cr.fromJson(e.action) : void 0, a, s);
            }
          }
        }
      }
    }, t.prototype.toJson = function() {
      var e, r, n, i, o, a, s, u;
      return {
        variationKey: this.variationKey,
        lang: this.lang,
        layout: {
          layoutType: this.layout.layoutType,
          alignment: (r = (e = this.layout.alignment) === null || e === void 0 ? void 0 : e.toJson()) !== null && r !== void 0 ? r : null,
          displayType: this.layout.displayType
        },
        images: this.images.map(function(c) {
          return c.toJson();
        }),
        text: (i = (n = this.text) === null || n === void 0 ? void 0 : n.toJson()) !== null && i !== void 0 ? i : null,
        closeButton: (a = (o = this.closeButton) === null || o === void 0 ? void 0 : o.toCloseButtonJson()) !== null && a !== void 0 ? a : null,
        buttons: this.buttons.map(function(c) {
          return c.toJson();
        }),
        background: {
          color: this.background.color
        },
        action: (u = (s = this.action) === null || s === void 0 ? void 0 : s.toJson()) !== null && u !== void 0 ? u : null,
        outerButtons: this.outerButtons.map(function(c) {
          return c.toJson();
        }),
        innerButtons: this.innerButtons.map(function(c) {
          return c.toJson();
        })
      };
    }, t;
  }()
), Lh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.displayType = e, this.layoutType = r, this.alignment = n;
    }
    return t.fromJson = function(e) {
      var r = Q(Ih, e.layoutType), n = Q(yh, e.displayType);
      if (!v.isNullOrUndefined(n) && !v.isNullOrUndefined(r))
        return new t(n, r, e.alignment ? Dl.fromJson(e.alignment) : void 0);
    }, t;
  }()
), Dl = (
  /** @class */
  function() {
    function t(e, r) {
      this.horizontal = e, this.vertical = r;
    }
    return t.fromJson = function(e) {
      var r = Q(Ch, e.horizontal);
      if (!v.isNullOrUndefined(r)) {
        var n = Q(Eh, e.vertical);
        if (!v.isNullOrUndefined(n))
          return new t(r, n);
      }
    }, t.prototype.toJson = function() {
      return { horizontal: this.horizontal, vertical: this.vertical };
    }, t;
  }()
), $h = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.orientation = e, this.imagePath = r, this.action = n;
    }
    return t.fromJson = function(e) {
      var r = Q(Ul, e.orientation);
      if (!v.isNullOrUndefined(r)) {
        var n = void 0;
        if (!(v.isNotNullOrUndefined(e.action) && (n = cr.fromJson(e.action), v.isNullOrUndefined(n))))
          return new t(r, e.imagePath, n);
      }
    }, t.prototype.toJson = function() {
      var e, r;
      return {
        orientation: this.orientation,
        imagePath: this.imagePath,
        action: (r = (e = this.action) === null || e === void 0 ? void 0 : e.toJson()) !== null && r !== void 0 ? r : null
      };
    }, t;
  }()
), kh = (
  /** @class */
  function() {
    function t(e, r) {
      this.title = e, this.body = r;
    }
    return t.fromJson = function(e) {
      return new t(us.fromJson(e.title), us.fromJson(e.body));
    }, t.prototype.toJson = function() {
      return {
        title: {
          text: this.title.text,
          style: {
            textColor: this.title.style.color
          }
        },
        body: {
          text: this.body.text,
          style: {
            textColor: this.body.style.color
          }
        }
      };
    }, t;
  }()
), us = (
  /** @class */
  function() {
    function t(e, r) {
      this.text = e, this.style = r;
    }
    return t.fromJson = function(e) {
      return new t(e.text, new Fh(e.style.textColor));
    }, t;
  }()
), Fh = (
  /** @class */
  function() {
    function t(e) {
      this.color = e;
    }
    return t;
  }()
), ao = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.text = e, this.style = r, this.action = n;
    }
    return t.fromJson = function(e) {
      var r = cr.fromJson(e.action);
      if (!v.isNullOrUndefined(r))
        return new t(e.text, new ls(e.style.textColor, e.style.bgColor, e.style.borderColor), r);
    }, t.fromJson2 = function(e) {
      var r = cr.fromJson(e.action);
      if (!v.isNullOrUndefined(r))
        return new t("✕", new ls(e.style.color, "#FFFFFF", "#FFFFFF"), r);
    }, t.prototype.toJson = function() {
      return {
        text: this.text,
        action: this.action.toJson(),
        style: {
          textColor: this.style.textColor,
          bgColor: this.style.backgroundColor,
          borderColor: this.style.borderColor
        }
      };
    }, t.prototype.toCloseButtonJson = function() {
      return {
        action: this.action.toJson(),
        style: {
          color: this.style.textColor
        }
      };
    }, t;
  }()
), cs = (
  /** @class */
  function() {
    function t(e, r) {
      this.button = e, this.alignment = r;
    }
    return t.fromJson = function(e) {
      var r = ao.fromJson(e.button);
      if (!v.isNullOrUndefined(r)) {
        var n = Dl.fromJson(e.alignment);
        if (!v.isNullOrUndefined(n))
          return new t(r, n);
      }
    }, t.prototype.toJson = function() {
      return { button: this.button.toJson(), alignment: this.alignment.toJson() };
    }, t;
  }()
), ls = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.textColor = e, this.backgroundColor = r, this.borderColor = n;
    }
    return t;
  }()
), Gh = (
  /** @class */
  function() {
    function t(e) {
      this.color = e;
    }
    return t;
  }()
), cr = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.behavior = e, this.type = r, this.value = n;
    }
    return t.fromJson = function(e) {
      var r, n = Q(mh, e.behavior);
      if (!v.isNullOrUndefined(n)) {
        var i = Q(Ah, e.type);
        if (!v.isNullOrUndefined(i))
          return new t(n, i, (r = e.value) !== null && r !== void 0 ? r : void 0);
      }
    }, t.prototype.toJson = function() {
      var e;
      return {
        behavior: this.behavior,
        type: this.type,
        value: (e = this.value) !== null && e !== void 0 ? e : null
      };
    }, t;
  }()
), Vh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.type = e, this.close = r, this.link = n;
    }
    return t.fromJson = function(e) {
      var r = e.type, n = e.value, i = this.linkActionTypes.some(function(c) {
        return c === r;
      }), o = this.closeActionTypes.some(function(c) {
        return c === r;
      }), a = this.tabTargetActionsTypes.some(function(c) {
        return c === r;
      }), s = this.windowTargetActionsTypes.some(function(c) {
        return c === r;
      }), u = r === "HIDDEN";
      return new t(i ? "LINK" : "CLOSE", o ? {
        hideDurationMillis: u ? _l : null
      } : void 0, i ? {
        url: n ?? "",
        target: s ? "NEW_WINDOW" : a ? "NEW_TAB" : "CURRENT",
        shouldCloseAfterLink: o
      } : void 0);
    }, t.fromInteraction = function(e) {
      return e.type === "CLOSE" ? new t(e.type, { hideDurationMillis: null }) : t.fromJson(e.action);
    }, t.fromAction = function(e) {
      return t.fromJson(e.toJson());
    }, t.linkActionTypes = [
      "LINK_AND_CLOSE",
      "LINK_NEW_TAB",
      "LINK_NEW_TAB_AND_CLOSE",
      "LINK_NEW_WINDOW",
      "LINK_NEW_WINDOW_AND_CLOSE",
      "WEB_LINK"
    ], t.closeActionTypes = [
      "CLOSE",
      "HIDDEN",
      "LINK_AND_CLOSE",
      "LINK_NEW_TAB_AND_CLOSE",
      "LINK_NEW_WINDOW_AND_CLOSE"
    ], t.tabTargetActionsTypes = ["LINK_NEW_TAB", "LINK_NEW_TAB_AND_CLOSE"], t.windowTargetActionsTypes = ["LINK_NEW_WINDOW", "LINK_NEW_WINDOW_AND_CLOSE"], t;
  }()
), Bh = (
  /** @class */
  function() {
    function t(e) {
      this.id = e;
    }
    return t;
  }()
), an;
(function(t) {
  t.MANUAL = "MANUAL";
})(an || (an = {}));
var jh = function(t) {
  return Object.values(an).includes(t);
}, Hh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.needRedirect = e, this.redirectType = r, this.redirectUrl = n;
    }
    return t.fromDto = function(e) {
      var r = e.needRedirect, n = jh(e.properties.type) ? e.properties.type : null, i = e.properties.value;
      return new t(r, n, i);
    }, t;
  }()
), Xh = (
  /** @class */
  function() {
    function t(e, r) {
      this.includeTargets = e, this.excludeTargets = r;
    }
    return t.fromJson = function(e) {
      if (e !== null) {
        var r = x.mapNotNullOrUndefined(e.match, function(i) {
          return We.fromJson(i, Le.PROPERTY);
        }), n = x.mapNotNullOrUndefined(e.notMatch, function(i) {
          return We.fromJson(i, Le.PROPERTY);
        });
        return new t(r, n);
      }
    }, t;
  }()
), Wh = (
  /** @class */
  function() {
    function t(e) {
      this.name = e, this._tags = {}, this.name = e;
    }
    return t.prototype.tags = function(e) {
      var r = this;
      return Object.entries(e).forEach(function(n) {
        var i = n[0], o = n[1];
        r._tags[i] = o;
      }), this;
    }, t.prototype.tag = function(e, r) {
      return this._tags[e] = r, this;
    }, t.prototype.register = function(e) {
      return e.registerTimer({ name: this.name, tags: this._tags, type: "TIMER" });
    }, t;
  }()
), at = (
  /** @class */
  function() {
    function t(e) {
      this._clock = e, this.startTime = this._clock.tick();
    }
    return t.start = function(e) {
      return e === void 0 && (e = t.defaultClock), new t(e);
    }, t.prototype.stop = function(e) {
      var r = this._clock.tick(), n = r - this.startTime;
      e.record(n, "microseconds");
    }, t.defaultClock = new be(), t;
  }()
);
function zh(t) {
  return t.id.type === "TIMER";
}
var Jh = (
  /** @class */
  function() {
    function t(e) {
      this.name = e, this._tags = {};
    }
    return t.prototype.tags = function(e) {
      var r = this;
      return Object.entries(e).forEach(function(n) {
        var i = n[0], o = n[1];
        r._tags[i] = o;
      }), this;
    }, t.prototype.tag = function(e, r) {
      return this._tags[e] = r, this;
    }, t.prototype.register = function(e) {
      return e.registerCounter({ name: this.name, tags: this._tags, type: "COUNTER" });
    }, t;
  }()
);
function Zh(t) {
  return t.id.type === "COUNTER";
}
var st = (
  /** @class */
  function() {
    function t(e) {
      this.compareFn = e, this.data = /* @__PURE__ */ new Map(), this.compareFn = e, this.data = /* @__PURE__ */ new Map();
    }
    return t.prototype.values = function() {
      return Array.from(this.data.values());
    }, t.prototype.keys = function() {
      return Array.from(this.data.keys());
    }, t.prototype.get = function(e) {
      var r = this, n = this.keys().find(function(i) {
        return r.compareFn(i, e);
      });
      return n ? this.data.get(n) : void 0;
    }, t.prototype.has = function(e) {
      return this.get(e) !== void 0;
    }, t.prototype.add = function(e, r) {
      var n = r;
      return n || (n = e), this.data.set(e, n), this;
    }, t.prototype.delete = function(e) {
      if (this.has(e)) {
        var r = this.get(e);
        return this.data.delete(e), r;
      }
    }, t.prototype.forEach = function(e) {
      this.data.forEach(e);
    }, t.prototype.filter = function(e) {
      for (var r = new t(this.compareFn), n = 0, i = this.entries(); n < i.length; n++) {
        var o = i[n];
        e(o[0], o[1]) && r.add(o[0], o[1]);
      }
      return r;
    }, t.prototype.entries = function() {
      return Array.from(this.data.entries());
    }, t;
  }()
), K = (
  /** @class */
  function() {
    function t(e, r) {
      this.valueSupplier = r, this.field = e;
    }
    return Object.defineProperty(t.prototype, "value", {
      get: function() {
        return this.valueSupplier();
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
);
function Yh(t, e) {
  return t.name === e.name && fe.isEquals(t.tags, e.tags);
}
var Ll = (
  /** @class */
  function() {
    function t() {
      this.id = Pt(), this.name = "MetricRegistry", this._metrics = new st(Yh);
    }
    return Object.defineProperty(t.prototype, "metrics", {
      get: function() {
        return Array.from(this._metrics.values());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.registerCounter = function(e) {
      return this.registerMetricIfNecessary(e, this.createCounter.bind(this));
    }, t.prototype.registerTimer = function(e) {
      return this.registerMetricIfNecessary(e, this.createTimer.bind(this));
    }, t.prototype.counter = function(e, r) {
      return r === void 0 && (r = {}), new Jh(e).tags(r).register(this);
    }, t.prototype.timer = function(e, r) {
      return r === void 0 && (r = {}), new Wh(e).tags(r).register(this);
    }, t.prototype.registerMetricIfNecessary = function(e, r) {
      return this.getOrCreateMetric(e, r);
    }, t.prototype.getOrCreateMetric = function(e, r) {
      var n, i = this._metrics.get(e);
      return i ? n = i : (n = r(e), this._metrics.add(e, n)), n;
    }, t.prototype.close = function() {
    }, t;
  }()
), Kh = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      var i = t.call(this) || this;
      return i.scheduler = r, i.pushIntervalMillis = n, i.publishingJob = null, i;
    }
    return e.prototype.start = function() {
      var r = this;
      this.publishingJob === null && (this.publishingJob = this.scheduler.schedulePeriodically(this.pushIntervalMillis, this.pushIntervalMillis, function() {
        return r.publish(!1);
      }), O.log.debug("PushMetricRegistry started. Publish metrics every ".concat(this.pushIntervalMillis, "ms.")));
    }, e.prototype.stop = function() {
      var r;
      (r = this.publishingJob) === null || r === void 0 || r.cancel(), this.publishingJob = null, this.publish(!0), O.log.debug("PushMetricRegistry stopped.");
    }, e.prototype.close = function() {
      this.stop();
    }, e;
  }(Ll)
), fs = (
  /** @class */
  function() {
    function t(e) {
      this.counterValue = 0, this.id = e;
    }
    return t.prototype.count = function() {
      return this.counterValue;
    }, t.prototype.increment = function(e) {
      this.counterValue += e ?? 1;
    }, t.prototype.measure = function() {
      return [new K("count", this.count.bind(this))];
    }, t;
  }()
), Qh = (
  /** @class */
  function() {
    function t(e) {
      this.id = e, this.currentCounter = new fs(e);
    }
    return t.prototype.flush = function() {
      var e = this.currentCounter;
      return this.currentCounter = new fs(this.id), e;
    }, t.prototype.count = function() {
      return this.currentCounter.count();
    }, t.prototype.increment = function(e) {
      this.currentCounter.increment(e);
    }, t.prototype.measure = function() {
      return [new K("count", this.count.bind(this))];
    }, t;
  }()
);
function qh(t) {
  return typeof t.flush < "u" && typeof t.flush == "function";
}
var ps = (
  /** @class */
  function() {
    function t(e) {
      this._count = 0, this._total = 0, this._max = 0, this.id = e;
    }
    return t.prototype.count = function() {
      return this._count;
    }, t.prototype.totalTime = function(e) {
      return zr.nanosToUnit(this._total, e);
    }, t.prototype.max = function(e) {
      return zr.nanosToUnit(this._max, e);
    }, t.prototype.mean = function(e) {
      return this.count() === 0 ? 0 : this.totalTime(e) / this.count();
    }, t.prototype.record = function(e, r) {
      if (!(e < 0)) {
        var n = zr.converter[r](e, "nanoseconds");
        this._count = this.count() + 1, this._total += n, this._max = Math.max(n, this._max);
      }
    }, t.prototype.measure = function() {
      var e = this;
      return [
        new K("count", this.count.bind(this)),
        new K("total", function() {
          return e.totalTime("milliseconds");
        }),
        new K("max", function() {
          return e.max("milliseconds");
        }),
        new K("mean", function() {
          return e.mean("milliseconds");
        })
      ];
    }, t;
  }()
), eg = (
  /** @class */
  function() {
    function t(e) {
      this.id = e, this.currentTimer = new ps(e);
    }
    return t.prototype.flush = function() {
      var e = this.currentTimer;
      return this.currentTimer = new ps(this.id), e;
    }, t.prototype.count = function() {
      return this.currentTimer.count();
    }, t.prototype.totalTime = function(e) {
      return this.currentTimer.totalTime(e);
    }, t.prototype.max = function(e) {
      return this.currentTimer.max(e);
    }, t.prototype.record = function(e, r) {
      this.currentTimer.record(e, r);
    }, t.prototype.mean = function(e) {
      return this.count() === 0 ? 0 : this.totalTime(e) / this.count();
    }, t.prototype.measure = function() {
      var e = this;
      return [
        new K("count", this.count.bind(this)),
        new K("total", function() {
          return e.totalTime("milliseconds");
        }),
        new K("max", function() {
          return e.max("milliseconds");
        }),
        new K("mean", function() {
          return e.mean("milliseconds");
        })
      ];
    }, t;
  }()
), tg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return t.call(this, r, n) || this;
    }
    return e.prototype.createCounter = function(r) {
      return new Qh(r);
    }, e.prototype.createTimer = function(r) {
      return new eg(r);
    }, e.prototype.publish = function(r) {
      r === void 0 && (r = !1);
      var n = this.metrics.reduce(function(i, o) {
        return qh(o) ? i.concat(o.flush()) : i;
      }, []);
      this.flushMetrics(n, r);
    }, e;
  }(Kh)
), rg = (
  /** @class */
  function() {
    function t(e) {
      this.id = e;
    }
    return t.prototype.count = function() {
      return 0;
    }, t.prototype.increment = function(e) {
    }, t.prototype.measure = function() {
      return [new K("count", this.count.bind(this))];
    }, t;
  }()
), ng = (
  /** @class */
  function() {
    function t(e) {
      this._counters = new st(function(r, n) {
        return r.id === n.id;
      }), this.id = e, this.noopCounter = new rg(e);
    }
    return Object.defineProperty(t.prototype, "counters", {
      get: function() {
        return Array.from(this._counters.values());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.add = function(e) {
      this._counters.add(e, e.registerCounter(this.id));
    }, t.prototype.count = function() {
      return (this.counters[0] || this.noopCounter).count();
    }, t.prototype.increment = function(e) {
      this.counters.forEach(function(r) {
        r.increment(e);
      });
    }, t.prototype.measure = function() {
      return [new K("count", this.count.bind(this))];
    }, t;
  }()
);
function ig(t) {
  return typeof t.add < "u" && typeof t.add == "function";
}
var og = (
  /** @class */
  function() {
    function t(e) {
      this.id = e;
    }
    return t.prototype.measure = function() {
      var e = this;
      return [
        new K("count", this.count.bind(this)),
        new K("total", function() {
          return e.totalTime("milliseconds");
        }),
        new K("max", function() {
          return e.max("milliseconds");
        }),
        new K("mean", function() {
          return e.mean("milliseconds");
        })
      ];
    }, t.prototype.count = function() {
      return 0;
    }, t.prototype.totalTime = function(e) {
      return 0;
    }, t.prototype.max = function(e) {
      return 0;
    }, t.prototype.mean = function(e) {
      return 0;
    }, t.prototype.record = function(e, r) {
    }, t;
  }()
), ag = (
  /** @class */
  function() {
    function t(e) {
      this._timers = new st(function(r, n) {
        return r.id === n.id;
      }), this.id = e, this.noopTimer = new og(e);
    }
    return Object.defineProperty(t.prototype, "firstTimer", {
      get: function() {
        return this.timers[0] || this.noopTimer;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.totalTime = function(e) {
      return this.firstTimer.totalTime(e);
    }, t.prototype.max = function(e) {
      return this.firstTimer.max(e);
    }, t.prototype.mean = function(e) {
      return this.firstTimer.mean(e);
    }, t.prototype.record = function(e, r) {
      this.timers.forEach(function(n) {
        n.record(e, r);
      });
    }, Object.defineProperty(t.prototype, "timers", {
      get: function() {
        return Array.from(this._timers.values());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.add = function(e) {
      this._timers.add(e, e.registerTimer(this.id));
    }, t.prototype.count = function() {
      return this.firstTimer.count();
    }, t.prototype.measure = function() {
      var e = this;
      return [
        new K("count", this.count.bind(this)),
        new K("total", function() {
          return e.totalTime("milliseconds");
        }),
        new K("max", function() {
          return e.max("milliseconds");
        }),
        new K("mean", function() {
          return e.mean("milliseconds");
        })
      ];
    }, t;
  }()
), sg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.registries = new st(function(n, i) {
        return n.id === i.id;
      }), r;
    }
    return e.prototype.createCounter = function(r) {
      var n = new ng(r);
      return this.addRegistry(n), n;
    }, e.prototype.createTimer = function(r) {
      var n = new ag(r);
      return this.addRegistry(n), n;
    }, e.prototype.addRegistry = function(r) {
      this.registries.forEach(function(n) {
        return r.add(n);
      });
    }, e.prototype.add = function(r) {
      r instanceof e || this.registries.has(r) || (this.registries.add(r), this.metrics.forEach(function(n) {
        ig(n) && n.add(r);
      }));
    }, e.prototype.close = function() {
      this.registries.forEach(function(r) {
        r.close();
      });
    }, e;
  }(Ll)
), Ue = (
  /** @class */
  function() {
    function t() {
    }
    return t.counter = function(e, r) {
      return t.globalRegistry.counter(e, r);
    }, t.timer = function(e, r) {
      return t.globalRegistry.timer(e, r);
    }, t.addRegistry = function(e) {
      t.globalRegistry.add(e), O.log.debug("MetricRegistry added ".concat(e.name));
    }, t.globalRegistry = new sg(), t;
  }()
), Cn = (
  /** @class */
  function() {
    function t() {
    }
    return t.equalsIgnoreCase = function(e, r) {
      return e.toLowerCase() === r.toLowerCase();
    }, t.isNotEmptyString = function(e) {
      return v.isNullOrUndefined(e) || typeof e != "string" ? !1 : e.length > 0;
    }, t;
  }()
), dr = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.url = e, this.method = r, this.body = n, this.headers = i, this.options = o;
    }
    return t.builder = function() {
      return new ds();
    }, t.get = function(e) {
      return t.builder().url(e).build();
    }, t.prototype.toBuilder = function() {
      return new ds(this);
    }, t;
  }()
), ds = (
  /** @class */
  function() {
    function t(e) {
      var r, n, i, o, a, s, u;
      this._url = (r = e == null ? void 0 : e.url) !== null && r !== void 0 ? r : null, this._method = (n = e == null ? void 0 : e.method) !== null && n !== void 0 ? n : "GET", this._body = (i = e == null ? void 0 : e.body) !== null && i !== void 0 ? i : null, this._headers = (a = (o = e == null ? void 0 : e.headers) === null || o === void 0 ? void 0 : o.toBuilder()) !== null && a !== void 0 ? a : _t.builder(), this._timeoutMillis = (u = (s = e == null ? void 0 : e.options) === null || s === void 0 ? void 0 : s.timeoutMillis) !== null && u !== void 0 ? u : null;
    }
    return t.prototype.url = function(e) {
      return this._url = e, this;
    }, t.prototype.method = function(e) {
      return this._method = e, this;
    }, t.prototype.body = function(e) {
      return this._body = e, this;
    }, t.prototype.addHeader = function(e, r) {
      return this._headers.add(e, r), this;
    }, t.prototype.timeoutMillis = function(e) {
      return this._timeoutMillis = e, this;
    }, t.prototype.build = function() {
      if (this._url === null)
        throw new Error("url is null");
      var e = { timeoutMillis: this._timeoutMillis };
      return new dr(this._url, this._method, this._body, this._headers.build(), e);
    }, t;
  }()
), $l = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.statusCode = e, this.body = r, this.headers = n;
    }
    return t.ok = function(e, r) {
      return t.of(200, e, r);
    }, t.of = function(e, r, n) {
      return new t(e, r ?? null, n ?? _t.empty());
    }, t.prototype.isSuccessful = function() {
      return this.statusCode >= 200 && this.statusCode < 300;
    }, t.prototype.isClientError = function() {
      return this.statusCode >= 400 && this.statusCode < 500;
    }, t.prototype.isNotModified = function() {
      return this.statusCode === 304;
    }, t;
  }()
), _t = (
  /** @class */
  function() {
    function t(e) {
      this.headers = e;
    }
    return t.empty = function() {
      return new t(/* @__PURE__ */ new Map());
    }, t.builder = function() {
      return new vs(/* @__PURE__ */ new Map());
    }, t.prototype.get = function(e) {
      for (var r = 0, n = Array.from(this.headers.entries()); r < n.length; r++) {
        var i = n[r], o = i[0], a = i[1];
        if (Cn.equalsIgnoreCase(o, e))
          return a;
      }
      return null;
    }, t.prototype.getOrDefault = function(e, r) {
      var n;
      return (n = this.get(e)) !== null && n !== void 0 ? n : r;
    }, t.prototype.raw = function() {
      return Array.from(this.headers.entries()).reduce(function(e, r) {
        var n = r[0], i = r[1];
        return e[n] = i, e;
      }, {});
    }, t.prototype.toBuilder = function() {
      return new vs(this.headers);
    }, t.IF_MODIFIED_SINCE = "If-Modified-Since", t.LAST_MODIFIED = "Last-Modified", t;
  }()
), vs = (
  /** @class */
  function() {
    function t(e) {
      this.headers = e;
    }
    return t.prototype.add = function(e, r) {
      return this.headers.set(e, r), this;
    }, t.prototype.build = function() {
      return new _t(this.headers);
    }, t;
  }()
), ug = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o, a) {
      var s = t.call(this, o, a) || this;
      return s.url = r, s.transport = n, s.synchronousTransport = i, s.start(), s;
    }
    return e.prototype.flushMetrics = function(r, n) {
      var i = this;
      x.chunked(r.filter(this.isDispatchTarget.bind(this)), oo).forEach(function(o) {
        i.dispatch(o, n);
      });
    }, e.prototype.isDispatchTarget = function(r) {
      return Zh(r) || zh(r) ? r.count() > 0 : !1;
    }, e.prototype.dispatch = function(r, n) {
      var i = this.createRequest(r);
      this.execute(i, n).catch(function(o) {
        return O.log.debug("Failed to flushing metrics: ".concat(o));
      });
    }, e.prototype.createRequest = function(r) {
      return dr.builder().url(this.url).method("POST").body(JSON.stringify(this.batch(r))).addHeader("Content-Type", "application/json").build();
    }, e.prototype.execute = function(r, n) {
      return n ? this.synchronousTransport.send(r) : this.transport.send(r);
    }, e.prototype.batch = function(r) {
      return {
        metrics: r.map(function(n) {
          return {
            name: n.id.name,
            type: n.id.type,
            tags: n.id.tags,
            measurements: v.fromMap(x.associate(n.measure(), function(i) {
              return [i.field, i.value];
            }))
          };
        })
      };
    }, e.prototype.onLifecycleChanged = function(r, n) {
      switch (r) {
        case "hidden":
        case "pagehide":
          return this.publish(!0);
        case "visible":
        case "pageshow":
        case "blur":
        case "locationChange":
        case "focus":
          return;
      }
    }, e;
  }(tg)
), sn = (
  /** @class */
  function() {
    function t() {
    }
    return t.experiment = function(e, r, n) {
      var i = Ue.timer("experiment.decision", {
        key: String(r),
        variation: n.variation,
        reason: String(n.reason)
      });
      e.stop(i);
    }, t.featureFlag = function(e, r, n) {
      var i = Ue.timer("feature.flag.decision", {
        key: String(r),
        on: String(n.isOn),
        reason: String(n.reason)
      });
      e.stop(i);
    }, t.remoteConfig = function(e, r, n) {
      var i = Ue.timer("remote.config.decision", {
        key: String(r),
        reason: String(n.reason)
      });
      e.stop(i);
    }, t.inAppMessage = function(e, r, n) {
      var i = Ue.timer("iam.decision", {
        key: String(r),
        show: String(n.isShow()),
        reason: String(n.reason)
      });
      e.stop(i);
    }, t;
  }()
), St = (
  /** @class */
  function() {
    function t() {
    }
    return t.record = function(e, r, n) {
      var i = Ue.timer("api.call", {
        operation: e,
        success: t.success(n)
      });
      r.stop(i);
    }, t.success = function(e) {
      return e === null ? "false" : String(e.isSuccessful() || e.isNotModified());
    }, t;
  }()
), cg = (
  /** @class */
  function() {
    function t() {
    }
    return t.decide = function(e, r, n, i) {
      if (v.isNullOrUndefined(n))
        return this.decision(e, r, "NULL", n, i);
      switch (typeof n) {
        case "string":
          return this.decision(e, r, "STRING", n, i);
        case "number":
          return this.decision(e, r, "NUMBER", n, i);
        case "boolean":
          return this.decision(e, r, "BOOLEAN", n, i);
        default:
          return this.decision(e, r, "UNKNOWN", n, i);
      }
    }, t.decision = function(e, r, n, i, o) {
      return v.isNullOrUndefined(r) ? rr.of(i, w.INVALID_INPUT) : e.remoteConfig(r, o, n, i);
    }, t;
  }()
), lg = O.log, fg = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.core = e, this.userManager = r, this.user = n;
    }
    return t.prototype.get = function(e, r) {
      var n = at.start(), i;
      try {
        i = this.decide(e, r);
      } catch (o) {
        lg.error("Unexpected exception while deciding remote config parameter[".concat(e, "]. Returning default value. : ").concat(o)), i = rr.of(r, w.EXCEPTION);
      }
      return sn.remoteConfig(n, e, i), i.value;
    }, t.prototype.decide = function(e, r) {
      var n = this.userManager.resolve(this.user);
      return cg.decide(this.core, e, r, n);
    }, t;
  }()
), Dt = (
  /** @class */
  function() {
    function t() {
      this._properties = /* @__PURE__ */ new Map(), this.MAX_PROPERTIES_COUNT = 128, this.MAX_PROPERTY_KEY_LENGTH = 128;
    }
    return t.prototype.contains = function(e) {
      return this._properties.has(e);
    }, t.prototype.remove = function(e) {
      var r = this;
      return e instanceof Map && e.forEach(function(n, i) {
        r.remove(i);
      }), typeof e == "string" && this._properties.delete(e), this;
    }, t.prototype.compute = function(e, r) {
      var n = this._properties.get(e), i = r(n);
      i !== null ? this.add(e, i) : (n !== null || this.contains(e)) && this.remove(e);
    }, t.prototype.add = function(e, r, n) {
      if (n === void 0 && (n = !1), n && this.contains(e))
        return this;
      if (this._properties.size >= this.MAX_PROPERTIES_COUNT)
        return this;
      if (typeof e == "string" && e.length > this.MAX_PROPERTY_KEY_LENGTH)
        return this;
      var i = de.sanitizeValue(e, r);
      return v.isNullOrUndefined(i) ? this : (this._properties.set(e, i), this);
    }, t.prototype.addProperties = function(e, r) {
      var n = this;
      return r === void 0 && (r = !1), e.forEach(function(i, o) {
        n.add(o, i, r);
      }), this;
    }, t.prototype.build = function() {
      return this._properties;
    }, t;
  }()
), j;
(function(t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.UNSET = "$unset", t.INCREMENT = "$increment", t.APPEND = "$append", t.APPEND_ONCE = "$appendOnce", t.PREPEND = "$prepend", t.PREPEND_ONCE = "$prependOnce", t.REMOVE = "$remove", t.CLEAR_ALL = "$clearAll";
})(j || (j = {}));
var pg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      return e.size === 0 ? r : r.size === 0 ? e : new Dt().addProperties(e).addProperties(r).build();
    }, t;
  }()
), dg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      return e.size === 0 ? r : r.size === 0 ? e : new Dt().addProperties(e).addProperties(r, !0).build();
    }, t;
  }()
), vg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      return e.size === 0 ? /* @__PURE__ */ new Map() : r.size === 0 ? e : new Dt().addProperties(e).remove(r).build();
    }, t;
  }()
), hg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      var n = this;
      if (r.size === 0)
        return e;
      var i = new Dt();
      return i.addProperties(e), r.forEach(function(o, a) {
        i.compute(a, function(s) {
          return n.increment(s, o);
        });
      }), i.build();
    }, t.prototype.increment = function(e, r) {
      return typeof r != "number" ? e : typeof e != "number" ? e ?? r : e + r;
    }, t;
  }()
), vr = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      var n = this;
      if (r.size === 0)
        return e;
      var i = new Dt();
      return i.addProperties(e), r.forEach(function(o, a) {
        i.compute(a, function(s) {
          return n.compute(s, o);
        });
      }), i.build();
    }, t.prototype.compute = function(e, r) {
      var n = this.toArray(e), i = this.toArray(r);
      return this.operateArray(n, i);
    }, t.prototype.toArray = function(e) {
      return e == null ? [] : Array.isArray(e) ? e : [e];
    }, t.prototype.contains = function(e, r) {
      return e.includes(r);
    }, t.prototype.prepend = function(e, r, n) {
      return n === void 0 && (n = !1), n && this.contains(r, e) ? r : qn([e], r, !0);
    }, t.prototype.append = function(e, r, n) {
      return n === void 0 && (n = !1), n && this.contains(e, r) ? e : qn(qn([], e, !0), [r], !1);
    }, t;
  }()
), gg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      var i = this;
      return n.reduce(function(o, a) {
        return i.append.bind(i)(o, a);
      }, r);
    }, e;
  }(vr)
), yg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      return n.reduce(this.appendOnce.bind(this), r);
    }, e.prototype.appendOnce = function(r, n) {
      return this.append(r, n, !0);
    }, e;
  }(vr)
), Ig = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      var i = this;
      return n.reduceRight(function(o, a) {
        return i.prepend.bind(i)(a, o);
      }, r);
    }, e;
  }(vr)
), mg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      var i = this;
      return n.reduce(this.appendOnce.bind(this), []).reduceRight(function(o, a) {
        return i.prependOnce.bind(i)(a, o);
      }, r);
    }, e.prototype.appendOnce = function(r, n) {
      return this.append(r, n, !0);
    }, e.prototype.prependOnce = function(r, n) {
      return this.prepend(r, n, !0);
    }, e;
  }(vr)
), Ag = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      return n.reduce(this.remove.bind(this), r);
    }, e.prototype.remove = function(r, n) {
      return r.filter(function(i) {
        return i !== n;
      });
    }, e;
  }(vr)
), Eg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      return /* @__PURE__ */ new Map();
    }, t;
  }()
), Cg = (
  /** @class */
  function() {
    function t() {
    }
    return t.get = function(e) {
      switch (e) {
        case j.SET:
          return new pg();
        case j.SET_ONCE:
          return new dg();
        case j.UNSET:
          return new vg();
        case j.INCREMENT:
          return new hg();
        case j.APPEND:
          return new gg();
        case j.APPEND_ONCE:
          return new yg();
        case j.PREPEND:
          return new Ig();
        case j.PREPEND_ONCE:
          return new mg();
        case j.CLEAR_ALL:
          return new Eg();
        case j.REMOVE:
          return new Ag();
      }
    }, t;
  }()
), ir = (
  /** @class */
  function() {
    function t() {
      this.operations = /* @__PURE__ */ new Map();
    }
    return t.prototype.set = function(e, r) {
      return this.add(j.SET, e, r);
    }, t.prototype.setOnce = function(e, r) {
      return this.add(j.SET_ONCE, e, r);
    }, t.prototype.unset = function(e) {
      return this.add(j.UNSET, e, "-");
    }, t.prototype.increment = function(e, r) {
      return this.add(j.INCREMENT, e, r);
    }, t.prototype.append = function(e, r) {
      return this.add(j.APPEND, e, r);
    }, t.prototype.appendOnce = function(e, r) {
      return this.add(j.APPEND_ONCE, e, r);
    }, t.prototype.prepend = function(e, r) {
      return this.add(j.PREPEND, e, r);
    }, t.prototype.prependOnce = function(e, r) {
      return this.add(j.PREPEND_ONCE, e, r);
    }, t.prototype.remove = function(e, r) {
      return this.add(j.REMOVE, e, r);
    }, t.prototype.clearAll = function() {
      return this.add(j.CLEAR_ALL, "clearAll", "-");
    }, t.prototype.build = function() {
      var e = Array.from(this.operations.entries()).map(function(r) {
        var n = r[0], i = r[1];
        return [n, i.build()];
      });
      return new bg(new Map(e));
    }, t.prototype.containsKey = function(e) {
      return Array.from(this.operations.entries()).some(function(r) {
        r[0];
        var n = r[1];
        return n.contains(e);
      });
    }, t.prototype.add = function(e, r, n) {
      if (this.containsKey(r))
        return this;
      this.operations.has(e) || this.operations.set(e, new Dt());
      var i = this.operations.get(e);
      return i == null || i.add(r, n), this;
    }, t;
  }()
), bg = (
  /** @class */
  function() {
    function t(e) {
      this.operations = e ?? /* @__PURE__ */ new Map();
    }
    return t.prototype.operate = function(e) {
      var r = e;
      return this.operations.forEach(function(n, i) {
        r = Cg.get(i).operate(r, n);
      }), r;
    }, t.prototype.toEvent = function() {
      var e = {
        key: "$properties"
      };
      return this.operations.forEach(function(r, n) {
        var i, o;
        e.properties = b(b({}, e.properties), (i = {}, i[n] = b(b({}, (o = e.properties) === null || o === void 0 ? void 0 : o[n]), de.sanitize(v.fromMap(r))), i));
      }), e;
    }, t.prototype.toRecord = function() {
      var e = {};
      return this.operations.forEach(function(r, n) {
        var i = {};
        r.forEach(function(o, a) {
          i[a] = o;
        }), e[n] = i;
      }), e;
    }, t;
  }()
), Tg = (
  /** @class */
  function() {
    function t() {
    }
    return t.timeout = function(e, r) {
      return new Promise(function(n, i) {
        setTimeout(function() {
          return i(new Error("timeout (".concat(r, "ms)")));
        }, r), e.then(n, i);
      });
    }, t;
  }()
), so = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s) {
      e === void 0 && (e = ""), r === void 0 && (r = ""), n === void 0 && (n = ""), i === void 0 && (i = ""), o === void 0 && (o = ""), a === void 0 && (a = ""), s === void 0 && (s = ""), this.pagePath = e, this.host = r, this.hostname = n, this.url = i, this.referrer = o, this.queryParameter = a, this.protocol = s;
    }
    return t.prototype.isEquals = function(e) {
      return this.url === e.url;
    }, Object.defineProperty(t.prototype, "pageTitle", {
      get: function() {
        return typeof window > "u" || typeof document > "u" ? "" : window.document.title;
      },
      enumerable: !1,
      configurable: !0
    }), t.createWithCurrentPage = function() {
      return typeof window > "u" || typeof document > "u" ? new t() : new t(window.location.pathname, window.location.host, window.location.hostname, window.location.href, window.document.referrer, window.location.search, window.location.protocol);
    }, t.prototype.toProperties = function() {
      return {
        pagePath: this.pagePath,
        pageTitle: this.pageTitle,
        host: this.host,
        url: this.url,
        referrer: this.referrer,
        queryParameter: this.queryParameter,
        protocol: this.protocol.replace(":", "")
      };
    }, t;
  }()
), J = O.log, wg = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u) {
      this.core = e, this.synchronizer = r, this.sessionManager = n, this.userManager = i, this.fetchThrottler = o, this.pageEventTracker = a, this.inAppMessageUi = s, this.devTools = u, this.initialized = !1, this.initialize = this.initialize.bind(this), this.getSessionId = this.getSessionId.bind(this), this.getUser = this.getUser.bind(this), this.setUser = this.setUser.bind(this), this.setUserId = this.setUserId.bind(this), this.setDeviceId = this.setDeviceId.bind(this), this.setUserProperty = this.setUserProperty.bind(this), this.setUserProperties = this.setUserProperties.bind(this), this.updateUserProperties = this.updateUserProperties.bind(this), this.resetUser = this.resetUser.bind(this), this.variation = this.variation.bind(this), this.variationDetail = this.variationDetail.bind(this), this.isFeatureOn = this.isFeatureOn.bind(this), this.featureFlagDetail = this.featureFlagDetail.bind(this), this.track = this.track.bind(this), this.trackPageView = this.trackPageView.bind(this), this.remoteConfig = this.remoteConfig.bind(this), this.onReady = this.onReady.bind(this), this.onInitialized = this.onInitialized.bind(this), this.showUserExplorer = this.showUserExplorer.bind(this), this.hideUserExplorer = this.hideUserExplorer.bind(this), this.fetch = this.fetch.bind(this), this.close = this.close.bind(this), this.setInAppMessageListener = this.setInAppMessageListener.bind(this), this.initialization = this.initialize();
    }
    return t.prototype.initialize = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, 3, 4]), J.debug("HackleClient initializing"), [4, this.synchronizer.sync()];
            case 1:
              return r.sent(), J.debug("HackleClient initialized"), [3, 4];
            case 2:
              throw e = r.sent(), J.error("HackleClient initialize failed: ".concat(e)), e;
            case 3:
              return this.initialized = !0, [
                7
                /*endfinally*/
              ];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getSessionId = function() {
      return this.sessionManager.sessionId;
    }, t.prototype.getUser = function() {
      return this.userManager.currentUser;
    }, t.prototype.setUser = function(e) {
      try {
        var r = Zr(e);
        if (!r)
          return J.warn("invalid user"), Promise.resolve();
        var n = this.userManager.setUser(r);
        return this.userManager.syncIfNeeded(n).catch(function() {
        });
      } catch (i) {
        return J.error("Unexpected exception while set user: ".concat(i)), Promise.resolve();
      }
    }, t.prototype.setUserId = function(e) {
      try {
        var r = void 0;
        if (e === void 0)
          r = this.userManager.setUserId(void 0);
        else {
          var n = fe.sanitizeValue(e);
          if (!n)
            return J.warn("Invalid userId. [userId=".concat(e, "]")), Promise.resolve();
          r = this.userManager.setUserId(n);
        }
        return this.userManager.syncIfNeeded(r).catch(function() {
        });
      } catch (i) {
        return J.error("Unexpected exception while set userId: ".concat(i)), Promise.resolve();
      }
    }, t.prototype.setDeviceId = function(e) {
      try {
        var r = fe.sanitizeValue(e);
        if (!r)
          return J.warn("Invalid deviceId. [deviceId=".concat(e, "]")), Promise.resolve();
        var n = this.userManager.setDeviceId(r);
        return this.userManager.syncIfNeeded(n).catch(function() {
        });
      } catch (i) {
        return J.error("Unexpected exception while set deviceId: ".concat(i)), Promise.resolve();
      }
    }, t.prototype.setUserProperty = function(e, r) {
      var n = new ir().set(e, r).build();
      return this.updateUserProperties(n);
    }, t.prototype.setUserProperties = function(e) {
      try {
        var r = de.sanitize(e), n = new ir();
        return Object.entries(r).forEach(function(i) {
          var o = i[0], a = i[1];
          n.set(o, a);
        }), this.updateUserProperties(n.build());
      } catch (i) {
        return J.error("Unexpected exception while set userProperties: ".concat(i)), Promise.resolve();
      }
    }, t.prototype.updateUserProperties = function(e) {
      try {
        var r = e.toEvent();
        return this.track(r), this.userManager.updateUserProperties(e), this.core.flush(!1), Promise.resolve();
      } catch (n) {
        return J.error("Unexpected exception while update userProperties: ".concat(n)), Promise.resolve();
      }
    }, t.prototype.resetUser = function() {
      try {
        var e = this.userManager.resetUser(), r = new ir().clearAll().build();
        return this.track(r.toEvent()), this.userManager.syncIfNeeded(e).catch(function() {
        });
      } catch (n) {
        return J.error("Unexpected exception while reset user: ".concat(n)), Promise.resolve();
      }
    }, t.prototype.variation = function(e, r, n) {
      return this.variationDetail(e, r, n).variation;
    }, t.prototype.variationDetail = function(e, r, n) {
      var i = n || "A", o = at.start(), a = function(s) {
        try {
          var u = s.userManager.resolve(r);
          return s.core.experiment(e, u, i);
        } catch (c) {
          return J.error("Unexpected exception while deciding variation for experiment[".concat(e, "]. Returning default variation[").concat(i, "] : ").concat(c)), et.of(i, w.EXCEPTION);
        }
      }(this);
      return sn.experiment(o, e, a), a;
    }, t.prototype.isFeatureOn = function(e, r) {
      return this.featureFlagDetail(e, r).isOn;
    }, t.prototype.featureFlagDetail = function(e, r) {
      var n = at.start(), i = function(o) {
        try {
          var a = o.userManager.resolve(r);
          return o.core.featureFlag(e, a);
        } catch (s) {
          return J.error("Unexpected exception while deciding feature flag[".concat(e, "]. Returning default value[false] : ").concat(s)), je.off(w.EXCEPTION);
        }
      }(this);
      return sn.featureFlag(n, e, i), i;
    }, t.prototype.track = function(e, r) {
      try {
        J.debug("track event : ".concat(JSON.stringify(e)));
        var n = this._convertEvent(e), i = this.userManager.resolve(r);
        this.core.track(n, i);
      } catch (o) {
        J.error("Unexpected exception while tracking event: ".concat(o));
      }
    }, t.prototype.trackPageView = function(e) {
      var r = so.createWithCurrentPage();
      this.pageEventTracker.track(r);
    }, t.prototype.remoteConfig = function(e) {
      return new fg(this.core, this.userManager, e);
    }, t.prototype.onReady = function(e, r) {
      r === void 0 && (r = Qa), this.onInitialized({ timeout: r }).finally(function() {
        return e();
      });
    }, t.prototype.onInitialized = function(e) {
      var r;
      return M(this, void 0, void 0, function() {
        var n;
        return _(this, function(i) {
          switch (i.label) {
            case 0:
              if (this.initialized)
                return [2, { success: !0 }];
              i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), [4, Tg.timeout(this.initialization, (r = e == null ? void 0 : e.timeout) !== null && r !== void 0 ? r : Qa)];
            case 2:
              return i.sent(), [2, { success: !0 }];
            case 3:
              return n = i.sent(), J.error("Failed to onInitialized: ".concat(n)), [2, { success: !1 }];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._convertEvent = function(e) {
      return typeof e == "string" ? { key: e } : e;
    }, t.prototype.showUserExplorer = function() {
      var e;
      if (!(!((e = this.devTools) === null || e === void 0) && e.userExplorer)) {
        J.error("UserExplorer is not provided");
        return;
      }
      J.debug("UserExplorer opened."), Ue.counter("user.explorer.show", {}).increment(), this.devTools.manager.userExplorer(this.devTools.userExplorer);
    }, t.prototype.hideUserExplorer = function() {
      if (!this.devTools) {
        J.warn("There is no active HackleDevtools.");
        return;
      }
      this.devTools.manager.close();
    }, t.prototype.fetch = function() {
      var e = this;
      return this.fetchThrottler.execute(function() {
        return e.synchronizer.sync();
      }, function() {
        return Promise.resolve();
      });
    }, t.prototype.setInAppMessageListener = function(e) {
      this.inAppMessageUi.setListener(e);
    }, t.prototype.close = function() {
      J.debug("HackleClient closing"), this.core.close(), this.synchronizer.close();
    }, t;
  }()
), Ng = O.log, Og = (
  /** @class */
  function() {
    function t(e, r) {
      this.invocationProcessor = e, this.user = r;
    }
    return t.prototype.get = function(e, r) {
      var n = typeof r;
      try {
        var i = {
          command: "remoteConfig",
          parameters: {
            defaultValue: r,
            key: e,
            valueType: n,
            user: this.user
          }
        }, o = this.invocationProcessor.process(i);
        if (!o)
          throw new Error("invoke result data not exists");
        switch (n) {
          case "number":
            return Number(o);
          case "boolean":
            return !!o;
          default:
            return o;
        }
      } catch (a) {
        return Ng.error("Unexpected exception while deciding remote config parameter[".concat(e, "]. Returning default value. : ").concat(a)), r;
      }
    }, t;
  }()
), Ce = (
  /** @class */
  function() {
    function t() {
    }
    return t.tryParse = function(e) {
      try {
        return new URL(e);
      } catch {
        return;
      }
    }, t.removePathnameTrailingSlash = function(e) {
      var r = e instanceof URL ? e : t.tryParse(e);
      if (!r)
        return String(e);
      if (r.pathname.endsWith("/")) {
        var n = /\/+$/;
        r.pathname = r.pathname.replace(n, "");
      }
      return r.href;
    }, t.tryDecodeURI = function(e) {
      try {
        return decodeURI(e);
      } catch {
        return;
      }
    }, t.tryDecodeURIComponent = function(e) {
      try {
        return decodeURIComponent(e);
      } catch {
        return;
      }
    }, t.decodeURIOrOriginal = function(e) {
      try {
        return decodeURI(e);
      } catch {
        return e;
      }
    }, t.decodeURIComponentOrOriginal = function(e) {
      try {
        return decodeURIComponent(e);
      } catch {
        return e;
      }
    }, t;
  }()
), hr = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = {
        days: 0,
        isCrossSubdomain: !1,
        isSecure: !1
      }), this.options = e;
    }
    return t.extractDomain = function(e) {
      var r = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, n = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, i = r, o = e.split("."), a = o[o.length - 1];
      (a.length > 4 || a === "com" || a === "org") && (i = n);
      var s = e.match(i);
      return s ? s[0] : "";
    }, t.prototype.getItem = function(e) {
      for (var r, n = e + "=", i = document.cookie.split(";"), o = 0; o < i.length; o++) {
        for (var a = i[o]; a.charAt(0) == " "; )
          a = a.substring(1, a.length);
        if (a.indexOf(n) === 0)
          return (r = Ce.tryDecodeURIComponent(a.substring(n.length, a.length))) !== null && r !== void 0 ? r : null;
      }
      return null;
    }, t.prototype.getAllItem = function(e) {
      var r = document.cookie.split("; ").map(function(i) {
        return i.split("=");
      }), n = e == null ? void 0 : e.keyPrefix;
      return n ? r.filter(function(i) {
        var o = i[0];
        return i[1], o.startsWith(n);
      }) : r;
    }, t.prototype.setItem = function(e, r, n) {
      var i = b(b({}, this.options), n), o = "", a = "", s = "", u = "";
      if (i.isCrossSubdomain) {
        var c = t.extractDomain(document.location.hostname);
        o = c ? "; domain=." + c : "";
      }
      if (i.days) {
        var l = /* @__PURE__ */ new Date();
        l.setTime(l.getTime() + i.days * 24 * 60 * 60 * 1e3), a = "; expires=" + l.toUTCString();
      }
      i.sameSite && (u = "; SameSite=".concat(i.sameSite)), i.isSecure && (s += "; secure");
      var f = e + "=" + encodeURIComponent(r) + a + "; path=/" + o + u + s;
      return document.cookie = f, f;
    }, t.prototype.removeItem = function(e, r) {
      this.setItem(e, "", b(b({}, r), { days: -1 }));
    }, t.prototype.getOptions = function() {
      return this.options;
    }, t.getInstance = function(e) {
      return e === void 0 && (e = { days: Ol, isCrossSubdomain: !0 }), t.storage || (t.storage = new t(e)), t.storage;
    }, t;
  }()
), Mg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.initialize = function() {
      var e = hr.getInstance().getItem(jo);
      e || kl();
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "hidden":
        case "pagehide":
          return _g();
        case "blur":
        case "focus":
        case "locationChange":
        case "visible":
        case "pageshow":
          return;
      }
    }, t;
  }()
);
function Yr() {
  var t = hr.getInstance(), e = t.getItem(Ml);
  if (e)
    return e;
  var r = t.getItem(jo);
  return r || kl();
}
function _g() {
  hr.getInstance().removeItem(Ml);
}
function kl() {
  var t = Pt();
  return hr.getInstance().setItem(jo, t), t;
}
var B = O.log, un;
(function(t) {
  t.native = "native", t.web_view_wrapper = "web_view_wrapper";
})(un || (un = {}));
function Sg(t) {
  return !(!t || !("_hackleApp" in t) || t._hackleApp === null || typeof t._hackleApp != "object" || !("getAppSdkKey" in t._hackleApp) || typeof t._hackleApp.getAppSdkKey != "function" || !("getInvocationType" in t._hackleApp) || typeof t._hackleApp.getInvocationType != "function");
}
var Rg = (
  /** @class */
  function() {
    function t(e) {
      this.invocationProcessor = e, this.getSessionId = this.getSessionId.bind(this), this.getUser = this.getUser.bind(this), this.setUser = this.setUser.bind(this), this.setUserId = this.setUserId.bind(this), this.setDeviceId = this.setDeviceId.bind(this), this.setUserProperty = this.setUserProperty.bind(this), this.setUserProperties = this.setUserProperties.bind(this), this.updateUserProperties = this.updateUserProperties.bind(this), this.resetUser = this.resetUser.bind(this), this.variation = this.variation.bind(this), this.variationDetail = this.variationDetail.bind(this), this.isFeatureOn = this.isFeatureOn.bind(this), this.featureFlagDetail = this.featureFlagDetail.bind(this), this.track = this.track.bind(this), this.trackPageView = this.trackPageView.bind(this), this.remoteConfig = this.remoteConfig.bind(this), this.onReady = this.onReady.bind(this), this.onInitialized = this.onInitialized.bind(this), this.showUserExplorer = this.showUserExplorer.bind(this), this.hideUserExplorer = this.hideUserExplorer.bind(this), this.fetch = this.fetch.bind(this), this.close = this.close.bind(this), this.setInAppMessageListener = this.setInAppMessageListener.bind(this);
    }
    return t.prototype.getSessionId = function() {
      try {
        var e = { command: "getSessionId" }, r = this.invocationProcessor.process(e);
        return r ?? Yr();
      } catch (n) {
        return B.error("Unexpected exception while get sessionId: ".concat(n)), Yr();
      }
    }, t.prototype.getUser = function() {
      var e;
      try {
        var r = { command: "getUser" }, n = this.invocationProcessor.process(r);
        return (e = Zr(n)) !== null && e !== void 0 ? e : this.defaultUser();
      } catch (i) {
        return B.error("Unexpected exception while get user: ".concat(i)), this.defaultUser();
      }
    }, t.prototype.setUser = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          try {
            if (r = Zr(e), !r)
              return B.warn("invalid user"), [
                2
                /*return*/
              ];
            n = { command: "setUser", parameters: { user: r } }, this.invocationProcessor.process(n);
          } catch (o) {
            B.error("Unexpected exception while set user: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.setUserId = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          try {
            if (r = fe.sanitizeValue(e), !r)
              return B.warn("Invalid userId. [userId=".concat(e, "]")), [
                2
                /*return*/
              ];
            n = { command: "setUserId", parameters: { userId: r } }, this.invocationProcessor.process(n);
          } catch (o) {
            B.error("Unexpected exception while set userId: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.setDeviceId = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          try {
            if (r = fe.sanitizeValue(e), !r)
              return B.warn("Invalid deviceId. [deviceId=".concat(e, "]")), [
                2
                /*return*/
              ];
            n = {
              command: "setDeviceId",
              parameters: { deviceId: r }
            }, this.invocationProcessor.process(n);
          } catch (o) {
            B.error("Unexpected exception while set deviceId: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.setUserProperty = function(e, r) {
      return M(this, void 0, void 0, function() {
        var n;
        return _(this, function(i) {
          try {
            n = {
              command: "setUserProperty",
              parameters: { key: e, value: r }
            }, this.invocationProcessor.process(n);
          } catch (o) {
            B.error("Unexpected exception while set userProperty: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.setUserProperties = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          try {
            r = de.sanitize(e), n = new ir(), Object.entries(r).forEach(function(o) {
              var a = o[0], s = o[1];
              n.set(a, s);
            }), this.updateUserProperties(n.build());
          } catch (o) {
            B.error("Unexpected exception while set userProperties: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.updateUserProperties = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          try {
            r = {
              command: "updateUserProperties",
              parameters: { operations: e.toRecord() }
            }, this.invocationProcessor.process(r);
          } catch (i) {
            B.error("Unexpected exception while update userProperties: ".concat(i));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.resetUser = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          try {
            e = { command: "resetUser" }, this.invocationProcessor.process(e);
          } catch (n) {
            B.error("Unexpected exception while reset user: ".concat(n));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.variation = function(e, r, n) {
      n === void 0 && (n = "A");
      try {
        var i = {
          command: "variation",
          parameters: { experimentKey: e, defaultVariation: n, user: this.convertUser(r) }
        }, o = this.invocationProcessor.process(i);
        if (!o)
          throw new Error("invoke result data not exists");
        return o;
      } catch (a) {
        return B.error("Unexpected exception while deciding variation for experiment[".concat(e, "]. Returning default variation[").concat(n, "] : ").concat(a)), n;
      }
    }, t.prototype.variationDetail = function(e, r, n) {
      var i;
      n === void 0 && (n = "A");
      try {
        var o = {
          command: "variationDetail",
          parameters: { experimentKey: e, defaultVariation: n, user: this.convertUser(r) }
        }, a = this.invocationProcessor.process(o);
        if (a === null)
          throw new Error("invoke result data not exists");
        return et.of(a.variation, a.reason, new io(new Map(Object.entries((i = a.config.parameters) !== null && i !== void 0 ? i : {}))));
      } catch (s) {
        return B.error("Unexpected exception while deciding variation for experiment[".concat(e, "]. Returning default variation[").concat(n, "] : ").concat(s)), et.of(n, w.EXCEPTION);
      }
    }, t.prototype.isFeatureOn = function(e, r) {
      try {
        var n = {
          command: "isFeatureOn",
          parameters: { featureKey: e, user: this.convertUser(r) }
        }, i = this.invocationProcessor.process(n);
        if (i === null)
          throw new Error("invoke result data not exists");
        return !!i;
      } catch (o) {
        return B.error("Unexpected exception while deciding feature flag[".concat(e, "]. Returning default value[false] : ").concat(o)), !1;
      }
    }, t.prototype.featureFlagDetail = function(e, r) {
      var n;
      try {
        var i = {
          command: "featureFlagDetail",
          parameters: { featureKey: e, user: this.convertUser(r) }
        }, o = this.invocationProcessor.process(i);
        if (o === null)
          throw new Error("invoke result data not exists");
        return new je(o.isOn, o.reason, new io(new Map(Object.entries((n = o.config.parameters) !== null && n !== void 0 ? n : {}))), void 0);
      } catch (a) {
        return B.error("Unexpected exception while deciding feature flag[".concat(e, "]. Returning default value[false] : ").concat(a)), je.off(w.EXCEPTION);
      }
    }, t.prototype.track = function(e, r) {
      try {
        var n = {
          command: "track",
          parameters: { event: this.convertEvent(e), user: this.convertUser(r) }
        };
        this.invocationProcessor.process(n);
      } catch (i) {
        B.error("Unexpected exception while tracking event: ".concat(i));
      }
    }, t.prototype.trackPageView = function(e) {
      B.info("Web to app integration feature is not support 'trackPageView' method");
    }, t.prototype.remoteConfig = function(e) {
      return new Og(this.invocationProcessor, this.convertUser(e));
    }, t.prototype.onReady = function(e, r) {
      e();
    }, t.prototype.showUserExplorer = function() {
      try {
        var e = { command: "showUserExplorer" };
        this.invocationProcessor.process(e);
      } catch (r) {
        B.error("Unexpected exception while show userExplorer: ".concat(r));
      }
    }, t.prototype.hideUserExplorer = function() {
      B.info("Web to app integration feature is not support 'hideUserExplorer' method");
    }, t.prototype.setInAppMessageListener = function(e) {
      B.info("Web to app integration feature is not support 'setInAppMessageListener' method");
    }, t.prototype.fetch = function() {
      return Promise.resolve();
    }, t.prototype.onInitialized = function(e) {
      return Promise.resolve({ success: !0 });
    }, t.prototype.close = function() {
      B.info("Web to app integration feature is not support 'close' method");
    }, t.prototype.convertEvent = function(e) {
      return typeof e == "string" ? { key: e } : e;
    }, t.prototype.convertUser = function(e) {
      var r;
      if (typeof e == "string")
        return e;
      if (e)
        return (r = Zr(e)) !== null && r !== void 0 ? r : void 0;
    }, t.prototype.defaultUser = function() {
      return {
        deviceId: Yr()
      };
    }, t;
  }()
), xg = (
  /** @class */
  function() {
    function t(e, r) {
      this.browser = e, this.app = r, this.getSessionId = this.getSessionId.bind(this), this.getUser = this.getUser.bind(this), this.setUser = this.setUser.bind(this), this.setUserId = this.setUserId.bind(this), this.setDeviceId = this.setDeviceId.bind(this), this.setUserProperty = this.setUserProperty.bind(this), this.setUserProperties = this.setUserProperties.bind(this), this.updateUserProperties = this.updateUserProperties.bind(this), this.resetUser = this.resetUser.bind(this), this.variation = this.variation.bind(this), this.variationDetail = this.variationDetail.bind(this), this.isFeatureOn = this.isFeatureOn.bind(this), this.featureFlagDetail = this.featureFlagDetail.bind(this), this.track = this.track.bind(this), this.trackPageView = this.trackPageView.bind(this), this.remoteConfig = this.remoteConfig.bind(this), this.onReady = this.onReady.bind(this), this.onInitialized = this.onInitialized.bind(this), this.showUserExplorer = this.showUserExplorer.bind(this), this.hideUserExplorer = this.hideUserExplorer.bind(this), this.fetch = this.fetch.bind(this), this.close = this.close.bind(this), this.setInAppMessageListener = this.setInAppMessageListener.bind(this);
    }
    return t.prototype.getSessionId = function() {
      return this.browser.getSessionId();
    }, t.prototype.getUser = function() {
      return this.browser.getUser();
    }, t.prototype.syncUser = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return e = this.browser.getUser(), [4, this.app.setUser(e)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setUser = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.setUser(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setUserId = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.setUserId(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setDeviceId = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.setDeviceId(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setUserProperty = function(e, r) {
      return M(this, void 0, void 0, function() {
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.browser.setUserProperty(e, r)];
            case 1:
              return n.sent(), [4, this.syncUser()];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setUserProperties = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.setUserProperties(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.updateUserProperties = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.updateUserProperties(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.resetUser = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, this.browser.resetUser()];
            case 1:
              return e.sent(), [4, this.syncUser()];
            case 2:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.variation = function(e, r, n) {
      return n === void 0 && (n = "A"), this.browser.variation(e, r, n);
    }, t.prototype.variationDetail = function(e, r, n) {
      return n === void 0 && (n = "A"), this.browser.variationDetail(e, r, n);
    }, t.prototype.isFeatureOn = function(e, r) {
      return this.browser.isFeatureOn(e, r);
    }, t.prototype.featureFlagDetail = function(e, r) {
      return this.browser.featureFlagDetail(e, r);
    }, t.prototype.track = function(e, r) {
      return this.browser.track(e, r);
    }, t.prototype.trackPageView = function(e) {
      return this.browser.trackPageView(e);
    }, t.prototype.remoteConfig = function(e) {
      return this.browser.remoteConfig(e);
    }, t.prototype.onReady = function(e, r) {
      this.browser.onReady(e, r);
    }, t.prototype.showUserExplorer = function() {
      this.browser.showUserExplorer();
    }, t.prototype.hideUserExplorer = function() {
      this.browser.hideUserExplorer();
    }, t.prototype.fetch = function() {
      return this.browser.fetch();
    }, t.prototype.onInitialized = function(e) {
      return this.browser.onInitialized(e);
    }, t.prototype.close = function() {
      this.browser.close();
    }, t.prototype.setInAppMessageListener = function(e) {
      this.browser.setInAppMessageListener(e);
    }, t;
  }()
), hs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Pg = { exports: {} }, Sr = function(t) {
  return t && t.Math == Math && t;
}, X = (
  // eslint-disable-next-line es-x/no-global-this -- safe
  Sr(typeof globalThis == "object" && globalThis) || Sr(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Sr(typeof self == "object" && self) || Sr(typeof hs == "object" && hs) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
), bn = {}, F = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, Ug = F, ve = !Ug(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), Dg = F, Tn = !Dg(function() {
  var t = function() {
  }.bind();
  return typeof t != "function" || t.hasOwnProperty("prototype");
}), Lg = Tn, Rr = Function.prototype.call, ee = Lg ? Rr.bind(Rr) : function() {
  return Rr.apply(Rr, arguments);
}, Fl = {}, Gl = {}.propertyIsEnumerable, Vl = Object.getOwnPropertyDescriptor, $g = Vl && !Gl.call({ 1: 2 }, 1);
Fl.f = $g ? function(e) {
  var r = Vl(this, e);
  return !!r && r.enumerable;
} : Gl;
var Lt = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, Bl = Tn, jl = Function.prototype, kg = jl.bind, uo = jl.call, Fg = Bl && kg.bind(uo, uo), k = Bl ? function(t) {
  return t && Fg(t);
} : function(t) {
  return t && function() {
    return uo.apply(t, arguments);
  };
}, Hl = k, Gg = Hl({}.toString), Vg = Hl("".slice), $t = function(t) {
  return Vg(Gg(t), 8, -1);
}, Bg = k, jg = F, Hg = $t, ni = Object, Xg = Bg("".split), lt = jg(function() {
  return !ni("z").propertyIsEnumerable(0);
}) ? function(t) {
  return Hg(t) == "String" ? Xg(t, "") : ni(t);
} : ni, Wg = TypeError, Wo = function(t) {
  if (t == null)
    throw Wg("Can't call method on " + t);
  return t;
}, zg = lt, Jg = Wo, he = function(t) {
  return zg(Jg(t));
}, G = function(t) {
  return typeof t == "function";
}, Zg = G, oe = function(t) {
  return typeof t == "object" ? t !== null : Zg(t);
}, ii = X, Yg = G, Kg = function(t) {
  return Yg(t) ? t : void 0;
}, ne = function(t, e) {
  return arguments.length < 2 ? Kg(ii[t]) : ii[t] && ii[t][e];
}, Qg = k, wn = Qg({}.isPrototypeOf), qg = ne, ft = qg("navigator", "userAgent") || "", Xl = X, oi = ft, gs = Xl.process, ys = Xl.Deno, Is = gs && gs.versions || ys && ys.version, ms = Is && Is.v8, Ae, cn;
ms && (Ae = ms.split("."), cn = Ae[0] > 0 && Ae[0] < 4 ? 1 : +(Ae[0] + Ae[1]));
!cn && oi && (Ae = oi.match(/Edge\/(\d+)/), (!Ae || Ae[1] >= 74) && (Ae = oi.match(/Chrome\/(\d+)/), Ae && (cn = +Ae[1])));
var pt = cn, As = pt, ey = F, Wl = !!Object.getOwnPropertySymbols && !ey(function() {
  var t = Symbol();
  return !String(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && As && As < 41;
}), ty = Wl, zl = ty && !Symbol.sham && typeof Symbol.iterator == "symbol", ry = ne, ny = G, iy = wn, oy = zl, ay = Object, Jl = oy ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  var e = ry("Symbol");
  return ny(e) && iy(e.prototype, ay(t));
}, sy = String, gr = function(t) {
  try {
    return sy(t);
  } catch {
    return "Object";
  }
}, uy = G, cy = gr, ly = TypeError, ie = function(t) {
  if (uy(t))
    return t;
  throw ly(cy(t) + " is not a function");
}, fy = ie, dt = function(t, e) {
  var r = t[e];
  return r == null ? void 0 : fy(r);
}, ai = ee, si = G, ui = oe, py = TypeError, dy = function(t, e) {
  var r, n;
  if (e === "string" && si(r = t.toString) && !ui(n = ai(r, t)) || si(r = t.valueOf) && !ui(n = ai(r, t)) || e !== "string" && si(r = t.toString) && !ui(n = ai(r, t)))
    return n;
  throw py("Can't convert object to primitive value");
}, zo = { exports: {} }, Es = X, vy = Object.defineProperty, Jo = function(t, e) {
  try {
    vy(Es, t, { value: e, configurable: !0, writable: !0 });
  } catch {
    Es[t] = e;
  }
  return e;
}, hy = X, gy = Jo, Cs = "__core-js_shared__", yy = hy[Cs] || gy(Cs, {}), Nn = yy, bs = Nn;
(zo.exports = function(t, e) {
  return bs[t] || (bs[t] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.24.1",
  mode: "global",
  copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.24.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Iy = Wo, my = Object, W = function(t) {
  return my(Iy(t));
}, Ay = k, Ey = W, Cy = Ay({}.hasOwnProperty), Te = Object.hasOwn || function(e, r) {
  return Cy(Ey(e), r);
}, by = k, Ty = 0, wy = Math.random(), Ny = by(1 .toString), Zo = function(t) {
  return "Symbol(" + (t === void 0 ? "" : t) + ")_" + Ny(++Ty + wy, 36);
}, Oy = X, My = zo.exports, Ts = Te, _y = Zo, ws = Wl, Zl = zl, It = My("wks"), it = Oy.Symbol, Ns = it && it.for, Sy = Zl ? it : it && it.withoutSetter || _y, z = function(t) {
  if (!Ts(It, t) || !(ws || typeof It[t] == "string")) {
    var e = "Symbol." + t;
    ws && Ts(it, t) ? It[t] = it[t] : Zl && Ns ? It[t] = Ns(e) : It[t] = Sy(e);
  }
  return It[t];
}, Ry = ee, Os = oe, Ms = Jl, xy = dt, Py = dy, Uy = z, Dy = TypeError, Ly = Uy("toPrimitive"), $y = function(t, e) {
  if (!Os(t) || Ms(t))
    return t;
  var r = xy(t, Ly), n;
  if (r) {
    if (e === void 0 && (e = "default"), n = Ry(r, t, e), !Os(n) || Ms(n))
      return n;
    throw Dy("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), Py(t, e);
}, ky = $y, Fy = Jl, On = function(t) {
  var e = ky(t, "string");
  return Fy(e) ? e : e + "";
}, Gy = X, _s = oe, co = Gy.document, Vy = _s(co) && _s(co.createElement), Mn = function(t) {
  return Vy ? co.createElement(t) : {};
}, By = ve, jy = F, Hy = Mn, Yl = !By && !jy(function() {
  return Object.defineProperty(Hy("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), Xy = ve, Wy = ee, zy = Fl, Jy = Lt, Zy = he, Yy = On, Ky = Te, Qy = Yl, Ss = Object.getOwnPropertyDescriptor;
bn.f = Xy ? Ss : function(e, r) {
  if (e = Zy(e), r = Yy(r), Qy)
    try {
      return Ss(e, r);
    } catch {
    }
  if (Ky(e, r))
    return Jy(!Wy(zy.f, e, r), e[r]);
};
var ge = {}, qy = ve, eI = F, Kl = qy && eI(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype != 42;
}), tI = oe, rI = String, nI = TypeError, ae = function(t) {
  if (tI(t))
    return t;
  throw nI(rI(t) + " is not an object");
}, iI = ve, oI = Yl, aI = Kl, xr = ae, Rs = On, sI = TypeError, ci = Object.defineProperty, uI = Object.getOwnPropertyDescriptor, li = "enumerable", fi = "configurable", pi = "writable";
ge.f = iI ? aI ? function(e, r, n) {
  if (xr(e), r = Rs(r), xr(n), typeof e == "function" && r === "prototype" && "value" in n && pi in n && !n[pi]) {
    var i = uI(e, r);
    i && i[pi] && (e[r] = n.value, n = {
      configurable: fi in n ? n[fi] : i[fi],
      enumerable: li in n ? n[li] : i[li],
      writable: !1
    });
  }
  return ci(e, r, n);
} : ci : function(e, r, n) {
  if (xr(e), r = Rs(r), xr(n), oI)
    try {
      return ci(e, r, n);
    } catch {
    }
  if ("get" in n || "set" in n)
    throw sI("Accessors not supported");
  return "value" in n && (e[r] = n.value), e;
};
var cI = ve, lI = ge, fI = Lt, kt = cI ? function(t, e, r) {
  return lI.f(t, e, fI(1, r));
} : function(t, e, r) {
  return t[e] = r, t;
}, Yo = { exports: {} }, lo = ve, pI = Te, Ql = Function.prototype, dI = lo && Object.getOwnPropertyDescriptor, Ko = pI(Ql, "name"), vI = Ko && function() {
}.name === "something", hI = Ko && (!lo || lo && dI(Ql, "name").configurable), ql = {
  EXISTS: Ko,
  PROPER: vI,
  CONFIGURABLE: hI
}, gI = k, yI = G, fo = Nn, II = gI(Function.toString);
yI(fo.inspectSource) || (fo.inspectSource = function(t) {
  return II(t);
});
var _n = fo.inspectSource, mI = X, AI = G, EI = _n, xs = mI.WeakMap, CI = AI(xs) && /native code/.test(EI(xs)), bI = zo.exports, TI = Zo, Ps = bI("keys"), Qo = function(t) {
  return Ps[t] || (Ps[t] = TI(t));
}, Sn = {}, wI = CI, ef = X, di = k, NI = oe, OI = kt, vi = Te, hi = Nn, MI = Qo, _I = Sn, Us = "Object already initialized", po = ef.TypeError, SI = ef.WeakMap, ln, lr, fn, RI = function(t) {
  return fn(t) ? lr(t) : ln(t, {});
}, xI = function(t) {
  return function(e) {
    var r;
    if (!NI(e) || (r = lr(e)).type !== t)
      throw po("Incompatible receiver, " + t + " required");
    return r;
  };
};
if (wI || hi.state) {
  var Je = hi.state || (hi.state = new SI()), PI = di(Je.get), Ds = di(Je.has), UI = di(Je.set);
  ln = function(t, e) {
    if (Ds(Je, t))
      throw new po(Us);
    return e.facade = t, UI(Je, t, e), e;
  }, lr = function(t) {
    return PI(Je, t) || {};
  }, fn = function(t) {
    return Ds(Je, t);
  };
} else {
  var mt = MI("state");
  _I[mt] = !0, ln = function(t, e) {
    if (vi(t, mt))
      throw new po(Us);
    return e.facade = t, OI(t, mt, e), e;
  }, lr = function(t) {
    return vi(t, mt) ? t[mt] : {};
  }, fn = function(t) {
    return vi(t, mt);
  };
}
var Ft = {
  set: ln,
  get: lr,
  has: fn,
  enforce: RI,
  getterFor: xI
}, DI = F, LI = G, Pr = Te, vo = ve, $I = ql.CONFIGURABLE, kI = _n, tf = Ft, FI = tf.enforce, GI = tf.get, Kr = Object.defineProperty, VI = vo && !DI(function() {
  return Kr(function() {
  }, "length", { value: 8 }).length !== 8;
}), BI = String(String).split("String"), jI = Yo.exports = function(t, e, r) {
  String(e).slice(0, 7) === "Symbol(" && (e = "[" + String(e).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (e = "get " + e), r && r.setter && (e = "set " + e), (!Pr(t, "name") || $I && t.name !== e) && (vo ? Kr(t, "name", { value: e, configurable: !0 }) : t.name = e), VI && r && Pr(r, "arity") && t.length !== r.arity && Kr(t, "length", { value: r.arity });
  try {
    r && Pr(r, "constructor") && r.constructor ? vo && Kr(t, "prototype", { writable: !1 }) : t.prototype && (t.prototype = void 0);
  } catch {
  }
  var n = FI(t);
  return Pr(n, "source") || (n.source = BI.join(typeof e == "string" ? e : "")), t;
};
Function.prototype.toString = jI(function() {
  return LI(this) && GI(this).source || kI(this);
}, "toString");
var HI = G, XI = ge, WI = Yo.exports, zI = Jo, Se = function(t, e, r, n) {
  n || (n = {});
  var i = n.enumerable, o = n.name !== void 0 ? n.name : e;
  if (HI(r) && WI(r, o, n), n.global)
    i ? t[e] = r : zI(e, r);
  else {
    try {
      n.unsafe ? t[e] && (i = !0) : delete t[e];
    } catch {
    }
    i ? t[e] = r : XI.f(t, e, {
      value: r,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return t;
}, Rn = {}, JI = Math.ceil, ZI = Math.floor, YI = Math.trunc || function(e) {
  var r = +e;
  return (r > 0 ? ZI : JI)(r);
}, KI = YI, Fe = function(t) {
  var e = +t;
  return e !== e || e === 0 ? 0 : KI(e);
}, QI = Fe, qI = Math.max, em = Math.min, vt = function(t, e) {
  var r = QI(t);
  return r < 0 ? qI(r + e, 0) : em(r, e);
}, tm = Fe, rm = Math.min, nm = function(t) {
  return t > 0 ? rm(tm(t), 9007199254740991) : 0;
}, im = nm, L = function(t) {
  return im(t.length);
}, om = he, am = vt, sm = L, Ls = function(t) {
  return function(e, r, n) {
    var i = om(e), o = sm(i), a = am(n, o), s;
    if (t && r != r) {
      for (; o > a; )
        if (s = i[a++], s != s)
          return !0;
    } else
      for (; o > a; a++)
        if ((t || a in i) && i[a] === r)
          return t || a || 0;
    return !t && -1;
  };
}, qo = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Ls(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Ls(!1)
}, um = k, gi = Te, cm = he, lm = qo.indexOf, fm = Sn, $s = um([].push), rf = function(t, e) {
  var r = cm(t), n = 0, i = [], o;
  for (o in r)
    !gi(fm, o) && gi(r, o) && $s(i, o);
  for (; e.length > n; )
    gi(r, o = e[n++]) && (~lm(i, o) || $s(i, o));
  return i;
}, ea = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], pm = rf, dm = ea, vm = dm.concat("length", "prototype");
Rn.f = Object.getOwnPropertyNames || function(e) {
  return pm(e, vm);
};
var nf = {};
nf.f = Object.getOwnPropertySymbols;
var hm = ne, gm = k, ym = Rn, Im = nf, mm = ae, Am = gm([].concat), Em = hm("Reflect", "ownKeys") || function(e) {
  var r = ym.f(mm(e)), n = Im.f;
  return n ? Am(r, n(e)) : r;
}, ks = Te, Cm = Em, bm = bn, Tm = ge, of = function(t, e, r) {
  for (var n = Cm(e), i = Tm.f, o = bm.f, a = 0; a < n.length; a++) {
    var s = n[a];
    !ks(t, s) && !(r && ks(r, s)) && i(t, s, o(e, s));
  }
}, wm = F, Nm = G, Om = /#|\.prototype\./, yr = function(t, e) {
  var r = _m[Mm(t)];
  return r == Rm ? !0 : r == Sm ? !1 : Nm(e) ? wm(e) : !!e;
}, Mm = yr.normalize = function(t) {
  return String(t).replace(Om, ".").toLowerCase();
}, _m = yr.data = {}, Sm = yr.NATIVE = "N", Rm = yr.POLYFILL = "P", ta = yr, yi = X, xm = bn.f, Pm = kt, Um = Se, Dm = Jo, Lm = of, $m = ta, E = function(t, e) {
  var r = t.target, n = t.global, i = t.stat, o, a, s, u, c, l;
  if (n ? a = yi : i ? a = yi[r] || Dm(r, {}) : a = (yi[r] || {}).prototype, a)
    for (s in e) {
      if (c = e[s], t.dontCallGetSet ? (l = xm(a, s), u = l && l.value) : u = a[s], o = $m(n ? s : r + (i ? "." : "#") + s, t.forced), !o && u !== void 0) {
        if (typeof c == typeof u)
          continue;
        Lm(c, u);
      }
      (t.sham || u && u.sham) && Pm(c, "sham", !0), Um(a, s, c, t);
    }
}, km = F, Fm = !km(function() {
  function t() {
  }
  return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
}), Gm = Te, Vm = G, Bm = W, jm = Qo, Hm = Fm, Fs = jm("IE_PROTO"), ho = Object, Xm = ho.prototype, xn = Hm ? ho.getPrototypeOf : function(t) {
  var e = Bm(t);
  if (Gm(e, Fs))
    return e[Fs];
  var r = e.constructor;
  return Vm(r) && e instanceof r ? r.prototype : e instanceof ho ? Xm : null;
}, Wm = G, zm = String, Jm = TypeError, Zm = function(t) {
  if (typeof t == "object" || Wm(t))
    return t;
  throw Jm("Can't set " + zm(t) + " as a prototype");
}, Ym = k, Km = ae, Qm = Zm, Pn = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var t = !1, e = {}, r;
  try {
    r = Ym(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set), r(e, []), t = e instanceof Array;
  } catch {
  }
  return function(i, o) {
    return Km(i), Qm(o), t ? r(i, o) : i.__proto__ = o, i;
  };
}() : void 0), af = {}, qm = rf, eA = ea, tA = Object.keys || function(e) {
  return qm(e, eA);
}, rA = ve, nA = Kl, iA = ge, oA = ae, aA = he, sA = tA;
af.f = rA && !nA ? Object.defineProperties : function(e, r) {
  oA(e);
  for (var n = aA(r), i = sA(r), o = i.length, a = 0, s; o > a; )
    iA.f(e, s = i[a++], n[s]);
  return e;
};
var uA = ne, sf = uA("document", "documentElement"), cA = ae, lA = af, Gs = ea, fA = Sn, pA = sf, dA = Mn, vA = Qo, Vs = ">", Bs = "<", go = "prototype", yo = "script", uf = vA("IE_PROTO"), Ii = function() {
}, cf = function(t) {
  return Bs + yo + Vs + t + Bs + "/" + yo + Vs;
}, js = function(t) {
  t.write(cf("")), t.close();
  var e = t.parentWindow.Object;
  return t = null, e;
}, hA = function() {
  var t = dA("iframe"), e = "java" + yo + ":", r;
  return t.style.display = "none", pA.appendChild(t), t.src = String(e), r = t.contentWindow.document, r.open(), r.write(cf("document.F=Object")), r.close(), r.F;
}, Ur, Qr = function() {
  try {
    Ur = new ActiveXObject("htmlfile");
  } catch {
  }
  Qr = typeof document < "u" ? document.domain && Ur ? js(Ur) : hA() : js(Ur);
  for (var t = Gs.length; t--; )
    delete Qr[go][Gs[t]];
  return Qr();
};
fA[uf] = !0;
var Gt = Object.create || function(e, r) {
  var n;
  return e !== null ? (Ii[go] = cA(e), n = new Ii(), Ii[go] = null, n[uf] = e) : n = Qr(), r === void 0 ? n : lA.f(n, r);
}, gA = k, lf = Error, yA = gA("".replace), IA = function(t) {
  return String(lf(t).stack);
}("zxcasd"), ff = /\n\s*at [^:]*:[^\n]*/, mA = ff.test(IA), AA = function(t, e) {
  if (mA && typeof t == "string" && !lf.prepareStackTrace)
    for (; e--; )
      t = yA(t, ff, "");
  return t;
}, EA = oe, CA = kt, bA = function(t, e) {
  EA(e) && "cause" in e && CA(t, "cause", e.cause);
}, Hs = k, TA = ie, wA = Tn, NA = Hs(Hs.bind), we = function(t, e) {
  return TA(t), e === void 0 ? t : wA ? NA(t, e) : function() {
    return t.apply(e, arguments);
  };
}, Ir = {}, OA = z, MA = Ir, _A = OA("iterator"), SA = Array.prototype, pf = function(t) {
  return t !== void 0 && (MA.Array === t || SA[_A] === t);
}, RA = z, xA = RA("toStringTag"), df = {};
df[xA] = "z";
var ra = String(df) === "[object z]", PA = ra, UA = G, qr = $t, DA = z, LA = DA("toStringTag"), $A = Object, kA = qr(function() {
  return arguments;
}()) == "Arguments", FA = function(t, e) {
  try {
    return t[e];
  } catch {
  }
}, Un = PA ? qr : function(t) {
  var e, r, n;
  return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (r = FA(e = $A(t), LA)) == "string" ? r : kA ? qr(e) : (n = qr(e)) == "Object" && UA(e.callee) ? "Arguments" : n;
}, GA = Un, Xs = dt, VA = Ir, BA = z, jA = BA("iterator"), Dn = function(t) {
  if (t != null)
    return Xs(t, jA) || Xs(t, "@@iterator") || VA[GA(t)];
}, HA = ee, XA = ie, WA = ae, zA = gr, JA = Dn, ZA = TypeError, Ln = function(t, e) {
  var r = arguments.length < 2 ? JA(t) : e;
  if (XA(r))
    return WA(HA(r, t));
  throw ZA(zA(t) + " is not iterable");
}, YA = ee, Ws = ae, KA = dt, vf = function(t, e, r) {
  var n, i;
  Ws(t);
  try {
    if (n = KA(t, "return"), !n) {
      if (e === "throw")
        throw r;
      return r;
    }
    n = YA(n, t);
  } catch (o) {
    i = !0, n = o;
  }
  if (e === "throw")
    throw r;
  if (i)
    throw n;
  return Ws(n), r;
}, QA = we, qA = ee, eE = ae, tE = gr, rE = pf, nE = L, zs = wn, iE = Ln, oE = Dn, Js = vf, aE = TypeError, en = function(t, e) {
  this.stopped = t, this.result = e;
}, Zs = en.prototype, ht = function(t, e, r) {
  var n = r && r.that, i = !!(r && r.AS_ENTRIES), o = !!(r && r.IS_RECORD), a = !!(r && r.IS_ITERATOR), s = !!(r && r.INTERRUPTED), u = QA(e, n), c, l, f, p, d, C, R, S = function(N) {
    return c && Js(c, "normal", N), new en(!0, N);
  }, T = function(N) {
    return i ? (eE(N), s ? u(N[0], N[1], S) : u(N[0], N[1])) : s ? u(N, S) : u(N);
  };
  if (o)
    c = t.iterator;
  else if (a)
    c = t;
  else {
    if (l = oE(t), !l)
      throw aE(tE(t) + " is not iterable");
    if (rE(l)) {
      for (f = 0, p = nE(t); p > f; f++)
        if (d = T(t[f]), d && zs(Zs, d))
          return d;
      return new en(!1);
    }
    c = iE(t, l);
  }
  for (C = o ? t.next : c.next; !(R = qA(C, c)).done; ) {
    try {
      d = T(R.value);
    } catch (N) {
      Js(c, "throw", N);
    }
    if (typeof d == "object" && d && zs(Zs, d))
      return d;
  }
  return new en(!1);
}, sE = Un, uE = String, $n = function(t) {
  if (sE(t) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return uE(t);
}, cE = $n, lE = function(t, e) {
  return t === void 0 ? arguments.length < 2 ? "" : e : cE(t);
}, fE = F, pE = Lt, dE = !fE(function() {
  var t = Error("a");
  return "stack" in t ? (Object.defineProperty(t, "stack", pE(1, 7)), t.stack !== 7) : !0;
}), vE = E, hE = wn, gE = xn, pn = Pn, yE = of, hf = Gt, Dr = kt, mi = Lt, IE = AA, mE = bA, AE = ht, EE = lE, CE = z, bE = dE, TE = CE("toStringTag"), dn = Error, wE = [].push, fr = function(e, r) {
  var n = arguments.length > 2 ? arguments[2] : void 0, i = hE(Ai, this), o;
  pn ? o = pn(new dn(), i ? gE(this) : Ai) : (o = i ? this : hf(Ai), Dr(o, TE, "Error")), r !== void 0 && Dr(o, "message", EE(r)), bE && Dr(o, "stack", IE(o.stack, 1)), mE(o, n);
  var a = [];
  return AE(e, wE, { that: a }), Dr(o, "errors", a), o;
};
pn ? pn(fr, dn) : yE(fr, dn, { name: !0 });
var Ai = fr.prototype = hf(dn.prototype, {
  constructor: mi(1, fr),
  message: mi(1, ""),
  name: mi(1, "AggregateError")
});
vE({ global: !0, constructor: !0, arity: 2 }, {
  AggregateError: fr
});
var NE = z, OE = Gt, ME = ge.f, Io = NE("unscopables"), mo = Array.prototype;
mo[Io] == null && ME(mo, Io, {
  configurable: !0,
  value: OE(null)
});
var V = function(t) {
  mo[Io][t] = !0;
}, _E = F, SE = G, Ys = xn, RE = Se, xE = z, Ao = xE("iterator"), gf = !1, ut, Ei, Ci;
[].keys && (Ci = [].keys(), "next" in Ci ? (Ei = Ys(Ys(Ci)), Ei !== Object.prototype && (ut = Ei)) : gf = !0);
var PE = ut == null || _E(function() {
  var t = {};
  return ut[Ao].call(t) !== t;
});
PE && (ut = {});
SE(ut[Ao]) || RE(ut, Ao, function() {
  return this;
});
var yf = {
  IteratorPrototype: ut,
  BUGGY_SAFARI_ITERATORS: gf
}, UE = ge.f, DE = Te, LE = z, Ks = LE("toStringTag"), kn = function(t, e, r) {
  t && !r && (t = t.prototype), t && !DE(t, Ks) && UE(t, Ks, { configurable: !0, value: e });
}, $E = yf.IteratorPrototype, kE = Gt, FE = Lt, GE = kn, VE = Ir, BE = function() {
  return this;
}, jE = function(t, e, r, n) {
  var i = e + " Iterator";
  return t.prototype = kE($E, { next: FE(+!n, r) }), GE(t, i, !1), VE[i] = BE, t;
}, HE = E, XE = ee, If = ql, WE = G, zE = jE, Qs = xn, qs = Pn, JE = kn, ZE = kt, bi = Se, YE = z, KE = Ir, mf = yf, QE = If.PROPER, qE = If.CONFIGURABLE, eu = mf.IteratorPrototype, Lr = mf.BUGGY_SAFARI_ITERATORS, Wt = YE("iterator"), tu = "keys", zt = "values", ru = "entries", eC = function() {
  return this;
}, na = function(t, e, r, n, i, o, a) {
  zE(r, e, n);
  var s = function(T) {
    if (T === i && p)
      return p;
    if (!Lr && T in l)
      return l[T];
    switch (T) {
      case tu:
        return function() {
          return new r(this, T);
        };
      case zt:
        return function() {
          return new r(this, T);
        };
      case ru:
        return function() {
          return new r(this, T);
        };
    }
    return function() {
      return new r(this);
    };
  }, u = e + " Iterator", c = !1, l = t.prototype, f = l[Wt] || l["@@iterator"] || i && l[i], p = !Lr && f || s(i), d = e == "Array" && l.entries || f, C, R, S;
  if (d && (C = Qs(d.call(new t())), C !== Object.prototype && C.next && (Qs(C) !== eu && (qs ? qs(C, eu) : WE(C[Wt]) || bi(C, Wt, eC)), JE(C, u, !0))), QE && i == zt && f && f.name !== zt && (qE ? ZE(l, "name", zt) : (c = !0, p = function() {
    return XE(f, this);
  })), i)
    if (R = {
      values: s(zt),
      keys: o ? p : s(tu),
      entries: s(ru)
    }, a)
      for (S in R)
        (Lr || c || !(S in l)) && bi(l, S, R[S]);
    else
      HE({ target: e, proto: !0, forced: Lr || c }, R);
  return l[Wt] !== p && bi(l, Wt, p, { name: i }), KE[e] = p, R;
}, tC = he, ia = V, nu = Ir, Af = Ft, rC = ge.f, nC = na, iC = ve, Ef = "Array Iterator", oC = Af.set, aC = Af.getterFor(Ef), sC = nC(Array, "Array", function(t, e) {
  oC(this, {
    type: Ef,
    target: tC(t),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var t = aC(this), e = t.target, r = t.kind, n = t.index++;
  return !e || n >= e.length ? (t.target = void 0, { value: void 0, done: !0 }) : r == "keys" ? { value: n, done: !1 } : r == "values" ? { value: e[n], done: !1 } : { value: [n, e[n]], done: !1 };
}, "values"), iu = nu.Arguments = nu.Array;
ia("keys");
ia("values");
ia("entries");
if (iC && iu.name !== "values")
  try {
    rC(iu, "name", { value: "values" });
  } catch {
  }
var uC = ra, cC = Un, lC = uC ? {}.toString : function() {
  return "[object " + cC(this) + "]";
}, fC = ra, pC = Se, dC = lC;
fC || pC(Object.prototype, "toString", dC, { unsafe: !0 });
var vC = $t, hC = X, Vt = vC(hC.process) == "process", gC = ne, yC = ge, IC = z, mC = ve, ou = IC("species"), oa = function(t) {
  var e = gC(t), r = yC.f;
  mC && e && !e[ou] && r(e, ou, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, AC = wn, EC = TypeError, aa = function(t, e) {
  if (AC(e, t))
    return t;
  throw EC("Incorrect invocation");
}, CC = k, bC = F, Cf = G, TC = Un, wC = ne, NC = _n, bf = function() {
}, OC = [], Tf = wC("Reflect", "construct"), sa = /^\s*(?:class|function)\b/, MC = CC(sa.exec), _C = !sa.exec(bf), Jt = function(e) {
  if (!Cf(e))
    return !1;
  try {
    return Tf(bf, OC, e), !0;
  } catch {
    return !1;
  }
}, wf = function(e) {
  if (!Cf(e))
    return !1;
  switch (TC(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return _C || !!MC(sa, NC(e));
  } catch {
    return !0;
  }
};
wf.sham = !0;
var Bt = !Tf || bC(function() {
  var t;
  return Jt(Jt.call) || !Jt(Object) || !Jt(function() {
    t = !0;
  }) || t;
}) ? wf : Jt, SC = Bt, RC = gr, xC = TypeError, PC = function(t) {
  if (SC(t))
    return t;
  throw xC(RC(t) + " is not a constructor");
}, au = ae, UC = PC, DC = z, LC = DC("species"), Nf = function(t, e) {
  var r = au(t).constructor, n;
  return r === void 0 || (n = au(r)[LC]) == null ? e : UC(n);
}, $C = Tn, Of = Function.prototype, su = Of.apply, uu = Of.call, Mf = typeof Reflect == "object" && Reflect.apply || ($C ? uu.bind(su) : function() {
  return uu.apply(su, arguments);
}), kC = k, _f = kC([].slice), FC = TypeError, GC = function(t, e) {
  if (t < e)
    throw FC("Not enough arguments");
  return t;
}, VC = ft, Sf = /(?:ipad|iphone|ipod).*applewebkit/i.test(VC), pe = X, BC = Mf, jC = we, cu = G, HC = Te, XC = F, lu = sf, WC = _f, fu = Mn, zC = GC, JC = Sf, ZC = Vt, Eo = pe.setImmediate, Co = pe.clearImmediate, YC = pe.process, Ti = pe.Dispatch, KC = pe.Function, pu = pe.MessageChannel, QC = pe.String, wi = 0, or = {}, du = "onreadystatechange", pr, Ze, Ni, Oi;
try {
  pr = pe.location;
} catch {
}
var ua = function(t) {
  if (HC(or, t)) {
    var e = or[t];
    delete or[t], e();
  }
}, Mi = function(t) {
  return function() {
    ua(t);
  };
}, vu = function(t) {
  ua(t.data);
}, hu = function(t) {
  pe.postMessage(QC(t), pr.protocol + "//" + pr.host);
};
(!Eo || !Co) && (Eo = function(e) {
  zC(arguments.length, 1);
  var r = cu(e) ? e : KC(e), n = WC(arguments, 1);
  return or[++wi] = function() {
    BC(r, void 0, n);
  }, Ze(wi), wi;
}, Co = function(e) {
  delete or[e];
}, ZC ? Ze = function(t) {
  YC.nextTick(Mi(t));
} : Ti && Ti.now ? Ze = function(t) {
  Ti.now(Mi(t));
} : pu && !JC ? (Ni = new pu(), Oi = Ni.port2, Ni.port1.onmessage = vu, Ze = jC(Oi.postMessage, Oi)) : pe.addEventListener && cu(pe.postMessage) && !pe.importScripts && pr && pr.protocol !== "file:" && !XC(hu) ? (Ze = hu, pe.addEventListener("message", vu, !1)) : du in fu("script") ? Ze = function(t) {
  lu.appendChild(fu("script"))[du] = function() {
    lu.removeChild(this), ua(t);
  };
} : Ze = function(t) {
  setTimeout(Mi(t), 0);
});
var Rf = {
  set: Eo,
  clear: Co
}, qC = ft, eb = X, tb = /ipad|iphone|ipod/i.test(qC) && eb.Pebble !== void 0, rb = ft, nb = /web0s(?!.*chrome)/i.test(rb), ct = X, gu = we, ib = bn.f, _i = Rf.set, ob = Sf, ab = tb, sb = nb, Si = Vt, yu = ct.MutationObserver || ct.WebKitMutationObserver, Iu = ct.document, mu = ct.process, $r = ct.Promise, Au = ib(ct, "queueMicrotask"), xf = Au && Au.value, Zt, Ke, ar, bt, Ri, xi, kr, Eu;
xf || (Zt = function() {
  var t, e;
  for (Si && (t = mu.domain) && t.exit(); Ke; ) {
    e = Ke.fn, Ke = Ke.next;
    try {
      e();
    } catch (r) {
      throw Ke ? bt() : ar = void 0, r;
    }
  }
  ar = void 0, t && t.enter();
}, !ob && !Si && !sb && yu && Iu ? (Ri = !0, xi = Iu.createTextNode(""), new yu(Zt).observe(xi, { characterData: !0 }), bt = function() {
  xi.data = Ri = !Ri;
}) : !ab && $r && $r.resolve ? (kr = $r.resolve(void 0), kr.constructor = $r, Eu = gu(kr.then, kr), bt = function() {
  Eu(Zt);
}) : Si ? bt = function() {
  mu.nextTick(Zt);
} : (_i = gu(_i, ct), bt = function() {
  _i(Zt);
}));
var ub = xf || function(t) {
  var e = { fn: t, next: void 0 };
  ar && (ar.next = e), Ke || (Ke = e, bt()), ar = e;
}, cb = X, lb = function(t, e) {
  var r = cb.console;
  r && r.error && (arguments.length == 1 ? r.error(t) : r.error(t, e));
}, jt = function(t) {
  try {
    return { error: !1, value: t() };
  } catch (e) {
    return { error: !0, value: e };
  }
}, Pf = function() {
  this.head = null, this.tail = null;
};
Pf.prototype = {
  add: function(t) {
    var e = { item: t, next: null };
    this.head ? this.tail.next = e : this.head = e, this.tail = e;
  },
  get: function() {
    var t = this.head;
    if (t)
      return this.head = t.next, this.tail === t && (this.tail = null), t.item;
  }
};
var fb = Pf, pb = X, mr = pb.Promise, Uf = typeof Deno == "object" && Deno && typeof Deno.version == "object", db = Uf, vb = Vt, hb = !db && !vb && typeof window == "object" && typeof document == "object", gb = X, sr = mr, yb = G, Ib = ta, mb = _n, Ab = z, Eb = hb, Cb = Uf, Pi = pt;
sr && sr.prototype;
var bb = Ab("species"), bo = !1, Df = yb(gb.PromiseRejectionEvent), Tb = Ib("Promise", function() {
  var t = mb(sr), e = t !== String(sr);
  if (!e && Pi === 66)
    return !0;
  if (!Pi || Pi < 51 || !/native code/.test(t)) {
    var r = new sr(function(o) {
      o(1);
    }), n = function(o) {
      o(function() {
      }, function() {
      });
    }, i = r.constructor = {};
    if (i[bb] = n, bo = r.then(function() {
    }) instanceof n, !bo)
      return !0;
  }
  return !e && (Eb || Cb) && !Df;
}), Ar = {
  CONSTRUCTOR: Tb,
  REJECTION_EVENT: Df,
  SUBCLASSING: bo
}, Ge = {}, Cu = ie, wb = function(t) {
  var e, r;
  this.promise = new t(function(n, i) {
    if (e !== void 0 || r !== void 0)
      throw TypeError("Bad Promise constructor");
    e = n, r = i;
  }), this.resolve = Cu(e), this.reject = Cu(r);
};
Ge.f = function(t) {
  return new wb(t);
};
var Nb = E, vn = Vt, ze = X, Rt = ee, bu = Se, Tu = Pn, Ob = kn, Mb = oa, _b = ie, tn = G, Sb = oe, Rb = aa, xb = Nf, Lf = Rf.set, ca = ub, Pb = lb, Ub = jt, Db = fb, $f = Ft, hn = mr, la = Ar, kf = Ge, Fn = "Promise", Ff = la.CONSTRUCTOR, Lb = la.REJECTION_EVENT, $b = la.SUBCLASSING, Ui = $f.getterFor(Fn), kb = $f.set, Tt = hn && hn.prototype, Qe = hn, Fr = Tt, Gf = ze.TypeError, To = ze.document, fa = ze.process, wo = kf.f, Fb = wo, Gb = !!(To && To.createEvent && ze.dispatchEvent), Vf = "unhandledrejection", Vb = "rejectionhandled", wu = 0, Bf = 1, Bb = 2, pa = 1, jf = 2, Gr, Nu, jb, Ou, Hf = function(t) {
  var e;
  return Sb(t) && tn(e = t.then) ? e : !1;
}, Xf = function(t, e) {
  var r = e.value, n = e.state == Bf, i = n ? t.ok : t.fail, o = t.resolve, a = t.reject, s = t.domain, u, c, l;
  try {
    i ? (n || (e.rejection === jf && Xb(e), e.rejection = pa), i === !0 ? u = r : (s && s.enter(), u = i(r), s && (s.exit(), l = !0)), u === t.promise ? a(Gf("Promise-chain cycle")) : (c = Hf(u)) ? Rt(c, u, o, a) : o(u)) : a(r);
  } catch (f) {
    s && !l && s.exit(), a(f);
  }
}, Wf = function(t, e) {
  t.notified || (t.notified = !0, ca(function() {
    for (var r = t.reactions, n; n = r.get(); )
      Xf(n, t);
    t.notified = !1, e && !t.rejection && Hb(t);
  }));
}, zf = function(t, e, r) {
  var n, i;
  Gb ? (n = To.createEvent("Event"), n.promise = e, n.reason = r, n.initEvent(t, !1, !0), ze.dispatchEvent(n)) : n = { promise: e, reason: r }, !Lb && (i = ze["on" + t]) ? i(n) : t === Vf && Pb("Unhandled promise rejection", r);
}, Hb = function(t) {
  Rt(Lf, ze, function() {
    var e = t.facade, r = t.value, n = Mu(t), i;
    if (n && (i = Ub(function() {
      vn ? fa.emit("unhandledRejection", r, e) : zf(Vf, e, r);
    }), t.rejection = vn || Mu(t) ? jf : pa, i.error))
      throw i.value;
  });
}, Mu = function(t) {
  return t.rejection !== pa && !t.parent;
}, Xb = function(t) {
  Rt(Lf, ze, function() {
    var e = t.facade;
    vn ? fa.emit("rejectionHandled", e) : zf(Vb, e, t.value);
  });
}, wt = function(t, e, r) {
  return function(n) {
    t(e, n, r);
  };
}, Mt = function(t, e, r) {
  t.done || (t.done = !0, r && (t = r), t.value = e, t.state = Bb, Wf(t, !0));
}, No = function(t, e, r) {
  if (!t.done) {
    t.done = !0, r && (t = r);
    try {
      if (t.facade === e)
        throw Gf("Promise can't be resolved itself");
      var n = Hf(e);
      n ? ca(function() {
        var i = { done: !1 };
        try {
          Rt(
            n,
            e,
            wt(No, i, t),
            wt(Mt, i, t)
          );
        } catch (o) {
          Mt(i, o, t);
        }
      }) : (t.value = e, t.state = Bf, Wf(t, !1));
    } catch (i) {
      Mt({ done: !1 }, i, t);
    }
  }
};
if (Ff && (Qe = function(e) {
  Rb(this, Fr), _b(e), Rt(Gr, this);
  var r = Ui(this);
  try {
    e(wt(No, r), wt(Mt, r));
  } catch (n) {
    Mt(r, n);
  }
}, Fr = Qe.prototype, Gr = function(e) {
  kb(this, {
    type: Fn,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new Db(),
    rejection: !1,
    state: wu,
    value: void 0
  });
}, Gr.prototype = bu(Fr, "then", function(e, r) {
  var n = Ui(this), i = wo(xb(this, Qe));
  return n.parent = !0, i.ok = tn(e) ? e : !0, i.fail = tn(r) && r, i.domain = vn ? fa.domain : void 0, n.state == wu ? n.reactions.add(i) : ca(function() {
    Xf(i, n);
  }), i.promise;
}), Nu = function() {
  var t = new Gr(), e = Ui(t);
  this.promise = t, this.resolve = wt(No, e), this.reject = wt(Mt, e);
}, kf.f = wo = function(t) {
  return t === Qe || t === jb ? new Nu(t) : Fb(t);
}, tn(hn) && Tt !== Object.prototype)) {
  Ou = Tt.then, $b || bu(Tt, "then", function(e, r) {
    var n = this;
    return new Qe(function(i, o) {
      Rt(Ou, n, i, o);
    }).then(e, r);
  }, { unsafe: !0 });
  try {
    delete Tt.constructor;
  } catch {
  }
  Tu && Tu(Tt, Fr);
}
Nb({ global: !0, constructor: !0, wrap: !0, forced: Ff }, {
  Promise: Qe
});
Ob(Qe, Fn, !1);
Mb(Fn);
var Wb = z, Jf = Wb("iterator"), Zf = !1;
try {
  var zb = 0, _u = {
    next: function() {
      return { done: !!zb++ };
    },
    return: function() {
      Zf = !0;
    }
  };
  _u[Jf] = function() {
    return this;
  }, Array.from(_u, function() {
    throw 2;
  });
} catch {
}
var da = function(t, e) {
  if (!e && !Zf)
    return !1;
  var r = !1;
  try {
    var n = {};
    n[Jf] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, t(n);
  } catch {
  }
  return r;
}, Jb = mr, Zb = da, Yb = Ar.CONSTRUCTOR, Yf = Yb || !Zb(function(t) {
  Jb.all(t).then(void 0, function() {
  });
}), Kb = E, Qb = ee, qb = ie, eT = Ge, tT = jt, rT = ht, nT = Yf;
Kb({ target: "Promise", stat: !0, forced: nT }, {
  all: function(e) {
    var r = this, n = eT.f(r), i = n.resolve, o = n.reject, a = tT(function() {
      var s = qb(r.resolve), u = [], c = 0, l = 1;
      rT(e, function(f) {
        var p = c++, d = !1;
        l++, Qb(s, r, f).then(function(C) {
          d || (d = !0, u[p] = C, --l || i(u));
        }, o);
      }), --l || i(u);
    });
    return a.error && o(a.value), n.promise;
  }
});
var iT = E, oT = Ar.CONSTRUCTOR, Oo = mr, aT = ne, sT = G, uT = Se, Su = Oo && Oo.prototype;
iT({ target: "Promise", proto: !0, forced: oT, real: !0 }, {
  catch: function(t) {
    return this.then(void 0, t);
  }
});
if (sT(Oo)) {
  var Ru = aT("Promise").prototype.catch;
  Su.catch !== Ru && uT(Su, "catch", Ru, { unsafe: !0 });
}
var cT = E, lT = ee, fT = ie, pT = Ge, dT = jt, vT = ht, hT = Yf;
cT({ target: "Promise", stat: !0, forced: hT }, {
  race: function(e) {
    var r = this, n = pT.f(r), i = n.reject, o = dT(function() {
      var a = fT(r.resolve);
      vT(e, function(s) {
        lT(a, r, s).then(n.resolve, i);
      });
    });
    return o.error && i(o.value), n.promise;
  }
});
var gT = E, yT = ee, IT = Ge, mT = Ar.CONSTRUCTOR;
gT({ target: "Promise", stat: !0, forced: mT }, {
  reject: function(e) {
    var r = IT.f(this);
    return yT(r.reject, void 0, e), r.promise;
  }
});
var AT = ae, ET = oe, CT = Ge, Kf = function(t, e) {
  if (AT(t), ET(e) && e.constructor === t)
    return e;
  var r = CT.f(t), n = r.resolve;
  return n(e), r.promise;
}, bT = E, TT = ne, wT = Ar.CONSTRUCTOR, NT = Kf;
TT("Promise");
bT({ target: "Promise", stat: !0, forced: wT }, {
  resolve: function(e) {
    return NT(this, e);
  }
});
var OT = E, MT = ee, _T = ie, ST = Ge, RT = jt, xT = ht;
OT({ target: "Promise", stat: !0 }, {
  allSettled: function(e) {
    var r = this, n = ST.f(r), i = n.resolve, o = n.reject, a = RT(function() {
      var s = _T(r.resolve), u = [], c = 0, l = 1;
      xT(e, function(f) {
        var p = c++, d = !1;
        l++, MT(s, r, f).then(function(C) {
          d || (d = !0, u[p] = { status: "fulfilled", value: C }, --l || i(u));
        }, function(C) {
          d || (d = !0, u[p] = { status: "rejected", reason: C }, --l || i(u));
        });
      }), --l || i(u);
    });
    return a.error && o(a.value), n.promise;
  }
});
var PT = E, UT = ee, DT = ie, LT = ne, $T = Ge, kT = jt, FT = ht, xu = "No one promise resolved";
PT({ target: "Promise", stat: !0 }, {
  any: function(e) {
    var r = this, n = LT("AggregateError"), i = $T.f(r), o = i.resolve, a = i.reject, s = kT(function() {
      var u = DT(r.resolve), c = [], l = 0, f = 1, p = !1;
      FT(e, function(d) {
        var C = l++, R = !1;
        f++, UT(u, r, d).then(function(S) {
          R || p || (p = !0, o(S));
        }, function(S) {
          R || p || (R = !0, c[C] = S, --f || a(new n(c, xu)));
        });
      }), --f || a(new n(c, xu));
    });
    return s.error && a(s.value), i.promise;
  }
});
var GT = E, gn = mr, VT = F, Qf = ne, qf = G, BT = Nf, Pu = Kf, jT = Se, Mo = gn && gn.prototype, HT = !!gn && VT(function() {
  Mo.finally.call({ then: function() {
  } }, function() {
  });
});
GT({ target: "Promise", proto: !0, real: !0, forced: HT }, {
  finally: function(t) {
    var e = BT(this, Qf("Promise")), r = qf(t);
    return this.then(
      r ? function(n) {
        return Pu(e, t()).then(function() {
          return n;
        });
      } : t,
      r ? function(n) {
        return Pu(e, t()).then(function() {
          throw n;
        });
      } : t
    );
  }
});
if (qf(gn)) {
  var Uu = Qf("Promise").prototype.finally;
  Mo.finally !== Uu && jT(Mo, "finally", Uu, { unsafe: !0 });
}
var va = k, XT = Fe, WT = $n, zT = Wo, JT = va("".charAt), Du = va("".charCodeAt), ZT = va("".slice), Lu = function(t) {
  return function(e, r) {
    var n = WT(zT(e)), i = XT(r), o = n.length, a, s;
    return i < 0 || i >= o ? t ? "" : void 0 : (a = Du(n, i), a < 55296 || a > 56319 || i + 1 === o || (s = Du(n, i + 1)) < 56320 || s > 57343 ? t ? JT(n, i) : a : t ? ZT(n, i, i + 2) : (a - 55296 << 10) + (s - 56320) + 65536);
  };
}, YT = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Lu(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Lu(!0)
}, KT = YT.charAt, QT = $n, ep = Ft, qT = na, tp = "String Iterator", ew = ep.set, tw = ep.getterFor(tp);
qT(String, "String", function(t) {
  ew(this, {
    type: tp,
    string: QT(t),
    index: 0
  });
}, function() {
  var e = tw(this), r = e.string, n = e.index, i;
  return n >= r.length ? { value: void 0, done: !0 } : (i = KT(r, n), e.index += i.length, { value: i, done: !1 });
});
var rw = X, rp = rw, nw = rp, iw = nw.Promise, ow = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, aw = Mn, Di = aw("span").classList, $u = Di && Di.constructor && Di.constructor.prototype, sw = $u === Object.prototype ? void 0 : $u, ku = X, np = ow, uw = sw, qt = sC, Li = kt, ip = z, $i = ip("iterator"), Fu = ip("toStringTag"), ki = qt.values, op = function(t, e) {
  if (t) {
    if (t[$i] !== ki)
      try {
        Li(t, $i, ki);
      } catch {
        t[$i] = ki;
      }
    if (t[Fu] || Li(t, Fu, e), np[e]) {
      for (var r in qt)
        if (t[r] !== qt[r])
          try {
            Li(t, r, qt[r]);
          } catch {
            t[r] = qt[r];
          }
    }
  }
};
for (var Fi in np)
  op(ku[Fi] && ku[Fi].prototype, Fi);
op(uw, "DOMTokenList");
var cw = iw, lw = cw, fw = lw, pw = fw, dw = E, vw = Ge, hw = jt;
dw({ target: "Promise", stat: !0, forced: !0 }, {
  try: function(t) {
    var e = vw.f(this), r = hw(t);
    return (r.error ? e.reject : e.resolve)(r.value), e.promise;
  }
});
var gw = pw, yw = gw;
(function(t) {
  t.exports = yw;
})(Pg);
var Iw = { exports: {} }, mw = ae, Aw = vf, Ew = function(t, e, r, n) {
  try {
    return n ? e(mw(r)[0], r[1]) : e(r);
  } catch (i) {
    Aw(t, "throw", i);
  }
}, Cw = On, bw = ge, Tw = Lt, Ht = function(t, e, r) {
  var n = Cw(e);
  n in t ? bw.f(t, n, Tw(0, r)) : t[n] = r;
}, ww = we, Nw = ee, Ow = W, Mw = Ew, _w = pf, Sw = Bt, Rw = L, Gu = Ht, xw = Ln, Pw = Dn, Vu = Array, Uw = function(e) {
  var r = Ow(e), n = Sw(this), i = arguments.length, o = i > 1 ? arguments[1] : void 0, a = o !== void 0;
  a && (o = ww(o, i > 2 ? arguments[2] : void 0));
  var s = Pw(r), u = 0, c, l, f, p, d, C;
  if (s && !(this === Vu && _w(s)))
    for (p = xw(r, s), d = p.next, l = n ? new this() : []; !(f = Nw(d, p)).done; u++)
      C = a ? Mw(p, o, [f.value, u], !0) : f.value, Gu(l, u, C);
  else
    for (c = Rw(r), l = n ? new this(c) : Vu(c); c > u; u++)
      C = a ? o(r[u], u) : r[u], Gu(l, u, C);
  return l.length = u, l;
}, Dw = E, Lw = Uw, $w = da, kw = !$w(function(t) {
  Array.from(t);
});
Dw({ target: "Array", stat: !0, forced: kw }, {
  from: Lw
});
var Fw = $t, gt = Array.isArray || function(e) {
  return Fw(e) == "Array";
}, Gw = E, Vw = gt;
Gw({ target: "Array", stat: !0 }, {
  isArray: Vw
});
var Bw = E, jw = F, Hw = Bt, Xw = Ht, ap = Array, Ww = jw(function() {
  function t() {
  }
  return !(ap.of.call(t) instanceof t);
});
Bw({ target: "Array", stat: !0, forced: Ww }, {
  of: function() {
    for (var e = 0, r = arguments.length, n = new (Hw(this) ? this : ap)(r); r > e; )
      Xw(n, e, arguments[e++]);
    return n.length = r, n;
  }
});
var zw = E, Jw = W, Zw = L, Yw = Fe, Kw = V;
zw({ target: "Array", proto: !0 }, {
  at: function(e) {
    var r = Jw(this), n = Zw(r), i = Yw(e), o = i >= 0 ? i : n + i;
    return o < 0 || o >= n ? void 0 : r[o];
  }
});
Kw("at");
var Qw = TypeError, qw = 9007199254740991, yt = function(t) {
  if (t > qw)
    throw Qw("Maximum allowed index exceeded");
  return t;
}, Bu = gt, e0 = Bt, t0 = oe, r0 = z, n0 = r0("species"), ju = Array, i0 = function(t) {
  var e;
  return Bu(t) && (e = t.constructor, e0(e) && (e === ju || Bu(e.prototype)) ? e = void 0 : t0(e) && (e = e[n0], e === null && (e = void 0))), e === void 0 ? ju : e;
}, o0 = i0, Xt = function(t, e) {
  return new (o0(t))(e === 0 ? 0 : e);
}, a0 = F, s0 = z, u0 = pt, c0 = s0("species"), Er = function(t) {
  return u0 >= 51 || !a0(function() {
    var e = [], r = e.constructor = {};
    return r[c0] = function() {
      return { foo: 1 };
    }, e[t](Boolean).foo !== 1;
  });
}, l0 = E, f0 = F, p0 = gt, d0 = oe, v0 = W, h0 = L, Hu = yt, Xu = Ht, g0 = Xt, y0 = Er, I0 = z, m0 = pt, sp = I0("isConcatSpreadable"), A0 = m0 >= 51 || !f0(function() {
  var t = [];
  return t[sp] = !1, t.concat()[0] !== t;
}), E0 = y0("concat"), C0 = function(t) {
  if (!d0(t))
    return !1;
  var e = t[sp];
  return e !== void 0 ? !!e : p0(t);
}, b0 = !A0 || !E0;
l0({ target: "Array", proto: !0, arity: 1, forced: b0 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(e) {
    var r = v0(this), n = g0(r, 0), i = 0, o, a, s, u, c;
    for (o = -1, s = arguments.length; o < s; o++)
      if (c = o === -1 ? r : arguments[o], C0(c))
        for (u = h0(c), Hu(i + u), a = 0; a < u; a++, i++)
          a in c && Xu(n, i, c[a]);
      else
        Hu(i + 1), Xu(n, i++, c);
    return n.length = i, n;
  }
});
var Wu = gr, T0 = TypeError, Gn = function(t, e) {
  if (!delete t[e])
    throw T0("Cannot delete property " + Wu(e) + " of " + Wu(t));
}, w0 = W, Gi = vt, N0 = L, O0 = Gn, M0 = Math.min, _0 = [].copyWithin || function(e, r) {
  var n = w0(this), i = N0(n), o = Gi(e, i), a = Gi(r, i), s = arguments.length > 2 ? arguments[2] : void 0, u = M0((s === void 0 ? i : Gi(s, i)) - a, i - o), c = 1;
  for (a < o && o < a + u && (c = -1, a += u - 1, o += u - 1); u-- > 0; )
    a in n ? n[o] = n[a] : O0(n, o), o += c, a += c;
  return n;
}, S0 = E, R0 = _0, x0 = V;
S0({ target: "Array", proto: !0 }, {
  copyWithin: R0
});
x0("copyWithin");
var P0 = we, U0 = k, D0 = lt, L0 = W, $0 = L, k0 = Xt, zu = U0([].push), Be = function(t) {
  var e = t == 1, r = t == 2, n = t == 3, i = t == 4, o = t == 6, a = t == 7, s = t == 5 || o;
  return function(u, c, l, f) {
    for (var p = L0(u), d = D0(p), C = P0(c, l), R = $0(d), S = 0, T = f || k0, N = e ? T(u, R) : r || a ? T(u, 0) : void 0, U, D; R > S; S++)
      if ((s || S in d) && (U = d[S], D = C(U, S, p), t))
        if (e)
          N[S] = D;
        else if (D)
          switch (t) {
            case 3:
              return !0;
            case 5:
              return U;
            case 6:
              return S;
            case 2:
              zu(N, U);
          }
        else
          switch (t) {
            case 4:
              return !1;
            case 7:
              zu(N, U);
          }
    return o ? -1 : n || i ? i : N;
  };
}, Ve = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Be(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: Be(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: Be(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: Be(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: Be(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: Be(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: Be(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: Be(7)
}, F0 = F, Ne = function(t, e) {
  var r = [][t];
  return !!r && F0(function() {
    r.call(null, e || function() {
      return 1;
    }, 1);
  });
}, G0 = E, V0 = Ve.every, B0 = Ne, j0 = B0("every");
G0({ target: "Array", proto: !0, forced: !j0 }, {
  every: function(e) {
    return V0(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var H0 = W, Ju = vt, X0 = L, W0 = function(e) {
  for (var r = H0(this), n = X0(r), i = arguments.length, o = Ju(i > 1 ? arguments[1] : void 0, n), a = i > 2 ? arguments[2] : void 0, s = a === void 0 ? n : Ju(a, n); s > o; )
    r[o++] = e;
  return r;
}, z0 = E, J0 = W0, Z0 = V;
z0({ target: "Array", proto: !0 }, {
  fill: J0
});
Z0("fill");
var Y0 = E, K0 = Ve.filter, Q0 = Er, q0 = Q0("filter");
Y0({ target: "Array", proto: !0, forced: !q0 }, {
  filter: function(e) {
    return K0(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var eN = E, tN = Ve.find, rN = V, _o = "find", up = !0;
_o in [] && Array(1)[_o](function() {
  up = !1;
});
eN({ target: "Array", proto: !0, forced: up }, {
  find: function(e) {
    return tN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
rN(_o);
var nN = E, iN = Ve.findIndex, oN = V, So = "findIndex", cp = !0;
So in [] && Array(1)[So](function() {
  cp = !1;
});
nN({ target: "Array", proto: !0, forced: cp }, {
  findIndex: function(e) {
    return iN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
oN(So);
var aN = we, sN = lt, uN = W, cN = L, Zu = function(t) {
  var e = t == 1;
  return function(r, n, i) {
    for (var o = uN(r), a = sN(o), s = aN(n, i), u = cN(a), c, l; u-- > 0; )
      if (c = a[u], l = s(c, u, o), l)
        switch (t) {
          case 0:
            return c;
          case 1:
            return u;
        }
    return e ? -1 : void 0;
  };
}, lp = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: Zu(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: Zu(1)
}, lN = E, fN = lp.findLast, pN = V;
lN({ target: "Array", proto: !0 }, {
  findLast: function(e) {
    return fN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
pN("findLast");
var dN = E, vN = lp.findLastIndex, hN = V;
dN({ target: "Array", proto: !0 }, {
  findLastIndex: function(e) {
    return vN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
hN("findLastIndex");
var gN = gt, yN = L, IN = yt, mN = we, fp = function(t, e, r, n, i, o, a, s) {
  for (var u = i, c = 0, l = a ? mN(a, s) : !1, f, p; c < n; )
    c in r && (f = l ? l(r[c], c, e) : r[c], o > 0 && gN(f) ? (p = yN(f), u = fp(t, e, f, p, u, o - 1) - 1) : (IN(u + 1), t[u] = f), u++), c++;
  return u;
}, pp = fp, AN = E, EN = pp, CN = W, bN = L, TN = Fe, wN = Xt;
AN({ target: "Array", proto: !0 }, {
  flat: function() {
    var e = arguments.length ? arguments[0] : void 0, r = CN(this), n = bN(r), i = wN(r, 0);
    return i.length = EN(i, r, r, n, 0, e === void 0 ? 1 : TN(e)), i;
  }
});
var NN = E, ON = pp, MN = ie, _N = W, SN = L, RN = Xt;
NN({ target: "Array", proto: !0 }, {
  flatMap: function(e) {
    var r = _N(this), n = SN(r), i;
    return MN(e), i = RN(r, 0), i.length = ON(i, r, r, n, 0, 1, e, arguments.length > 1 ? arguments[1] : void 0), i;
  }
});
var xN = Ve.forEach, PN = Ne, UN = PN("forEach"), DN = UN ? [].forEach : function(e) {
  return xN(this, e, arguments.length > 1 ? arguments[1] : void 0);
}, LN = E, Yu = DN;
LN({ target: "Array", proto: !0, forced: [].forEach != Yu }, {
  forEach: Yu
});
var $N = E, kN = qo.includes, FN = F, GN = V, VN = FN(function() {
  return !Array(1).includes();
});
$N({ target: "Array", proto: !0, forced: VN }, {
  includes: function(e) {
    return kN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
GN("includes");
var BN = E, jN = k, HN = qo.indexOf, XN = Ne, Ro = jN([].indexOf), Ku = !!Ro && 1 / Ro([1], 1, -0) < 0, WN = XN("indexOf");
BN({ target: "Array", proto: !0, forced: Ku || !WN }, {
  indexOf: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return Ku ? Ro(this, e, r) || 0 : HN(this, e, r);
  }
});
var zN = E, JN = k, ZN = lt, YN = he, KN = Ne, QN = JN([].join), qN = ZN != Object, eO = KN("join", ",");
zN({ target: "Array", proto: !0, forced: qN || !eO }, {
  join: function(e) {
    return QN(YN(this), e === void 0 ? "," : e);
  }
});
var tO = Mf, rO = he, nO = Fe, iO = L, oO = Ne, aO = Math.min, xo = [].lastIndexOf, dp = !!xo && 1 / [1].lastIndexOf(1, -0) < 0, sO = oO("lastIndexOf"), uO = dp || !sO, cO = uO ? function(e) {
  if (dp)
    return tO(xo, this, arguments) || 0;
  var r = rO(this), n = iO(r), i = n - 1;
  for (arguments.length > 1 && (i = aO(i, nO(arguments[1]))), i < 0 && (i = n + i); i >= 0; i--)
    if (i in r && r[i] === e)
      return i || 0;
  return -1;
} : xo, lO = E, Qu = cO;
lO({ target: "Array", proto: !0, forced: Qu !== [].lastIndexOf }, {
  lastIndexOf: Qu
});
var fO = E, pO = Ve.map, dO = Er, vO = dO("map");
fO({ target: "Array", proto: !0, forced: !vO }, {
  map: function(e) {
    return pO(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var hO = E, gO = W, yO = L, IO = yt, mO = F, AO = mO(function() {
  return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
}), EO = !function() {
  try {
    Object.defineProperty([], "length", { writable: !1 }).push();
  } catch (t) {
    return t instanceof TypeError;
  }
}();
hO({ target: "Array", proto: !0, arity: 1, forced: AO || EO }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function(e) {
    var r = gO(this), n = yO(r), i = arguments.length;
    IO(n + i);
    for (var o = 0; o < i; o++)
      r[n] = arguments[o], n++;
    return r.length = n, n;
  }
});
var CO = ie, bO = W, TO = lt, wO = L, NO = TypeError, qu = function(t) {
  return function(e, r, n, i) {
    CO(r);
    var o = bO(e), a = TO(o), s = wO(o), u = t ? s - 1 : 0, c = t ? -1 : 1;
    if (n < 2)
      for (; ; ) {
        if (u in a) {
          i = a[u], u += c;
          break;
        }
        if (u += c, t ? u < 0 : s <= u)
          throw NO("Reduce of empty array with no initial value");
      }
    for (; t ? u >= 0 : s > u; u += c)
      u in a && (i = r(i, a[u], u, o));
    return i;
  };
}, vp = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: qu(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: qu(!0)
}, OO = E, MO = vp.left, _O = Ne, ec = pt, SO = Vt, RO = _O("reduce"), xO = !SO && ec > 79 && ec < 83;
OO({ target: "Array", proto: !0, forced: !RO || xO }, {
  reduce: function(e) {
    var r = arguments.length;
    return MO(this, e, r, r > 1 ? arguments[1] : void 0);
  }
});
var PO = E, UO = vp.right, DO = Ne, tc = pt, LO = Vt, $O = DO("reduceRight"), kO = !LO && tc > 79 && tc < 83;
PO({ target: "Array", proto: !0, forced: !$O || kO }, {
  reduceRight: function(e) {
    return UO(this, e, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var FO = E, GO = k, VO = gt, BO = GO([].reverse), rc = [1, 2];
FO({ target: "Array", proto: !0, forced: String(rc) === String(rc.reverse()) }, {
  reverse: function() {
    return VO(this) && (this.length = this.length), BO(this);
  }
});
var jO = E, nc = gt, HO = Bt, XO = oe, ic = vt, WO = L, zO = he, JO = Ht, ZO = z, YO = Er, KO = _f, QO = YO("slice"), qO = ZO("species"), Vi = Array, eM = Math.max;
jO({ target: "Array", proto: !0, forced: !QO }, {
  slice: function(e, r) {
    var n = zO(this), i = WO(n), o = ic(e, i), a = ic(r === void 0 ? i : r, i), s, u, c;
    if (nc(n) && (s = n.constructor, HO(s) && (s === Vi || nc(s.prototype)) ? s = void 0 : XO(s) && (s = s[qO], s === null && (s = void 0)), s === Vi || s === void 0))
      return KO(n, o, a);
    for (u = new (s === void 0 ? Vi : s)(eM(a - o, 0)), c = 0; o < a; o++, c++)
      o in n && JO(u, c, n[o]);
    return u.length = c, u;
  }
});
var tM = E, rM = Ve.some, nM = Ne, iM = nM("some");
tM({ target: "Array", proto: !0, forced: !iM }, {
  some: function(e) {
    return rM(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var oc = vt, oM = L, aM = Ht, sM = Array, uM = Math.max, hp = function(t, e, r) {
  for (var n = oM(t), i = oc(e, n), o = oc(r === void 0 ? n : r, n), a = sM(uM(o - i, 0)), s = 0; i < o; i++, s++)
    aM(a, s, t[i]);
  return a.length = s, a;
}, ac = hp, cM = Math.floor, Po = function(t, e) {
  var r = t.length, n = cM(r / 2);
  return r < 8 ? lM(t, e) : fM(
    t,
    Po(ac(t, 0, n), e),
    Po(ac(t, n), e),
    e
  );
}, lM = function(t, e) {
  for (var r = t.length, n = 1, i, o; n < r; ) {
    for (o = n, i = t[n]; o && e(t[o - 1], i) > 0; )
      t[o] = t[--o];
    o !== n++ && (t[o] = i);
  }
  return t;
}, fM = function(t, e, r, n) {
  for (var i = e.length, o = r.length, a = 0, s = 0; a < i || s < o; )
    t[a + s] = a < i && s < o ? n(e[a], r[s]) <= 0 ? e[a++] : r[s++] : a < i ? e[a++] : r[s++];
  return t;
}, pM = Po, dM = ft, sc = dM.match(/firefox\/(\d+)/i), vM = !!sc && +sc[1], hM = ft, gM = /MSIE|Trident/.test(hM), yM = ft, uc = yM.match(/AppleWebKit\/(\d+)\./), IM = !!uc && +uc[1], mM = E, gp = k, AM = ie, EM = W, CM = L, bM = Gn, cc = $n, ha = F, TM = pM, wM = Ne, lc = vM, NM = gM, fc = pt, pc = IM, He = [], dc = gp(He.sort), OM = gp(He.push), MM = ha(function() {
  He.sort(void 0);
}), _M = ha(function() {
  He.sort(null);
}), SM = wM("sort"), yp = !ha(function() {
  if (fc)
    return fc < 70;
  if (!(lc && lc > 3)) {
    if (NM)
      return !0;
    if (pc)
      return pc < 603;
    var t = "", e, r, n, i;
    for (e = 65; e < 76; e++) {
      switch (r = String.fromCharCode(e), e) {
        case 66:
        case 69:
        case 70:
        case 72:
          n = 3;
          break;
        case 68:
        case 71:
          n = 4;
          break;
        default:
          n = 2;
      }
      for (i = 0; i < 47; i++)
        He.push({ k: r + i, v: n });
    }
    for (He.sort(function(o, a) {
      return a.v - o.v;
    }), i = 0; i < He.length; i++)
      r = He[i].k.charAt(0), t.charAt(t.length - 1) !== r && (t += r);
    return t !== "DGBEFHACIJK";
  }
}), RM = MM || !_M || !SM || !yp, xM = function(t) {
  return function(e, r) {
    return r === void 0 ? -1 : e === void 0 ? 1 : t !== void 0 ? +t(e, r) || 0 : cc(e) > cc(r) ? 1 : -1;
  };
};
mM({ target: "Array", proto: !0, forced: RM }, {
  sort: function(e) {
    e !== void 0 && AM(e);
    var r = EM(this);
    if (yp)
      return e === void 0 ? dc(r) : dc(r, e);
    var n = [], i = CM(r), o, a;
    for (a = 0; a < i; a++)
      a in r && OM(n, r[a]);
    for (TM(n, xM(e)), o = n.length, a = 0; a < o; )
      r[a] = n[a++];
    for (; a < i; )
      bM(r, a++);
    return r;
  }
});
var PM = oa;
PM("Array");
var UM = E, DM = W, LM = vt, $M = Fe, kM = L, FM = yt, GM = Xt, VM = Ht, Bi = Gn, BM = Er, jM = BM("splice"), HM = Math.max, XM = Math.min;
UM({ target: "Array", proto: !0, forced: !jM }, {
  splice: function(e, r) {
    var n = DM(this), i = kM(n), o = LM(e, i), a = arguments.length, s, u, c, l, f, p;
    for (a === 0 ? s = u = 0 : a === 1 ? (s = 0, u = i - o) : (s = a - 2, u = XM(HM($M(r), 0), i - o)), FM(i + s - u), c = GM(n, u), l = 0; l < u; l++)
      f = o + l, f in n && VM(c, l, n[f]);
    if (c.length = u, s < u) {
      for (l = o; l < i - u; l++)
        f = l + u, p = l + s, f in n ? n[p] = n[f] : Bi(n, p);
      for (l = i; l > i - u + s; l--)
        Bi(n, l - 1);
    } else if (s > u)
      for (l = i - u; l > o; l--)
        f = l + u - 1, p = l + s - 1, f in n ? n[p] = n[f] : Bi(n, p);
    for (l = 0; l < s; l++)
      n[l + o] = arguments[l + 2];
    return n.length = i - u + s, c;
  }
});
var WM = V;
WM("flat");
var zM = V;
zM("flatMap");
var JM = E, ZM = W, YM = L, KM = Gn, QM = yt, qM = [].unshift(0) !== 1, e1 = !function() {
  try {
    Object.defineProperty([], "length", { writable: !1 }).unshift();
  } catch (t) {
    return t instanceof TypeError;
  }
}();
JM({ target: "Array", proto: !0, arity: 1, forced: qM || e1 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function(e) {
    var r = ZM(this), n = YM(r), i = arguments.length;
    if (i) {
      QM(n + i);
      for (var o = n; o--; ) {
        var a = o + i;
        o in r ? r[a] = r[o] : KM(r, a);
      }
      for (var s = 0; s < i; s++)
        r[s] = arguments[s];
    }
    return r.length = n + i;
  }
});
var t1 = rp, r1 = t1.Array, n1 = r1, i1 = n1, ga = { exports: {} }, Ip = {}, o1 = $t, a1 = he, mp = Rn.f, s1 = hp, Ap = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], u1 = function(t) {
  try {
    return mp(t);
  } catch {
    return s1(Ap);
  }
};
Ip.f = function(e) {
  return Ap && o1(e) == "Window" ? u1(e) : mp(a1(e));
};
var c1 = F, l1 = c1(function() {
  if (typeof ArrayBuffer == "function") {
    var t = new ArrayBuffer(8);
    Object.isExtensible(t) && Object.defineProperty(t, "a", { value: 8 });
  }
}), f1 = F, p1 = oe, d1 = $t, vc = l1, rn = Object.isExtensible, v1 = f1(function() {
  rn(1);
}), h1 = v1 || vc ? function(e) {
  return !p1(e) || vc && d1(e) == "ArrayBuffer" ? !1 : rn ? rn(e) : !0;
} : rn, g1 = F, y1 = !g1(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), I1 = E, m1 = k, A1 = Sn, E1 = oe, ya = Te, C1 = ge.f, hc = Rn, b1 = Ip, Ia = h1, T1 = Zo, w1 = y1, Ep = !1, ke = T1("meta"), N1 = 0, ma = function(t) {
  C1(t, ke, { value: {
    objectID: "O" + N1++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, O1 = function(t, e) {
  if (!E1(t))
    return typeof t == "symbol" ? t : (typeof t == "string" ? "S" : "P") + t;
  if (!ya(t, ke)) {
    if (!Ia(t))
      return "F";
    if (!e)
      return "E";
    ma(t);
  }
  return t[ke].objectID;
}, M1 = function(t, e) {
  if (!ya(t, ke)) {
    if (!Ia(t))
      return !0;
    if (!e)
      return !1;
    ma(t);
  }
  return t[ke].weakData;
}, _1 = function(t) {
  return w1 && Ep && Ia(t) && !ya(t, ke) && ma(t), t;
}, S1 = function() {
  R1.enable = function() {
  }, Ep = !0;
  var t = hc.f, e = m1([].splice), r = {};
  r[ke] = 1, t(r).length && (hc.f = function(n) {
    for (var i = t(n), o = 0, a = i.length; o < a; o++)
      if (i[o] === ke) {
        e(i, o, 1);
        break;
      }
    return i;
  }, I1({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: b1.f
  }));
}, R1 = ga.exports = {
  enable: S1,
  fastKey: O1,
  getWeakData: M1,
  onFreeze: _1
};
A1[ke] = !0;
var x1 = G, P1 = oe, gc = Pn, U1 = function(t, e, r) {
  var n, i;
  return (
    // it can work only with native `setPrototypeOf`
    gc && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    x1(n = e.constructor) && n !== r && P1(i = n.prototype) && i !== r.prototype && gc(t, i), t
  );
}, D1 = E, L1 = X, $1 = k, yc = ta, k1 = Se, F1 = ga.exports, G1 = ht, V1 = aa, B1 = G, ji = oe, Hi = F, j1 = da, H1 = kn, X1 = U1, W1 = function(t, e, r) {
  var n = t.indexOf("Map") !== -1, i = t.indexOf("Weak") !== -1, o = n ? "set" : "add", a = L1[t], s = a && a.prototype, u = a, c = {}, l = function(T) {
    var N = $1(s[T]);
    k1(
      s,
      T,
      T == "add" ? function(D) {
        return N(this, D === 0 ? 0 : D), this;
      } : T == "delete" ? function(U) {
        return i && !ji(U) ? !1 : N(this, U === 0 ? 0 : U);
      } : T == "get" ? function(D) {
        return i && !ji(D) ? void 0 : N(this, D === 0 ? 0 : D);
      } : T == "has" ? function(D) {
        return i && !ji(D) ? !1 : N(this, D === 0 ? 0 : D);
      } : function(D, Oe) {
        return N(this, D === 0 ? 0 : D, Oe), this;
      }
    );
  }, f = yc(
    t,
    !B1(a) || !(i || s.forEach && !Hi(function() {
      new a().entries().next();
    }))
  );
  if (f)
    u = r.getConstructor(e, t, n, o), F1.enable();
  else if (yc(t, !0)) {
    var p = new u(), d = p[o](i ? {} : -0, 1) != p, C = Hi(function() {
      p.has(1);
    }), R = j1(function(T) {
      new a(T);
    }), S = !i && Hi(function() {
      for (var T = new a(), N = 5; N--; )
        T[o](N, N);
      return !T.has(-0);
    });
    R || (u = e(function(T, N) {
      V1(T, s);
      var U = X1(new a(), T, u);
      return N != null && G1(N, U[o], { that: U, AS_ENTRIES: n }), U;
    }), u.prototype = s, s.constructor = u), (C || S) && (l("delete"), l("has"), n && l("get")), (S || d) && l(o), i && s.clear && delete s.clear;
  }
  return c[t] = u, D1({ global: !0, constructor: !0, forced: u != a }, c), H1(u, t), i || r.setStrong(u, t, n), u;
}, z1 = Se, Cp = function(t, e, r) {
  for (var n in e)
    z1(t, n, e[n], r);
  return t;
}, J1 = ge.f, Z1 = Gt, Ic = Cp, Y1 = we, K1 = aa, Q1 = ht, q1 = na, e_ = oa, Yt = ve, mc = ga.exports.fastKey, bp = Ft, Ac = bp.set, Xi = bp.getterFor, t_ = {
  getConstructor: function(t, e, r, n) {
    var i = t(function(c, l) {
      K1(c, o), Ac(c, {
        type: e,
        index: Z1(null),
        first: void 0,
        last: void 0,
        size: 0
      }), Yt || (c.size = 0), l != null && Q1(l, c[n], { that: c, AS_ENTRIES: r });
    }), o = i.prototype, a = Xi(e), s = function(c, l, f) {
      var p = a(c), d = u(c, l), C, R;
      return d ? d.value = f : (p.last = d = {
        index: R = mc(l, !0),
        key: l,
        value: f,
        previous: C = p.last,
        next: void 0,
        removed: !1
      }, p.first || (p.first = d), C && (C.next = d), Yt ? p.size++ : c.size++, R !== "F" && (p.index[R] = d)), c;
    }, u = function(c, l) {
      var f = a(c), p = mc(l), d;
      if (p !== "F")
        return f.index[p];
      for (d = f.first; d; d = d.next)
        if (d.key == l)
          return d;
    };
    return Ic(o, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var l = this, f = a(l), p = f.index, d = f.first; d; )
          d.removed = !0, d.previous && (d.previous = d.previous.next = void 0), delete p[d.index], d = d.next;
        f.first = f.last = void 0, Yt ? f.size = 0 : l.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(c) {
        var l = this, f = a(l), p = u(l, c);
        if (p) {
          var d = p.next, C = p.previous;
          delete f.index[p.index], p.removed = !0, C && (C.next = d), d && (d.previous = C), f.first == p && (f.first = d), f.last == p && (f.last = C), Yt ? f.size-- : l.size--;
        }
        return !!p;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(l) {
        for (var f = a(this), p = Y1(l, arguments.length > 1 ? arguments[1] : void 0), d; d = d ? d.next : f.first; )
          for (p(d.value, d.key, this); d && d.removed; )
            d = d.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(l) {
        return !!u(this, l);
      }
    }), Ic(o, r ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(l) {
        var f = u(this, l);
        return f && f.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(l, f) {
        return s(this, l === 0 ? 0 : l, f);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(l) {
        return s(this, l = l === 0 ? 0 : l, l);
      }
    }), Yt && J1(o, "size", {
      get: function() {
        return a(this).size;
      }
    }), i;
  },
  setStrong: function(t, e, r) {
    var n = e + " Iterator", i = Xi(e), o = Xi(n);
    q1(t, e, function(a, s) {
      Ac(this, {
        type: n,
        target: a,
        state: i(a),
        kind: s,
        last: void 0
      });
    }, function() {
      for (var a = o(this), s = a.kind, u = a.last; u && u.removed; )
        u = u.previous;
      return !a.target || !(a.last = u = u ? u.next : a.state.first) ? (a.target = void 0, { value: void 0, done: !0 }) : s == "keys" ? { value: u.key, done: !1 } : s == "values" ? { value: u.value, done: !1 } : { value: [u.key, u.value], done: !1 };
    }, r ? "entries" : "values", !r, !0), e_(e);
  }
}, r_ = W1, n_ = t_;
r_("Map", function(t) {
  return function() {
    return t(this, arguments.length ? arguments[0] : void 0);
  };
}, n_);
var i_ = L, Tp = function(t, e) {
  for (var r = 0, n = i_(e), i = new t(n); n > r; )
    i[r] = e[r++];
  return i;
}, o_ = we, a_ = k, s_ = lt, u_ = W, c_ = On, l_ = L, f_ = Gt, p_ = Tp, d_ = Array, v_ = a_([].push), wp = function(t, e, r, n) {
  for (var i = u_(t), o = s_(i), a = o_(e, r), s = f_(null), u = l_(o), c = 0, l, f, p; u > c; c++)
    p = o[c], f = c_(a(p, c, i)), f in s ? v_(s[f], p) : s[f] = [p];
  if (n && (l = n(i), l !== d_))
    for (f in s)
      s[f] = p_(l, s[f]);
  return s;
}, h_ = E, g_ = wp, y_ = V;
h_({ target: "Array", proto: !0 }, {
  group: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return g_(this, e, r);
  }
});
y_("group");
var I_ = E, m_ = wp, A_ = Ne, E_ = V;
I_({ target: "Array", proto: !0, forced: !A_("groupBy") }, {
  groupBy: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return m_(this, e, r);
  }
});
E_("groupBy");
var C_ = ne, b_ = we, Vn = k, T_ = lt, w_ = W, N_ = L, Np = C_("Map"), Aa = Np.prototype, O_ = Vn(Aa.get), M_ = Vn(Aa.has), __ = Vn(Aa.set), S_ = Vn([].push), Op = function(e) {
  for (var r = w_(this), n = T_(r), i = b_(e, arguments.length > 1 ? arguments[1] : void 0), o = new Np(), a = N_(n), s = 0, u, c; a > s; s++)
    c = n[s], u = i(c, s, r), M_(o, u) ? S_(O_(o, u), c) : __(o, u, [c]);
  return o;
}, R_ = E, x_ = Ne, P_ = V, U_ = Op;
R_({ target: "Array", proto: !0, name: "groupToMap", forced: !x_("groupByToMap") }, {
  groupByToMap: U_
});
P_("groupByToMap");
var D_ = E, L_ = V, $_ = Op;
D_({ target: "Array", proto: !0 }, {
  groupToMap: $_
});
L_("groupToMap");
var k_ = L, F_ = function(t, e) {
  for (var r = k_(t), n = new e(r), i = 0; i < r; i++)
    n[i] = t[r - i - 1];
  return n;
}, G_ = E, V_ = F_, B_ = he, j_ = V, H_ = Array;
G_({ target: "Array", proto: !0 }, {
  toReversed: function() {
    return V_(B_(this), H_);
  }
});
j_("toReversed");
var X_ = X, Mp = function(t) {
  return X_[t].prototype;
}, W_ = E, z_ = k, J_ = ie, Z_ = he, Y_ = Tp, K_ = Mp, Q_ = V, q_ = Array, eS = z_(K_("Array").sort);
W_({ target: "Array", proto: !0 }, {
  toSorted: function(e) {
    e !== void 0 && J_(e);
    var r = Z_(this), n = Y_(q_, r);
    return eS(n, e);
  }
});
Q_("toSorted");
var tS = E, rS = V, nS = yt, iS = L, oS = vt, aS = he, sS = Fe, uS = Array, cS = Math.max, lS = Math.min;
tS({ target: "Array", proto: !0 }, {
  toSpliced: function(e, r) {
    var n = aS(this), i = iS(n), o = oS(e, i), a = arguments.length, s = 0, u, c, l, f;
    for (a === 0 ? u = c = 0 : a === 1 ? (u = 0, c = i - o) : (u = a - 2, c = lS(cS(sS(r), 0), i - o)), l = nS(i + u - c), f = uS(l); s < o; s++)
      f[s] = n[s];
    for (; s < o + u; s++)
      f[s] = arguments[s - o + 2];
    for (; s < l; s++)
      f[s] = n[s + c - u];
    return f;
  }
});
rS("toSpliced");
var fS = L, pS = Fe, dS = RangeError, vS = function(t, e, r, n) {
  var i = fS(t), o = pS(r), a = o < 0 ? i + o : o;
  if (a >= i || a < 0)
    throw dS("Incorrect index");
  for (var s = new e(i), u = 0; u < i; u++)
    s[u] = u === a ? n : t[u];
  return s;
}, hS = E, gS = vS, yS = he, IS = Array;
hS({ target: "Array", proto: !0 }, {
  with: function(t, e) {
    return gS(yS(this), IS, t, e);
  }
});
var mS = i1, AS = mS, _p = X, Sp = Nn, Rp = G, Vr = xn, ES = Se, CS = z, Ec = "USE_FUNCTION_CONSTRUCTOR", Cc = CS("asyncIterator"), bc = _p.AsyncIterator, Tc = Sp.AsyncIteratorPrototype, Xe, Wi;
if (Tc)
  Xe = Tc;
else if (Rp(bc))
  Xe = bc.prototype;
else if (Sp[Ec] || _p[Ec])
  try {
    Wi = Vr(Vr(Vr(Function("return async function*(){}()")()))), Vr(Wi) === Object.prototype && (Xe = Wi);
  } catch {
  }
Xe || (Xe = {});
Rp(Xe[Cc]) || ES(Xe, Cc, function() {
  return this;
});
var bS = Xe, wc = ee, Uo = ae, TS = Gt, wS = dt, NS = Cp, xp = Ft, OS = ne, MS = bS, Do = OS("Promise"), Pp = "AsyncFromSyncIterator", _S = xp.set, Nc = xp.getterFor(Pp), Oc = function(t, e, r) {
  var n = t.done;
  Do.resolve(t.value).then(function(i) {
    e({ done: n, value: i });
  }, r);
}, Up = function(e) {
  _S(this, {
    type: Pp,
    iterator: Uo(e),
    next: e.next
  });
};
Up.prototype = NS(TS(MS), {
  next: function() {
    var e = Nc(this);
    return new Do(function(r, n) {
      var i = Uo(wc(e.next, e.iterator));
      Oc(i, r, n);
    });
  },
  return: function() {
    var t = Nc(this).iterator;
    return new Do(function(e, r) {
      var n = wS(t, "return");
      if (n === void 0)
        return e({ done: !0, value: void 0 });
      var i = Uo(wc(n, t));
      Oc(i, e, r);
    });
  }
});
var Dp = Up, SS = ee, RS = Dp, xS = ae, PS = Ln, US = dt, DS = z, LS = DS("asyncIterator"), $S = function(t, e) {
  var r = arguments.length < 2 ? US(t, LS) : e;
  return r ? xS(SS(r, t)) : new RS(PS(t));
}, kS = ie, FS = ae, GS = function(t) {
  return {
    iterator: t,
    next: kS(FS(t).next)
  };
}, VS = ee, BS = ne, jS = dt, HS = function(t, e, r, n) {
  try {
    var i = jS(t, "return");
    if (i)
      return BS("Promise").resolve(VS(i, t)).then(function() {
        e(r);
      }, function(o) {
        n(o);
      });
  } catch (o) {
    return n(o);
  }
  e(r);
}, XS = ee, WS = ie, Mc = ae, zS = yt, JS = ne, ZS = GS, zi = HS, Kt = function(t) {
  var e = t == 0, r = t == 1, n = t == 2, i = t == 3;
  return function(o, a, s) {
    var u = ZS(o), c = JS("Promise"), l = u.iterator, f = u.next, p = 0, d = a !== void 0;
    return (d || !e) && WS(a), new c(function(C, R) {
      var S = function(N) {
        zi(l, R, N, R);
      }, T = function() {
        try {
          if (e && d)
            try {
              zS(p);
            } catch (N) {
              S(N);
            }
          c.resolve(Mc(XS(f, l))).then(function(N) {
            try {
              if (Mc(N).done)
                e ? (s.length = p, C(s)) : C(i ? !1 : n || void 0);
              else {
                var U = N.value;
                try {
                  d ? c.resolve(e ? a(U, p) : a(U)).then(function(D) {
                    if (r)
                      T();
                    else if (n)
                      D ? T() : zi(l, C, !1, R);
                    else if (e)
                      try {
                        s[p++] = D, T();
                      } catch (Oe) {
                        S(Oe);
                      }
                    else
                      D ? zi(l, C, i || U, R) : T();
                  }, S) : (s[p++] = U, T());
                } catch (D) {
                  S(D);
                }
              }
            } catch (D) {
              R(D);
            }
          }, R);
        } catch (N) {
          R(N);
        }
      };
      T();
    });
  };
}, YS = {
  toArray: Kt(0),
  forEach: Kt(1),
  every: Kt(2),
  some: Kt(3),
  find: Kt(4)
}, KS = we, QS = W, qS = Bt, eR = $S, tR = Ln, rR = Dn, nR = dt, iR = Mp, oR = ne, aR = z, sR = Dp, uR = YS.toArray, cR = aR("asyncIterator"), lR = iR("Array").values, fR = function(e) {
  var r = this, n = arguments.length, i = n > 1 ? arguments[1] : void 0, o = n > 2 ? arguments[2] : void 0;
  return new (oR("Promise"))(function(a) {
    var s = QS(e);
    i !== void 0 && (i = KS(i, o));
    var u = nR(s, cR), c = u ? void 0 : rR(s) || lR, l = qS(r) ? new r() : [], f = u ? eR(s, u) : new sR(tR(s, c));
    a(uR(f, i, l));
  });
}, pR = E, dR = fR;
pR({ target: "Array", stat: !0, forced: !0 }, {
  fromAsync: dR
});
var vR = E, hR = Ve.filterReject, gR = V;
vR({ target: "Array", proto: !0, forced: !0 }, {
  filterOut: function(e) {
    return hR(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
gR("filterOut");
var yR = E, IR = Ve.filterReject, mR = V;
yR({ target: "Array", proto: !0, forced: !0 }, {
  filterReject: function(e) {
    return IR(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
mR("filterReject");
var AR = E, ER = gt, _c = Object.isFrozen, Sc = function(t, e) {
  if (!_c || !ER(t) || !_c(t))
    return !1;
  for (var r = 0, n = t.length, i; r < n; )
    if (i = t[r++], !(typeof i == "string" || e && typeof i > "u"))
      return !1;
  return n !== 0;
};
AR({ target: "Array", stat: !0, sham: !0, forced: !0 }, {
  isTemplateObject: function(e) {
    if (!Sc(e, !0))
      return !1;
    var r = e.raw;
    return r.length === e.length && Sc(r, !1);
  }
});
var Rc = Yo.exports, CR = ge, Lp = function(t, e, r) {
  return r.get && Rc(r.get, e, { getter: !0 }), r.set && Rc(r.set, e, { setter: !0 }), CR.f(t, e, r);
}, bR = ve, TR = V, xc = W, Pc = L, wR = Lp;
bR && (wR(Array.prototype, "lastItem", {
  configurable: !0,
  get: function() {
    var e = xc(this), r = Pc(e);
    return r == 0 ? void 0 : e[r - 1];
  },
  set: function(e) {
    var r = xc(this), n = Pc(r);
    return r[n == 0 ? 0 : n - 1] = e;
  }
}), TR("lastItem"));
var NR = ve, OR = V, MR = W, _R = L, SR = Lp;
NR && (SR(Array.prototype, "lastIndex", {
  configurable: !0,
  get: function() {
    var e = MR(this), r = _R(e);
    return r == 0 ? 0 : r - 1;
  }
}), OR("lastIndex"));
var RR = ne, Bn = k, xR = ie, PR = L, UR = W, DR = Xt, $p = RR("Map"), Ea = $p.prototype, LR = Bn(Ea.forEach), $R = Bn(Ea.has), kR = Bn(Ea.set), FR = Bn([].push), GR = function(e) {
  var r = UR(this), n = PR(r), i = DR(r, 0), o = new $p(), a = e != null ? xR(e) : function(l) {
    return l;
  }, s, u, c;
  for (s = 0; s < n; s++)
    u = r[s], c = a(u), $R(o, c) || kR(o, c, u);
  return LR(o, function(l) {
    FR(i, l);
  }), i;
}, VR = E, BR = V, jR = GR;
VR({ target: "Array", proto: !0, forced: !0 }, {
  uniqueBy: jR
});
BR("uniqueBy");
var HR = AS, XR = HR;
(function(t) {
  t.exports = XR;
})(Iw);
var WR = function(t, e) {
  var r;
  if (e.currentSessionId === null)
    return t;
  if (!t.user.identifiers[Ee.SESSION]) {
    var n = t.copyWithUser(b(b({}, t.user), { identifiers: b(b({}, t.user.identifiers), (r = {}, r[Ee.SESSION] = e.sessionId, r)) }));
    return n;
  }
  return t;
}, Z = (
  /** @class */
  function() {
    function t(e, r, n) {
      n === void 0 && (n = Pt()), this.timestamp = e, this.user = r, this.insertId = n;
    }
    return t.exposure = function(e, r, n, i) {
      return new zR(i, e, r.experiment, r.variationId, r.variationKey, r.reason, n);
    }, t.track = function(e, r, n, i) {
      return new JR(i, n, e, r);
    }, t.remoteConfig = function(e, r, n, i) {
      return new ZR(i, e, r.parameter, r.valueId, r.reason, n);
    }, t.isExposureEvent = function(e) {
      return e.experiment !== void 0;
    }, t.isTrackEvent = function(e) {
      return e.eventType !== void 0;
    }, t.isRemoteConfigEvent = function(e) {
      return e.parameter !== void 0;
    }, t.isExposureEventDto = function(e) {
      return "experimentId" in e && typeof e.experimentId < "u";
    }, t.isTrackEventDto = function(e) {
      return "eventTypeId" in e && typeof e.eventTypeId < "u";
    }, t.isRemoteConfigEventDto = function(e) {
      return "parameterId" in e && typeof e.parameterId < "u";
    }, t.prototype.toDto = function() {
      return {
        insertId: this.insertId,
        timestamp: this.timestamp,
        userId: this.user.identifiers[Ee.ID],
        identifiers: this.user.identifiers,
        userProperties: de.sanitize(this.user.properties),
        hackleProperties: de.sanitize(this.user.hackleProperties)
      };
    }, t;
  }()
), zR = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o, a, s, u, c) {
      var l = t.call(this, r, n, c) || this;
      return l.experiment = i, l.variationId = o, l.variationKey = a, l.decisionReason = s, l.properties = u, l;
    }
    return e.prototype.copyWithUser = function(r) {
      return new e(this.timestamp, r, this.experiment, this.variationId, this.variationKey, this.decisionReason, this.properties, this.insertId);
    }, e.prototype.toDto = function() {
      return b(b({}, t.prototype.toDto.call(this)), { experimentId: this.experiment.id, experimentKey: this.experiment.key, experimentType: this.experiment.type, experimentVersion: this.experiment.version, variationId: this.variationId, variationKey: this.variationKey, decisionReason: this.decisionReason.toString(), properties: this.properties });
    }, e;
  }(Z)
), JR = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o, a) {
      var s = t.call(this, r, n, a) || this;
      return s.eventType = i, s.event = o, s;
    }
    return e.prototype.copyWithUser = function(r) {
      return new e(this.timestamp, r, this.eventType, this.event, this.insertId);
    }, e.prototype.toDto = function() {
      return b(b({}, t.prototype.toDto.call(this)), { eventTypeId: this.eventType.id, eventTypeKey: this.eventType.key, value: this.event.value || 0, properties: de.sanitize(this.event.properties) });
    }, e;
  }(Z)
), ZR = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o, a, s, u) {
      var c = t.call(this, r, n, u) || this;
      return c.parameter = i, c.valueId = o, c.decisionReason = a, c.properties = s, c;
    }
    return e.prototype.copyWithUser = function(r) {
      return new e(this.timestamp, r, this.parameter, this.valueId, this.decisionReason, this.properties, this.insertId);
    }, e.prototype.toDto = function() {
      return b(b({}, t.prototype.toDto.call(this)), { parameterId: this.parameter.id, parameterKey: this.parameter.key, parameterType: this.parameter.type, valueId: this.valueId, decisionReason: this.decisionReason.toString(), properties: de.sanitize(this.properties) });
    }, e;
  }(Z)
), kp = (
  /** @class */
  function() {
    function t(e, r) {
      this.userManager = e, this.core = r;
    }
    return t.isSessionEvent = function(e) {
      return Z.isTrackEvent(e) ? e.event.key === t.SESSION_START_EVENT_NAME || e.event.key === t.SESSION_END_EVENT_NAME : !1;
    }, t.prototype.onSessionStarted = function(e, r, n) {
      this.track(t.SESSION_START_EVENT_NAME, e, r, n);
    }, t.prototype.onSessionEnded = function(e, r, n) {
      this.track(t.SESSION_END_EVENT_NAME, e, r, n);
    }, t.prototype.track = function(e, r, n, i) {
      var o = { key: e }, a = this.userManager.toHackleUser(n), s = this.decorateSession(a, r);
      this.core.track(o, s, i);
    }, t.prototype.decorateSession = function(e, r) {
      var n = new Xo().add(Ee.SESSION, r).addIdentifiers(e.identifiers).build();
      return b(b({}, e), { identifiers: n });
    }, t.SESSION_START_EVENT_NAME = "$session_start", t.SESSION_END_EVENT_NAME = "$session_end", t;
  }()
), YR = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.delegate = e, this.eventDedupDeterminer = r, this.sessionManager = n, this.userManager = i;
    }
    return t.prototype.process = function(e) {
      if (kp.isSessionEvent(e) || this.sessionManager.startNewSessionIfNeeded(this.userManager.currentUser, e.timestamp), !this.eventDedupDeterminer.isDedupTarget(e)) {
        var r = WR(e.copyWithUser(e.user), this.sessionManager);
        this.delegate.process(r);
      }
    }, t.prototype.flush = function(e) {
      this.delegate.flush(e);
    }, t.prototype.close = function() {
      this.delegate.close();
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "hidden":
        case "pagehide":
          return this.flush(!0);
        case "blur":
        case "focus":
        case "locationChange":
        case "visible":
        case "pageshow":
          return;
      }
    }, t;
  }()
), KR = (
  /** @class */
  function() {
    function t() {
    }
    return t.toEvent = function(e) {
      var r;
      return {
        key: t.EVENT_KEY,
        properties: {
          level: t.LEVEL_ERROR,
          type: e.name,
          message: (r = e.message) !== null && r !== void 0 ? r : "",
          $stacktrace: t._stacktrace(e)
        }
      };
    }, t._stacktrace = function(e) {
      return v.isNullOrUndefined(e.stack) ? "" : e.stack.split(`
`).slice(0, t.STACK_TRACK_LIMIT).join(`
`);
    }, t.EVENT_KEY = "$trace", t.LEVEL_ERROR = "error", t.STACK_TRACK_LIMIT = 30, t;
  }()
), Ca = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r) {
      if (!this.supports(e))
        throw new Error("Unsupported EvaluatorRequest ".concat(e.toString()));
      if (r.contains(e)) {
        var n = r.stack.map(function(i) {
          return i.toString();
        }).join(" - ");
        throw new Error("Circular evaluation has occurred [".concat(n, " - ").concat(e.toString(), "]"));
      }
      r.addRequest(e);
      try {
        return this.evaluateInternal(e, r);
      } finally {
        r.removeRequest(e);
      }
    }, t;
  }()
), q = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      this.reason = e, this.targetEvaluations = r, this.experiment = n, this.variationId = i, this.variationKey = o, this.config = a;
    }
    return t.prototype.with = function(e) {
      return new t(e, this.targetEvaluations, this.experiment, this.variationId, this.variationKey, this.config);
    }, t.of = function(e, r, n, i) {
      var o = this.config(e.workspace, n);
      return new t(i, r.targetEvaluations, e.experiment, n.id, n.key, o);
    }, t.ofDefault = function(e, r, n) {
      var i = e.experiment._getVariationByKeyOrNull(e.defaultVariationKey);
      return v.isNotNullOrUndefined(i) ? this.of(e, r, i, n) : new t(n, r.targetEvaluations, e.experiment, void 0, e.defaultVariationKey, void 0);
    }, t.config = function(e, r) {
      if (!v.isNullOrUndefined(r.parameterConfigurationId))
        return v.requiredNotNullOrUndefined(e.getParameterConfigurationOrNull(r.parameterConfigurationId), function() {
          return "ParameterConfiguration[".concat(r.parameterConfigurationId, "]");
        });
    }, t;
  }()
), QR = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r) {
      var n = t.call(this) || this;
      return n.evaluationFlowFactory = r, n;
    }
    return e.prototype.supports = function(r) {
      return r.experiment !== void 0;
    }, e.prototype.evaluateInternal = function(r, n) {
      var i, o = this.evaluationFlowFactory.getExperimentFlow(r.experiment.type);
      return (i = o.evaluate(r, n)) !== null && i !== void 0 ? i : q.ofDefault(r, n, w.TRAFFIC_NOT_ALLOCATED);
    }, e;
  }(Ca)
), nn = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      this.reason = e, this.targetEvaluations = r, this.parameter = n, this.valueId = i, this.value = o, this.properties = a;
    }
    return t.of = function(e, r, n, i, o, a) {
      return a.returnValue = de.truncateStringValue(i), new t(o, r.targetEvaluations, e.parameter, n, i, a);
    }, t.ofDefault = function(e, r, n, i) {
      return this.of(e, r, void 0, e.defaultValue, n, i);
    }, t;
  }()
), qR = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r) {
      var n = t.call(this) || this;
      return n.targetRuleDeterminer = r, n;
    }
    return e.prototype.supports = function(r) {
      return r.parameter !== void 0;
    }, e.prototype.evaluateInternal = function(r, n) {
      var i = {};
      if (i.requestValueType = r.requiredType, i.requestDefaultValue = de.truncateStringValue(r.defaultValue), v.isNullOrUndefined(r.user.identifiers[r.parameter.identifierType]))
        return nn.ofDefault(r, n, w.IDENTIFIER_NOT_FOUND, i);
      var o = this.targetRuleDeterminer.determineTargetRuleOrNull(r, n);
      return v.isNotNullOrUndefined(o) ? (i.targetRuleKey = o.key, i.targetRuleName = o.name, this.evaluation(r, n, o.value, w.TARGET_RULE_MATCH, i)) : this.evaluation(r, n, r.parameter.defaultValue, w.DEFAULT_RULE, i);
    }, e.prototype.evaluation = function(r, n, i, o, a) {
      return r.requiredType === "UNKNOWN" || r.requiredType !== "NULL" && typeof r.defaultValue != typeof i.rawValue ? nn.ofDefault(r, n, w.TYPE_MISMATCH, a) : nn.of(r, n, i.id, i.rawValue, o, a);
    }, e;
  }(Ca)
), Cr = (
  /** @class */
  function() {
    function t(e, r) {
      this.type = e, this.id = r;
    }
    return t.prototype.isEquals = function(e) {
      return this.type === e.type && this.id === e.id;
    }, t;
  }()
), tt = (
  /** @class */
  function() {
    function t() {
      this._stack = [], this._targetEvaluations = [], this._properties = {};
    }
    return t.create = function() {
      return new t();
    }, Object.defineProperty(t.prototype, "stack", {
      get: function() {
        return Array.from(this._stack);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "targetEvaluations", {
      get: function() {
        return Array.from(this._targetEvaluations);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "properties", {
      get: function() {
        return de.sanitize(this._properties);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.contains = function(e) {
      return this._stack.some(function(r) {
        return r.key.isEquals(e.key);
      });
    }, t.prototype.addRequest = function(e) {
      this._stack.push(e);
    }, t.prototype.removeRequest = function(e) {
      var r = this._stack.indexOf(e, 0);
      r > -1 && this._stack.splice(r, 1);
    }, t.prototype.getEvaluation = function(e) {
      return this._targetEvaluations.find(function(r) {
        return r instanceof q && r.experiment.id === e.id;
      });
    }, t.prototype.addEvaluation = function(e) {
      this._targetEvaluations.push(e);
    }, t.prototype.setProperty = function(e, r) {
      this._properties[e] = r;
    }, t;
  }()
), rt = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.key = new Cr("EXPERIMENT", n.id), this.workspace = e, this.user = r, this.experiment = n, this.defaultVariationKey = i;
    }
    return t.of = function(e, r, n, i) {
      return new t(e, r, n, i);
    }, t.by = function(e, r) {
      return new t(e.workspace, e.user, r, "A");
    }, t.prototype.toString = function() {
      return "EvaluatorRequest(type=".concat(this.experiment.type, ", key=").concat(this.experiment.key, ")");
    }, t;
  }()
), e2 = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.key = new Cr("REMOTE_CONFIG", n.id), this.workspace = e, this.user = r, this.parameter = n, this.requiredType = i, this.defaultValue = o;
    }
    return t.of = function(e, r, n, i, o) {
      return new t(e, r, n, i, o);
    }, t.prototype.toString = function() {
      return "EvaluatorRequest(type=".concat(this.key.type, ", key=").concat(this.parameter.key, ")");
    }, t;
  }()
), $e = (
  /** @class */
  function() {
    function t() {
    }
    return t.asString = function(e) {
      switch (typeof e) {
        case "string":
          return e;
        case "number":
          return e.toString();
        default:
          return;
      }
    }, t.asNumber = function(e) {
      switch (typeof e) {
        case "number":
          return this.asActualNumber(e);
        case "string":
          return this.asActualNumber(Number(e));
        default:
          return;
      }
    }, t.asActualNumber = function(e) {
      if (!isNaN(e) && isFinite(e))
        return e;
    }, t;
  }()
), t2 = (
  /** @class */
  function() {
    function t(e) {
      this.storages = e;
    }
    return t.prototype.getVariation = function(e, r) {
      if (this.storages.length !== 0)
        for (var n = 0, i = this.storages; n < i.length; n++) {
          var o = i[n], a = o.getVariation(e, r);
          if (a !== void 0)
            return a;
        }
    }, t;
  }()
), Uc = (
  /** @class */
  function() {
    function t(e) {
      this.listStorage = e;
    }
    return t.prototype.getVariation = function(e, r) {
      var n = this.get(e);
      if (n)
        return e._getVariationByIdOrNull(n);
    }, t.prototype.get = function(e) {
      var r = this.listStorage.getItem(e.id.toString());
      return $e.asNumber(r);
    }, t.prototype.getAll = function() {
      var e = /* @__PURE__ */ new Map();
      return this.listStorage.entries().forEach(function(r) {
        var n = r[0], i = r[1], o = $e.asNumber(n), a = $e.asNumber(i);
        v.isNullOrUndefined(o) || o < 0 || v.isNullOrUndefined(a) || o < 0 || e.set(o, a);
      }), e;
    }, t.prototype.set = function(e, r) {
      this.listStorage.setItem(e.id.toString(), r.toString());
    }, t.prototype.remove = function(e) {
      this.listStorage.removeItem(e.id.toString());
    }, t.prototype.clear = function() {
      this.listStorage.clear();
    }, t;
  }()
), r2 = (
  /** @class */
  function() {
    function t() {
      this.evaluators = new Array();
    }
    return t.prototype.add = function(e) {
      this.evaluators.push(e);
    }, t.prototype.evaluate = function(e, r) {
      var n = this.evaluators.find(function(i) {
        return i.supports(e);
      });
      if (v.isNullOrUndefined(n))
        throw new Error("Unsupported EvaluatorRequest [".concat(e.toString(), "]"));
      return n.evaluate(e, r);
    }, t;
  }()
), n2 = (
  /** @class */
  function() {
    function t(e) {
      this.conditionMatcherFactory = e;
    }
    return t.prototype.matches = function(e, r, n) {
      var i = this;
      return n.conditions.every(function(o) {
        return i._matches(e, r, o);
      });
    }, t.prototype.anyMatches = function(e, r, n) {
      var i = this;
      return n.length ? n.some(function(o) {
        return i.matches(e, r, o);
      }) : !0;
    }, t.prototype._matches = function(e, r, n) {
      var i = this.conditionMatcherFactory.getMatcher(n.key.type);
      return i.matches(e, r, n);
    }, t;
  }()
), Fp = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decorate = function(e) {
      return e;
    }, t;
  }()
), i2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decorate = function(e) {
      return typeof e == "string" ? Ce.decodeURIOrOriginal(e) : e;
    }, t;
  }()
), o2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.valueMatcherFactory = e, this.operatorMatcherFactory = r;
    }
    return t.prototype.matches = function(e, r, n) {
      n === void 0 && (n = new Fp());
      var i = this.valueMatcherFactory.getMatcher(r.valueType), o = this.operatorMatcherFactory.getMatcher(r.operator), a = this.userValueMatches(e, r, i, o, n);
      return this.typeMatches(r.type, a);
    }, t.prototype.userValueMatches = function(e, r, n, i, o) {
      return Array.isArray(e) ? this.arrayMatches(e, r, n, i, o) : this.singleMatches(e, r, n, i, o);
    }, t.prototype.singleMatches = function(e, r, n, i, o) {
      return r.values.some(function(a) {
        return n.matches(i, o.decorate(e), o.decorate(a));
      });
    }, t.prototype.arrayMatches = function(e, r, n, i, o) {
      var a = this;
      return e.some(function(s) {
        return a.singleMatches(s, r, n, i, o);
      });
    }, t.prototype.typeMatches = function(e, r) {
      switch (e) {
        case "MATCH":
          return r;
        case "NOT_MATCH":
          return !r;
      }
    }, t;
  }()
), a2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return e === r;
    }, t.prototype.numberMatches = function(e, r) {
      return e === r;
    }, t.prototype.stringMatches = function(e, r) {
      return e === r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isEqualTo(r);
    }, t.prototype.urlMatches = function(e, r) {
      var n = Ce.decodeURIOrOriginal(Ce.removePathnameTrailingSlash(e)), i = Ce.decodeURIOrOriginal(Ce.removePathnameTrailingSlash(r));
      return n === i;
    }, t;
  }()
), s2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return !1;
    }, t.prototype.stringMatches = function(e, r) {
      return e.includes(r);
    }, t.prototype.versionMatches = function(e, r) {
      return !1;
    }, t.prototype.urlMatches = function(e, r) {
      var n = Ce.decodeURIOrOriginal(e.href);
      return n.includes(r) || n.includes(encodeURI(r));
    }, t;
  }()
), u2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return !1;
    }, t.prototype.stringMatches = function(e, r) {
      return e.startsWith(r);
    }, t.prototype.versionMatches = function(e, r) {
      return !1;
    }, t.prototype.urlMatches = function(e, r) {
      var n = Ce.decodeURIOrOriginal(e.href);
      return n.startsWith(r) || n.startsWith(encodeURI(r));
    }, t;
  }()
), c2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return !1;
    }, t.prototype.stringMatches = function(e, r) {
      return e.endsWith(r);
    }, t.prototype.versionMatches = function(e, r) {
      return !1;
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), l2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return e > r;
    }, t.prototype.stringMatches = function(e, r) {
      return e > r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isGreaterThan(r);
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), f2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return e >= r;
    }, t.prototype.stringMatches = function(e, r) {
      return e >= r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isGreaterThanOrEqualTo(r);
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), p2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return e < r;
    }, t.prototype.stringMatches = function(e, r) {
      return e < r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isLessThan(r);
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), d2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return e <= r;
    }, t.prototype.stringMatches = function(e, r) {
      return e <= r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isLessThanOrEqualTo(r);
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), v2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getMatcher = function(e) {
      switch (e) {
        case "IN":
          return t.IN_MATCHER;
        case "CONTAINS":
          return t.CONTAINS_MATCHER;
        case "STARTS_WITH":
          return t.STARTS_WITH_MATCHER;
        case "ENDS_WITH":
          return t.ENDS_WITH_MATCHER;
        case "GT":
          return t.GT_MATCHER;
        case "GTE":
          return t.GTE_MATCHER;
        case "LT":
          return t.LT_MATCHER;
        case "LTE":
          return t.LTE_MATCHER;
      }
    }, t.IN_MATCHER = new a2(), t.CONTAINS_MATCHER = new s2(), t.STARTS_WITH_MATCHER = new u2(), t.ENDS_WITH_MATCHER = new c2(), t.GT_MATCHER = new l2(), t.GTE_MATCHER = new f2(), t.LT_MATCHER = new p2(), t.LTE_MATCHER = new d2(), t;
  }()
), h2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      var i = $e.asString(r), o = $e.asString(n);
      return v.isNullOrUndefined(i) || v.isNullOrUndefined(o) ? !1 : e.stringMatches(i, o);
    }, t;
  }()
), g2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      var i = $e.asNumber(r), o = $e.asNumber(n);
      return v.isNullOrUndefined(i) || v.isNullOrUndefined(o) ? !1 : e.numberMatches(i, o);
    }, t;
  }()
), y2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      return typeof r == "boolean" && typeof n == "boolean" ? e.booleanMatches(r, n) : !1;
    }, t;
  }()
), I2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      var i = as.tryParse(r), o = as.tryParse(n);
      return i && o ? e.versionMatches(i, o) : !1;
    }, t;
  }()
), m2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      var i = Ce.tryParse(r), o = $e.asString(n);
      return v.isNullOrUndefined(i) || v.isNullOrUndefined(o) ? !1 : e.urlMatches(i, o);
    }, t;
  }()
), A2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      return !1;
    }, t;
  }()
), E2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getMatcher = function(e) {
      switch (e) {
        case "STRING":
          return t.STRING_MATCHER;
        case "JSON":
          return t.STRING_MATCHER;
        case "NUMBER":
          return t.NUMBER_MATCHER;
        case "BOOLEAN":
          return t.BOOLEAN_MATCHER;
        case "VERSION":
          return t.VERSION_MATCHER;
        case "URL":
          return t.URL_MATCHER;
        case "NULL":
          return t.NULL_MATCHER;
        case "UNKNOWN":
          return t.NULL_MATCHER;
      }
    }, t.STRING_MATCHER = new h2(), t.NUMBER_MATCHER = new g2(), t.BOOLEAN_MATCHER = new y2(), t.VERSION_MATCHER = new I2(), t.URL_MATCHER = new m2(), t.NULL_MATCHER = new A2(), t;
  }()
), C2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.URL_HACKLE_PROPERTY_KEY_NAMES = ["pagePath", "host", "url", "queryParameter"], this.userValueResolver = e, this.valueOperatorMatcher = r;
    }
    return t.prototype.matches = function(e, r, n) {
      var i = this.userValueResolver.resolveOrNull(e.user, n.key);
      if (v.isNullOrUndefined(i))
        return !1;
      var o = this.valueDecorator(n.key);
      return this.valueOperatorMatcher.matches(i, n.match, o);
    }, t.prototype.valueDecorator = function(e) {
      return e.type === "HACKLE_PROPERTY" && this.URL_HACKLE_PROPERTY_KEY_NAMES.includes(e.name) ? new i2() : new Fp();
    }, t;
  }()
), b2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.resolveOrNull = function(e, r) {
      switch (r.type) {
        case "USER_ID":
          return e.identifiers[r.name];
        case "USER_PROPERTY":
          return e.properties[r.name];
        case "HACKLE_PROPERTY":
          return e.hackleProperties[r.name];
        case "SEGMENT":
        case "AB_TEST":
        case "FEATURE_FLAG":
        case "EVENT_PROPERTY":
        case "COHORT":
          throw new Error("Unsupported TargetKeyType [".concat(r.type, "]"));
      }
    }, t;
  }()
), T2 = (
  /** @class */
  function() {
    function t(e) {
      this.segmentMatcher = e;
    }
    return t.prototype.matches = function(e, r, n) {
      var i = this;
      if (n.key.type != "SEGMENT")
        throw new Error("Unsupported TargetKeyType [".concat(n.key.type, "]"));
      var o = n.match.values.some(function(a) {
        return i._matches(e, r, a);
      });
      switch (n.match.type) {
        case "MATCH":
          return o;
        case "NOT_MATCH":
          return !o;
      }
    }, t.prototype._matches = function(e, r, n) {
      if (typeof n != "string")
        throw new Error("SegmentKey[".concat(n, "]"));
      var i = e.workspace.getSegmentOrNull(n);
      if (!i)
        throw new Error("Segment[".concat(n, "]"));
      return this.segmentMatcher.matches(e, r, i);
    }, t;
  }()
), w2 = (
  /** @class */
  function() {
    function t(e) {
      this.userConditionMatcher = e;
    }
    return t.prototype.matches = function(e, r, n) {
      var i = this;
      return n.targets.some(function(o) {
        return i._matches(e, r, o);
      });
    }, t.prototype._matches = function(e, r, n) {
      var i = this;
      return n.conditions.every(function(o) {
        return i.userConditionMatcher.matches(e, r, o);
      });
    }, t;
  }()
), N2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.abTestMatcher = e, this.featureFlagMatcher = r;
    }
    return t.prototype.matches = function(e, r, n) {
      switch (n.key.type) {
        case "AB_TEST":
          return this.abTestMatcher.matches(e, r, n);
        case "FEATURE_FLAG":
          return this.featureFlagMatcher.matches(e, r, n);
        case "USER_ID":
        case "USER_PROPERTY":
        case "HACKLE_PROPERTY":
        case "EVENT_PROPERTY":
        case "SEGMENT":
        case "COHORT":
          throw new Error("Unsupported TargetKeyType [".concat(n.key.type, "]"));
      }
    }, t;
  }()
), Gp = (
  /** @class */
  function() {
    function t(e, r) {
      this.evaluator = e, this.valueOperatorMatcher = r;
    }
    return t.prototype.matches = function(e, r, n) {
      var i, o = v.requiredNotNullOrUndefined($e.asNumber(n.key.name), function() {
        return "Invalid key [".concat(n.key.type, ", ").concat(n.key.name, "]");
      }), a = this.experiment(e, o);
      if (v.isNullOrUndefined(a))
        return !1;
      var s = (i = r.getEvaluation(a)) !== null && i !== void 0 ? i : this.evaluate(e, r, a);
      return this.evaluationMatches(s, n);
    }, t.prototype.evaluate = function(e, r, n) {
      var i = rt.by(e, n), o = this.evaluator.evaluate(i, r), a = this.resolve(e, o);
      return r.addEvaluation(a), a;
    }, t;
  }()
), O2 = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return t.call(this, r, n) || this;
    }
    return e.prototype.experiment = function(r, n) {
      return r.workspace.getExperimentOrNull(n);
    }, e.prototype.resolve = function(r, n) {
      return r instanceof rt && n.reason === w.TRAFFIC_ALLOCATED ? n.with(w.TRAFFIC_ALLOCATED_BY_TARGETING) : n;
    }, e.prototype.evaluationMatches = function(r, n) {
      return e.AB_TEST_MATCHED_REASONS.includes(r.reason) ? this.valueOperatorMatcher.matches(r.variationKey, n.match) : !1;
    }, e.AB_TEST_MATCHED_REASONS = [
      w.OVERRIDDEN,
      w.TRAFFIC_ALLOCATED,
      w.EXPERIMENT_COMPLETED,
      w.TRAFFIC_ALLOCATED_BY_TARGETING
    ], e;
  }(Gp)
), M2 = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return t.call(this, r, n) || this;
    }
    return e.prototype.experiment = function(r, n) {
      return r.workspace.getFeatureFlagOrNull(n);
    }, e.prototype.resolve = function(r, n) {
      return n;
    }, e.prototype.evaluationMatches = function(r, n) {
      var i = r.variationKey !== "A";
      return this.valueOperatorMatcher.matches(i, n.match);
    }, e;
  }(Gp)
), _2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.eventValueResolver = e, this.valueOperatorMatcher = r;
    }
    return t.prototype.matches = function(e, r, n) {
      if (!this.isEventEvaluatorRequest(e))
        return !1;
      var i = this.eventValueResolver.resolveOrNull(e.event, n.key);
      return v.isNullOrUndefined(i) ? !1 : this.valueOperatorMatcher.matches(i, n.match);
    }, t.prototype.isEventEvaluatorRequest = function(e) {
      return e.event !== void 0;
    }, t;
  }()
), S2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.resolveOrNull = function(e, r) {
      var n;
      switch (r.type) {
        case "EVENT_PROPERTY":
          return (n = this.properties(e)) === null || n === void 0 ? void 0 : n[r.name];
        case "USER_ID":
        case "USER_PROPERTY":
        case "HACKLE_PROPERTY":
        case "SEGMENT":
        case "AB_TEST":
        case "FEATURE_FLAG":
        case "COHORT":
          throw new Error("Unsupported TargetKeyType [".concat(r.type, "]"));
      }
    }, t.prototype.properties = function(e) {
      if (Z.isTrackEvent(e))
        return e.event.properties;
      if (Z.isExposureEvent(e) || Z.isRemoteConfigEvent(e))
        return e.properties;
    }, t;
  }()
), R2 = (
  /** @class */
  function() {
    function t(e) {
      this.valueOperatorMatcher = e;
    }
    return t.prototype.matches = function(e, r, n) {
      var i, o;
      if (n.key.type !== "COHORT")
        throw new Error("Unsupported TargetKeyType [".concat(n.key.type, "]"));
      var a = (o = (i = e.user.cohorts) === null || i === void 0 ? void 0 : i.map(function(s) {
        return s.id;
      })) !== null && o !== void 0 ? o : [];
      return this.valueOperatorMatcher.matches(a, n.match);
    }, t;
  }()
), x2 = (
  /** @class */
  function() {
    function t(e) {
      var r = new o2(new E2(), new v2());
      this.userConditionMatcher = new C2(new b2(), r), this.eventConditionMatcher = new _2(new S2(), r), this.segmentConditionMatcher = new T2(new w2(this.userConditionMatcher)), this.experimentConditionMatcher = new N2(new O2(e, r), new M2(e, r)), this.cohortConditionMatcher = new R2(r);
    }
    return t.prototype.getMatcher = function(e) {
      switch (e) {
        case "USER_ID":
        case "USER_PROPERTY":
        case "HACKLE_PROPERTY":
          return this.userConditionMatcher;
        case "EVENT_PROPERTY":
          return this.eventConditionMatcher;
        case "SEGMENT":
          return this.segmentConditionMatcher;
        case "AB_TEST":
        case "FEATURE_FLAG":
          return this.experimentConditionMatcher;
        case "COHORT":
          return this.cohortConditionMatcher;
      }
    }, t;
  }()
), P2 = (
  /** @class */
  function() {
    function t(e) {
      this.bucketer = e;
    }
    return t.prototype.resolveOrNull = function(e, r, n) {
      switch (n.type) {
        case "VARIATION":
          return this.resolveVariation(e, n);
        case "BUCKET":
          return this.resolveBucket(e, n);
      }
    }, t.prototype.resolveVariation = function(e, r) {
      return e.experiment._getVariationByIdOrNull(r.variationId);
    }, t.prototype.resolveBucket = function(e, r) {
      var n = e.workspace.getBucketOrNull(r.bucketId), i = e.user.identifiers[e.experiment.identifierType];
      if (i) {
        var o = this.bucketer.bucketing(n, i);
        if (o)
          return e.experiment._getVariationByIdOrNull(o.variationId);
      }
    }, t;
  }()
), U2 = {
  murmurhash3_x86_32: function(t, e, r, n) {
    n === void 0 && (n = t.length);
    for (var i = 3432918353, o = 461845907, a = n & -4, s = e, u, c = 0; c < a; c += 4)
      u = t.charCodeAt(c) & 255 | (t.charCodeAt(c + 1) & 255) << 8 | (t.charCodeAt(c + 2) & 255) << 16 | (t.charCodeAt(c + 3) & 255) << 24, u = this.mul32(u, i), u = (u & 131071) << 15 | u >>> 17, u = this.mul32(u, o), s ^= u, s = (s & 524287) << 13 | s >>> 19, s = s * 5 + 3864292196 | 0;
    switch (u = 0, n % 4) {
      case 3:
        u = (t.charCodeAt(a + 2) & 255) << 16;
      case 2:
        u |= (t.charCodeAt(a + 1) & 255) << 8;
      case 1:
        u |= t.charCodeAt(a) & 255, u = this.mul32(u, i), u = (u & 131071) << 15 | u >>> 17, u = this.mul32(u, o), s ^= u;
    }
    return s ^= n, s ^= s >>> 16, s = this.mul32(s, 2246822507), s ^= s >>> 13, s = this.mul32(s, 3266489909), s ^= s >>> 16, s;
  },
  mul32: function(t, e) {
    var r = e & 65535, n = e - r;
    return (n * t | 0) + (r * t | 0) | 0;
  }
}, D2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.bucketing = function(e, r) {
      var n = this.calculateSlotNumber(e.seed, e.slotSize, r);
      return e.slots.find(function(i) {
        return i.contains(n);
      });
    }, t.prototype.calculateSlotNumber = function(e, r, n) {
      var i = U2.murmurhash3_x86_32(n, e);
      return Math.abs(i) % Math.abs(r);
    }, t;
  }()
), Ji = (
  /** @class */
  function() {
    function t(e, r) {
      this.flowEvaluator = e, this.nextFlow = r;
    }
    return t.prototype.evaluate = function(e, r) {
      if (this.flowEvaluator && this.nextFlow)
        return this.flowEvaluator.evaluate(e, r, this.nextFlow);
    }, t.end = function() {
      return new t(void 0, void 0);
    }, t.decision = function(e, r) {
      return new t(e, r);
    }, t.of = function() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      for (var n = this.end(), i = 0, o = e.reverse(); i < o.length; i++) {
        var a = o[i];
        n = this.decision(a, n);
      }
      return n;
    }, t;
  }()
), Dc = (
  /** @class */
  function() {
    function t(e) {
      this.overrideResolver = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      var i = this.overrideResolver.resolveOrNull(e, r);
      if (i)
        switch (e.experiment.type) {
          case "AB_TEST":
            return q.of(e, r, i, w.OVERRIDDEN);
          case "FEATURE_FLAG":
            return q.of(e, r, i, w.INDIVIDUAL_TARGET_MATCH);
        }
      else
        return n.evaluate(e, r);
    }, t;
  }()
), Lc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.experiment.status === "DRAFT" ? q.ofDefault(e, r, w.EXPERIMENT_DRAFT) : n.evaluate(e, r);
    }, t;
  }()
), $c = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status === "PAUSED")
        switch (e.experiment.type) {
          case "AB_TEST":
            return q.ofDefault(e, r, w.EXPERIMENT_PAUSED);
          case "FEATURE_FLAG":
            return q.ofDefault(e, r, w.FEATURE_FLAG_INACTIVE);
        }
      else
        return n.evaluate(e, r);
    }, t;
  }()
), kc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status === "COMPLETED") {
        var i = e.experiment._winnerVariationOrNull();
        if (!i)
          throw new Error("winner variation [".concat(e.experiment.id, "]"));
        return q.of(e, r, i, w.EXPERIMENT_COMPLETED);
      } else
        return n.evaluate(e, r);
    }, t;
  }()
), L2 = (
  /** @class */
  function() {
    function t(e) {
      this.experimentTargetDeterminer = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.type !== "AB_TEST")
        throw new Error("experiment type must be AB_TEST [".concat(e.experiment.id, "]"));
      var i = this.experimentTargetDeterminer.isUserInExperimentTarget(e, r);
      return i ? n.evaluate(e, r) : q.ofDefault(e, r, w.NOT_IN_EXPERIMENT_TARGET);
    }, t;
  }()
), $2 = (
  /** @class */
  function() {
    function t(e) {
      this.actionResolver = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status !== "RUNNING")
        throw new Error("experiment status must be RUNNING [".concat(e.experiment.id, "]"));
      if (e.experiment.type !== "AB_TEST")
        throw new Error("experiment type must be AB_TEST [".concat(e.experiment.id, "]"));
      var i = this.actionResolver.resolveOrNull(e, r, e.experiment.defaultRule);
      return i ? i.isDropped ? q.ofDefault(e, r, w.VARIATION_DROPPED) : q.of(e, r, i, w.TRAFFIC_ALLOCATED) : q.ofDefault(e, r, w.TRAFFIC_NOT_ALLOCATED);
    }, t;
  }()
), k2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.targetRuleDeterminer = e, this.actionResolver = r;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status !== "RUNNING")
        throw new Error("experiment status must be RUNNING [".concat(e.experiment.id, "]"));
      if (e.experiment.type !== "FEATURE_FLAG")
        throw new Error("experiment type must be FEATURE_FLAG [".concat(e.experiment.id, "]"));
      if (!e.user.identifiers[e.experiment.identifierType])
        return n.evaluate(e, r);
      var i = this.targetRuleDeterminer.determineTargetRuleOrNull(e, r);
      if (!i)
        return n.evaluate(e, r);
      var o = this.actionResolver.resolveOrNull(e, r, i.action);
      if (!o)
        throw new Error("FeatureFlag must decide the Variation [".concat(e.experiment.id, "]"));
      return q.of(e, r, o, w.TARGET_RULE_MATCH);
    }, t;
  }()
), F2 = (
  /** @class */
  function() {
    function t(e) {
      this.actionResolver = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status !== "RUNNING")
        throw new Error("experiment status must be RUNNING [".concat(e.experiment.id, "]"));
      if (e.experiment.type !== "FEATURE_FLAG")
        throw new Error("experiment type must be FEATURE_FLAG [".concat(e.experiment.id, "]"));
      if (!e.user.identifiers[e.experiment.identifierType])
        return q.ofDefault(e, r, w.DEFAULT_RULE);
      var i = this.actionResolver.resolveOrNull(e, r, e.experiment.defaultRule);
      if (!i)
        throw new Error("FeatureFlag must decide the Variation [".concat(e.experiment.id, "]"));
      return q.of(e, r, i, w.DEFAULT_RULE);
    }, t;
  }()
), G2 = (
  /** @class */
  function() {
    function t(e) {
      this.containerResolver = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      var i = e.experiment.containerId;
      if (!i)
        return n.evaluate(e, r);
      var o = e.workspace.getContainerOrNull(i);
      if (!o)
        throw new Error("container[".concat(i, "]"));
      var a = this.containerResolver.isUserInContainerGroup(e, r, o);
      return a ? n.evaluate(e, r) : q.ofDefault(e, r, w.NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT);
    }, t;
  }()
), Fc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.user.identifiers[e.experiment.identifierType] ? n.evaluate(e, r) : q.ofDefault(e, r, w.IDENTIFIER_NOT_FOUND);
    }, t;
  }()
), V2 = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.isUserInExperimentTarget = function(e, r) {
      var n = this;
      return e.experiment.targetAudiences.length === 0 ? !0 : e.experiment.targetAudiences.some(function(i) {
        return n.targetMatcher.matches(e, r, i);
      });
    }, t;
  }()
), B2 = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.determineTargetRuleOrNull = function(e, r) {
      var n = this;
      return e.experiment.targetRules.find(function(i) {
        return n.targetMatcher.matches(e, r, i.target);
      });
    }, t;
  }()
), j2 = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.manualOverrideStorage = e, this.targetMatcher = r, this.actionResolver = n;
    }
    return t.prototype.resolveOrNull = function(e, r) {
      var n, i;
      return (i = (n = this.resolveManualOverride(e)) !== null && n !== void 0 ? n : this._resolveUserOverride(e)) !== null && i !== void 0 ? i : this._resolveSegmentOverride(e, r);
    }, t.prototype.resolveManualOverride = function(e) {
      return this.manualOverrideStorage.getVariation(e.experiment, e.user);
    }, t.prototype._resolveUserOverride = function(e) {
      var r = e.experiment, n = e.user.identifiers[r.identifierType];
      if (n) {
        var i = r.userOverrides.get(n);
        if (i)
          return r._getVariationByIdOrNull(i);
      }
    }, t.prototype._resolveSegmentOverride = function(e, r) {
      var n = this, i = e.experiment.segmentOverrides.find(function(o) {
        return n.targetMatcher.matches(e, r, o.target);
      });
      if (i)
        return this.actionResolver.resolveOrNull(e, r, i.action);
    }, t;
  }()
), H2 = (
  /** @class */
  function() {
    function t(e) {
      this.bucketer = e;
    }
    return t.prototype.isUserInContainerGroup = function(e, r, n) {
      var i = e.user.identifiers[e.experiment.identifierType];
      if (v.isNullOrUndefined(i))
        return !1;
      var o = e.workspace.getBucketOrNull(n.bucketId);
      if (v.isNullOrUndefined(o))
        throw new Error("Bucket[".concat(n.bucketId, "]"));
      var a = this.bucketer.bucketing(o, i);
      if (v.isNullOrUndefined(a))
        return !1;
      var s = n.getGroupOrNull(a.variationId);
      if (v.isNullOrUndefined(s))
        throw new Error("ContainerGroup[".concat(a.variationId, "]"));
      return s.experiments.includes(e.experiment.id);
    }, t;
  }()
), _e = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.reason = e, this.targetEvaluations = r, this.inAppMessage = n, this.message = i, this.properties = o;
    }
    return t.of = function(e, r, n, i) {
      return new t(n, r.targetEvaluations, e.inAppMessage, i, r.properties);
    }, t;
  }()
), X2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.inAppMessage.supports("WEB") ? n.evaluate(e, r) : _e.of(e, r, w.UNSUPPORTED_PLATFORM);
    }, t;
  }()
), W2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.userOverrideMatcher = e, this.inAppMessageResolver = r;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (this.userOverrideMatcher.matches(e, r)) {
        var i = this.inAppMessageResolver.resolve(e, r);
        return _e.of(e, r, w.OVERRIDDEN, i);
      }
      return n.evaluate(e, r);
    }, t;
  }()
), z2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.inAppMessage.status === "DRAFT" ? _e.of(e, r, w.IN_APP_MESSAGE_DRAFT) : n.evaluate(e, r);
    }, t;
  }()
), J2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.inAppMessage.status === "PAUSE" ? _e.of(e, r, w.IN_APP_MESSAGE_PAUSED) : n.evaluate(e, r);
    }, t;
  }()
), Z2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.inAppMessage.period.within(e.timestamp) ? n.evaluate(e, r) : _e.of(e, r, w.NOT_IN_IN_APP_MESSAGE_PERIOD);
    }, t;
  }()
), Y2 = (
  /** @class */
  function() {
    function t(e) {
      this.hiddenMatcher = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      return this.hiddenMatcher.matches(e, r) ? _e.of(e, r, w.IN_APP_MESSAGE_HIDDEN) : n.evaluate(e, r);
    }, t;
  }()
), K2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.targetMatcher = e, this.inAppMessageResolver = r;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (this.targetMatcher.matches(e, r)) {
        var i = this.inAppMessageResolver.resolve(e, r);
        return _e.of(e, r, w.IN_APP_MESSAGE_TARGET, i);
      }
      return _e.of(e, r, w.NOT_IN_IN_APP_MESSAGE_TARGET);
    }, t;
  }()
), Q2 = (
  /** @class */
  function() {
    function t(e) {
      this.evaluator = e;
    }
    return t.prototype.resolve = function(e, r) {
      var n;
      return (n = this.resolveExperiment(e, r)) !== null && n !== void 0 ? n : this.resolveDefault(e);
    }, t.prototype.resolveExperiment = function(e, r) {
      var n = e.inAppMessage.messageContext.experimentContext;
      if (!n)
        return null;
      var i = v.requiredNotNullOrUndefined(e.workspace.getExperimentOrNull(n.key), function() {
        return "Experiment[".concat(n.key, "]");
      }), o = rt.by(e, i), a = this.evaluator.evaluate(o, r);
      this.addExperimentContext(a, r);
      var s = e.inAppMessage.messageContext.defaultLang;
      return this.resolveMessage(e, function(u) {
        return u.lang === s && a.variationKey === u.variationKey;
      });
    }, t.prototype.addExperimentContext = function(e, r) {
      r.addEvaluation(e), r.setProperty("experiment_id", e.experiment.id), r.setProperty("experiment_key", e.experiment.key), r.setProperty("variation_id", e.variationId), r.setProperty("variation_key", e.variationKey), r.setProperty("experiment_decision_reason", e.reason);
    }, t.prototype.resolveDefault = function(e) {
      var r = e.inAppMessage.messageContext.defaultLang;
      return this.resolveMessage(e, function(n) {
        return n.lang === r;
      });
    }, t.prototype.resolveMessage = function(e, r) {
      var n = e.inAppMessage.messageContext.messages.find(r);
      return v.requiredNotNullOrUndefined(n, function() {
        return "InAppMessage must be decided [".concat(e.inAppMessage.id, "]");
      });
    }, t;
  }()
), q2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r) {
      var n = this;
      return e.inAppMessage.targetContext.overrides.some(function(i) {
        return n.isUserOverridden(e, i);
      });
    }, t.prototype.isUserOverridden = function(e, r) {
      var n = e.user.identifiers[r.identifierType];
      return v.isNullOrUndefined(n) ? !1 : r.identifiers.includes(n);
    }, t;
  }()
), ex = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.matches = function(e, r) {
      var n = this, i = e.inAppMessage.targetContext.targets;
      return i.length === 0 ? !0 : i.some(function(o) {
        return n.targetMatcher.matches(e, r, o);
      });
    }, t;
  }()
), tx = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.matches = function(e, r) {
      return this.storage.exist(e.inAppMessage, e.timestamp);
    }, t;
  }()
), rx = (
  /** @class */
  function() {
    function t(e, r) {
      this.targetMatcher = e, this.bucketer = r;
    }
    return t.prototype.determineTargetRuleOrNull = function(e, r) {
      var n = this;
      return e.parameter.targetRules.find(function(i) {
        return n.matches(e, r, i);
      });
    }, t.prototype.matches = function(e, r, n) {
      if (!this.targetMatcher.matches(e, r, n.target))
        return !1;
      var i = e.user.identifiers[e.parameter.identifierType];
      if (v.isNullOrUndefined(i))
        return !1;
      var o = e.workspace.getBucketOrNull(n.bucketId);
      if (v.isNullOrUndefined(o))
        throw new Error("bucket[".concat(n.bucketId, "]"));
      return v.isNotNullOrUndefined(this.bucketer.bucketing(o, i));
    }, t;
  }()
), Lo = (
  /** @class */
  function() {
    function t() {
    }
    return t.get = function(e) {
      return v.requiredNotNullOrUndefined(this.getOrNull(e), function() {
        return "Instance not registered [".concat(e, "]");
      });
    }, t.getOrNull = function(e) {
      return t.instances.get(e);
    }, t.register = function(e, r) {
      return t.instances.set(e, r), r;
    }, t.instances = /* @__PURE__ */ new Map(), t;
  }()
), nx = (
  /** @class */
  function() {
    function t(e, r, n) {
      var i = new D2(), o = Lo.register("targetMatcher", new n2(new x2(e))), a = new P2(i), s = new j2(r, o, a), u = new H2(i);
      this.abTestFlow = Ji.of(new Dc(s), new Fc(), new G2(u), new L2(new V2(o)), new Lc(), new $c(), new kc(), new $2(a)), this.featureFlagFlow = Ji.of(new Lc(), new $c(), new kc(), new Dc(s), new Fc(), new k2(new B2(o), a), new F2(a));
      var c = new Q2(e);
      this.inAppMessageFlow = Ji.of(new X2(), new W2(new q2(), c), new z2(), new J2(), new Z2(), new Y2(new tx(n)), new K2(new ex(o), c)), this.remoteConfigParameterTargetRuleDeterminer = new rx(o, i);
    }
    return t.prototype.getExperimentFlow = function(e) {
      switch (e) {
        case "AB_TEST":
          return this.abTestFlow;
        case "FEATURE_FLAG":
          return this.featureFlagFlow;
      }
    }, t.prototype.getInAppMessageFlow = function() {
      return this.inAppMessageFlow;
    }, t;
  }()
), ix = (
  /** @class */
  function() {
    function t(e) {
      this.clock = e;
    }
    return t.prototype.create = function(e, r) {
      var n = this, i = this.clock.currentMillis(), o = new Array(), a = this.createEvent(e, r, i, {});
      return a && o.push(a), r.targetEvaluations.forEach(function(s) {
        var u, c = (u = {}, u[t.ROOT_TYPE] = e.key.type, u[t.ROOT_ID] = e.key.id, u), l = n.createEvent(e, s, i, c);
        l && o.push(l);
      }), o;
    }, t.prototype.createEvent = function(e, r, n, i) {
      var o;
      if (r instanceof q)
        return i[t.CONFIG_ID_PROPERTY_KEY] = (o = r.config) === null || o === void 0 ? void 0 : o.id, i[t.EXPERIMENT_VERSION_KEY] = r.experiment.version, i[t.EXECUTION_VERSION_KEY] = r.experiment.executionVersion, Z.exposure(e.user, r, i, n);
      if (r instanceof nn)
        return Z.remoteConfig(e.user, r, b(b({}, i), r.properties), n);
      if (r instanceof _e)
        return null;
      throw new Error("Unsupported Evaluation [".concat(typeof r, "]"));
    }, t.ROOT_TYPE = "$targetingRootType", t.ROOT_ID = "$targetingRootId", t.CONFIG_ID_PROPERTY_KEY = "$parameterConfigurationId", t.EXPERIMENT_VERSION_KEY = "$experiment_version", t.EXECUTION_VERSION_KEY = "$execution_version", t;
  }()
), ox = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r) {
      var n = t.call(this) || this;
      return n.evaluationFlowFactory = r, n;
    }
    return e.prototype.supports = function(r) {
      return r.inAppMessage !== void 0;
    }, e.prototype.evaluateInternal = function(r, n) {
      var i, o = this.evaluationFlowFactory.getInAppMessageFlow();
      return (i = o.evaluate(r, n)) !== null && i !== void 0 ? i : _e.of(r, n, w.NOT_IN_IN_APP_MESSAGE_TARGET);
    }, e;
  }(Ca)
), ax = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.key = new Cr("IN_APP_MESSAGE", n.id), this.workspace = e, this.user = r, this.inAppMessage = n, this.timestamp = i;
    }
    return t.of = function(e, r, n, i) {
      return new t(e, r, n, i);
    }, t.prototype.toString = function() {
      return "EvaluatorRequest(type=".concat(this.key.type, ", key=").concat(this.inAppMessage.key, ")");
    }, t;
  }()
), se = O.log, sx = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u) {
      this.experimentEvaluator = e, this.remoteConfigEvaluator = r, this.inAppMessageEvaluator = n, this.workspaceFetcher = i, this.eventFactory = o, this.eventProcessor = a, this.errorDedupDeterminer = s, this.clock = u;
    }
    return t.create = function(e, r, n, i) {
      var o = new r2(), a = new t2(n), s = new nx(o, a, i), u = new QR(s), c = new qR(s.remoteConfigParameterTargetRuleDeterminer), l = new ox(s);
      return o.add(u), o.add(c), new t(u, c, l, e, new ix(be.instance), r, new ux(), be.instance);
    }, t.prototype.experiment = function(e, r, n) {
      var i = this;
      if (!e)
        return se.error("experimentKey must not be empty"), et.of(n, w.INVALID_INPUT);
      var o = this.workspaceFetcher.get();
      if (!o)
        return se.warn("SDK not ready."), et.of(n, w.SDK_NOT_READY);
      var a = o.getExperimentOrNull(e);
      if (!a)
        return se.warn("Experiment does not exist."), et.of(n, w.EXPERIMENT_NOT_FOUND);
      var s = rt.of(o, r, a, n), u = this.experimentInternal(s), c = u[0], l = u[1], f = this.eventFactory.create(s, c);
      return f.forEach(function(p) {
        return i.eventProcessor.process(p);
      }), l;
    }, t.prototype.experiments = function(e) {
      var r = this, n = new st(function(o, a) {
        return o.id === a.id;
      }), i = this.workspaceFetcher.get();
      return i && i.getExperiments().forEach(function(o) {
        var a = rt.of(i, e, o, "A"), s = r.experimentInternal(a);
        s[0];
        var u = s[1];
        n.add(o, u);
      }), n;
    }, t.prototype.experimentInternal = function(e) {
      var r, n = this.experimentEvaluator.evaluate(e, tt.create()), i = (r = n.config) !== null && r !== void 0 ? r : new ur(), o = et.of(n.variationKey, n.reason, i, n.experiment);
      return [n, o];
    }, t.prototype.featureFlag = function(e, r) {
      var n = this;
      if (!e)
        return se.error("featureKey must not be empty"), je.off(w.INVALID_INPUT);
      var i = this.workspaceFetcher.get();
      if (!i)
        return se.warn("SDK not ready."), je.off(w.SDK_NOT_READY);
      var o = i.getFeatureFlagOrNull(e);
      if (!o)
        return se.warn("FeatureFlag does not exist."), je.off(w.FEATURE_FLAG_NOT_FOUND);
      var a = rt.of(i, r, o, "A"), s = this.featureFlagInternal(a), u = s[0], c = s[1], l = this.eventFactory.create(a, u);
      return l.forEach(function(f) {
        return n.eventProcessor.process(f);
      }), c;
    }, t.prototype.featureFlags = function(e) {
      var r = this, n = new st(function(o, a) {
        return o.id === a.id;
      }), i = this.workspaceFetcher.get();
      return i && i.getFeatureFlags().forEach(function(o) {
        var a = rt.of(i, e, o, "A"), s = r.featureFlagInternal(a);
        s[0];
        var u = s[1];
        n.add(o, u);
      }), n;
    }, t.prototype.featureFlagInternal = function(e) {
      var r, n = this.experimentEvaluator.evaluate(e, tt.create()), i = (r = n.config) !== null && r !== void 0 ? r : new ur(), o = n.variationKey === "A" ? je.off(n.reason, i, n.experiment) : je.on(n.reason, i, n.experiment);
      return [n, o];
    }, t.prototype.inAppMessage = function(e, r) {
      var n = this, i = this.workspaceFetcher.get();
      if (!i)
        return se.warn("SDK not ready."), _r.of(w.SDK_NOT_READY);
      var o = i.getInAppMessageOrNull(e);
      if (!o)
        return se.warn("In app message does not exist."), _r.of(w.IN_APP_MESSAGE_NOT_FOUND);
      var a = ax.of(i, r, o, this.clock.currentMillis()), s = this.inAppMessageEvaluator.evaluate(a, tt.create()), u = this.eventFactory.create(a, s);
      return u.forEach(function(c) {
        return n.eventProcessor.process(c);
      }), _r.of(s.reason, s.inAppMessage, s.message, s.properties);
    }, t.prototype.tryInAppMessage = function(e, r) {
      var n = at.start(), i;
      try {
        i = this.inAppMessage(e, r);
      } catch (o) {
        se.error("Unexpected error while deciding in app message [".concat(e, "]: ").concat(o)), i = _r.of(w.EXCEPTION);
      }
      return sn.inAppMessage(n, e, i), i;
    }, t.prototype.track = function(e, r, n) {
      var i;
      if (n === void 0 && (n = (/* @__PURE__ */ new Date()).getTime()), !e) {
        se.warn("event must not be null.");
        return;
      }
      if (typeof e != "object") {
        se.warn("Event must be event type.");
        return;
      }
      if (typeof e == "object" && (!e.key || typeof e.key != "string")) {
        se.warn("Event key must be not null. or event key must be string type.");
        return;
      }
      var o = ((i = this.workspaceFetcher.get()) === null || i === void 0 ? void 0 : i.getEventTypeOrNull(e.key)) || new Sl(0, e.key);
      this.eventProcessor.process(Z.track(o, e, r, n));
    }, t.prototype.trackException = function(e, r) {
      if (!this.errorDedupDeterminer.isDedupTarget(e)) {
        var n = KR.toEvent(e);
        this.flush(), this.track(n, r), this.flush();
      }
    }, t.prototype.flush = function(e) {
      e === void 0 && (e = !1), this.eventProcessor.flush(e);
    }, t.prototype.remoteConfig = function(e, r, n, i) {
      var o = this, a = this.workspaceFetcher.get();
      if (v.isNullOrUndefined(a))
        return se.warn("SDK not ready."), rr.of(i, w.SDK_NOT_READY);
      var s = a.getRemoteConfigParameterOrNull(e);
      if (v.isNullOrUndefined(s))
        return se.warn("Remote config parameter does not exist."), rr.of(i, w.REMOTE_CONFIG_PARAMETER_NOT_FOUND);
      var u = e2.of(a, r, s, n, i), c = this.remoteConfigEvaluator.evaluate(u, tt.create()), l = this.eventFactory.create(u, c);
      return l.forEach(function(f) {
        return o.eventProcessor.process(f);
      }), rr.of(c.value, c.reason);
    }, t.prototype.close = function() {
      this.eventProcessor.close();
    }, t;
  }()
), ux = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.isDedupTarget = function(e) {
      return this._isSameError(e, this.previous) ? !0 : (this.previous = e, !1);
    }, t.prototype._isSameError = function(e, r) {
      return v.isNullOrUndefined(r) ? !1 : e.name === r.name && e.message === r.message && e.stack === r.stack;
    }, t;
  }()
), cx = (
  /** @class */
  function() {
    function t() {
      this._installed = [], this._installations = {
        onerror: lx,
        onunhandledrejection: fx
      };
    }
    return t.prototype.install = function(e, r) {
      this._install("onerror", e, r), this._install("onunhandledrejection", e, r);
    }, t.prototype._install = function(e, r, n) {
      if (!(e in this._installed)) {
        var i = this._installations[e];
        i(r, n), this._installed.push(e);
      }
    }, t;
  }()
), Zi = null;
function lx(t, e) {
  Zi = window.onerror, window.onerror = function(r, n, i, o, a) {
    v.isNotNullOrUndefined(a) && t.trackException(a, e.resolve()), Zi && Zi.apply(this, arguments);
  };
}
var Yi;
function fx(t, e) {
  Yi = window.onunhandledrejection, window.onunhandledrejection = function(r) {
    var n;
    try {
      "reason" in r ? n = r.reason : "detail" in r && "reason" in r.detail && (n = r.detail.reason);
    } catch {
    }
    n instanceof Error && t.trackException(n, e.resolve()), Yi && Yi.apply(this, arguments);
  };
}
var px = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.storage = e, this.storageKey = r, this.maxSize = n;
    }
    return t.prototype.read = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          return e = this.storage.getItem(this.storageKey), e ? [2, JSON.parse(e)] : [2, []];
        });
      });
    }, t.prototype.save = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          return e.length === 0 ? [2, this.clear()] : (r = JSON.stringify(e.slice(-this.maxSize)), this.storage.setItem(this.storageKey, r), [
            2
            /*return*/
          ]);
        });
      });
    }, t.prototype.add = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.read()];
            case 1:
              return r = n.sent(), [4, this.save(r.concat(e).slice(-this.maxSize))];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.delete = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n, i = this;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, this.read()];
            case 1:
              return r = o.sent(), n = r.filter(function(a) {
                return !i.isDeleteTarget(a, e);
              }), [4, this.save(n)];
            case 2:
              return o.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.isDeleteTarget = function(e, r) {
      return r.some(function(n) {
        return n.insertId === e.insertId;
      });
    }, t.prototype.clear = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          return this.storage.removeItem(this.storageKey), [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), ba = function(t, e) {
  return t === null ? !1 : t.userId === e.userId && t.deviceId === e.deviceId;
}, dx = function(t, e) {
  return ba(t, e) ? b(b({}, e), { properties: b(b({}, t.properties), e.properties) }) : e;
}, Ta = (
  /** @class */
  function() {
    function t(e) {
      this.cohorts = e;
    }
    return t.builder = function() {
      return new Gc();
    }, t.empty = function() {
      return t.builder().build();
    }, t.from = function(e) {
      return new t(e);
    }, t.fromDto = function(e) {
      for (var r = t.builder(), n = 0, i = e.cohorts; n < i.length; n++) {
        var o = i[n];
        r.put({
          identifier: o.identifier,
          cohorts: o.cohorts.map(function(a) {
            return new Bh(a);
          })
        });
      }
      return r.build();
    }, Object.defineProperty(t.prototype, "rawCohorts", {
      get: function() {
        return this.cohorts.values().flatMap(function(e) {
          return e.cohorts;
        });
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.get = function(e) {
      return this.cohorts.get(e);
    }, t.prototype.filterBy = function(e) {
      var r = on(e), n = this.asComparable().filter(function(i, o) {
        return r[i.type] === i.value;
      });
      return t.from(n);
    }, t.prototype.asArray = function() {
      return this.cohorts.values();
    }, t.prototype.asComparable = function() {
      return this.cohorts;
    }, t.prototype.toBuilder = function() {
      return new Gc(this);
    }, t;
  }()
), Gc = (
  /** @class */
  function() {
    function t(e) {
      this.cohorts = new st(fe.isEqual), e && this.putAll(e);
    }
    return t.prototype.put = function(e) {
      return this.cohorts.add(e.identifier, e), this;
    }, t.prototype.putAll = function(e) {
      var r = this;
      return e.asArray().forEach(function(n) {
        return r.put(n);
      }), this;
    }, t.prototype.build = function() {
      return new Ta(this.cohorts);
    }, t;
  }()
), h = "model", I = "name", g = "type", y = "vendor", m = "version", Ye = "architecture", Br = "console", $ = "mobile", P = "tablet", Pe = "smarttv", Vc = "wearable", vx = (
  /** @class */
  function() {
    function t() {
    }
    return t.parse = function(e) {
      return {
        browser: t.getBrowser(e),
        cpu: t.getCPU(e),
        device: t.getDevice(e),
        engine: t.getEngine(e),
        os: t.getOS(e)
      };
    }, t.getBrowser = function(e) {
      var r = { name: void 0, version: void 0, major: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.browser), r.major = t.util.major(r.version), r;
    }, t.getCPU = function(e) {
      var r = { architecture: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.cpu), r;
    }, t.getDevice = function(e) {
      var r = { model: void 0, type: void 0, vendor: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.device), r;
    }, t.getEngine = function(e) {
      var r = { name: void 0, version: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.os), r;
    }, t.getOS = function(e) {
      var r = { name: void 0, version: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.os), r;
    }, t.util = {
      extend: function(e, r) {
        var n = {};
        for (var i in e)
          r[i] && r[i].length % 2 === 0 ? n[i] = r[i].concat(e[i]) : n[i] = e[i];
        return n;
      },
      has: function(e, r) {
        return typeof e == "string" ? r.toLowerCase().indexOf(e.toLowerCase()) !== -1 : !1;
      },
      lowerize: function(e) {
        return e.toLowerCase();
      },
      major: function(e) {
        return typeof e == "string" ? e.replace(/[^\d\.]/g, "").split(".")[0] : void 0;
      },
      trim: function(e) {
        return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      }
    }, t.mapper = {
      rgx: function(e, r) {
        for (var n = 0, i, o, a, s, u, c; n < r.length && !u; ) {
          var l = r[n], f = r[n + 1];
          for (i = o = 0; i < l.length && !u; )
            if (u = l[i++].exec(e), u)
              for (a = 0; a < f.length; a++)
                c = u[++o], s = f[a], typeof s == "object" && s.length > 0 ? s.length == 2 ? typeof s[1] == "function" ? this[s[0]] = s[1].call(this, c) : this[s[0]] = s[1] : s.length == 3 ? typeof s[1] == "function" && !(s[1].exec && s[1].test) ? this[s[0]] = c ? s[1].call(this, c, s[2]) : void 0 : this[s[0]] = c ? c.replace(s[1], s[2]) : void 0 : s.length == 4 && (this[s[0]] = c ? s[3].call(this, c.replace(s[1], s[2])) : void 0) : this[s] = c || void 0;
          n += 2;
        }
      },
      str: function(e, r) {
        for (var n in r)
          if (typeof r[n] == "object" && r[n].length > 0) {
            for (var i = 0; i < r[n].length; i++)
              if (t.util.has(r[n][i], e))
                return n === "?" ? void 0 : n;
          } else if (t.util.has(r[n], e))
            return n === "?" ? void 0 : n;
        return e;
      }
    }, t.maps = {
      browser: {
        oldsafari: {
          version: {
            "1.0": "/8",
            "1.2": "/1",
            "1.3": "/3",
            "2.0": "/412",
            "2.0.2": "/416",
            "2.0.3": "/417",
            "2.0.4": "/419",
            "?": "/"
          }
        }
      },
      device: {
        amazon: {
          model: {
            "Fire Phone": ["SD", "KF"]
          }
        },
        sprint: {
          model: {
            "Evo Shift 4G": "7373KT"
          },
          vendor: {
            HTC: "APA",
            Sprint: "Sprint"
          }
        }
      },
      os: {
        windows: {
          version: {
            ME: "4.90",
            "NT 3.11": "NT3.51",
            "NT 4.0": "NT4.0",
            2e3: "NT 5.0",
            XP: ["NT 5.1", "NT 5.2"],
            Vista: "NT 6.0",
            7: "NT 6.1",
            8: "NT 6.2",
            "8.1": "NT 6.3",
            10: ["NT 6.4", "NT 10.0"],
            RT: "ARM"
          }
        }
      }
    }, t.regexes = {
      browser: [
        [
          // Presto based
          /(opera\smini)\/([\w\.-]+)/i,
          /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,
          /(opera).+version\/([\w\.]+)/i,
          /(opera)[\/\s]+([\w\.]+)/i
          // Opera < 9.80
        ],
        [I, m],
        [
          /(opios)[\/\s]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [[I, "Opera Mini"], m],
        [
          /\s(opr)\/([\w\.]+)/i
          // Opera Webkit
        ],
        [[I, "Opera"], m],
        [
          // Mixed
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,
          /(?:ms|\()(ie)\s([\w\.]+)/i,
          // Webkit/KHTML based
          /(rekonq)\/([\w\.]*)/i,
          /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
          // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
        ],
        [I, m],
        [
          /(konqueror)\/([\w\.]+)/i
          // Konqueror
        ],
        [[I, "Konqueror"], m],
        [
          /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i
          // IE11
        ],
        [[I, "IE"], m],
        [
          /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i
          // Microsoft Edge
        ],
        [[I, "Edge"], m],
        [
          /(yabrowser)\/([\w\.]+)/i
          // Yandex
        ],
        [[I, "Yandex"], m],
        [
          /(Avast)\/([\w\.]+)/i
          // Avast Secure Browser
        ],
        [[I, "Avast Secure Browser"], m],
        [
          /(AVG)\/([\w\.]+)/i
          // AVG Secure Browser
        ],
        [[I, "AVG Secure Browser"], m],
        [
          /(puffin)\/([\w\.]+)/i
          // Puffin
        ],
        [[I, "Puffin"], m],
        [
          /(focus)\/([\w\.]+)/i
          // Firefox Focus
        ],
        [[I, "Firefox Focus"], m],
        [
          /(opt)\/([\w\.]+)/i
          // Opera Touch
        ],
        [[I, "Opera Touch"], m],
        [
          /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
          // UCBrowser
        ],
        [[I, "UCBrowser"], m],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[I, /_/g, " "], m],
        [
          /(windowswechat qbcore)\/([\w\.]+)/i
          // WeChat Desktop for Windows Built-in Browser
        ],
        [[I, "WeChat(Win) Desktop"], m],
        [
          /(micromessenger)\/([\w\.]+)/i
          // WeChat
        ],
        [[I, "WeChat"], m],
        [
          /(brave)\/([\w\.]+)/i
          // Brave browser
        ],
        [[I, "Brave"], m],
        [
          /(whale)\/([\w\.]+)/i
          // Whale browser
        ],
        [[I, "Whale"], m],
        [
          /(qqbrowserlite)\/([\w\.]+)/i
          // QQBrowserLite
        ],
        [I, m],
        [
          /(QQ)\/([\d\.]+)/i
          // QQ, aka ShouQ
        ],
        [I, m],
        [
          /m?(qqbrowser)[\/\s]?([\w\.]+)/i
          // QQBrowser
        ],
        [I, m],
        [
          /(baiduboxapp)[\/\s]?([\w\.]+)/i
          // Baidu App
        ],
        [I, m],
        [
          /(2345Explorer)[\/\s]?([\w\.]+)/i
          // 2345 Browser
        ],
        [I, m],
        [
          /(MetaSr)[\/\s]?([\w\.]+)/i
          // SouGouBrowser
        ],
        [I],
        [
          /(LBBROWSER)/i
          // LieBao Browser
        ],
        [I],
        [
          /xiaomi\/miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [m, [I, "MIUI Browser"]],
        [
          /;fbav\/([\w\.]+);/i
          // Facebook App for iOS & Android
        ],
        [m, [I, "Facebook"]],
        [
          /safari\s(line)\/([\w\.]+)/i,
          /android.+(line)\/([\w\.]+)\/iab/i
          // Line App for Android
        ],
        [I, m],
        [
          /headlesschrome(?:\/([\w\.]+)|\s)/i
          // Chrome Headless
        ],
        [m, [I, "Chrome Headless"]],
        [
          /\swv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[I, /(.+)/, "$1 WebView"], m],
        [/((?:oculus|samsung)browser)\/([\w\.]+)/i],
        [[I, /(.+(?:g|us))(.+)/, "$1 $2"], m],
        [
          // Oculus / Samsung Browser
          /((?:android.+)crmo|crios)\/([\w\.]+)/i,
          /android.+(chrome)\/([\w\.]+)\s+(?:mobile\s?safari)/i
        ],
        [[I, "Chrome Mobile"], m],
        [
          /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i
          // Android Browser
        ],
        [m, [I, "Android Browser"]],
        [
          /(sailfishbrowser)\/([\w\.]+)/i
          // Sailfish Browser
        ],
        [[I, "Sailfish Browser"], m],
        [
          /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [I, m],
        [
          /(dolfin)\/([\w\.]+)/i
          // Dolphin
        ],
        [[I, "Dolphin"], m],
        [
          /(qihu|qhbrowser|qihoobrowser|360browser)/i
          // 360
        ],
        [[I, "360 Browser"]],
        [
          /(coast)\/([\w\.]+)/i
          // Opera Coast
        ],
        [[I, "Opera Coast"], m],
        [
          /fxios\/([\w\.-]+)/i
          // Firefox for iOS
        ],
        [m, [I, "Firefox"]],
        [
          /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i
          // Mobile Safari
        ],
        [m, [I, "Mobile Safari"]],
        [
          /version\/([\w\.]+).+?(mobile\s?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [m, I],
        [
          /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i
          // Google Search Appliance on iOS
        ],
        [[I, "GSA"], m],
        [
          /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [I, [m, t.mapper.str, t.maps.browser.oldsafari.version]],
        [/(webkit|khtml)\/([\w\.]+)/i],
        [I, m],
        [
          // Gecko based
          /(navigator|netscape)\/([\w\.-]+)/i
          // Netscape
        ],
        [[I, "Netscape"], m],
        [
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
          /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
          /(links)\s\(([\w\.]+)/i,
          /(gobrowser)\/?([\w\.]*)/i,
          /(ice\s?browser)\/v?([\w\._]+)/i,
          /(mosaic)[\/\s]([\w\.]+)/i
          // Mosaic
        ],
        [I, m]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i
          // AMD64
        ],
        [[Ye, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[Ye, t.util.lowerize]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32
        ],
        [[Ye, "ia32"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows\s(ce|mobile);\sppc;/i
        ],
        [[Ye, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i
          // PowerPC
        ],
        [[Ye, /ower/, "", t.util.lowerize]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[Ye, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[Ye, t.util.lowerize]]
      ],
      device: [
        [
          /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i
          // iPad/PlayBook
        ],
        [h, y, [g, P]],
        [
          /applecoremedia\/[\w\.]+ \((ipad)/
          // iPad
        ],
        [h, [y, "Apple"], [g, P]],
        [
          /(apple\s{0,1}tv)/i
          // Apple TV
        ],
        [
          [h, "Apple TV"],
          [y, "Apple"],
          [g, Pe]
        ],
        [
          /(archos)\s(gamepad2?)/i,
          /(hp).+(touchpad)/i,
          /(hp).+(tablet)/i,
          /(kindle)\/([\w\.]+)/i,
          /\s(nook)[\w\s]+build\/(\w+)/i,
          /(dell)\s(strea[kpr\s\d]*[\dko])/i
          // Dell Streak
        ],
        [y, h, [g, P]],
        [
          /(kf[A-z]+)\sbuild\/.+silk\//i
          // Kindle Fire HD
        ],
        [h, [y, "Amazon"], [g, P]],
        [
          /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i
          // Fire Phone
        ],
        [
          [h, t.mapper.str, t.maps.device.amazon.model],
          [y, "Amazon"],
          [g, $]
        ],
        [
          /android.+aft([bms])\sbuild/i
          // Fire TV
        ],
        [h, [y, "Amazon"], [g, Pe]],
        [
          /\((ip[honed|\s\w*]+);.+(apple)/i
          // iPod/iPhone
        ],
        [h, y, [g, $]],
        [
          /\((ip[honed|\s\w*]+);/i
          // iPod/iPhone
        ],
        [h, [y, "Apple"], [g, $]],
        [
          /(blackberry)[\s-]?(\w+)/i,
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
          // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp)\s([\w\s]+\w)/i,
          /(asus)-?(\w+)/i
          // Asus
        ],
        [y, h, [g, $]],
        [
          /\(bb10;\s(\w+)/i
          // BlackBerry 10
        ],
        [h, [y, "BlackBerry"], [g, $]],
        [
          // Asus Tablets
          /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
        ],
        [h, [y, "Asus"], [g, P]],
        [
          /(sony)\s(tablet\s[ps])\sbuild\//i,
          /(sony)?(?:sgp.+)\sbuild\//i
        ],
        [
          [y, "Sony"],
          [h, "Xperia Tablet"],
          [g, P]
        ],
        [/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],
        [h, [y, "Sony"], [g, $]],
        [
          /\s(ouya)\s/i,
          /(nintendo)\s([wids3u]+)/i
          // Nintendo
        ],
        [y, h, [g, Br]],
        [
          /android.+;\s(shield)\sbuild/i
          // Nvidia
        ],
        [h, [y, "Nvidia"], [g, Br]],
        [
          /(playstation\s[34portablevi]+)/i
          // Playstation
        ],
        [h, [y, "Sony"], [g, Br]],
        [
          /(sprint\s(\w+))/i
          // Sprint Phones
        ],
        [
          [y, t.mapper.str, t.maps.device.sprint.vendor],
          [h, t.mapper.str, t.maps.device.sprint.model],
          [g, $]
        ],
        [
          /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,
          /(zte)-(\w*)/i,
          /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [y, [h, /_/g, " "], [g, $]],
        [
          /(nexus\s9)/i
          // HTC Nexus 9
        ],
        [h, [y, "HTC"], [g, P]],
        [
          /d\/huawei([\w\s-]+)[;\)]/i,
          /(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i
          // Huawei
        ],
        [h, [y, "Huawei"], [g, $]],
        [
          /android.+(bah2?-a?[lw]\d{2})/i
          // Huawei MediaPad
        ],
        [h, [y, "Huawei"], [g, P]],
        [
          /(microsoft);\s(lumia[\s\w]+)/i
          // Microsoft Lumia
        ],
        [y, h, [g, $]],
        [
          /[\s\(;](xbox(?:\sone)?)[\s\);]/i
          // Microsoft Xbox
        ],
        [h, [y, "Microsoft"], [g, Br]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [
          [h, /\./g, " "],
          [y, "Microsoft"],
          [g, $]
        ],
        [
          // Motorola
          /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
          /mot[\s-]?(\w*)/i,
          /(XT\d{3,4}) build\//i,
          /(nexus\s6)/i
        ],
        [h, [y, "Motorola"], [g, $]],
        [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],
        [h, [y, "Motorola"], [g, P]],
        [
          /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [
          [y, t.util.trim],
          [h, t.util.trim],
          [g, Pe]
        ],
        [/hbbtv.+maple;(\d+)/i],
        [
          [h, /^/, "SmartTV"],
          [y, "Samsung"],
          [g, Pe]
        ],
        [
          /\(dtv[\);].+(aquos)/i
          // Sharp
        ],
        [h, [y, "Sharp"], [g, Pe]],
        [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i],
        [[y, "Samsung"], h, [g, P]],
        [
          // Samsung
          /smart-tv.+(samsung)/i
        ],
        [y, [g, Pe], h],
        [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i],
        [[y, "Samsung"], h, [g, $]],
        [
          /sie-(\w*)/i
          // Siemens
        ],
        [h, [y, "Siemens"], [g, $]],
        [
          /(maemo|nokia).*(n900|lumia\s\d+)/i,
          /(nokia)[\s_-]?([\w-]*)/i
        ],
        [[y, "Nokia"], h, [g, $]],
        [
          /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i
          // Acer
        ],
        [h, [y, "Acer"], [g, P]],
        [
          /android.+([vl]k\-?\d{3})\s+build/i
          // LG Tablet
        ],
        [h, [y, "LG"], [g, P]],
        [
          /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i
          // LG Tablet
        ],
        [[y, "LG"], h, [g, P]],
        [
          /(lg) netcast\.tv/i
          // LG SmartTV
        ],
        [y, h, [g, Pe]],
        [
          /(nexus\s[45])/i,
          /lg[e;\s\/-]+(\w*)/i,
          /android.+lg(\-?[\d\w]+)\s+build/i
        ],
        [h, [y, "LG"], [g, $]],
        [
          /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i
          // Lenovo tablets
        ],
        [y, h, [g, P]],
        [
          /android.+(ideatab[a-z0-9\-\s]+)/i
          // Lenovo
        ],
        [h, [y, "Lenovo"], [g, P]],
        [/(lenovo)[_\s-]?([\w-]+)/i],
        [y, h, [g, $]],
        [
          /linux;.+((jolla));/i
          // Jolla
        ],
        [y, h, [g, $]],
        [
          /((pebble))app\/[\d\.]+\s/i
          // Pebble
        ],
        [y, h, [g, Vc]],
        [
          /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i
          // OPPO
        ],
        [y, h, [g, $]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [
          [h, "Chromecast"],
          [y, "Google"],
          [g, Pe]
        ],
        [
          /android.+;\s(glass)\s\d/i
          // Google Glass
        ],
        [h, [y, "Google"], [g, Vc]],
        [
          /android.+;\s(pixel c)[\s)]/i
          // Google Pixel C
        ],
        [h, [y, "Google"], [g, P]],
        [
          /android.+;\s(pixel( [23])?( xl)?)[\s)]/i
          // Google Pixel
        ],
        [h, [y, "Google"], [g, $]],
        [
          /android.+;\s(\w+)\s+build\/hm\1/i,
          /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,
          /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,
          // Xiaomi Mi
          /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i
          // Redmi Phones
        ],
        [
          [h, /_/g, " "],
          [y, "Xiaomi"],
          [g, $]
        ],
        [
          /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i
          // Mi Pad tablets
        ],
        [
          [h, /_/g, " "],
          [y, "Xiaomi"],
          [g, P]
        ],
        [
          /android.+;\s(m[1-5]\snote)\sbuild/i
          // Meizu
        ],
        [h, [y, "Meizu"], [g, $]],
        [/(mz)-([\w-]{2,})/i],
        [[y, "Meizu"], h, [g, $]],
        [
          /android.+a000(1)\s+build/i,
          /android.+oneplus\s(a\d{4})[\s)]/i
        ],
        [h, [y, "OnePlus"], [g, $]],
        [
          /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i
          // RCA Tablets
        ],
        [h, [y, "RCA"], [g, P]],
        [
          /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i
          // Dell Venue Tablets
        ],
        [h, [y, "Dell"], [g, P]],
        [
          /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i
          // Verizon Tablet
        ],
        [h, [y, "Verizon"], [g, P]],
        [
          /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i
          // Barnes & Noble Tablet
        ],
        [[y, "Barnes & Noble"], h, [g, P]],
        [
          /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i
          // Barnes & Noble Tablet
        ],
        [h, [y, "NuVision"], [g, P]],
        [
          /android.+;\s(k88)\sbuild/i
          // ZTE K Series Tablet
        ],
        [h, [y, "ZTE"], [g, P]],
        [
          /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i
          // Swiss GEN Mobile
        ],
        [h, [y, "Swiss"], [g, $]],
        [
          /android.+[;\/]\s*(zur\d{3})\s+build/i
          // Swiss ZUR Tablet
        ],
        [h, [y, "Swiss"], [g, P]],
        [
          /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i
          // Zeki Tablets
        ],
        [h, [y, "Zeki"], [g, P]],
        [
          /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
          /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i
          // Dragon Touch Tablet
        ],
        [[y, "Dragon Touch"], h, [g, P]],
        [
          /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i
          // Insignia Tablets
        ],
        [h, [y, "Insignia"], [g, P]],
        [
          /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i
          // NextBook Tablets
        ],
        [h, [y, "NextBook"], [g, P]],
        [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],
        [[y, "Voice"], h, [g, $]],
        [
          // Voice Xtreme Phones
          /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i
          // LvTel Phones
        ],
        [[y, "LvTel"], h, [g, $]],
        [/android.+;\s(PH-1)\s/i],
        [h, [y, "Essential"], [g, $]],
        [
          // Essential PH-1
          /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i
          // Envizen Tablets
        ],
        [h, [y, "Envizen"], [g, P]],
        [
          /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i
          // Le Pan Tablets
        ],
        [y, h, [g, P]],
        [
          /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i
          // MachSpeed Tablets
        ],
        [h, [y, "MachSpeed"], [g, P]],
        [
          /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i
          // Trinity Tablets
        ],
        [y, h, [g, P]],
        [
          /android.+[;\/]\s*TU_(1491)\s+build/i
          // Rotor Tablets
        ],
        [h, [y, "Rotor"], [g, P]],
        [
          /android.+(KS(.+))\s+build/i
          // Amazon Kindle Tablets
        ],
        [h, [y, "Amazon"], [g, P]],
        [
          /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i
          // Gigaset Tablets
        ],
        [y, h, [g, P]],
        [
          /\s(tablet|tab)[;\/]/i,
          /\s(mobile)(?:[;\/]|\ssafari)/i
          // Unidentifiable Mobile
        ],
        [[g, t.util.lowerize], y, h],
        [
          /[\s\/\(](smart-?tv)[;\)]/i
          // SmartTV
        ],
        [[g, Pe]],
        [
          /(android[\w\.\s\-]{0,9});.+build/i
          // Generic Android Device
        ],
        [h, [y, "Generic"]]
      ],
      engine: [
        [
          /windows.+\sedge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [m, [I, "EdgeHTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [m, [I, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,
          /(icab)[\/\s]([23]\.[\d\.]+)/i
          // iCab
        ],
        [I, m],
        [
          /rv\:([\w\.]{1,9}).+(gecko)/i
          // Gecko
        ],
        [m, I]
      ],
      os: [
        [
          // Windows based
          /microsoft\s(windows)\s(vista|xp)/i
          // Windows (iTunes)
        ],
        [I, m],
        [
          /(windows)\snt\s6\.2;\s(arm)/i,
          /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,
          /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
        ],
        [
          [I, t.mapper.str, t.maps.os.windows],
          [m, t.mapper.str, t.maps.os.windows.version]
        ],
        [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],
        [
          [I, "Windows"],
          [m, t.mapper.str, t.maps.os.windows.version]
        ],
        [
          // Mobile/Embedded OS
          /\((bb)(10);/i
          // BlackBerry 10
        ],
        [[I, "BlackBerry"], m],
        [
          /(blackberry)\w*\/?([\w\.]*)/i,
          /(tizen|kaios)[\/\s]([\w\.]+)/i,
          /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
          // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
        ],
        [I, m],
        [
          /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i
          // Symbian
        ],
        [[I, "Symbian"], m],
        [
          /\((series40);/i
          // Series 40
        ],
        [I],
        [
          /mozilla.+\(mobile;.+gecko.+firefox/i
          // Firefox OS
        ],
        [[I, "Firefox OS"], m],
        [
          // Console
          /(nintendo|playstation)\s([wids34portablevu]+)/i,
          // GNU/Linux based
          /(mint)[\/\s\(]?(\w*)/i,
          /(mageia|vectorlinux)[;\s]/i,
          /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
          // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
          // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
          /(hurd|linux)\s?([\w\.]*)/i,
          /(gnu)\s?([\w\.]*)/i
          // GNU
        ],
        [[I, "Linux"], m],
        [
          /(cros)\s[\w]+\s([\w\.]+\w)/i
          // Chromium OS
        ],
        [[I, "Chromium OS"], m],
        [
          // Solaris
          /(sunos)\s?([\w\.\d]*)/i
          // Solaris
        ],
        [[I, "Solaris"], m],
        [
          // BSD based
          /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
        ],
        [[I, "Linux"], m],
        [
          /(iphone)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i
          // iOS
        ],
        [
          [I, "iOS"],
          [m, /_/g, "."]
        ],
        [
          /(ipad)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i
          // iOS
        ],
        [
          [I, "iOS"],
          [m, /_/g, "."]
        ],
        [
          /(haiku)\s(\w+)/i
          // Haiku
        ],
        [I, m],
        [
          /cfnetwork\/.+darwin/i,
          /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i
          // iOS
        ],
        [
          [m, /_/g, "."],
          [I, "iOS"]
        ],
        [
          /(mac\sos\sx)\s?([\w\s\.]*)/i,
          /(macintosh|mac(?=_powerpc)\s)/i
          // Mac OS
        ],
        [
          [I, "Mac"],
          [m, /_/g, "."]
        ],
        [
          // Other
          /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,
          /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,
          /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
          // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
          /(unix)\s?([\w\.]*)/i
          // UNIX
        ],
        [I, m]
      ]
    }, t;
  }()
), hx = (
  /** @class */
  function() {
    function t() {
    }
    return t.generate = function(e) {
      var r, n, i, o, a, s, u;
      typeof e > "u" ? u = {
        navigator: { userAgent: "", vendor: "", languages: [] },
        screen: {
          width: "",
          height: ""
        }
      } : u = e;
      var c = vx.parse(u.navigator.userAgent), l = c.browser, f = c.os, p = c.device, d = u.screen, C = ((r = u.navigator.languages) === null || r === void 0 ? void 0 : r[0]) || "", R = C.split("-")[0], S = ((n = p.type) !== null && n !== void 0 ? n : "pc").replace(/\b(mobile|smarttv)\b/g, function(D, Oe) {
        return Oe === "mobile" ? "phone" : Oe === "smarttv" ? "tv" : D;
      }), T = f.name || "", N = "", U = "";
      try {
        T = (o = (i = T.match(/\b(Mac|Windows|Linux|Android|iOS)\b/)) === null || i === void 0 ? void 0 : i[0]) !== null && o !== void 0 ? o : T, N = (s = (a = d.orientation.type.match(/\b(landscape|portrait)\b/)) === null || a === void 0 ? void 0 : a[0]) !== null && s !== void 0 ? s : "", U = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      } catch {
      }
      return {
        platform: "Web",
        browserName: l.name || "",
        browserMajorVersion: l.major || "",
        browserVersion: l.version || "",
        osName: T,
        osVersion: f.version || "",
        deviceModel: p.model || "",
        deviceType: S,
        deviceVendor: p.vendor || "",
        deviceBrand: p.vendor || "",
        locale: C,
        language: R,
        orientation: N,
        userAgent: u.navigator.userAgent || "",
        screenWidth: d.width || "",
        screenHeight: d.height || "",
        timeZone: U
      };
    }, t;
  }()
), gx = (
  /** @class */
  function() {
    function t(e, r) {
      this.previous = e, this.current = r;
    }
    return t.prototype.map = function(e) {
      return new t(e(this.previous), e(this.current));
    }, t;
  }()
), yx = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u) {
      this.hackleDeviceId = e, this.storage = r, this.cohortFetcher = n, this.campaignParser = i, this.pageManager = o, this.clock = a, this.userListeners = [], this.defaultUser = { id: this.hackleDeviceId, deviceId: this.hackleDeviceId }, this.context = this.initContext(s, u), this.storage.saveUser(this.context.user);
    }
    return t.prototype.initContext = function(e, r) {
      var n, i = (n = r ?? e) !== null && n !== void 0 ? n : this.defaultUser;
      return mx.of(Bc(i, this.hackleDeviceId), Ta.empty());
    }, t.prototype.addListener = function(e) {
      this.userListeners.push(e);
    }, Object.defineProperty(t.prototype, "currentUser", {
      get: function() {
        return this.context.user;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resolve = function(e) {
      var r = this.resolveContext(e);
      return this.hackleUser(r);
    }, t.prototype.resolveContext = function(e) {
      return e === void 0 ? this.context : typeof e == "string" ? this.updateUser({ id: e }).current : this.updateUser(e).current;
    }, t.prototype.toHackleUser = function(e) {
      var r = this.context.with(e);
      return this.hackleUser(r);
    }, t.prototype.hackleUser = function(e) {
      var r = new Xo().addIdentifiers(e.user.identifiers || {}).add(Ee.ID, e.user.id || this.hackleDeviceId).add(Ee.DEVICE, e.user.deviceId || this.hackleDeviceId).add(Ee.HACKLE_DEVICE, this.hackleDeviceId);
      v.isNotNullOrUndefined(e.user.userId) && r.add(Ee.USER, e.user.userId);
      var n = r.build(), i = this.campaignParser.parse(), o = b(b({}, i), e.user.properties);
      return {
        identifiers: n,
        properties: o,
        hackleProperties: this.hackleProperties(),
        cohorts: e.cohorts.rawCohorts
      };
    }, t.prototype.hackleProperties = function() {
      var e;
      return typeof window < "u" && (e = b(b({}, hx.generate(window)), this.pageManager.currentPage.toProperties())), e || {};
    }, t.prototype.setUser = function(e) {
      return this.updateUser(e).map(function(r) {
        return r.user;
      });
    }, t.prototype.setUserId = function(e) {
      var r = b(b({}, this.context.user), { userId: e });
      return this.setUser(r);
    }, t.prototype.setDeviceId = function(e) {
      var r = b(b({}, this.context.user), { deviceId: e });
      return this.setUser(r);
    }, t.prototype.updateUserProperties = function(e) {
      return this.operateProperties(e).map(function(r) {
        return r.user;
      });
    }, t.prototype.resetUser = function() {
      var e = this;
      return this.updateContext(function() {
        return e.defaultUser;
      }).map(function(r) {
        return r.user;
      });
    }, t.prototype.changeUser = function(e, r, n) {
      this.userListeners.forEach(function(i) {
        i.onUserUpdated(e, r, n);
      });
    }, t.prototype.saveUser = function(e) {
      this.storage.saveUser(e);
    }, t.prototype.updateContext = function(e) {
      var r = this.context, n = r.user, i = e(n), o = this.context.with(i);
      return this.context = o, ba(n, i) || (this.changeUser(n, i, this.clock.currentMillis()), this.saveUser(i)), new gx(r, o);
    }, t.prototype.updateUser = function(e) {
      var r = this;
      return this.updateContext(function(n) {
        return dx(n, Bc(e, r.hackleDeviceId));
      });
    }, t.prototype.operateProperties = function(e) {
      return this.updateContext(function(r) {
        var n, i = (n = r.properties) !== null && n !== void 0 ? n : {}, o = e.operate(new Map(Object.entries(i)));
        return b(b({}, r), { properties: v.fromMap(o) });
      });
    }, t.prototype.sync = function() {
      return M(this, void 0, void 0, function() {
        var e, r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, this.cohortFetcher.fetch(this.currentUser)];
            case 1:
              return e = n.sent(), this.context = this.context.update(e), [3, 3];
            case 2:
              return r = n.sent(), O.log.error("Failed to sync cohorts: ".concat(r)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.syncIfNeeded = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          return this.hasNewIdentifiers(e.previous, e.current) ? [2, this.sync()] : [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.hasNewIdentifiers = function(e, r) {
      var n = on(e), i = on(r);
      return Object.entries(i).some(function(o) {
        var a = o[0], s = o[1];
        return n[a] !== s;
      });
    }, t.prototype.close = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), Ix = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.getUser = function() {
      var e = this.deviceId || void 0, r = this.userId || void 0;
      return e !== void 0 || r !== void 0 ? { deviceId: e, userId: r } : null;
    }, t.prototype.saveUser = function(e) {
      this.setDeviceId(e.deviceId || null), this.setUserId(e.userId || null);
    }, Object.defineProperty(t.prototype, "deviceId", {
      get: function() {
        return this.storage.getItem(rs);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "userId", {
      get: function() {
        return this.storage.getItem(ts);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setDeviceId = function(e) {
      this.setId(rs, e);
    }, t.prototype.setUserId = function(e) {
      this.setId(ts, e);
    }, t.prototype.setId = function(e, r) {
      v.isNotNullOrUndefined(r) ? this.storage.setItem(e, r) : this.storage.removeItem(e);
    }, t;
  }()
), mx = (
  /** @class */
  function() {
    function t(e, r) {
      this.user = e, this.cohorts = r;
    }
    return t.of = function(e, r) {
      return new t(e, r.filterBy(e));
    }, t.prototype.with = function(e) {
      return t.of(e, this.cohorts.filterBy(e));
    }, t.prototype.update = function(e) {
      var r = e.filterBy(this.user), n = this.cohorts.toBuilder().putAll(r).build();
      return t.of(this.user, n);
    }, t;
  }()
), Bc = function(t, e) {
  return b(b({}, t), { id: t.id || e, deviceId: t.deviceId || e });
}, Ax = function(t) {
  return "".concat(t, ".").concat(Pt().slice(0, 8));
}, Ex = (
  /** @class */
  function() {
    function t(e, r) {
      this.sessionTimeoutMillis = e, this.storage = r, this.sessionListeners = [], this._currentSessionId = null, this._lastEventTime = null, this.loadSession(), this.loadLastEventTime();
    }
    return Object.defineProperty(t.prototype, "currentSessionId", {
      get: function() {
        return this._currentSessionId;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sessionId", {
      get: function() {
        var e;
        return (e = this._currentSessionId) !== null && e !== void 0 ? e : t.EMPTY_SESSION_ID;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.addListener = function(e) {
      this.sessionListeners.push(e);
    }, t.prototype.startNewSession = function(e, r, n) {
      return e && this.endSession(e), this.newSession(r, n);
    }, t.prototype.startNewSessionIfNeeded = function(e, r) {
      var n = this._lastEventTime;
      return n === null ? this.startNewSession(e, e, r) : this._currentSessionId !== null && r - n < this.sessionTimeoutMillis ? (this.updateLastEventTime(r), this._currentSessionId) : this.startNewSession(e, e, r);
    }, t.prototype.updateLastEventTime = function(e) {
      this._lastEventTime = e, this.storage.setItem(es, "".concat(e));
    }, t.prototype.endSession = function(e) {
      var r = this._currentSessionId, n = this._lastEventTime;
      r !== null && n !== null && this.sessionListeners.forEach(function(i) {
        return i.onSessionEnded(r, e, n);
      });
    }, t.prototype.newSession = function(e, r) {
      var n = Ax(r);
      return this.saveSession(n), this.updateLastEventTime(r), this.sessionListeners.forEach(function(i) {
        i.onSessionStarted(n, e, r);
      }), n;
    }, t.prototype.saveSession = function(e) {
      this._currentSessionId = e, this.storage.setItem(qa, e);
    }, t.prototype.loadSession = function() {
      this._currentSessionId = this.storage.getItem(qa);
    }, t.prototype.loadLastEventTime = function() {
      var e = this.storage.getItem(es);
      if (e !== null) {
        var r = Number.parseFloat(e);
        r > 0 && (this._lastEventTime = r);
      }
    }, t.prototype.onUserUpdated = function(e, r, n) {
      this.endSession(e), this.newSession(r, n);
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "hidden":
        case "pagehide":
          return this.updateLastEventTime(r);
        case "blur":
        case "focus":
        case "locationChange":
        case "visible":
        case "pageshow":
          return;
      }
    }, t.EMPTY_SESSION_ID = "0.ffffffff", t;
  }()
), Cx = (
  /** @class */
  function() {
    function t() {
      this.storage = window.localStorage;
    }
    return t.prototype.getItem = function(e) {
      var r, n;
      return (n = (r = this.storage) === null || r === void 0 ? void 0 : r.getItem(e)) !== null && n !== void 0 ? n : null;
    }, t.prototype.removeItem = function(e) {
      var r;
      (r = this.storage) === null || r === void 0 || r.removeItem(e);
    }, t.prototype.setItem = function(e, r) {
      var n;
      (n = this.storage) === null || n === void 0 || n.setItem(e, r);
    }, t.prototype.clear = function() {
      var e;
      (e = this.storage) === null || e === void 0 || e.clear();
    }, t;
  }()
), At = (
  /** @class */
  function() {
    function t(e, r) {
      this.delegate = e, this.transform = r;
    }
    return t.postfix = function(e, r) {
      return new t(e, function(n) {
        return "".concat(n).concat(r);
      });
    }, t.prefix = function(e, r) {
      return new t(e, function(n) {
        return "".concat(r).concat(n);
      });
    }, t.prototype.getItem = function(e) {
      return this.delegate.getItem(this.transform(e));
    }, t.prototype.removeItem = function(e) {
      this.delegate.removeItem(this.transform(e));
    }, t.prototype.setItem = function(e, r) {
      this.delegate.setItem(this.transform(e), r);
    }, t;
  }()
), jc = (
  /** @class */
  function() {
    function t(e, r, n) {
      n === void 0 && (n = 4096);
      var i = this;
      this.delegate = e, this.listKey = r, this.encodedListCharLen = 6, this.resolveMaxLength = function(o) {
        var a = o - i.encodedListCharLen;
        return a < 0 ? 0 : a;
      }, this.maxLength = this.resolveMaxLength(n);
    }
    return t.prototype.isEqualItem = function(e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.prototype.getRemainListSize = function() {
      try {
        return this.maxLength - JSON.stringify(this.getList()).length;
      } catch {
        return 0;
      }
    }, t.prototype.isAddableItem = function(e) {
      try {
        return this.getRemainListSize() > JSON.stringify(e).length;
      } catch {
        return !1;
      }
    }, t.prototype.getVictimIndex = function(e) {
      var r = this.getRemainListSize();
      try {
        var n = JSON.stringify(e), i = this.getList(), o = 0;
        return i.findIndex(function(a) {
          return o += JSON.stringify(a).length, o + r >= n.length;
        });
      } catch {
        return -1;
      }
    }, t.prototype.getList = function() {
      try {
        var e = this.delegate.getItem(this.listKey);
        if (!e)
          return [];
        var r = JSON.parse(e);
        return Array.isArray(r) ? r : [];
      } catch {
        return [];
      }
    }, t.prototype.entries = function() {
      return this.getList().flatMap(Object.entries);
    }, t.prototype.setItem = function(e, r) {
      var n;
      try {
        this.removeItem(e);
        var i = this.getList(), o = (n = {}, n[e] = r, n);
        if (!this.isAddableItem(o)) {
          var a = this.getVictimIndex(o);
          if (a < 0)
            return;
          i = i.slice(a + 1);
        }
        var s = JSON.stringify(i.concat(o));
        this.delegate.setItem(this.listKey, s);
      } catch {
      }
    }, t.prototype.getItem = function(e) {
      var r = this, n = this.getList().find(function(i) {
        return r.isEqualItem(i, e);
      });
      if (!(!n || !n[e]))
        return n[e];
    }, t.prototype.removeItem = function(e) {
      var r = this, n = this.getList();
      try {
        var i = n.filter(function(a) {
          return !r.isEqualItem(a, e);
        }), o = JSON.stringify(i);
        this.delegate.setItem(this.listKey, o);
      } catch {
      }
    }, t.prototype.clear = function() {
      this.delegate.removeItem(this.listKey);
    }, t;
  }()
), bx = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.core = e, this.userManager = r, this.abOverrideStorage = n, this.ffOverrideStorage = i;
    }
    return t.prototype.currentUser = function() {
      return this.userManager.resolve();
    }, t.prototype.getAbTestDecisions = function() {
      return this.core.experiments(this.currentUser()).entries();
    }, t.prototype.getAbTestOverrides = function() {
      return this.abOverrideStorage.getAll();
    }, t.prototype.setAbTestOverride = function(e, r) {
      this.abOverrideStorage.set(e, r), this.increment("AB_TEST", "set");
    }, t.prototype.resetAbTestOverride = function(e) {
      this.abOverrideStorage.remove(e), this.increment("AB_TEST", "reset");
    }, t.prototype.resetAllAbTestOverride = function() {
      this.abOverrideStorage.clear(), this.increment("AB_TEST", "reset.all");
    }, t.prototype.getFeatureFlagDecisions = function() {
      return this.core.featureFlags(this.currentUser()).entries();
    }, t.prototype.getFeatureFlagOverrides = function() {
      return this.ffOverrideStorage.getAll();
    }, t.prototype.setFeatureFlagOverride = function(e, r) {
      this.ffOverrideStorage.set(e, r), this.increment("FEATURE_FLAG", "set");
    }, t.prototype.resetFeatureFlagOverride = function(e) {
      this.ffOverrideStorage.remove(e), this.increment("FEATURE_FLAG", "reset");
    }, t.prototype.resetAllFeatureFlagOverride = function() {
      this.ffOverrideStorage.clear(), this.increment("FEATURE_FLAG", "reset.all");
    }, t.prototype.increment = function(e, r) {
      Ue.counter("experiment.manual.override", {
        "experiment.type": e,
        operation: r
      }).increment();
    }, t;
  }()
), Et = (
  /** @class */
  function() {
    function t() {
    }
    return t.serverFetch = function(e, r) {
      return "".concat(e, "/api/v2/workspaces/").concat(r, "/config");
    }, t.clientFetch = function(e, r) {
      return "".concat(e, "/api/v2/workspaces/").concat(r, "/config");
    }, t.userCohorts = function(e) {
      return "".concat(e, "/api/v1/cohorts");
    }, t.serverDispatch = function(e) {
      return "".concat(e, "/api/v2/events");
    }, t.clientDispatch = function(e) {
      return "".concat(e, "/api/v2/w/events");
    }, t.beaconDispatch = function(e, r) {
      return "".concat(e, "/api/v2/w/").concat(r, "/events");
    }, t.inAppMessageRenderer = function(e, r) {
      return "".concat(e, "/sdk/iam-renderer/").concat(r, "/iam-renderer.js");
    }, t.monitoring = function(e) {
      return "".concat(e, "/metrics");
    }, t;
  }()
), Tx = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.exist = function(e, r) {
      var n = this.key(e), i = this.storage.getItem(n);
      if (v.isNullOrUndefined(i))
        return !1;
      var o = Number.parseInt(i, 10);
      return Number.isNaN(o) ? (this.storage.removeItem(n), !1) : r <= o ? !0 : (this.storage.removeItem(n), !1);
    }, t.prototype.put = function(e, r) {
      this.storage.setItem(this.key(e), "".concat(r));
    }, t.prototype.key = function(e) {
      return "".concat(e.key);
    }, t;
  }()
), wx = (
  /** @class */
  function() {
    function t(e) {
      this.handlers = e;
    }
    return t.prototype.get = function(e) {
      return this.handlers.find(function(r) {
        return r.supports(e);
      });
    }, t;
  }()
), Nx = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.handle = function(e, r) {
      e.close();
    }, t.prototype.supports = function(e) {
      return e.type === "CLOSE";
    }, t;
  }()
), Ox = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "WEB_LINK";
    }, t;
  }()
), Mx = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      e.close();
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_AND_CLOSE";
    }, t;
  }()
), _x = (
  /** @class */
  function() {
    function t(e, r) {
      this.storage = e, this.clock = r;
    }
    return t.prototype.handle = function(e, r) {
      var n = this.clock.currentMillis() + _l;
      this.storage.put(e.context.inAppMessage, n), e.close();
    }, t.prototype.supports = function(e) {
      return e.type === "HIDDEN";
    }, t;
  }()
), Sx = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_NEW_WINDOW";
    }, t;
  }()
), Rx = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      e.close();
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_NEW_WINDOW_AND_CLOSE";
    }, t;
  }()
), xx = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_NEW_TAB";
    }, t;
  }()
), Px = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      e.close();
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_NEW_TAB_AND_CLOSE";
    }, t;
  }()
), Ux = (
  /** @class */
  function() {
    function t(e) {
      this.core = e;
    }
    return t.prototype.track = function(e, r, n) {
      var i = this.createTrackEvent(r, e);
      this.core.track(i, e.user, n);
    }, t.prototype.createTrackEvent = function(e, r) {
      var n, i, o, a;
      switch (e.type) {
        case "IMPRESSION":
          return {
            key: "$in_app_impression",
            properties: b(b({}, r.properties), { in_app_message_id: r.inAppMessage.id, in_app_message_key: r.inAppMessage.key, in_app_message_display_type: r.message.layout.displayType, title_text: (i = (n = r.message.text) === null || n === void 0 ? void 0 : n.title) === null || i === void 0 ? void 0 : i.text, body_text: (a = (o = r.message.text) === null || o === void 0 ? void 0 : o.body) === null || a === void 0 ? void 0 : a.text, button_text: r.message.buttons.map(function(u) {
              return u.text;
            }), image_url: r.message.images.map(function(u) {
              return u.imagePath;
            }) })
          };
        case "CLOSE":
          return {
            key: "$in_app_close",
            properties: b(b({}, r.properties), { in_app_message_id: r.inAppMessage.id, in_app_message_key: r.inAppMessage.key, in_app_message_display_type: r.message.layout.displayType })
          };
        case "ACTION":
          var s = e;
          return {
            key: "$in_app_action",
            properties: b(b({}, r.properties), { in_app_message_id: r.inAppMessage.id, in_app_message_key: r.inAppMessage.key, in_app_message_display_type: r.message.layout.displayType, action_type: s.action.type, action_area: s.area, action_value: s.action.value, button_text: s.text })
          };
      }
    }, t;
  }()
), Dx = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      i === void 0 && (i = null), this.messageViewFactory = e, this.eventHandler = r, this.interactionHandlerFactory = n, this.inAppMessageListener = i, this.currentMessageView = null, this.opening = !1;
    }
    return t.prototype.setListener = function(e) {
      this.inAppMessageListener = e;
    }, t.prototype.present = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              if (this.currentMessageView)
                return [
                  2
                  /*return*/
                ];
              if (this.opening)
                return [
                  2
                  /*return*/
                ];
              this.opening = !0, r = null, n.label = 1;
            case 1:
              return n.trys.push([1, 3, 4, 5]), r = this.messageViewFactory.create(e, this), r === null ? [
                2
                /*return*/
              ] : (this.currentMessageView = r, [4, r.open()]);
            case 2:
              return n.sent(), [3, 5];
            case 3:
              return n.sent(), r == null || r.close(), [3, 5];
            case 4:
              return this.opening = !1, [
                7
                /*endfinally*/
              ];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), Lx = (
  /** @class */
  function() {
    function t(e, r, n) {
      var i = this;
      this.userEventEmitter = e, this.determiner = r, this.presenter = n, this.onEvent = function(o) {
        var a = i.determiner.determineOrNull(o);
        a && i.presenter.present(a);
      }, this.initialize();
    }
    return t.prototype.initialize = function() {
      this.userEventEmitter.on("event", this.onEvent);
    }, t.prototype.destroy = function() {
      this.userEventEmitter.off("event", this.onEvent);
    }, t;
  }()
), $x = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.inAppMessage = e, this.message = r, this.user = n, this.properties = i;
    }
    return t;
  }()
), kx = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.workspaceFetcher = e, this.eventMatcher = r, this.core = n;
    }
    return t.prototype.determineOrNull = function(e) {
      var r = this.workspaceFetcher.get();
      if (r)
        for (var n = 0, i = r.getInAppMessages(); n < i.length; n++) {
          var o = i[n];
          if (this.eventMatcher.matches(r, o, e)) {
            var a = this.context(o, e);
            if (!a)
              continue;
            return a;
          }
        }
    }, t.prototype.context = function(e, r) {
      var n = this.core.tryInAppMessage(e.key, r.user);
      if (n.inAppMessage && n.message) {
        var i = b(b({}, n.properties), { decision_reason: n.reason });
        return new $x(n.inAppMessage, n.message, r.user, de.sanitize(i));
      }
    }, t;
  }()
), Fx = function(t) {
  return typeof t.detail.id == "string" && ["OPEN", "CLOSE"].includes(t.detail.type);
}, Gx = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      var s = this;
      this.scriptLoader = e, this.context = r, this.ui = n, this.renderTypeResolver = i, this.status = o, this.lifecycleRegistry = a, this.container = null, this.renderer = null, this.resolveLifecycleEnd = function(u) {
        if (!(!(u instanceof CustomEvent) || !Fx(u))) {
          var c = u.detail, l = c.id, f = c.type, p = s.lifecycleRegistry.getAndRemove(f, l);
          p == null || p();
        }
      }, this.handleInAppMessageInteraction = function(u) {
        if (u instanceof CustomEvent && u.type === t.HACKLE_IAM_INTERACTION_EVENT_TYPE) {
          var c = u.detail;
          s.handleInteraction(c);
        }
      };
    }
    return t.prototype.open = function() {
      var e, r;
      return M(this, void 0, void 0, function() {
        var n, i, o, a = this;
        return _(this, function(s) {
          switch (s.label) {
            case 0:
              if (!this.status.canOpen())
                return O.log.debug("InAppMessage is already opened. (key=".concat(this.context.inAppMessage.key, ")")), [
                  2
                  /*return*/
                ];
              s.label = 1;
            case 1:
              return s.trys.push([1, 4, , 5]), (r = (e = this.ui.inAppMessageListener) === null || e === void 0 ? void 0 : e.beforeInAppMessageOpen) === null || r === void 0 || r.call(e, this.context.inAppMessage), this.status.current = "OPENING", window.addEventListener(t.HACKLE_IAM_INTERACTION_EVENT_TYPE, this.handleInAppMessageInteraction), window.addEventListener(t.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE, this.resolveLifecycleEnd), [
                4,
                this.scriptLoader.load()
                // add view container
              ];
            case 2:
              return s.sent(), n = this.addContainer(), n.style.display = "none", n.classList.add("".concat(t.CONTAINER_CLASS_NAME, "--loading")), i = window.HackleInAppMessageRenderer, this.renderer = new i.HackleInAppMessageRenderer(n), o = this.renderTypeResolver.resolve(this.context), [4, this.renderer.render({
                messageId: this.context.inAppMessage.id,
                message: this.context.message.toJson(),
                renderType: o
              })];
            case 3:
              return s.sent(), n.classList.remove("".concat(t.CONTAINER_CLASS_NAME, "--loading")), n.style.display = "block", this.handleInAppMessageLifecycle("OPEN", function() {
                var u, c;
                a.handleEvent({ type: "IMPRESSION" }), a.status.current = "OPENED", (c = (u = a.ui.inAppMessageListener) === null || u === void 0 ? void 0 : u.afterInAppMessageOpen) === null || c === void 0 || c.call(u, a.context.inAppMessage);
              }, function() {
                O.log.warn("Failed to open inAppMessage with [Timeout expired.]"), a.destroy();
              }), [3, 5];
            case 4:
              return s.sent(), this.destroy(), [3, 5];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.close = function() {
      var e = this, r, n;
      if (!this.status.canClose()) {
        O.log.debug("InAppMessage is already closed. (key=".concat(this.context.inAppMessage.key, ")"));
        return;
      }
      (n = (r = this.ui.inAppMessageListener) === null || r === void 0 ? void 0 : r.beforeInAppMessageClose) === null || n === void 0 || n.call(r, this.context.inAppMessage), this.status.current = "CLOSING", this.handleInAppMessageLifecycle("CLOSE", function() {
        var i, o;
        e.handleEvent({ type: "CLOSE" }), e.destroy(), (o = (i = e.ui.inAppMessageListener) === null || i === void 0 ? void 0 : i.afterInAppMessageClose) === null || o === void 0 || o.call(i, e.context.inAppMessage);
      }, function() {
        var i, o;
        O.log.warn("Failed to close inAppMessage with [Timeout expired.]"), e.destroy(), (o = (i = e.ui.inAppMessageListener) === null || i === void 0 ? void 0 : i.afterInAppMessageClose) === null || o === void 0 || o.call(i, e.context.inAppMessage);
      });
    }, t.prototype.handleInAppMessageLifecycle = function(e, r, n) {
      var i = this, o = this.lifecycleRegistry.register(e, r);
      window.dispatchEvent(new CustomEvent(t.HACKLE_IAM_LIFECYCLE_START_EVENT_TYPE, {
        detail: { type: e, id: o }
      })), setTimeout(function() {
        var a = i.lifecycleRegistry.getAndRemove(e, o), s = a === void 0;
        s || n();
      }, t.LIFE_CYCLE_EVENT_LISTEN_TIMEOUT);
    }, t.prototype.destroy = function() {
      var e;
      window.removeEventListener(t.HACKLE_IAM_INTERACTION_EVENT_TYPE, this.handleInAppMessageInteraction), window.removeEventListener(t.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE, this.resolveLifecycleEnd), (e = this.renderer) === null || e === void 0 || e.destroy(), this.renderer = null, this.removeContainer(), this.ui.currentMessageView = null, this.status.current = "CLOSED";
    }, t.prototype.addContainer = function() {
      if (!this.container) {
        var e = document.createElement("div");
        e.classList.add(t.CONTAINER_CLASS_NAME), this.container = e;
      }
      return this.container.parentNode || document.body.appendChild(this.container), this.container;
    }, t.prototype.removeContainer = function() {
      var e;
      this.container && ((e = this.container.parentNode) === null || e === void 0 || e.removeChild(this.container), this.container = null);
    }, t.prototype.handleInteraction = function(e) {
      var r = this.ui.interactionHandlerFactory.get(e);
      r && r.handle(this, e);
    }, t.prototype.handleEvent = function(e) {
      this.ui.eventHandler.handle(this, e);
    }, t.HACKLE_IAM_INTERACTION_EVENT_TYPE = "hackle-iam-interaction", t.HACKLE_IAM_LIFECYCLE_START_EVENT_TYPE = "hackle-iam-lifecycle-start", t.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE = "hackle-iam-lifecycle-end", t.CONTAINER_CLASS_NAME = "hackle-iam", t.LIFE_CYCLE_EVENT_LISTEN_TIMEOUT = 5e3, t;
  }()
), Vx = (
  /** @class */
  function() {
    function t() {
      this.mobileOSRegex = /(iOS|Android|iPad|iPhone)/g, this.mobileDeviceRegex = /(mobile|phone|tablet)/g;
    }
    return t.prototype.isMobileOS = function(e) {
      var r = e.user.hackleProperties, n = r.osName;
      return typeof n == "string" && !!n.match(this.mobileOSRegex);
    }, t.prototype.isMobileDeviceType = function(e) {
      var r = e.user.hackleProperties, n = r.deviceType;
      return typeof n == "string" && !!n.match(this.mobileDeviceRegex);
    }, t.prototype.resolve = function(e) {
      return this.isMobileOS(e) || this.isMobileDeviceType(e) ? "mobile" : "pc";
    }, t;
  }()
), Bx = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = "CLOSED"), this.current = e;
    }
    return t.prototype.canOpen = function() {
      return this.current !== "OPENED" && this.current !== "OPENING";
    }, t.prototype.canClose = function() {
      return this.current !== "CLOSED" && this.current !== "CLOSING";
    }, t;
  }()
), jx = (
  /** @class */
  function() {
    function t() {
      this.record = {};
    }
    return t.prototype.resolveKey = function(e, r) {
      return "".concat(e, "_").concat(r);
    }, t.prototype.register = function(e, r) {
      var n = Pt(), i = this.resolveKey(e, n);
      return this.record[i] = r, n;
    }, t.prototype.getAndRemove = function(e, r) {
      var n = this.resolveKey(e, r), i = this.record, o = n, a = i[o], s = Nv(i, [typeof o == "symbol" ? o : o + ""]);
      return this.record = s, a;
    }, t;
  }()
), Hx = (
  /** @class */
  function() {
    function t(e) {
      this.scriptLoader = e;
    }
    return t.create = function(e) {
      return new t(e);
    }, t.prototype.create = function(e, r) {
      var n = new Vx(), i = new Bx(), o = new jx();
      switch (e.message.layout.displayType) {
        case "MODAL":
        case "BANNER":
        case "BOTTOM_SHEET":
          return new Gx(this.scriptLoader, e, r, n, i, o);
        case "NONE":
          return null;
      }
    }, t;
  }()
), Xx = (
  /** @class */
  function() {
    function t(e) {
      this.scriptUrl = e;
    }
    return t.prototype.load = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return window.HackleInAppMessageRenderer ? [
                2
                /*return*/
              ] : (e = this.createScript(), document.head.appendChild(e), [4, this.waitForLoad(e)]);
            case 1:
              return [2, r.sent()];
          }
        });
      });
    }, t.prototype.createScript = function() {
      var e = document.createElement("script");
      return e.type = "text/javascript", e.async = !0, e.src = this.scriptUrl, e;
    }, t.prototype.waitForLoad = function(e) {
      return new Promise(function(r, n) {
        var i = function() {
          a(), r(e);
        }, o = function(s) {
          a(), n(s.message);
        }, a = function() {
          e.removeEventListener("error", o), e.removeEventListener("load", i);
        };
        e.addEventListener("load", i), e.addEventListener("error", o);
      });
    }, t;
  }()
), Wx = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.isTriggerTarget = function(e, r, n) {
      var i = this;
      return r.eventTrigger.rules.some(function(o) {
        return i.ruleMatches(e, n, r, o);
      });
    }, t.prototype.ruleMatches = function(e, r, n, i) {
      if (r.event.key !== i.eventKey)
        return !1;
      var o = zx.of(e, r, n);
      return this.targetMatcher.anyMatches(o, tt.create(), i.targets);
    }, t;
  }()
), zx = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.key = e, this.workspace = r, this.user = n, this.event = i;
    }
    return t.of = function(e, r, n) {
      return new t(new Cr("IN_APP_MESSAGE", n.id), e, r.user, r);
    }, t;
  }()
), Jx = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.isTriggerTarget = function(e, r, n) {
      if (!r.eventTrigger.frequencyCap)
        return !0;
      var i = this.createMatchContexts(r.eventTrigger.frequencyCap);
      if (i.length === 0)
        return !0;
      for (var o = this.storage.get(r), a = 0, s = o; a < s.length; a++)
        for (var u = s[a], c = 0, l = i; c < l.length; c++) {
          var f = l[c];
          if (f.matches(n, u))
            return !1;
        }
      return !0;
    }, t.prototype.createMatchContexts = function(e) {
      for (var r = [], n = 0, i = e.identifierCaps; n < i.length; n++) {
        var o = i[n];
        r.push(new Hc(new Zx(o)));
      }
      return e.durationCap && r.push(new Hc(new Yx(e.durationCap))), r;
    }, t;
  }()
), Hc = (
  /** @class */
  function() {
    function t(e) {
      this.matchCount = 0, this.predicate = e;
    }
    return t.prototype.matches = function(e, r) {
      return this.predicate.matches(e, r) && (this.matchCount += 1), this.matchCount >= this.predicate.thresholdCount;
    }, t;
  }()
), Zx = (
  /** @class */
  function() {
    function t(e) {
      this.identifierCap = e;
    }
    return Object.defineProperty(t.prototype, "thresholdCount", {
      get: function() {
        return this.identifierCap.count;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.matches = function(e, r) {
      var n = e.user.identifiers[this.identifierCap.identifierType];
      if (v.isNullOrUndefined(n))
        return !1;
      var i = r.identifiers[this.identifierCap.identifierType];
      return v.isNullOrUndefined(i) ? !1 : n === i;
    }, t;
  }()
), Yx = (
  /** @class */
  function() {
    function t(e) {
      this.durationCap = e;
    }
    return Object.defineProperty(t.prototype, "thresholdCount", {
      get: function() {
        return this.durationCap.count;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.matches = function(e, r) {
      return e.timestamp - r.timestamp <= this.durationCap.durationMillis;
    }, t;
  }()
), Kx = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.get = function(e) {
      var r = this.storage.getItem(e.id.toString());
      return v.isNullOrUndefined(r) ? [] : JSON.parse(r);
    }, t.prototype.set = function(e, r) {
      this.storage.setItem(e.id.toString(), JSON.stringify(r));
    }, t;
  }()
), Qx = (
  /** @class */
  function() {
    function t(e) {
      this.processors = e;
    }
    return t.prototype.get = function(e) {
      return this.processors.find(function(r) {
        return r.supports(e);
      });
    }, t;
  }()
), qx = (
  /** @class */
  function() {
    function t(e) {
      this.impressionStorage = e;
    }
    return t.prototype.process = function(e, r, n) {
      this.saveImpression(e.context.inAppMessage, e.context.user, n);
    }, t.prototype.saveImpression = function(e, r, n) {
      var i = this.impressionStorage.get(e), o = { identifiers: r.identifiers, timestamp: n };
      i.push(o), i.length > t.IMPRESSION_MAX_SIZE && i.splice(0, i.length - t.IMPRESSION_MAX_SIZE), this.impressionStorage.set(e, i);
    }, t.prototype.supports = function(e) {
      return e.type === "IMPRESSION";
    }, t.IMPRESSION_MAX_SIZE = 100, t;
  }()
), eP = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.process = function(e, r, n) {
    }, t.prototype.supports = function(e) {
      return e.type === "CLOSE";
    }, t;
  }()
), tP = (
  /** @class */
  function() {
    function t(e) {
      this.actionHandlerFactory = e;
    }
    return t.prototype.process = function(e, r, n) {
      var i, o, a = this.actionHandlerFactory.get(r.action), s = (o = (i = e.ui.inAppMessageListener) === null || i === void 0 ? void 0 : i.onInAppMessageClick) === null || o === void 0 ? void 0 : o.call(i, e.context.inAppMessage, e, Vh.fromAction(r.action));
      s || !e.status.canClose() || a == null || a.handle(e, r.action);
    }, t.prototype.supports = function(e) {
      return e.type === "ACTION";
    }, t;
  }()
), rP = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.clock = e, this.eventTracker = r, this.eventProcessorFactory = n;
    }
    return t.prototype.handle = function(e, r) {
      var n = this.clock.currentMillis();
      this.eventTracker.track(e.context, r, n);
      var i = this.eventProcessorFactory.get(r);
      i && i.process(e, r, n);
    }, t;
  }()
), nP = (
  /** @class */
  function() {
    function t(e, r) {
      this.ruleDeterminer = e, this.frequencyCapDeterminer = r;
    }
    return t.prototype.matches = function(e, r, n) {
      return !Z.isTrackEvent(n) || !this.ruleDeterminer.isTriggerTarget(e, r, n) ? !1 : this.frequencyCapDeterminer.isTriggerTarget(e, r, n);
    }, t;
  }()
), iP = (
  /** @class */
  function() {
    function t(e) {
      this.handlers = e;
    }
    return t.prototype.get = function(e) {
      return this.handlers.find(function(r) {
        return r.supports(e);
      });
    }, t;
  }()
), oP = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.handle = function(e, r) {
      e.close();
    }, t.prototype.supports = function(e) {
      return e.type === "CLOSE";
    }, t;
  }()
), aP = (
  /** @class */
  function() {
    function t(e) {
      this.eventHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      var n = cr.fromJson(r.action);
      if (n) {
        var i = {
          type: "ACTION",
          action: n,
          area: r.area,
          text: r.text
        };
        this.eventHandler.handle(e, i);
      }
    }, t.prototype.supports = function(e) {
      return e.type === "ACTION";
    }, t;
  }()
), Xc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.open = function(e) {
      window.location.href = e.href;
    }, t;
  }()
), Wc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.open = function(e) {
      window.open(e.href, "Hackle", "resizable:true");
    }, t;
  }()
), zc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.open = function(e) {
      window.open(e.href);
    }, t;
  }()
), sP = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.open = function(e) {
      window.location.replace(e);
    }, t;
  }()
), wa = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  gclid: void 0,
  fbclid: void 0
}, uP = {
  current: void 0,
  referrer: void 0
}, cP = function(t) {
  return Vp(t, wa);
}, Vp = function(t, e) {
  return Object.keys(wa).every(function(r) {
    return t[r] === e[r];
  });
}, lP = function(t, e, r) {
  return t === null ? !0 : cP(e) && r.current === r.referrer ? !1 : !Vp(t, e);
}, fP = function(t, e) {
  for (var r = 0, n = Object.entries(t); r < n.length; r++) {
    var i = n[r], o = i[0], a = i[1];
    Cn.isNotEmptyString(a) && e.searchParams.set(o, a);
  }
  return e;
}, pP = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.storage = e, this.parser = r, this.core = n, this.userManager = i;
    }
    return t.prototype.startNewCampaign = function(e, r, n) {
      for (var i = b(b({}, wa), r), o = new ir(), a = 0, s = Object.entries(i); a < s.length; a++) {
        var u = s[a], c = u[0], l = u[1];
        l ? o.set(c, l) : o.unset(c);
      }
      var f = o.build(), p = f.toEvent(), d = this.userManager.toHackleUser(e);
      this.core.track(p, d, n), this.userManager.updateUserProperties(f);
    }, t.prototype.startNewCampaignIfNeeded = function(e, r) {
      var n = this.storage.get(), i = this.parser.parse(), o = this.parser.parseDomain();
      lP(n, i, o) && (this.storage.set(i), this.startNewCampaign(e, i, r));
    }, t.prototype.onSessionEnded = function(e, r, n) {
    }, t.prototype.onSessionStarted = function(e, r, n) {
      this.startNewCampaignIfNeeded(r, n);
    }, t;
  }()
), dP = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.get = function() {
      var e = this.storage.getItem(ns);
      return e ? JSON.parse(e) : null;
    }, t.prototype.set = function(e) {
      this.storage.setItem(ns, JSON.stringify(e));
    }, t;
  }()
), vP = (
  /** @class */
  function() {
    function t(e) {
      this.search = e;
    }
    return t.prototype.getQueryParam = function(e) {
      var r = this.getQueryParams(function() {
        return !0;
      });
      return r[e] || "";
    }, t.prototype.getQueryParams = function(e) {
      for (var r = {}, n = this.search.substring(1).split("&"), i = 0, o = n; i < o.length; i++) {
        var a = o[i], s = a.split("="), u = s[0], c = s[1];
        if (!e || e(u, c)) {
          var l = Ce.tryDecodeURIComponent(c);
          l && (r[u] = l);
        }
      }
      return r;
    }, t;
  }()
), Jc = (
  /** @class */
  function() {
    function t() {
    }
    return t.extractDomain = function(e) {
      var r = this.DOMAIN_MATCH_REGEX, n = e.split("."), i = n[n.length - 1];
      (i.length > 4 || i === "com" || i === "org") && (r = this.SIMPLE_DOMAIN_MATCH_REGEX);
      var o = e.match(r);
      return o ? o[0] : e;
    }, t.DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, t.SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, t;
  }()
), hP = (
  /** @class */
  function() {
    function t(e) {
      this.pageManager = e;
    }
    return t.prototype.parse = function(e) {
      var r = this.params(e);
      return this.resolve(r);
    }, t.prototype.params = function(e) {
      var r = v.isNotNullOrUndefined(e) ? e : this.pageManager.currentPage.queryParameter;
      return new vP(r).getQueryParams(t.CAMPAIGN_QUERY_CONDITION);
    }, t.prototype.resolve = function(e) {
      return {
        utm_campaign: e[gP],
        utm_content: e[yP],
        utm_id: e[IP],
        utm_medium: e[mP],
        utm_source: e[AP],
        utm_term: e[EP],
        gclid: e[CP],
        fbclid: e[bP]
      };
    }, t.prototype.parseDomain = function() {
      var e = this;
      if (typeof window > "u")
        return uP;
      var r = function() {
        var n = e.pageManager.currentPage.referrer;
        if (n) {
          var i = new URL(n).hostname;
          return Jc.extractDomain(i);
        }
      };
      return {
        current: Jc.extractDomain(this.pageManager.currentPage.hostname),
        referrer: r()
      };
    }, t.CAMPAIGN_QUERY_CONDITION = function(e, r) {
      return Cn.isNotEmptyString(r);
    }, t;
  }()
), gP = "utm_campaign", yP = "utm_content", IP = "utm_id", mP = "utm_medium", AP = "utm_source", EP = "utm_term", CP = "gclid", bP = "fbclid", TP = (
  /** @class */
  function() {
    function t(e, r) {
      var n = this;
      this.userEventEmitter = e, this.determiner = r, this.onEvent = function(i) {
        var o = n.determiner.determineTargetExposureOrNull(i);
        o && n.send(o);
      }, this.initialize();
    }
    return t.prototype.initialize = function() {
      this.userEventEmitter.on("event", this.onEvent);
    }, t.prototype.send = function(e) {
      var r = e.experiment.key, n = e.variationKey, i = "HACKLE-EXPERIMENT_".concat(r, "_V").concat(e.experiment.version, "-").concat(n);
      try {
        window.gtag("event", "experience_impression", {
          exp_variant_string: i
        });
      } catch (o) {
        O.log.error("Unexpected exception while sending an event to Google Analytics with gtag: ".concat(o));
      }
    }, t;
  }()
), wP = (
  /** @class */
  function() {
    function t(e) {
      this.workspaceFetcher = e;
    }
    return t.prototype.determineTargetExposureOrNull = function(e) {
      var r = this.workspaceFetcher.get();
      if (!r)
        return null;
      var n = r.getAttributes();
      return !n.integration_ga_experiment || !Z.isExposureEvent(e) || e.experiment.status !== "RUNNING" || e.decisionReason !== w.TRAFFIC_ALLOCATED ? null : e;
    }, t;
  }()
), Zc = {
  user: void 0,
  debug: !1,
  log_disabled: !1,
  automaticPageTracking: !0,
  pollingIntervalMillis: Ot,
  exposureEventDedupIntervalMillis: Jr,
  sessionTimeoutMillis: $v,
  autoOpenDevTool: !1,
  sdkUrl: Mv,
  eventUrl: _v,
  monitoringUrl: Sv,
  cdnUrl: Rv,
  sameSiteCookie: "LAX",
  secureCookie: !1,
  SDK_NAME_HEADER: "javascript-sdk_browser",
  SDK_VERSION_HEADER: xv,
  IAM_RENDERER_VERSION_HEADER: jv
}, qe = (
  /** @class */
  function() {
    function t() {
    }
    return t.config = function(e) {
      return b(b(b({}, Zc), e), { automaticPageTracking: t.resolveAutomaticPageTracking(e) });
    }, t.resolveAutomaticPageTracking = function(e) {
      return typeof (e == null ? void 0 : e.automaticPageTracking) != "boolean" && typeof (e == null ? void 0 : e.auto_track_page_view) != "boolean" ? Zc.automaticPageTracking : !!e.automaticPageTracking || !!e.auto_track_page_view;
    }, t.logging = function(e) {
      O.initCounter(function(r) {
        return Ue.counter("log", { level: r });
      }), O.setLogLevel(Me.INFO), e.log_disabled ? O.setLogLevel(Me.DISABLE) : e.debug && O.setLogLevel(Me.DEBUG);
    }, t.sdk = function(e, r) {
      return O.log.debug("SDK key: ".concat(e)), e || O.log.error("invalid sdk key: '".concat(e, "' (expected: not null, not undefined and not empty string)")), {
        key: e,
        name: r.SDK_NAME_HEADER,
        version: r.SDK_VERSION_HEADER
      };
    }, t.isBeaconSupported = function() {
      var e = !1;
      return typeof window < "u" && (e = window && window.navigator && !!window.navigator.sendBeacon && !0, e && O.log.debug("support sendBeacon API")), e;
    }, t.pollingIntervalMillis = function(e) {
      return e.pollingIntervalMillis === void 0 || typeof e.pollingIntervalMillis != "number" || e.pollingIntervalMillis <= 0 ? Ot : Math.max(e.pollingIntervalMillis, Pv);
    }, t.dedupIntervalMillis = function(e) {
      return e.exposureEventDedupIntervalMillis === void 0 || typeof e.exposureEventDedupIntervalMillis != "number" ? Jr : e.exposureEventDedupIntervalMillis < 1e3 || e.exposureEventDedupIntervalMillis > 1e3 * 60 * 60 ? (O.log.warn("Exposure event dedup interval is outside allowed range[1_000ms..3_600_000ms]. Setting to default value[1m]."), Jr) : e.exposureEventDedupIntervalMillis;
    }, t;
  }()
), NP = (
  /** @class */
  function() {
    function t() {
      this.synchronizers = [];
    }
    return t.prototype.add = function(e) {
      this.synchronizers.push(e);
    }, t.prototype.sync = function() {
      return M(this, void 0, void 0, function() {
        var e = this;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, Promise.all(this.synchronizers.map(function(n) {
                return e.safe(n.sync());
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.close = function() {
      return M(this, void 0, void 0, function() {
        var e = this;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, Promise.all(this.synchronizers.map(function(n) {
                return e.safe(n.close());
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.safe = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, e];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), O.log.error("Failed to sync: ".concat(r)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), OP = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.delegate = e, this.scheduler = r, this.intervalMillis = n, this.pollingJob = null;
    }
    return t.prototype.sync = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, this.delegate.sync()];
            case 1:
              return r.sent(), [3, 3];
            case 2:
              return e = r.sent(), O.log.error("Failed to sync: ".concat(e)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.start = function() {
      var e = this;
      this.intervalMillis !== Ot && this.pollingJob === null && (this.pollingJob = this.scheduler.schedulePeriodically(this.intervalMillis, this.intervalMillis, function() {
        return e.sync();
      }));
    }, t.prototype.stop = function() {
      var e;
      this.intervalMillis !== Ot && ((e = this.pollingJob) === null || e === void 0 || e.cancel(), this.pollingJob = null);
    }, t.prototype.close = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          switch (e.label) {
            case 0:
              return this.stop(), [4, this.delegate.close()];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), Ki = (
  /** @class */
  function() {
    function t(e) {
      this.scheduleType = e;
    }
    return t.prototype.schedule = function(e, r) {
      var n = new MP(e, r);
      return n.start(), n;
    }, t.prototype.schedulePeriodically = function(e, r, n) {
      var i;
      switch (this.scheduleType) {
        case "setTimeout":
          i = new _P(e, r, n);
          break;
        case "setInterval":
          i = new SP(e, r, n);
          break;
      }
      return i.start(), i;
    }, t;
  }()
), MP = (
  /** @class */
  function() {
    function t(e, r) {
      this.delayMillis = e, this.task = r, this.timeout = null;
    }
    return t.prototype.start = function() {
      var e = this;
      this.timeout = setTimeout(function() {
        return e.task();
      }, this.delayMillis);
    }, t.prototype.cancel = function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null);
    }, t;
  }()
), _P = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.delayMillis = e, this.intervalMillis = r, this.task = n, this.timeout = null;
    }
    return t.prototype.start = function() {
      var e = this;
      this.timeout = setTimeout(function() {
        return e.run();
      }, this.delayMillis);
    }, t.prototype.run = function() {
      var e = this;
      try {
        this.task();
      } catch (r) {
        O.log.error("Failed to run task: ".concat(r));
      }
      this.timeout = setTimeout(function() {
        return e.run();
      }, this.intervalMillis);
    }, t.prototype.cancel = function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null);
    }, t;
  }()
), SP = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.delayMillis = e, this.intervalMillis = r, this.task = n, this.timeout = null, this.interval = null;
    }
    return t.prototype.start = function() {
      var e = this;
      this.timeout = setTimeout(function() {
        e.run(), e.interval = setInterval(function() {
          return e.run();
        }, e.intervalMillis);
      }, this.delayMillis);
    }, t.prototype.run = function() {
      try {
        this.task();
      } catch (e) {
        O.log.error("Failed to run task: ".concat(e));
      }
    }, t.prototype.cancel = function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null), this.interval && (clearInterval(this.interval), this.interval = null);
    }, t;
  }()
), RP = (
  /** @class */
  function() {
    function t(e, r) {
      this.url = e, this.transport = r;
    }
    return t.prototype.fetchIfModified = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          switch (i.label) {
            case 0:
              return r = this.createRequest(e), [4, this.execute(r)];
            case 1:
              return n = i.sent(), [2, this.handleResponse(n)];
          }
        });
      });
    }, t.prototype.createRequest = function(e) {
      var r = dr.builder().url(this.url).method("GET");
      return e !== null && r.addHeader(_t.IF_MODIFIED_SINCE, e), r.build();
    }, t.prototype.execute = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n, i;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              r = at.start(), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.transport.send(e)];
            case 2:
              return n = o.sent(), St.record("get.workspace", r, n), [2, n];
            case 3:
              throw i = o.sent(), St.record("get.workspace", r, null), i;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.handleResponse = function(e) {
      if (e.isNotModified())
        return null;
      if (!e.isSuccessful())
        throw new Error("Http status code: ".concat(e.statusCode));
      if (e.body === null)
        throw new Error("Response body is empty");
      var r = JSON.parse(e.body), n = e.headers.get(_t.LAST_MODIFIED);
      return { config: r, lastModified: n };
    }, t;
  }()
), xP = (
  /** @class */
  function() {
    function t(e, r) {
      this.url = e, this.transport = r;
    }
    return t.prototype.fetch = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          switch (i.label) {
            case 0:
              return r = this.createRequest(e), [4, this.execute(r)];
            case 1:
              return n = i.sent(), [2, this.handleResponse(n)];
          }
        });
      });
    }, t.prototype.createRequest = function(e) {
      var r = { identifiers: on(e) }, n = wv.encodeURL(JSON.stringify(r));
      return dr.builder().url(this.url).method("GET").addHeader("X-HACKLE-USER", n).build();
    }, t.prototype.execute = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n, i;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              r = at.start(), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.transport.send(e)];
            case 2:
              return n = o.sent(), St.record("get.cohorts", r, n), [2, n];
            case 3:
              throw i = o.sent(), St.record("get.cohorts", r, null), i;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.handleResponse = function(e) {
      if (!e.isSuccessful())
        throw new Error("Http status code: ".concat(e.statusCode));
      if (e.body === null)
        throw new Error("Response body is null");
      var r = JSON.parse(e.body);
      return Ta.fromDto(r);
    }, t;
  }()
), PP = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u, c, l, f) {
      this.experiments = x.associateBy(e, function(p) {
        return p.key;
      }), this.splitUrlExperiments = x.associateBy(r, function(p) {
        return p.key;
      }), this.featureFlags = x.associateBy(n, function(p) {
        return p.key;
      }), this.buckets = x.associateBy(i, function(p) {
        return p.id;
      }), this.eventTypes = x.associateBy(o, function(p) {
        return p.key;
      }), this.segments = x.associateBy(a, function(p) {
        return p.key;
      }), this.containers = x.associateBy(s, function(p) {
        return p.id;
      }), this.parameterConfigurations = x.associateBy(u, function(p) {
        return p.id;
      }), this.remoteConfigParameters = x.associateBy(c, function(p) {
        return p.key;
      }), this.inAppMessages = x.associateBy(l, function(p) {
        return p.key;
      }), this.attributes = f;
    }
    return t.prototype.getExperiments = function() {
      return Array.from(this.experiments.values());
    }, t.prototype.getSplitUrlExperiments = function() {
      return Array.from(this.splitUrlExperiments.values());
    }, t.prototype.getFeatureFlags = function() {
      return Array.from(this.featureFlags.values());
    }, t.prototype.getInAppMessages = function() {
      return Array.from(this.inAppMessages.values());
    }, t.prototype.getExperimentOrNull = function(e) {
      return this.experiments.get(e);
    }, t.prototype.getFeatureFlagOrNull = function(e) {
      return this.featureFlags.get(e);
    }, t.prototype.getBucketOrNull = function(e) {
      return this.buckets.get(e);
    }, t.prototype.getEventTypeOrNull = function(e) {
      return this.eventTypes.get(e);
    }, t.prototype.getSegmentOrNull = function(e) {
      return this.segments.get(e);
    }, t.prototype.getContainerOrNull = function(e) {
      return this.containers.get(e);
    }, t.prototype.getParameterConfigurationOrNull = function(e) {
      return this.parameterConfigurations.get(e);
    }, t.prototype.getRemoteConfigParameterOrNull = function(e) {
      return this.remoteConfigParameters.get(e);
    }, t.prototype.getInAppMessageOrNull = function(e) {
      return this.inAppMessages.get(e);
    }, t.prototype.getAttributes = function() {
      return this.attributes;
    }, t.from = function(e) {
      var r = x.mapNotNullOrUndefined(e.experiments, function(d) {
        return ri.fromJson("AB_TEST", d);
      }), n = x.mapNotNullOrUndefined(e.experiments, function(d) {
        return ri.fromJson("AB_TEST", d);
      }).filter(function(d) {
        return d.implementationType === "SPLIT_URL";
      }), i = x.mapNotNullOrUndefined(e.featureFlags, function(d) {
        return ri.fromJson("FEATURE_FLAG", d);
      }), o = e.buckets.map(Kv.fromJson), a = e.events.map(Sl.fromJson), s = x.mapNotNullOrUndefined(e.segments, nh.fromJson), u = e.containers.map(ih.fromJson), c = e.parameterConfigurations.map(Jv.fromJson), l = x.mapNotNullOrUndefined(e.remoteConfigParameters, ah.fromJson), f = x.mapNotNullOrUndefined(e.inAppMessages, bh.fromJson), p = e.workspace.attributes;
      return new t(r, n, i, o, a, s, u, c, l, f, p);
    }, t;
  }()
), UP = (
  /** @class */
  function() {
    function t(e, r) {
      this.workspaceConfigStorage = e, this.workspaceFetcher = r, this.workspace = null, this.lastModified = null;
      var n = this.workspaceConfigStorage.get();
      n && this.setConfig(n);
    }
    return t.prototype.setConfig = function(e) {
      this.setWorkspace(e), this.lastModified = e.lastModified;
    }, t.prototype.setWorkspace = function(e) {
      try {
        this.workspace = PP.from(e.config);
      } catch (r) {
        O.log.error("Failed to set workspace: ".concat(r));
      }
    }, t.prototype.get = function() {
      return this.workspace;
    }, t.prototype.sync = function() {
      return M(this, void 0, void 0, function() {
        var e, r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, this.workspaceFetcher.fetchIfModified(this.lastModified)];
            case 1:
              return e = n.sent(), e && (this.setConfig(e), this.workspaceConfigStorage.set(e)), [3, 3];
            case 2:
              return r = n.sent(), O.log.error("Failed to sync workspace: ".concat(r)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.close = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), DP = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.transport = e, this.synchronousTransport = r, this.retryManager = n;
    }
    return t.prototype.dispatch = function(e, r) {
      var n = e.map(function(i) {
        return i.toDto();
      });
      return r ? this.dispatchEventsSynchronously(n) : this.dispatchEvents(n);
    }, t.prototype.dispatchEventsSynchronously = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.retryManager.add(e)];
            case 1:
              return n.sent(), [4, this.synchronousTransport.send(e)];
            case 2:
              return r = n.sent(), r.isSuccessful() || r.isClientError() ? [4, this.retryManager.delete(e)] : [3, 4];
            case 3:
              n.sent(), n.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.dispatchEvents = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.transport.send(e)];
            case 1:
              return r = n.sent(), r.isSuccessful() || r.isClientError() ? [
                2
                /*return*/
              ] : [4, this.retryManager.add(e)];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
);
function LP(t) {
  var e = new Array(), r = new Array(), n = new Array();
  return t.forEach(function(i) {
    i instanceof Z ? Z.isExposureEvent(i) ? e.push(i.toDto()) : Z.isTrackEvent(i) ? r.push(i.toDto()) : Z.isRemoteConfigEvent(i) && n.push(i.toDto()) : Z.isExposureEventDto(i) ? e.push(i) : Z.isTrackEventDto(i) ? r.push(i) : Z.isRemoteConfigEventDto(i) && n.push(i);
  }), {
    exposureEvents: e,
    trackEvents: r,
    remoteConfigEvents: n
  };
}
var Yc = (
  /** @class */
  function() {
    function t(e, r) {
      this.url = e, this.transport = r;
    }
    return t.prototype.send = function(e) {
      var r = this.createRequest(e);
      return this.execute(r);
    }, t.prototype.createRequest = function(e) {
      var r = LP(e);
      return dr.builder().url(this.url).method("POST").addHeader("Content-Type", "application/json").body(JSON.stringify(r)).build();
    }, t.prototype.execute = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n, i;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              r = at.start(), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.transport.send(e)];
            case 2:
              return n = o.sent(), St.record("post.events", r, n), [2, n];
            case 3:
              throw i = o.sent(), St.record("post.events", r, null), i;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), $P = (
  /** @class */
  function() {
    function t(e, r) {
      this.repository = e, this.transport = r;
    }
    return t.prototype.add = function(e) {
      return this.repository.add(e);
    }, t.prototype.delete = function(e) {
      return this.repository.delete(e);
    }, t.prototype.flush = function() {
      return M(this, void 0, void 0, function() {
        var e, r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.repository.read()];
            case 1:
              return e = n.sent(), e.length === 0 ? [
                2
                /*return*/
              ] : [4, this.transport.send(e)];
            case 2:
              return r = n.sent(), r.isSuccessful() || r.isClientError() ? [4, this.delete(e)] : [3, 4];
            case 3:
              n.sent(), n.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "visible":
        case "pageshow":
          this.flush().catch(function(n) {
            return O.log.warn("Failed to flush retry events: ".concat(n));
          });
          return;
        case "blur":
        case "focus":
        case "hidden":
        case "locationChange":
        case "pagehide":
          return;
      }
    }, t;
  }()
), kP = (
  /** @class */
  function() {
    function t() {
      this.listeners = {};
    }
    return t.prototype.on = function(e, r) {
      this.listeners[e] = (this.listeners[e] || []).concat(r);
    }, t.prototype.off = function(e, r) {
      this.listeners[e] = (this.listeners[e] || []).filter(function(n) {
        return n !== r;
      });
    }, t.prototype.emit = function(e, r) {
      (this.listeners[e] || []).forEach(function(n) {
        n(r);
      });
    }, t;
  }()
), FP = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(kP)
), GP = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o) {
      var a = t.call(this) || this;
      return a.eventDispatcher = r, a.eventDispatchMaxSize = n, a.flushScheduler = i, a.flushIntervalMillis = o, a.queue = [], a.flushingJob = null, a;
    }
    return e.prototype.process = function(r) {
      this.enqueue(r), this.emit("event", r);
    }, e.prototype.enqueue = function(r) {
      this.queue.length === 0 && this.scheduleFlush(), this.queue.push(r), this.queue.length >= this.eventDispatchMaxSize && this.flush();
    }, e.prototype.scheduleFlush = function() {
      var r = this, n;
      (n = this.flushingJob) === null || n === void 0 || n.cancel(), this.flushingJob = this.flushScheduler.schedule(this.flushIntervalMillis, function() {
        return r.flush();
      });
    }, e.prototype.flush = function(r) {
      var n;
      r === void 0 && (r = !1), (n = this.flushingJob) === null || n === void 0 || n.cancel(), this.queue.length !== 0 && (this.eventDispatcher.dispatch(this.queue, r).catch(function(i) {
        return O.log.warn("Failed to dispatch events: ".concat(i));
      }), this.queue = []);
    }, e.prototype.close = function() {
      this.flush(!0);
    }, e;
  }(FP)
), Kc = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.sdk = e, this.clock = r, this.delegate = n;
    }
    return t.prototype.send = function(e) {
      var r = e.toBuilder().addHeader(bl, this.sdk.key).addHeader(Tl, this.sdk.name).addHeader(wl, this.sdk.version).addHeader(Nl, this.clock.currentMillis().toString()).build();
      return this.delegate.send(r);
    }, t;
  }()
), Qc = (
  /** @class */
  function() {
    function t() {
    }
    return t.intercept = function(e, r) {
      return r instanceof Kc ? r : new Kc(e, be.instance, r);
    }, t;
  }()
), VP = (
  /** @class */
  function() {
    function t() {
    }
    return t.create = function() {
      return new t();
    }, t.prototype.send = function(e) {
      return new Promise(function(r, n) {
        var i = new XMLHttpRequest();
        e.options.timeoutMillis && (i.timeout = e.options.timeoutMillis), i.open(e.method, e.url), i.onreadystatechange = function() {
          if (i.readyState === i.DONE) {
            if (i.status === 0) {
              n(new Error("Request Error"));
              return;
            }
            var o = jP(i);
            r(o);
          }
        }, BP(i, e), i.send(e.body);
      });
    }, t;
  }()
);
function BP(t, e) {
  var r = e.headers.raw();
  for (var n in r)
    r.hasOwnProperty(n) && t.setRequestHeader(n, r[n]);
}
function jP(t) {
  return new $l(t.status, t.responseText, HP(t));
}
function HP(t) {
  var e = _t.builder(), r = t.getAllResponseHeaders();
  if (!r)
    return e.build();
  for (var n = 0, i = r.split(`\r
`); n < i.length; n++) {
    var o = i[n], a = o.indexOf(": ");
    if (a > 0) {
      var s = o.slice(0, a), u = o.slice(a + 2);
      e.add(s, u);
    }
  }
  return e.build();
}
var XP = (
  /** @class */
  function() {
    function t() {
    }
    return t.create = function() {
      return new t();
    }, t.prototype.send = function(e) {
      var r = this;
      return new Promise(function(n, i) {
        var o = !1;
        if (typeof window < "u" && (o = window && window.navigator && !!window.navigator.sendBeacon && !0), !o)
          throw new Error("BeaconTransport not supported.");
        var a = r.createBody(e), s = window.navigator.sendBeacon(e.url, a);
        if (!s)
          throw Error("Failed to sendBeacon");
        n($l.ok());
      });
    }, t.prototype.createBody = function(e) {
      var r = new URLSearchParams(), n = e.headers.get(bl);
      n && r.append("sdkKey", n), r.append("sdkName", e.headers.getOrDefault(Tl, "unknown")), r.append("sdkVersion", e.headers.getOrDefault(wl, "unknown"));
      var i = e.headers.get(Nl);
      return i && r.append("sdkTime", i), e.body && r.append("data", e.body), r;
    }, t;
  }()
), WP = (
  /** @class */
  function() {
    function t(e) {
      this.invocationResponseResolver = e;
    }
    return t.prototype.invoke = function(e) {
      var r = window.prompt(JSON.stringify(e));
      return this.invocationResponseResolver.resolve(r);
    }, t;
  }()
), zP = (
  /** @class */
  function() {
    function t(e) {
      this.invocationResponseResolver = e;
    }
    return t.prototype.invoke = function(e) {
      var r;
      if (!(!((r = window._hackleApp) === null || r === void 0) && r.invoke))
        throw new Error("window._hackleApp.invoke is not implemented");
      var n = window._hackleApp.invoke(JSON.stringify(e));
      return this.invocationResponseResolver.resolve(n);
    }, t;
  }()
), yn;
(function(t) {
  t.prompt = "prompt", t.function = "function";
})(yn || (yn = {}));
var JP = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getInvocator = function(e, r) {
      return e === yn.prompt ? new WP(r) : e === yn.function ? new zP(r) : null;
    }, t;
  }()
), ZP = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.determiner = e, this.redirector = r, this.userManager = n, this.core = i;
    }
    return t.prototype.onPageStarted = function(e, r) {
      var n = this.userManager.resolve(), i = this.determiner.determineOrNull(n);
      i && (this.core.flush(!0), this.redirector.redirect(i));
    }, t.prototype.onPageEnded = function(e, r) {
    }, t;
  }()
), YP = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.workspace = e, this.experiment = r, this.decision = n, this.user = i;
    }
    return t;
  }()
), KP = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.workspaceFetcher = e, this.splitUrlMatcher = r, this.splitUrlRedirectedCookieStorage = n, this.core = i;
    }
    return t.prototype.determineOrNull = function(e) {
      if (this.splitUrlRedirectedCookieStorage.alreadyRedirected())
        return this.splitUrlRedirectedCookieStorage.clear(), null;
      var r = this.workspaceFetcher.get();
      if (!r)
        return null;
      for (var n = 0, i = r.getSplitUrlExperiments(); n < i.length; n++) {
        var o = i[n], a = this.splitUrlMatcher.matches(r, o, e);
        if (a) {
          var s = this.core.experiment(o.key, e, "A");
          return new YP(r, o, s, e);
        }
      }
      return null;
    }, t;
  }()
), QP = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.matches = function(e, r, n) {
      if (r.implementationType !== "SPLIT_URL" || !r.splitUrlTargets)
        return !1;
      var i = r.splitUrlTargets, o = qP.of(e, n);
      return i.excludeTargets.length > 0 && this.targetMatcher.anyMatches(o, tt.create(), i.excludeTargets) ? !1 : i.includeTargets.length > 0 && this.targetMatcher.anyMatches(o, tt.create(), i.includeTargets);
    }, t;
  }()
), qP = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.key = e, this.user = r, this.workspace = n;
    }
    return t.of = function(e, r) {
      return new t(new Cr("SPLIT_URL", Pt()), r, e);
    }, t;
  }()
), eU = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.urlResolver = e, this.urlHandler = r, this.splitUrlRedirectedCookieStorage = n, this.initializeEventDispatcher = i;
    }
    return t.prototype.redirect = function(e) {
      var r = this.urlResolver.resolveOrNull(e);
      r && (this.initializeEventDispatcher.setNeedDispatch(!1), this.splitUrlRedirectedCookieStorage.setRedirected(!0), this.urlHandler.open(r));
    }, t;
  }()
), tU = (
  /** @class */
  function() {
    function t(e) {
      this.campaignParser = e;
    }
    return t.prototype.resolveOrNull = function(e) {
      try {
        var r = JSON.parse(e.decision.get(t.SPLIT_URL_CONFIG_KEY, "")), n = Hh.fromDto(r);
        return n.needRedirect ? this.resolveByRedirectType(n.redirectType, n.redirectUrl, e) : null;
      } catch {
        return null;
      }
    }, t.prototype.resolveByRedirectType = function(e, r, n) {
      if (!r)
        return null;
      switch (e) {
        case an.MANUAL:
          return this.resolveManualRedirectUrl(r, n);
        default:
          return null;
      }
    }, t.prototype.resolveManualRedirectUrl = function(e, r) {
      var n = Ce.tryParse(e);
      return n ? this.decorateCampaign(n, r) : null;
    }, t.prototype.decorateCampaign = function(e, r) {
      var n = r.user.hackleProperties.queryParameter;
      if (Cn.isNotEmptyString(n)) {
        var i = this.campaignParser.parse(n);
        return fP(i, e);
      } else
        return e;
    }, t.SPLIT_URL_CONFIG_KEY = "redirectUrl", t;
  }()
), rU = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.storage = e, this.cookieKey = r, this.cookieStorageOptions = n;
    }
    return t.prototype.alreadyRedirected = function() {
      try {
        var e = this.storage.getItem(this.cookieKey);
        return v.isNullOrUndefined(e) ? !1 : !!JSON.parse(e);
      } catch {
        return !1;
      }
    }, t.prototype.clear = function() {
      this.storage.removeItem(this.cookieKey);
    }, t.prototype.setRedirected = function(e) {
      this.storage.setItem(this.cookieKey, String(e), this.cookieStorageOptions);
    }, t;
  }()
), nU = (
  /** @class */
  function() {
    function t() {
      this.needDispatch = !0;
    }
    return t.prototype.setNeedDispatch = function(e) {
      this.needDispatch = e;
    }, t.prototype.dispatchDoneEventIfNeeded = function() {
      this.needDispatch && window.dispatchEvent(new CustomEvent(t.HACKLE_INITIALIZE_DONE_EVENT_TYPE));
    }, t.HACKLE_INITIALIZE_DONE_EVENT_TYPE = "hackle-initialize-done", t;
  }()
), iU = (
  /** @class */
  function() {
    function t(e, r) {
      this.sdk = e, this.storage = r;
    }
    return t.prototype.get = function() {
      var e = this.storage.getItem(ti);
      if (v.isNullOrUndefined(e))
        return null;
      try {
        var r = JSON.parse(e);
        return this.sdk.version !== r.version ? (this.clear(), null) : r;
      } catch {
        return this.clear(), null;
      }
    }, t.prototype.set = function(e) {
      var r = b(b({}, e), { version: this.sdk.version });
      this.storage.setItem(ti, JSON.stringify(r));
    }, t.prototype.clear = function() {
      this.storage.removeItem(ti);
    }, t;
  }()
), jr = O.log, oU = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = be.instance), this.clock = e, this.listeners = [], this._initialized = !1;
    }
    return t.prototype.install = function(e) {
      e === void 0 && (e = null);
      try {
        var r = this.changeLifecycle.bind(this);
        window.addEventListener("pageshow", function() {
          return r("pageshow");
        }), window.addEventListener("pagehide", function() {
          return r("pagehide");
        }), document.addEventListener("visibilitychange", function() {
          return r(document.visibilityState);
        }), window.addEventListener("blur", function() {
          return r("blur");
        }), window.addEventListener("focus", function() {
          return r("focus");
        }), t.isSafariBrowser(e) && window.addEventListener("beforeunload", function() {
          return r("hidden");
        }), history.pushState = function(n) {
          return function() {
            try {
              var o = n.apply(history, arguments);
              return r("locationChange"), o;
            } catch (a) {
              (a instanceof Error || typeof a == "string") && jr.error(a);
            }
          };
        }(history.pushState), history.replaceState = function(n) {
          return function() {
            try {
              var o = n.apply(history, arguments);
              return r("locationChange"), o;
            } catch (a) {
              (a instanceof Error || typeof a == "string") && jr.error(a);
            }
          };
        }(history.replaceState), window.addEventListener("popstate", function() {
          try {
            r("locationChange");
          } catch (n) {
            (n instanceof Error || typeof n == "string") && jr.error(n);
          }
        });
      } catch (n) {
        (n instanceof Error || typeof n == "string") && jr.error(n);
      }
    }, t.prototype.addListener = function(e) {
      this.listeners.push(e);
    }, t.prototype.initialize = function() {
      this._initialized = !0, this.changeLifecycle("pageshow");
    }, t.prototype.changeLifecycle = function(e) {
      this._initialized && this.publish(e);
    }, t.prototype.publish = function(e) {
      var r = this.clock.currentMillis();
      this.listeners.forEach(function(n) {
        n.onLifecycleChanged(e, r);
      });
    }, t.isSafariBrowser = function(e) {
      return v.isNullOrUndefined(e) ? !1 : e.toLowerCase().includes("safari");
    }, t;
  }()
), aU = (
  /** @class */
  function() {
    function t(e) {
      this.limiter = e;
    }
    return t.create = function(e, r, n) {
      n === void 0 && (n = be.instance);
      var i = new sU(n, e, r);
      return new t(i);
    }, t.prototype.execute = function(e, r) {
      return this.limiter.tryAcquire() ? e() : r();
    }, t;
  }()
), sU = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.clock = e, this.intervalMillis = r, this.limit = n, this.currentScope = null;
    }
    return t.prototype.tryAcquire = function() {
      var e = this.clock.currentMillis(), r = this.refreshScopeIfNeeded(e);
      return r.tryAcquire();
    }, t.prototype.refreshScopeIfNeeded = function(e) {
      return (this.currentScope == null || this.currentScope.isExpired(e)) && (this.currentScope = new uU(e + this.intervalMillis, this.limit)), this.currentScope;
    }, t;
  }()
), uU = (
  /** @class */
  function() {
    function t(e, r) {
      this.expirationTime = e, this.token = r;
    }
    return t.prototype.isExpired = function(e) {
      return this.expirationTime < e;
    }, t.prototype.tryAcquire = function() {
      return this.token > 0 ? (this.token -= 1, !0) : !1;
    }, t;
  }()
), cU = (
  /** @class */
  function() {
    function t(e) {
      this.determiners = e;
    }
    return t.prototype.isDedupTarget = function(e) {
      var r = this.determiners.find(function(n) {
        return n.supports(e);
      });
      return r ? r.isDedupTarget(e) : !1;
    }, t;
  }()
), Bp = (
  /** @class */
  function() {
    function t(e, r) {
      this.dedupIntervalMillis = e, this.clock = r, this.cache = {}, this.currentUser = null;
    }
    return t.prototype.isDedupTarget = function(e) {
      var r;
      if (this.dedupIntervalMillis === kv)
        return !1;
      fe.isEquals(e.user.identifiers, (r = this.currentUser) === null || r === void 0 ? void 0 : r.identifiers) || (this.currentUser = e.user, this.cache = {});
      var n = this.cacheKey(e), i = this.clock.currentMillis(), o = this.cache[n];
      return o !== void 0 && i - o <= this.dedupIntervalMillis ? !0 : (this.cache[n] = i, !1);
    }, t;
  }()
), lU = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return n === void 0 && (n = be.instance), t.call(this, r, n) || this;
    }
    return e.prototype.supports = function(r) {
      return Z.isRemoteConfigEvent(r);
    }, e.prototype.cacheKey = function(r) {
      return [r.parameter.id, r.valueId, r.decisionReason].join("-");
    }, e;
  }(Bp)
), fU = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return n === void 0 && (n = be.instance), t.call(this, r, n) || this;
    }
    return e.prototype.supports = function(r) {
      return Z.isExposureEvent(r);
    }, e.prototype.cacheKey = function(r) {
      return [r.experiment.id, r.variationId, r.variationKey, r.decisionReason].join("-");
    }, e;
  }(Bp)
), pU = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.isInvocatorResponse = function(e) {
      return typeof e == "object" && e !== null && "success" in e && typeof e.success == "boolean" && "message" in e && typeof e.message == "string";
    }, t.prototype.resolve = function(e) {
      var r = JSON.parse(e ?? "");
      if (!this.isInvocatorResponse(r))
        throw new Error("invalid invocator response data");
      if (!r.success)
        throw new Error("failed response");
      var n = {
        message: r.message,
        success: r.success,
        data: r.data
      };
      return n;
    }, t;
  }()
), dU = (
  /** @class */
  function() {
    function t(e) {
      this.invocator = e;
    }
    return t.prototype.createInvocationRequestDto = function(e) {
      var r = e.command, n = e.parameters;
      return { _hackle: { command: r, parameters: n } };
    }, t.prototype.process = function(e) {
      var r, n = this.createInvocationRequestDto(e);
      return (r = this.invocator.invoke(n).data) !== null && r !== void 0 ? r : null;
    }, t;
  }()
), vU = O.log, jp = (
  /** @class */
  function() {
    function t(e, r) {
      this.core = e, this.userManager = r;
    }
    return t.prototype.onPageStarted = function(e, r) {
      this.track(e, r);
    }, t.prototype.onPageEnded = function(e, r) {
    }, t.prototype.track = function(e, r) {
      var n;
      vU.debug("tracking page view");
      var i = {
        key: t.PAGE_VIEW_EVENT_KEY,
        properties: (n = {}, n[t.PAGE_NAME_PROPERTY_KEY] = e.pageTitle, n)
      };
      this.core.track(i, this.userManager.resolve(), r);
    }, t.PAGE_VIEW_EVENT_KEY = "$page_view", t.PAGE_NAME_PROPERTY_KEY = "$page_name", t;
  }()
), hU = (
  /** @class */
  function() {
    function t() {
      this.listeners = [], this._currentPage = null;
    }
    return Object.defineProperty(t.prototype, "currentPage", {
      get: function() {
        var e;
        return (e = this._currentPage) !== null && e !== void 0 ? e : so.createWithCurrentPage();
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updatePage = function(e, r) {
      var n = this._currentPage;
      n && e.isEquals(n) || (n && this.publishEnd(n, r), this._currentPage = e, this.publishStart(e, r));
    }, t.prototype.publishStart = function(e, r) {
      for (var n = 0, i = this.listeners; n < i.length; n++) {
        var o = i[n];
        o.onPageStarted(e, r);
      }
    }, t.prototype.publishEnd = function(e, r) {
      for (var n = 0, i = this.listeners; n < i.length; n++) {
        var o = i[n];
        o.onPageEnded(e, r);
      }
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "pageshow":
        case "locationChange":
          var n = so.createWithCurrentPage();
          return this.updatePage(n, r);
        case "visible":
        case "pagehide":
        case "blur":
        case "focus":
        case "hidden":
          return;
      }
    }, t.prototype.addListener = function(e) {
      this.listeners.push(e);
    }, t;
  }()
), qc = O.log, gU = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.userManager = e, this.pageManager = r, this.minimumEngagementDurationMillis = n, this.listeners = [], this._lastEngagementTime = null;
    }
    return Object.defineProperty(t.prototype, "lastEngagementTime", {
      get: function() {
        return this._lastEngagementTime;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.startEngagement = function(e) {
      qc.debug("startEngagement timestamp:".concat(e, ", page:").concat(this.pageManager.currentPage.url)), this._lastEngagementTime = e;
    }, t.prototype.endEngagement = function(e, r) {
      if (!v.isNullOrUndefined(this._lastEngagementTime)) {
        var n = this._lastEngagementTime;
        this._lastEngagementTime = r;
        var i = r - n;
        if (!(i < this.minimumEngagementDurationMillis)) {
          var o = { page: e, durationMillis: i };
          this.publish(o, this.userManager.resolve(), r);
        }
      }
    }, t.prototype.publish = function(e, r, n) {
      qc.debug("onEngagement timestamp:".concat(n, ", page:").concat(this.pageManager.currentPage.url));
      for (var i = 0, o = this.listeners; i < o.length; i++) {
        var a = o[i];
        a.onEngagement(e, r, n);
      }
    }, t.prototype.onPageStarted = function(e, r) {
      this.startEngagement(r);
    }, t.prototype.onPageEnded = function(e, r) {
      this.endEngagement(e, r);
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "visible":
        case "focus":
          return this.startEngagement(r);
        case "pagehide":
        case "hidden":
        case "blur":
          return this.endEngagement(this.pageManager.currentPage, r);
        case "pageshow":
        case "locationChange":
          return;
      }
    }, t.prototype.addListener = function(e) {
      this.listeners.push(e);
    }, t;
  }()
), yU = (
  /** @class */
  function() {
    function t(e) {
      this.core = e;
    }
    return t.prototype.onEngagement = function(e, r, n) {
      var i, o = {
        key: t.ENGAGEMENT_EVENT_KEY,
        properties: (i = {}, i[jp.PAGE_NAME_PROPERTY_KEY] = e.page.pageTitle, i[t.ENGAGEMENT_TIME_PROPERTY_KEY] = e.durationMillis, i)
      };
      this.core.track(o, r, n);
    }, t.ENGAGEMENT_EVENT_KEY = "$engagement", t.ENGAGEMENT_TIME_PROPERTY_KEY = "$engagement_time_ms", t;
  }()
), $o = O.log, Qi = null;
function IU(t, e) {
  var r = qe.config(e);
  qe.logging(r);
  try {
    if (Sg(window) && t === window._hackleApp.getAppSdkKey())
      return mU(t, r, window._hackleApp);
  } catch (n) {
    $o.error("Unexpected exception while check WebApp client: ".concat(n));
  }
  return Hp(t, r);
}
function mU(t, e, r) {
  var n = new JP(), i = n.getInvocator(r.getInvocationType(), new pU());
  if (i === null)
    throw new Error("Failed to get invocator with invocationType:".concat(r.getInvocationType()));
  var o = new dU(i), a = new Rg(o);
  if (!r.getAppMode)
    return a;
  var s = r.getAppMode().toLowerCase();
  if (s === un.native)
    return a;
  if (s === un.web_view_wrapper) {
    var u = Hp(t, e), c = new xg(u, a);
    return c.syncUser(), c;
  }
  throw new Error("Unsupported HackleAppMode: ".concat(s));
}
function Hp(t, e) {
  var r, n, i = qe.sdk(t, e);
  if (Qi)
    return $o.debug("use already exists hackleClient"), Qi;
  var o = new Mg();
  o.initialize();
  var a = new Cx(), s = hr.getInstance({
    days: Ol,
    isCrossSubdomain: !0,
    sameSite: e.sameSiteCookie,
    isSecure: e.secureCookie
  }), u = qe.isBeaconSupported(), c = Qc.intercept(i, VP.create()), l = Qc.intercept(i, XP.create()), f = c;
  u && (f = l);
  var p = new NP(), d = new OP(p, new Ki("setTimeout"), qe.pollingIntervalMillis(e)), C = new iU(i, At.postfix(a, "_".concat(t.slice(0, 8)))), R = new RP(Et.clientFetch(e.sdkUrl, i.key), c), S = new UP(C, R);
  p.add(S);
  var T = new hU(), N = new xP(Et.userCohorts(e.sdkUrl), c), U = new hP(T), D = new Ix(At.postfix(s, "_".concat(t))), Oe = D.getUser(), Yp = e.user || null, ce = new yx(Yr(), D, N, U, T, be.instance, Oe, Yp);
  p.add(ce);
  var Re = new Ex(e.sessionTimeoutMillis, At.postfix(s, "_".concat(t.slice(8))));
  ce.addListener(Re);
  var Kp = new px(a, "".concat(Lv, "_").concat(t), oo), jn = new Yc(Et.clientDispatch(e.eventUrl), c), Oa = jn;
  u && (Oa = new Yc(Et.beaconDispatch(e.eventUrl, i.key), l));
  var Ma = new $P(Kp, jn), Qp = new DP(jn, Oa, Ma), qp = new cU([
    new lU(qe.dedupIntervalMillis(e)),
    new fU(qe.dedupIntervalMillis(e))
  ]), Hn = new GP(Qp, oo, new Ki("setTimeout"), Dv), _a = new YR(Hn, qp, Re, ce), Sa = new nU(), Ra = new Uc(new jc(s, "".concat(Fv, "_").concat(t.slice(0, 8)))), xa = new Uc(new jc(s, "".concat(Gv, "_").concat(t.slice(0, 8)))), Pa = new Tx(At.prefix(a, "".concat(Vv, "_").concat(t.slice(0, 8), "_"))), Ua = new Kx(At.prefix(a, "".concat(Bv, "_").concat(t.slice(0, 8), "_"))), me = sx.create(S, _a, [Ra, xa], Pa), Da = new pP(new dP(At.postfix(s, "_".concat(t.slice(0, 8)))), U, me, ce), ed = new kp(ce, me);
  Re.addListener(Da), Re.addListener(ed);
  var td = new Ux(me), rd = new wx([
    new Nx(),
    new Ox(new Xc()),
    new Mx(new Xc()),
    new _x(Pa, be.instance),
    new Sx(new Wc()),
    new Rx(new Wc()),
    new xx(new zc()),
    new Px(new zc())
  ]), nd = new Qx([
    new qx(Ua),
    new tP(rd),
    new eP()
  ]), La = new rP(be.instance, td, nd), id = new iP([
    new oP(),
    new aP(La)
  ]), od = new Xx(Et.inAppMessageRenderer(e.cdnUrl, e.IAM_RENDERER_VERSION_HEADER)), $a = new Dx(Hx.create(od), La, id), ad = new nP(new Wx(Lo.get("targetMatcher")), new Jx(Ua)), sd = new kx(S, ad, me);
  new Lx(Hn, sd, $a);
  var ud = new wP(S);
  new TP(Hn, ud);
  var Xn = new gU(ce, T, zv);
  T.addListener(Xn);
  var cd = new yU(me);
  Xn.addListener(cd);
  var ka = new jp(me, ce);
  e.automaticPageTracking && T.addListener(ka);
  var ld = new QP(Lo.get("targetMatcher")), Fa = new rU(s, Hv, { days: Xv }), fd = new KP(S, ld, Fa, me), pd = new eU(new tU(U), new sP(), Fa, Sa), dd = new ZP(fd, pd, ce, me);
  T.addListener(dd);
  var vd = new bx(me, ce, Ra, xa), hd = ((r = e.devTool) === null || r === void 0 ? void 0 : r.userExplorer) && typeof ((n = e.devTool) === null || n === void 0 ? void 0 : n.userExplorer) == "function", gd = e.devTool && hd ? { manager: e.devTool, userExplorer: vd } : void 0, Ga = new ug(Et.monitoring(e.monitoringUrl), c, f, new Ki("setTimeout"), Uv);
  Ue.addRegistry(Ga);
  var xe = new oU();
  xe.addListener(T), xe.addListener(Xn), xe.addListener(Re), xe.addListener(o), xe.addListener(Ma), xe.addListener(_a), xe.addListener(Ga), d.start();
  var yd = aU.create(Wv, 1), br = new wg(me, d, Re, ce, yd, ka, $a, gd);
  Qi = br;
  var Id = function() {
    e.autoOpenDevTool && (e.devTool ? br.showUserExplorer() : $o.error("DevTool is not provided"));
  }, md = function() {
    var Wn = Date.now(), Tr = ce.currentUser, Ad = Re.currentSessionId, zn;
    ba(Oe, Tr) ? zn = Re.startNewSessionIfNeeded(Tr, Wn) : zn = Re.startNewSession(Oe, Tr, Wn), zn === Ad && Da.startNewCampaignIfNeeded(Tr, Wn);
  };
  new cx().install(me, ce);
  var Va = ce.resolve().hackleProperties.browserName;
  return xe.install(typeof Va == "string" ? Va : null), md(), br.onReady(function() {
    Id(), xe.initialize(), Sa.dispatchDoneEventIfNeeded();
  }), br;
}
function Xp(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(t, e || [])).next());
  });
}
function Wp(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (r = 0)), r; )
      try {
        if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = c;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(c);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = e.call(t, r);
      } catch (l) {
        c = [6, l], i = 0;
      } finally {
        n = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var zp = "https://devtools.hackle.io", AU = "/user-explorer", EU = "https://cdn.hackle.io/images/20230330/84a95e8b-339b-412e-9200-f3655b5eb91b.png", Ct = function(t, e) {
  var r = e || document, n = r.querySelector(t);
  if (!n)
    throw Error("HackleDevtools Failed when getting element.");
  return n;
}, el = "hackle-devtools", ot = "hackle-devtools__toggler", In = "hackle-devtools__shadowWrapper", xt = "hackle-devtools__iframeWrapper", Na = "hackle-devtools__iframe", ko = "hackle-devtools__style", CU = `
  <template id="`.concat(xt, `-template">
    <div id="`).concat(xt, `">
      <iframe id="`).concat(Na, `"></iframe>
    </div>
  </template>
`), bU = `
  <template id="`.concat(In, `-template">
    <div id="`).concat(In, `" style="position:fixed; z-index:10000001; left:24px; bottom: 61px; height: 0;"></div>
  </template>
`), TU = `
  <template id="`.concat(ot, `-template">
    <button id="`).concat(ot, `" type="button">
    </button>
  </template>

`), wU = `
  <template id="`.concat(ko, `-template">
    <style id="`).concat(ko, `">
      #`).concat(ot, ` {
        width: 45px;
        height: 45px;
        display: block;
        background-image: url(`).concat(EU, `);
        background-size: contain;
        background-color: white;

        border: 2px solid white;
        border-radius: 50%;
        cursor: pointer;
        box-shadow: 0px 0px 10px 3px #CACACA;
      }
      #`).concat(ot, `.hide {
        display: none;
      }
      #`).concat(ot, ` > img {
        width: 100%;
        height: 100%;
      }
      #`).concat(Na, ` {
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 8px;
      }
      #`).concat(xt, ` {
        width:420px;
        height:80%;
        min-height:580px;
        max-height:620px;
        border-radius:18px;
        position:fixed;
        left:24px;
        bottom:18px;
        animation: fade 0.5s;
        background-color: #F5F5F5;
        overflow: hidden;
        box-shadow: rgba(255, 255, 255, 0.12) 0px 0px 2px 0px inset, rgba(0, 0, 0, 0.05) 0px 0px 2px 1px, rgba(0, 0, 0, 0.3) 0px 12px 60px;
      }

      @media screen and (max-width: 768px) {
        #`).concat(xt, ` {
          width: 100vw;
          min-height: unset;
          max-height: unset;
          left: 0;
        }
      }
      @keyframes fade {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
      }
    </style>
  </template>
`), NU = {
  iframeWrapper: CU,
  shadowWrapper: bU,
  toggler: TU,
  stylesheet: wU
}, H;
(function(t) {
  t.INIT = "HACKLE-EVENT_INIT", t.CLOSE = "HACKLE-EVENT_CLOSE", t.USER = "HACKLE-EVENT_USER", t.DECISION_AB_GET = "HACKLE-EVENT_GET_AB_DECISION", t.DECISION_FF_GET = "HACKLE-EVENT_GET_FF_DECISION", t.OVERRIDE_AB_GET = "HACKLE-EVENT_GET_AB_OVERRIDE", t.OVERRIDE_AB_SET = "HACKLE-EVENT_SET_AB_OVERRIDE", t.OVERRIDE_AB_RESET = "HACKLE-EVENT_RESET_AB_OVERRIDE", t.OVERRIDE_AB_RESET_ALL = "HACKLE-EVENT_RESET_ALL_AB_OVERRIDE", t.OVERRIDE_FF_GET = "HACKLE-EVENT_GET_FF_OVERRIDE", t.OVERRIDE_FF_SET = "HACKLE-EVENT_SET_FF_OVERRIDE", t.OVERRIDE_FF_RESET = "HACKLE-EVENT_RESET_FF_OVERRIDE", t.OVERRIDE_FF_RESET_ALL = "HACKLE-EVENT_RESET_ALL_FF_OVERRIDE";
})(H || (H = {}));
var ye = function(t) {
  return typeof t.type == "string" && Object.values(H).includes(t.type);
}, OU = function(t) {
  return ye(t) && t.type === H.CLOSE;
}, MU = function(t) {
  return ye(t) && t.type === H.INIT;
}, _U = function(t) {
  return ye(t) && t.type === H.USER;
}, SU = function(t) {
  return ye(t) && t.type === H.DECISION_AB_GET;
}, RU = function(t) {
  return ye(t) && t.type === H.DECISION_FF_GET;
}, xU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_AB_GET;
}, PU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_FF_GET;
}, UU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_AB_SET;
}, DU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_FF_SET;
}, LU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_AB_RESET;
}, $U = function(t) {
  return ye(t) && t.type === H.OVERRIDE_FF_RESET;
}, kU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_AB_RESET_ALL;
}, FU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_FF_RESET_ALL;
}, GU = (
  /** @class */
  function() {
    function t(e, r) {
      this.port = e, this.opposite = r, this.port.start();
    }
    return t.prototype.receive = function(e, r) {
      this.port.addEventListener("message", function(n) {
        e(n.data) && r(n.data.payload);
      });
    }, t.prototype.post = function(e) {
      this.port.postMessage(e);
    }, t.prototype.close = function() {
      this.port.close(), this.opposite.close();
    }, t;
  }()
), VU = O.log, BU = 5e3, jU = (
  /** @class */
  function() {
    function t(e) {
      this.transceiver = e;
    }
    return t.connectTo = function(e, r) {
      return Xp(this, void 0, void 0, function() {
        var n, i, o, a, s, u, c;
        return Wp(this, function(l) {
          switch (l.label) {
            case 0:
              return o = new Promise(function(f) {
                i = f, n = setTimeout(function() {
                  f({ port1: void 0, port2: void 0 });
                }, BU);
              }), window.addEventListener("message", function(f) {
                if (MU(f.data) && e.contentWindow) {
                  var p = new MessageChannel(), d = p.port1, C = p.port2;
                  e.contentWindow.postMessage({
                    type: H.INIT
                  }, "".concat(zp, "/").concat(r), [C]), clearTimeout(n), i == null || i({ port1: d, port2: C });
                }
              }), [4, o];
            case 1:
              return a = l.sent(), s = a.port1, u = a.port2, !s || !u ? (VU.error("Timeout occurred while loading devtools."), [
                2
                /*return*/
              ]) : (c = new GU(s, u), [2, new t(c)]);
          }
        });
      });
    }, t.prototype.addMessageListener = function(e, r) {
      this.transceiver.receive(e, r);
    }, t.prototype.applyChannel = function(e) {
      e(this.transceiver);
    }, t.prototype.close = function() {
      this.transceiver.close();
    }, t;
  }()
), HU = function(t) {
  return function(e) {
    e.receive(_U, function() {
      var r = {
        type: H.USER,
        payload: t.currentUser()
      };
      e.post(r);
    }), e.receive(SU, function() {
      var r = {
        type: H.DECISION_AB_GET,
        payload: t.getAbTestDecisions()
      };
      e.post(r);
    }), e.receive(xU, function() {
      var r = {
        type: H.OVERRIDE_AB_GET,
        payload: t.getAbTestOverrides()
      };
      e.post(r);
    }), e.receive(UU, function(r) {
      r && t.setAbTestOverride(r.experiment, r.variationId);
    }), e.receive(LU, function(r) {
      r && t.resetAbTestOverride(r.experiment);
    }), e.receive(kU, function() {
      t.resetAllAbTestOverride();
    }), e.receive(RU, function() {
      var r = {
        type: H.DECISION_FF_GET,
        payload: t.getFeatureFlagDecisions()
      };
      e.post(r);
    }), e.receive(PU, function() {
      var r = {
        type: H.OVERRIDE_FF_GET,
        payload: t.getFeatureFlagOverrides()
      };
      e.post(r);
    }), e.receive(DU, function(r) {
      r && t.setFeatureFlagOverride(r.experiment, r.variationId);
    }), e.receive($U, function(r) {
      r && t.resetFeatureFlagOverride(r.experiment);
    }), e.receive(FU, function() {
      t.resetAllFeatureFlagOverride();
    });
  };
}, XU = function(t) {
  var e = !1, r = 0, n = 0, i = function(s) {
    if (!e) {
      var u = s instanceof TouchEvent ? s.touches[0] : s;
      r = u.clientX, n = u.clientY, e = !0, window.addEventListener("mousemove", o), window.addEventListener("touchmove", o, { passive: !1 });
    }
  }, o = function(s) {
    if (e) {
      t.classList.add("dragged");
      var u = s instanceof TouchEvent ? s.touches[0] : s, c = r - u.clientX, l = n - u.clientY;
      r = u.clientX, n = u.clientY, t.style.left = t.offsetLeft - c + "px", t.style.top = t.offsetTop - l + "px", s.preventDefault();
    }
  }, a = function() {
    e = !1, window.removeEventListener("mousemove", o), window.removeEventListener("touchmove", o);
  };
  t.addEventListener("mousedown", i), t.addEventListener("mouseup", a), t.addEventListener("touchstart", i, { passive: !1 }), t.addEventListener("touchend", a);
}, mn = O.log, WU = (
  /** @class */
  function() {
    function t(e, r) {
      this.devtoolSubPath = e, this.channel = r, this.channelManager = null, this.shadowRoot = void 0, this.initialize();
    }
    return t.prototype.getShadowWrapper = function(e) {
      return Ct("#".concat(In), e);
    }, t.prototype.getIFrameWrapper = function(e) {
      return Ct("#".concat(xt), e);
    }, t.prototype.getToggler = function(e) {
      return Ct("#".concat(ot), e);
    }, t.prototype.getIFrame = function(e) {
      return Ct("#".concat(Na), e);
    }, t.prototype.getTemplate = function(e) {
      return Ct("#".concat(e, "-template"));
    }, t.prototype.createMessageChannel = function() {
      return Xp(this, void 0, void 0, function() {
        var e, r;
        return Wp(this, function(n) {
          switch (n.label) {
            case 0:
              return e = this.getIFrame(this.shadowRoot), e.src = "".concat(zp, "/").concat(this.devtoolSubPath), [4, jU.connectTo(e, this.devtoolSubPath)];
            case 1:
              return r = n.sent(), r ? (this.channelManager = r, r.addMessageListener(OU, this.hide.bind(this)), r.applyChannel(this.channel), [
                2
                /*return*/
              ]) : (this.hide(), [
                2
                /*return*/
              ]);
          }
        });
      });
    }, t.prototype.initialize = function() {
      if (typeof window > "u") {
        mn.error("HackleDevtools called before window loaded.");
        return;
      }
      document.getElementById(el) || this.createRoot();
    }, t.prototype.show = function() {
      var e, r = this.getTemplate(xt);
      (e = this.shadowRoot) === null || e === void 0 || e.appendChild(r.content.cloneNode(!0)), this.createMessageChannel();
    }, t.prototype.createRoot = function() {
      var e = this, r = document.createElement("div");
      r.id = "hackle-devtools", Object.values(NU).forEach(function(c) {
        return r.insertAdjacentHTML("beforeend", c);
      }), document.body.appendChild(r);
      var n = this.getTemplate(In);
      r.appendChild(n.content);
      var i = this.getShadowWrapper();
      XU(i);
      var o = i.attachShadow({ mode: "open" });
      this.shadowRoot = o;
      var a = this.getTemplate(ot), s = this.getTemplate(ko);
      o.appendChild(s.content), o.appendChild(a.content);
      var u = this.getToggler(o);
      u.addEventListener("click", function() {
        if (i.classList.contains("dragged")) {
          i.classList.remove("dragged");
          return;
        }
        e.show(), u.classList.add("hide");
      }, !0);
    }, t.prototype.hide = function() {
      var e = this.getToggler(this.shadowRoot);
      e.classList.remove("hide"), this.getIFrameWrapper(this.shadowRoot).remove();
    }, t.prototype.close = function() {
      var e;
      try {
        (e = this.channelManager) === null || e === void 0 || e.close();
        var r = Ct("#".concat(el));
        r.remove();
      } catch {
        mn.error("Failed to close HackleDevtools.");
      }
    }, t;
  }()
), zU = (
  /** @class */
  function() {
    function t() {
    }
    return t.userExplorer = function(e) {
      try {
        t.devtoolInstance = new WU(AU, HU(e));
      } catch {
        mn.error("Failed to initialize HackleDevTools.");
      }
    }, t.close = function() {
      if (!t.devtoolInstance) {
        mn.error("There is no active HackleDevtools.");
        return;
      }
      t.devtoolInstance.close();
    }, t.devtoolInstance = null, t;
  }()
), Fo = function(t, e) {
  return Fo = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Fo(t, e);
};
function JU(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Fo(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var ue = function() {
  return ue = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, ue.apply(this, arguments);
};
function ZU(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
var YU = "react-sdk", KU = "11.37.1", QU = (
  /** @class */
  function() {
    function t() {
      this.listeners = {};
    }
    return t.prototype.on = function(e, r) {
      this.listeners[e] = (this.listeners[e] || []).concat(r);
    }, t.prototype.off = function(e, r) {
      this.listeners[e] = (this.listeners[e] || []).filter(function(n) {
        return n !== r;
      });
    }, t.prototype.emit = function(e, r) {
      (this.listeners[e] || []).forEach(function(n) {
        n(r);
      });
    }, t;
  }()
), tl = (
  /** @class */
  function() {
    function t() {
    }
    return t.arePropertiesEqual = function(e, r) {
      var n = t.coerceUnknownToProperties(e), i = t.coerceUnknownToProperties(r), o = Object.keys(n), a = Object.keys(i);
      return o.length !== a.length ? !1 : o.every(function(s) {
        return s in i && n[s] === i[s];
      });
    }, t.coerceUnknownToProperties = function(e) {
      return typeof e == "object" && e !== null ? e : {};
    }, t;
  }()
), qU = (
  /** @class */
  function() {
    function t() {
    }
    return t.isUserEqual = function(e, r) {
      return (e == null ? void 0 : e.id) === (r == null ? void 0 : r.id) && (e == null ? void 0 : e.deviceId) === (r == null ? void 0 : r.deviceId) && (e == null ? void 0 : e.userId) === (r == null ? void 0 : r.userId) && tl.arePropertiesEqual(e == null ? void 0 : e.properties, r == null ? void 0 : r.properties) && tl.arePropertiesEqual(e == null ? void 0 : e.identifiers, r == null ? void 0 : r.identifiers);
    }, t;
  }()
), eD = (
  /** @class */
  function(t) {
    JU(e, t);
    function e(r, n) {
      var i = t.call(this) || this;
      return i._currentUser = null, i.client = IU(r, ue(ue({}, n), { SDK_NAME_HEADER: YU, SDK_VERSION_HEADER: KU })), i.getUser = i.getUser.bind(i), i.setUser = i.setUser.bind(i), i.setUserId = i.setUserId.bind(i), i.setDeviceId = i.setDeviceId.bind(i), i.setUserProperty = i.setUserProperty.bind(i), i.updateUserProperties = i.updateUserProperties.bind(i), i.resetUser = i.resetUser.bind(i), i.variation = i.variation.bind(i), i.variationDetail = i.variationDetail.bind(i), i.isFeatureOn = i.isFeatureOn.bind(i), i.featureFlagDetail = i.featureFlagDetail.bind(i), i.track = i.track.bind(i), i.trackPageView = i.trackPageView.bind(i), i.remoteConfig = i.remoteConfig.bind(i), i.onReady = i.onReady.bind(i), i.onInitialized = i.onInitialized.bind(i), i.emitUpdatedUser = i.emitUpdatedUser.bind(i), i.showUserExplorer = i.showUserExplorer.bind(i), i.hideUserExplorer = i.hideUserExplorer.bind(i), i.fetch = i.fetch.bind(i), i.setInAppMessageListener = i.setInAppMessageListener.bind(i), n != null && n.devTool && (n != null && n.autoOpenDevTool) && typeof window < "u" && i.showUserExplorer(), i;
    }
    return e.prototype.getUser = function() {
      return this.client.getUser();
    }, e.prototype.setUser = function(r) {
      this.client.setUser(r), this.emitUpdatedUser(this.getUser());
    }, e.prototype.setUserId = function(r) {
      this.client.setUserId(r), this.emitUpdatedUser(this.getUser());
    }, e.prototype.setDeviceId = function(r) {
      this.client.setDeviceId(r), this.emitUpdatedUser(this.getUser());
    }, e.prototype.setUserProperty = function(r, n) {
      this.client.setUserProperty(r, n), this.emitUpdatedUser(this.getUser());
    }, e.prototype.updateUserProperties = function(r) {
      this.client.updateUserProperties(r), this.emitUpdatedUser(this.getUser());
    }, e.prototype.resetUser = function() {
      this.client.resetUser(), this.emitUpdatedUser(this.getUser());
    }, e.prototype.variation = function(r, n, i) {
      return this.client.variation(r, n || void 0, i);
    }, e.prototype.variationDetail = function(r, n, i) {
      return this.client.variationDetail(r, n || void 0, i);
    }, e.prototype.isFeatureOn = function(r, n) {
      return this.client.isFeatureOn(r, n || void 0);
    }, e.prototype.featureFlagDetail = function(r, n) {
      return this.client.featureFlagDetail(r, n || void 0);
    }, e.prototype.track = function(r, n) {
      this.client.track(r, n || void 0);
    }, e.prototype.trackPageView = function(r) {
      this.client.trackPageView(ue(ue({}, r), { user: (r == null ? void 0 : r.user) || void 0 }));
    }, e.prototype.remoteConfig = function(r) {
      return this.client.remoteConfig(r || void 0);
    }, e.prototype.onReady = function(r, n) {
      this.client.onReady(r, n);
    }, e.prototype.onInitialized = function(r) {
      return this.client.onInitialized(r);
    }, e.prototype.emitUpdatedUser = function(r) {
      qU.isUserEqual(this._currentUser, r) || this.emit("user-updated", r), this._currentUser = r;
    }, e.prototype.showUserExplorer = function() {
      this.client.showUserExplorer();
    }, e.prototype.hideUserExplorer = function() {
      this.client.hideUserExplorer();
    }, e.prototype.fetch = function() {
      return this.client.fetch();
    }, e.prototype.setInAppMessageListener = function(r) {
      this.client.setInAppMessageListener(r);
    }, e;
  }(QU)
);
function tD(t, e) {
  return new eD(t, e);
}
var Jp = Rd({
  hackle: void 0,
  userVersion: 0,
  initialized: !1
});
Jp.Consumer;
var rl = Jp.Provider;
function rD(t) {
  var e = t.hackleClient, r = t.user, n = t.timeout, i = n === void 0 ? 3e3 : n, o = t.supportSSR, a = o === void 0 ? !1 : o, s = t.children, u = ZU(al({
    hackle: e,
    initialized: !1,
    userVersion: 0
  }), 2), c = u[0], l = u[1];
  return De(function() {
    typeof r < "u" && r !== null && e.setUser(r);
  }, [r]), De(function() {
    var f = function() {
      l(function(p) {
        return ue(ue({}, p), { userVersion: p.userVersion + 1 });
      });
    };
    return e.on("user-updated", f), function() {
      e.off("user-updated", f);
    };
  }, [e]), De(function() {
    e.onInitialized({ timeout: i }).then(function() {
      l(function(f) {
        return ue(ue({}, f), { initialized: !0 });
      });
    }, function() {
      l(function(f) {
        return ue(ue({}, f), { initialized: !0 });
      });
    }).catch(function() {
      l(function(f) {
        return ue(ue({}, f), { initialized: !0 });
      });
    });
  }, [e]), a ? Ha.createElement(rl, { value: c }, s) : c.initialized ? Ha.createElement(rl, { value: c }, s) : null;
}
O.log;
function nD({
  children: t
}) {
  const e = tD(Fd, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    devTool: zU,
    pollingIntervalMillis: 3e4,
    exposureEventDedupIntervalMillis: 1e3,
    autoOpenDevTool: kd !== "production"
  }), r = $d.get("deviceId"), n = r ? String(r) : void 0;
  return De(() => {
    !e || !n || e.setDeviceId(n);
  }, [n, e]), /* @__PURE__ */ A(rD, { hackleClient: e, supportSSR: !0, children: t });
}
function iD({
  size: t,
  fill: e
}) {
  return /* @__PURE__ */ Ie("svg", { xmlns: "http://www.w3.org/2000/svg", width: t || 18, height: t || 18, fill: e, viewBox: "0 0 18 18", children: [
    /* @__PURE__ */ A("path", { fill: "#4285F4", d: "M17.785 9.169c0-.738-.06-1.276-.189-1.834h-8.42v3.328h4.942c-.1.828-.638 2.073-1.834 2.91l-.016.112 2.662 2.063.185.018c1.694-1.565 2.67-3.867 2.67-6.597z" }),
    /* @__PURE__ */ A("path", { fill: "#34A853", d: "M9.175 17.938c2.422 0 4.455-.797 5.94-2.172l-2.83-2.193c-.758.528-1.774.897-3.11.897-2.372 0-4.385-1.564-5.102-3.727l-.105.01-2.769 2.142-.036.1c1.475 2.93 4.504 4.943 8.012 4.943z" }),
    /* @__PURE__ */ A("path", { fill: "#FBBC05", d: "M4.073 10.743c-.19-.558-.3-1.156-.3-1.774 0-.618.11-1.216.29-1.774l-.005-.119L1.254 4.9l-.091.044C.555 6.159.206 7.524.206 8.969c0 1.445.349 2.81.957 4.026l2.91-2.252z" }),
    /* @__PURE__ */ A("path", { fill: "#EB4335", d: "M9.175 3.468c1.684 0 2.82.728 3.468 1.335l2.531-2.471C13.62.887 11.598 0 9.175 0 5.667 0 2.638 2.013 1.163 4.943l2.9 2.252c.727-2.162 2.74-3.727 5.112-3.727z" })
  ] });
}
function oD({
  size: t,
  fill: e
}) {
  return /* @__PURE__ */ A("svg", { width: t || 30, height: t || 30, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ A("path", { fill: e || "#495057", fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 6C1.22386 6 1 6.22386 1 6.5C1 6.77614 1.22386 7 1.5 7H10C10.2761 7 10.5 6.77614 10.5 6.5C10.5 6.22386 10.2761 6 10 6H1.5ZM1.5 16C1.22386 16 1 16.2239 1 16.5C1 16.7761 1.22386 17 1.5 17H10C10.2761 17 10.5 16.7761 10.5 16.5C10.5 16.2239 10.2761 16 10 16H1.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H8.5C8.77614 11 9 11.2239 9 11.5C9 11.7761 8.77614 12 8.5 12H1.5C1.22386 12 1 11.7761 1 11.5ZM15.5 15.5C17.7091 15.5 19.5 13.7091 19.5 11.5C19.5 9.29086 17.7091 7.5 15.5 7.5C13.2909 7.5 11.5 9.29086 11.5 11.5C11.5 13.7091 13.2909 15.5 15.5 15.5ZM15.5 16.5C16.7006 16.5 17.8024 16.0768 18.6644 15.3715L22.1464 18.8536C22.3417 19.0488 22.6583 19.0488 22.8536 18.8536C23.0488 18.6583 23.0488 18.3417 22.8536 18.1464L19.3715 14.6644C20.0768 13.8024 20.5 12.7006 20.5 11.5C20.5 8.73858 18.2614 6.5 15.5 6.5C12.7386 6.5 10.5 8.73858 10.5 11.5C10.5 14.2614 12.7386 16.5 15.5 16.5Z" }) });
}
const aD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleLogo: iD,
  SearchHamburger: oD
}, Symbol.toStringTag, { value: "Module" }));
function sD({
  size: t,
  fill: e,
  icon: r,
  ...n
}) {
  const i = aD[r];
  return /* @__PURE__ */ A(i, { size: t, fill: e, ...n });
}
var Zp = /* @__PURE__ */ ((t) => (t.Kakao = "Kakao", t.Google = "Google", t.Github = "Github", t.Apple = "Apple", t))(Zp || {});
const Hr = {
  Kakao: "/api/v1/auth/kakao",
  Google: "/api/v1/auth/google",
  Github: "/api/v1/auth/github",
  Apple: "/api/v1/auth/apple"
}, uD = {
  Kakao: {
    responseType: "code",
    clientId: Gd,
    authorizationUrl: "https://kauth.kakao.com/oauth/authorize",
    redirectUri: `${Nr}${Hr.Kakao}`,
    scope: ["profile", "account_email", "birthday", "birthyear", "phone_number", "age_range", "gender"].join(",")
  },
  Github: {
    responseType: "code",
    clientId: Vd,
    authorizationUrl: "https://github.com/login/oauth/authorize",
    redirectUri: `${Nr}${Hr.Github}`,
    scope: ["user:email"].join(",")
  },
  Google: {
    responseType: "code",
    clientId: Bd,
    authorizationUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    redirectUri: `${Nr}${Hr.Google}`,
    scope: ["https://www.googleapis.com/auth/userinfo.email", "https://www.googleapis.com/auth/userinfo.profile"].join(" ")
  },
  Apple: {
    responseType: "code id_token",
    clientId: jd,
    authorizationUrl: "https://appleid.apple.com/auth/authorize",
    redirectUri: `${Nr}${Hr.Apple}`,
    scope: ["email", "name"].join(" "),
    responseMode: "form_post"
  }
};
function cD() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const lD = {
  Kakao: "카카오",
  Google: "구글",
  Github: "깃허브",
  Apple: "애플"
};
function fD(t) {
  return /* @__PURE__ */ A(nD, { children: /* @__PURE__ */ A(dD, { ...t }) });
}
var pD = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: cD
};
function dD({
  provider: t,
  showTooltip: e,
  isAuthPage: r = !1,
  checkBrowserRestrictions: n = !0
}) {
  const {
    t: i
  } = An(), o = ol(() => ({
    Kakao: {
      color: "yellow.4",
      icon: /* @__PURE__ */ A(Jn, { color: "dark.5", icon: cl.faComment })
    },
    Google: {
      color: "gray.1",
      icon: /* @__PURE__ */ A(sD, { icon: "GoogleLogo" })
    },
    Github: {
      color: "dark.4",
      icon: /* @__PURE__ */ A(Jn, { icon: cv })
    },
    Apple: {
      color: "white",
      icon: /* @__PURE__ */ A(Jn, { color: "dark", icon: uv })
    }
  })[t], [t]), a = Yn((l) => {
    if (nt()) {
      const {
        searchParams: f
      } = new URL(window.location.href), d = `${f.get("referUrl") || (r ? `${Hd}${tr.MAIN}` : window == null ? void 0 : window.location.href)}`;
      return Kn.stringifyUrl({
        url: l,
        query: {
          state: JSON.stringify({
            prev_url: d,
            enableLocalization: !0,
            previousUrl: d
          })
        }
      });
    }
    return Kn.stringifyUrl({
      url: l
    });
  }, [r]), s = Yn(() => {
    const {
      authorizationUrl: l,
      redirectUri: f,
      scope: p,
      clientId: d,
      responseMode: C,
      responseType: R
    } = uD[t], S = Kn.stringifyUrl({
      url: l,
      query: {
        scope: p,
        client_id: d,
        redirect_uri: f,
        response_type: R,
        response_mode: C
      }
    }, {
      skipNull: !0
    });
    return a(S);
  }, [t, a]), u = Yn(() => {
    var l;
    if (t === "Google" && nt() && n) {
      const {
        userAgent: f
      } = window.navigator;
      if (f.match(/kakaotalk/i) && f.match(/(inapp)/i))
        return ja({
          size: "md",
          zIndex: 202,
          title: i("카카오톡에서 구글 로그인을 지원하지 않습니다."),
          children: /* @__PURE__ */ A(qi, { children: i("다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.") }),
          labels: {
            confirm: i("확인")
          },
          footerType: "full",
          confirmProps: {
            color: "infgreen"
          }
        });
      if (f.match(/NAVER/i))
        return ja({
          size: "md",
          zIndex: 202,
          title: i("네이버에서 구글 로그인을 지원하지 않습니다."),
          children: /* @__PURE__ */ A(qi, { children: i("다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.") }),
          labels: {
            confirm: i("확인")
          },
          footerType: "full",
          confirmProps: {
            color: "infgreen"
          }
        });
    }
    nt() && ((l = Go) == null || l.set("referrer", window.location.href), window.location.href = s());
  }, [s]), c = i("{{provider}}-로그인-버튼", {
    provider: t
  });
  return /* @__PURE__ */ A("div", { css: pD, children: /* @__PURE__ */ A(Nd, { label: i("최근 로그인"), arrowPosition: "center", withArrow: !0, opened: e, "aria-describedby": c, fw: "bold", children: /* @__PURE__ */ A(Od, { id: c, size: "xl", variant: "filled", color: o.color, onClick: u, sx: (l) => ({
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
    ...o.color === "white" && {
      backgroundColor: o.color,
      "&:hover": {
        backgroundColor: l.colors.gray[1]
      }
    }
  }), "aria-label": i("{{socialProviderNameMap[provider]}}로 로그인", {
    "socialProviderNameMap[provider]": lD[t]
  }), children: o.icon }) }) });
}
function vD() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var hD = process.env.NODE_ENV === "production" ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : {
  name: "11ggwp1-LoginModal",
  styles: "overflow:visible;label:LoginModal;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: vD
};
function _D({
  onClose: t,
  opened: e
}) {
  const {
    t: r
  } = An(), [n, i] = al(null), {
    trackEvent: o
  } = sl();
  return De(() => {
    if (nt()) {
      const a = Go.get("_inflearn_spd");
      i(a ?? null);
    }
  }, []), /* @__PURE__ */ A(sv, { children: /* @__PURE__ */ Ie(le.Root, { radius: "md", size: 360, onClose: t, opened: e, closeOnClickOutside: !1, children: [
    /* @__PURE__ */ A(le.Overlay, {}),
    /* @__PURE__ */ Ie(le.Content, { children: [
      /* @__PURE__ */ A(le.Header, { children: /* @__PURE__ */ A(le.CloseButton, { onClick: t }) }),
      /* @__PURE__ */ A(le.Body, { css: hD, children: /* @__PURE__ */ Ie(Md, { component: "article", children: [
        /* @__PURE__ */ A(wr, { component: "h1", justify: "center", mb: "xl", "aria-label": r("인프런 브랜드 로고"), children: /* @__PURE__ */ A(nv, { type: "inflearn", size: 120 }) }),
        /* @__PURE__ */ A(ev, {}),
        /* @__PURE__ */ Ie(wr, { justify: "center", mt: 12, mb: 24, sx: (a) => ({
          ...gD(a.colors.gray[7], a.colors.gray[6])
        }), children: [
          /* @__PURE__ */ A(Zn, { href: tr.FIND_PW, underline: !1, onClick: () => o(er.CLICK_FIND_PW_AT_SIGNIN, {
            spot: "modal"
          }), children: r("비밀번호 찾기") }),
          /* @__PURE__ */ A(Xr, { orientation: "vertical", color: "gray.5", mx: 8, my: 4 }),
          /* @__PURE__ */ A(Zn, { underline: !1, href: tr.SIGN_UP, onClick: () => o(er.CLICK_SIGNUP_AT_SIGNIN, {
            spot: "modal"
          }), children: r("회원가입") }),
          /* @__PURE__ */ A(Xr, { orientation: "vertical", color: "gray.5", mx: 8, my: 4 }),
          /* @__PURE__ */ A(Zn, { underline: !1, href: tr.FIND_ID, onClick: () => o(er.CLICK_FIND_ID_AT_SIGNIN, {
            spot: "modal"
          }), children: r("아이디(이메일) 찾기") })
        ] }),
        /* @__PURE__ */ Ie(wr, { justify: "center", align: "center", direction: "column", children: [
          /* @__PURE__ */ A(Xr, { mb: "md", variant: "solid", labelPosition: "center", label: r("간편 로그인"), color: "gray.3", styles: (a) => ({
            root: {
              width: "100%"
            },
            label: {
              color: `${a.colors.gray[5]} !important`
            }
          }) }),
          /* @__PURE__ */ A(wr, { gap: "sm", children: Object.values(Zp).map((a) => /* @__PURE__ */ A(fD, { provider: a, showTooltip: n === a }, a)) })
        ] })
      ] }) })
    ] })
  ] }) });
}
const gD = (t, e) => ({
  a: {
    color: t,
    fontSize: "12px",
    borderBottom: `1px solid ${e}`
  }
});
export {
  sv as A,
  nv as B,
  nD as H,
  Kd as I,
  _D as L,
  MD as N,
  fD as S,
  Zp as a,
  rD as b,
  tD as c,
  zU as d
};
